import * as React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded$pM = ["size", "color", "stroke"];

function Icon2fa(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-2fa",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 16h-4l3.47 -4.66a2 2 0 1 0 -3.47 -1.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16v-8h4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 13,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16v-6a2 2 0 0 1 4 0v6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 13,
    x2: 21,
    y2: 13
  }));
}

var _excluded$pL = ["size", "color", "stroke"];

function Icon3dCubeSphere(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-3d-cube-sphere",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 17.6l-2 -1.1v-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10v-2.5l2 -1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4.1l2 -1.1l2 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6.4l2 1.1v2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14v2.5l-2 1.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19.9l-2 1.1l-2 -1.1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 14,
    y2: 10.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 8.6,
    x2: 20,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 14.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18.5,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l-2 -1.12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 8.6,
    x2: 4,
    y2: 7.5
  }));
}

var _excluded$pK = ["size", "color", "stroke"];

function Icon3dRotate(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-3d-rotate",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 15.5l4 -2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13l4 2.5v4.5l4 -2.5v-4.5l-4 -2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13v4.5l4 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4a7 7 0 0 1 7 7v4l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12l-3 3"
  }));
}

var _excluded$pJ = ["size", "color", "stroke"];

function IconAB(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-a-b",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16v-8h3a2 2 0 0 1 0 4h-3m3 0a2 2 0 0 1 0 4h-3"
  }));
}

var _excluded$pI = ["size", "color", "stroke"];

function IconAbacus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-abacus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3v18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21v-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21h18"
  }));
}

var _excluded$pH = ["size", "color", "stroke"];

function IconAccessPointOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-access-point-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.828 9.172a4 4 0 0 1 1.172 2.828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.657 6.343a8 8 0 0 1 1.635 8.952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.168 14.828a4 4 0 0 1 0 -5.656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.337 17.657a8 8 0 0 1 0 -11.314"
  }));
}

var _excluded$pG = ["size", "color", "stroke"];

function IconAccessPoint(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-access-point",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.828 9.172a4 4 0 0 1 0 5.656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.657 6.343a8 8 0 0 1 0 11.314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.168 14.828a4 4 0 0 1 0 -5.656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.337 17.657a8 8 0 0 1 0 -11.314"
  }));
}

var _excluded$pF = ["size", "color", "stroke"];

function IconAccessible(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-accessible",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16.5l2 -3l2 3m-2 -3v-2l3 -1m-6 0l3 1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.5,
    r: 0.5,
    fill: "currentColor"
  }));
}

var _excluded$pE = ["size", "color", "stroke"];

function IconActivity(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-activity",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h4l3 8l4 -16l3 8h4"
  }));
}

var _excluded$pD = ["size", "color", "stroke"];

function IconAd2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ad-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.933 5h-6.933v16h13v-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13h5v-4h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6l2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9h2"
  }));
}

var _excluded$pC = ["size", "color", "stroke"];

function IconAd(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ad",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 15v-4a2 2 0 0 1 4 0v4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 13,
    x2: 11,
    y2: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9v6h-1.5a1.5 1.5 0 1 1 1.5 -1.5"
  }));
}

var _excluded$pB = ["size", "color", "stroke"];

function IconAddressBook(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-address-book",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16h6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 11,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16h3"
  }));
}

var _excluded$pA = ["size", "color", "stroke"];

function IconAdjustmentsAlt(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-adjustments-alt",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 6,
    y2: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 4,
    x2: 18,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 9,
    x2: 18,
    y2: 20
  }));
}

var _excluded$pz = ["size", "color", "stroke"];

function IconAdjustmentsHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-adjustments-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 12,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 6,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 15,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 18,
    x2: 20,
    y2: 18
  }));
}

var _excluded$py = ["size", "color", "stroke"];

function IconAdjustments(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$py);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-adjustments",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 6,
    y2: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 7,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 4,
    x2: 18,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 9,
    x2: 18,
    y2: 20
  }));
}

var _excluded$px = ["size", "color", "stroke"];

function IconAerialLift(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$px);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-aerial-lift",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5l16 -2m-8 1v10m-5.106 -6h10.306c2.45 3 2.45 9 -.2 12h-10.106c-2.544 -3 -2.544 -9 0 -12zm-1.894 6h14"
  }));
}

var _excluded$pw = ["size", "color", "stroke"];

function IconAffiliate(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-affiliate",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.931 6.936l1.275 4.249m5.607 5.609l4.251 1.275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.683 12.317l5.759 -5.759"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 5.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 15.5,
    r: 4.5
  }));
}

var _excluded$pv = ["size", "color", "stroke"];

function IconAlarm(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pv);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alarm",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 10 12 13 14 13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 4.25,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 19.75,
    y2: 6
  }));
}

var _excluded$pu = ["size", "color", "stroke"];

function IconAlbum(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pu);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-album",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v7l2 -2l2 2v-7"
  }));
}

var _excluded$pt = ["size", "color", "stroke"];

function IconAlertCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pt);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alert-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12.01,
    y2: 16
  }));
}

var _excluded$ps = ["size", "color", "stroke"];

function IconAlertOctagon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ps);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alert-octagon",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12.01,
    y2: 16
  }));
}

var _excluded$pr = ["size", "color", "stroke"];

function IconAlertTriangle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pr);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alert-triangle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9v2m0 4v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
  }));
}

var _excluded$pq = ["size", "color", "stroke"];

function IconAlien(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-alien",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17a2.5 2.5 0 0 0 2 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3c-4.664 0 -7.396 2.331 -7.862 5.595a11.816 11.816 0 0 0 2 8.592a10.777 10.777 0 0 0 3.199 3.064c1.666 1 3.664 1 5.33 0a10.777 10.777 0 0 0 3.199 -3.064a11.89 11.89 0 0 0 2 -8.592c-.466 -3.265 -3.198 -5.595 -7.862 -5.595z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 10,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 11,
    x2: 14,
    y2: 13
  }));
}

var _excluded$pp = ["size", "color", "stroke"];

function IconAlignCenter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pp);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-center",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 18,
    y2: 18
  }));
}

var _excluded$po = ["size", "color", "stroke"];

function IconAlignJustified(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$po);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-justified",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 16,
    y2: 18
  }));
}

var _excluded$pn = ["size", "color", "stroke"];

function IconAlignLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pn);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 14,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 18,
    y2: 18
  }));
}

var _excluded$pm = ["size", "color", "stroke"];

function IconAlignRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pm);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 20,
    y2: 18
  }));
}

var _excluded$pl = ["size", "color", "stroke"];

function IconAmbulance(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pl);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ambulance",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10h4m-2 -2v4"
  }));
}

var _excluded$pk = ["size", "color", "stroke"];

function IconAnchor(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pk);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-anchor",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9v12m-8 -8a8 8 0 0 0 16 0m1 0h-2m-14 0h-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 3
  }));
}

var _excluded$pj = ["size", "color", "stroke"];

function IconAngle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-angle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 19h-18l9 -15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.615 15.171h.015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.515 11.771h.015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.715 8.671h.015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.415 5.971h.015"
  }));
}

var _excluded$pi = ["size", "color", "stroke"];

function IconAntennaBars1(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pi);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-antenna-bars-1",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 6,
    y2: 18.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 18,
    x2: 10,
    y2: 18.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 18.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 18,
    y2: 18.01
  }));
}

var _excluded$ph = ["size", "color", "stroke"];

function IconAntennaBars2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ph);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-antenna-bars-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 6,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 18,
    x2: 10,
    y2: 18.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 18.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 18,
    y2: 18.01
  }));
}

var _excluded$pg = ["size", "color", "stroke"];

function IconAntennaBars3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pg);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-antenna-bars-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 6,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 18,
    x2: 10,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 18.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 18,
    y2: 18.01
  }));
}

var _excluded$pf = ["size", "color", "stroke"];

function IconAntennaBars4(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pf);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-antenna-bars-4",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 6,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 18,
    x2: 10,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 18,
    y2: 18.01
  }));
}

var _excluded$pe = ["size", "color", "stroke"];

function IconAntennaBars5(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pe);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-antenna-bars-5",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 6,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 18,
    x2: 10,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 18,
    x2: 14,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 18,
    y2: 6
  }));
}

var _excluded$pd = ["size", "color", "stroke"];

function IconAperture(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pd);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-aperture",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 15,
    x2: 14.15,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 15,
    x2: 14.15,
    y2: 15,
    transform: "rotate(72 12 12)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 15,
    x2: 14.15,
    y2: 15,
    transform: "rotate(144 12 12)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 15,
    x2: 14.15,
    y2: 15,
    transform: "rotate(216 12 12)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 15,
    x2: 14.15,
    y2: 15,
    transform: "rotate(288 12 12)"
  }));
}

var _excluded$pc = ["size", "color", "stroke"];

function IconApiApp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pc);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-api-app",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12v6.5a2.5 2.5 0 1 1 -5 0v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9h6.5a2.5 2.5 0 1 1 0 5h-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12v-6.5a2.5 2.5 0 0 1 5 0v.5"
  }));
}

var _excluded$pb = ["size", "color", "stroke"];

function IconApi(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pb);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-api",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16v-8h3a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16v-5.5a2.5 2.5 0 0 0 -5 0v5.5"
  }));
}

var _excluded$pa = ["size", "color", "stroke"];

function IconAppWindow(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$pa);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-app-window",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8h.01"
  }));
}

var _excluded$p9 = ["size", "color", "stroke"];

function IconApple(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$p9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-apple",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11v-6a2 2 0 0 1 2 -2h2v1a2 2 0 0 1 -2 2h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5c1.333 .667 2.667 .667 4 0"
  }));
}

var _excluded$p8 = ["size", "color", "stroke"];

function IconApps(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$p8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-apps",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 7,
    x2: 20,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 17,
    y2: 10
  }));
}

var _excluded$p7 = ["size", "color", "stroke"];

function IconArchive(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$p7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-archive",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 14,
    y2: 12
  }));
}

var _excluded$p6 = ["size", "color", "stroke"];

function IconArmchair2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$p6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-armchair-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10v-4a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15v-2a3 3 0 1 1 3 3v3h-14v-3a3 3 0 1 1 3 -3v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 19v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 19v2"
  }));
}

var _excluded$p5 = ["size", "color", "stroke"];

function IconArmchair(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$p5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-armchair",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11a2 2 0 0 1 2 2v2h10v-2a2 2 0 1 1 4 0v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11v-5a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 19v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19v2"
  }));
}

var _excluded$p4 = ["size", "color", "stroke"];

function IconArrowAutofitContent(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$p4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-content",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4l-3 3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 16,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7h-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 7h-7"
  }));
}

var _excluded$p3 = ["size", "color", "stroke"];

function IconArrowAutofitDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$p3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4v17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18l3 3l3 -3"
  }));
}

var _excluded$p2 = ["size", "color", "stroke"];

function IconArrowAutofitHeight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$p2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-height",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14v7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 3v7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18l3 3l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6l3 -3l3 3"
  }));
}

var _excluded$p1 = ["size", "color", "stroke"];

function IconArrowAutofitLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$p1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18h-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15l-3 3l3 3"
  }));
}

var _excluded$p0 = ["size", "color", "stroke"];

function IconArrowAutofitRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$p0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12v-6a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18h17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l3 3l-3 3"
  }));
}

var _excluded$o$ = ["size", "color", "stroke"];

function IconArrowAutofitUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$o$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4h-6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20v-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6l3 -3l3 3"
  }));
}

var _excluded$o_ = ["size", "color", "stroke"];

function IconArrowAutofitWidth(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$o_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-autofit-width",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18h-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 18h-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15l-3 3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l3 3l-3 3"
  }));
}

var _excluded$oZ = ["size", "color", "stroke"];

function IconArrowBackUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-back-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13l-4 -4l4 -4m-4 4h11a4 4 0 0 1 0 8h-1"
  }));
}

var _excluded$oY = ["size", "color", "stroke"];

function IconArrowBack(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-back",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1"
  }));
}

var _excluded$oX = ["size", "color", "stroke"];

function IconArrowBarDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 8,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 20,
    y2: 4
  }));
}

var _excluded$oW = ["size", "color", "stroke"];

function IconArrowBarLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 14,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 8,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 20
  }));
}

var _excluded$oV = ["size", "color", "stroke"];

function IconArrowBarRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 10,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 16,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 20
  }));
}

var _excluded$oU = ["size", "color", "stroke"];

function IconArrowBarToDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-to-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 16,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 8,
    y2: 10
  }));
}

var _excluded$oT = ["size", "color", "stroke"];

function IconArrowBarToLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-to-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 14,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 14,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 20
  }));
}

var _excluded$oS = ["size", "color", "stroke"];

function IconArrowBarToRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-to-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 4,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 10,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 10,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 20
  }));
}

var _excluded$oR = ["size", "color", "stroke"];

function IconArrowBarToUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-to-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 12,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 16,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 8,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 20,
    y2: 4
  }));
}

var _excluded$oQ = ["size", "color", "stroke"];

function IconArrowBarUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bar-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 16,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 20
  }));
}

var _excluded$oP = ["size", "color", "stroke"];

function IconArrowBearLeft2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bear-left-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3h-5v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 5l-4.5 4.5"
  }));
}

var _excluded$oO = ["size", "color", "stroke"];

function IconArrowBearLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bear-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3h-5v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93"
  }));
}

var _excluded$oN = ["size", "color", "stroke"];

function IconArrowBearRight2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bear-right-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3h5v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5l4.5 4.5"
  }));
}

var _excluded$oM = ["size", "color", "stroke"];

function IconArrowBearRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bear-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3h5v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
  }));
}

var _excluded$oL = ["size", "color", "stroke"];

function IconArrowBigDownLine(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-down-line",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-6h6v6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3h-6"
  }));
}

var _excluded$oK = ["size", "color", "stroke"];

function IconArrowBigDownLines(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-down-lines",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-3h6v3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3h-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6h-6"
  }));
}

var _excluded$oJ = ["size", "color", "stroke"];

function IconArrowBigDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4v8h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-8a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1z"
  }));
}

var _excluded$oI = ["size", "color", "stroke"];

function IconArrowBigLeftLine(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-left-line",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h6v6h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15v-6"
  }));
}

var _excluded$oH = ["size", "color", "stroke"];

function IconArrowBigLeftLines(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-left-lines",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h3v6h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15v-6"
  }));
}

var _excluded$oG = ["size", "color", "stroke"];

function IconArrowBigLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15h-8v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h8a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1z"
  }));
}

var _excluded$oF = ["size", "color", "stroke"];

function IconArrowBigRightLine(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-right-line",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-6v-6h6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9v6"
  }));
}

var _excluded$oE = ["size", "color", "stroke"];

function IconArrowBigRightLines(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-right-lines",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-3v-6h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9v6"
  }));
}

var _excluded$oD = ["size", "color", "stroke"];

function IconArrowBigRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 9h8v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1z"
  }));
}

var _excluded$oC = ["size", "color", "stroke"];

function IconArrowBigTop(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-top",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20v-8h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v8a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
  }));
}

var _excluded$oB = ["size", "color", "stroke"];

function IconArrowBigUpLine(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-up-line",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v6h-6v-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21h6"
  }));
}

var _excluded$oA = ["size", "color", "stroke"];

function IconArrowBigUpLines(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-big-up-lines",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v3h-6v-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18h6"
  }));
}

var _excluded$oz = ["size", "color", "stroke"];

function IconArrowBottomBar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bottom-bar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18l3 3l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3h6"
  }));
}

var _excluded$oy = ["size", "color", "stroke"];

function IconArrowBottomCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oy);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bottom-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18l3 3l3 -3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }));
}

var _excluded$ox = ["size", "color", "stroke"];

function IconArrowBottomSquare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ox);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bottom-square",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18l3 3l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4h-4v-4z"
  }));
}

var _excluded$ow = ["size", "color", "stroke"];

function IconArrowBottomTail(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ow);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-bottom-tail",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6v15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18l3 3l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3l3 3l3 -3"
  }));
}

var _excluded$ov = ["size", "color", "stroke"];

function IconArrowCurveLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ov);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-curve-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7l-4 -4l-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3v4.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v2.394"
  }));
}

var _excluded$ou = ["size", "color", "stroke"];

function IconArrowCurveRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ou);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-curve-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7l4 -4l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4.394a6.737 6.737 0 0 1 -3 5.606a6.737 6.737 0 0 0 -3 5.606v2.394"
  }));
}

var _excluded$ot = ["size", "color", "stroke"];

function IconArrowDownCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ot);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 12,
    y2: 16
  }));
}

var _excluded$os = ["size", "color", "stroke"];

function IconArrowDownLeftCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$os);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-left-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 9,
    y2: 15
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 15 9 15 9 9"
  }));
}

var _excluded$or = ["size", "color", "stroke"];

function IconArrowDownLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$or);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 7,
    y2: 17
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 17 7 17 7 8"
  }));
}

var _excluded$oq = ["size", "color", "stroke"];

function IconArrowDownRightCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-right-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 9,
    y2: 15
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 9 15 15 9 9"
  }));
}

var _excluded$op = ["size", "color", "stroke"];

function IconArrowDownRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$op);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 17,
    y2: 17
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 8 17 17 8 17"
  }));
}

var _excluded$oo = ["size", "color", "stroke"];

function IconArrowDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oo);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 13,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 13,
    x2: 12,
    y2: 19
  }));
}

var _excluded$on = ["size", "color", "stroke"];

function IconArrowFork(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$on);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-fork",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3h5v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3h-5v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l7.536 7.536a5 5 0 0 1 1.464 3.534v.93"
  }));
}

var _excluded$om = ["size", "color", "stroke"];

function IconArrowForwardUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$om);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-forward-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13l4 -4l-4 -4m4 4h-11a4 4 0 0 0 0 8h1"
  }));
}

var _excluded$ol = ["size", "color", "stroke"];

function IconArrowForward(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ol);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-forward",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11l4 4l-4 4m4 -4h-11a4 4 0 0 1 0 -8h1"
  }));
}

var _excluded$ok = ["size", "color", "stroke"];

function IconArrowLeftBar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ok);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-left-bar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12h-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9l-3 3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9v6"
  }));
}

var _excluded$oj = ["size", "color", "stroke"];

function IconArrowLeftCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-left-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12h-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9l-3 3l3 3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 2
  }));
}

var _excluded$oi = ["size", "color", "stroke"];

function IconArrowLeftRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oi);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-left-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13l4 -4l-4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13l-4 -4l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14a5 5 0 0 1 5 -5h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19v-5a5 5 0 0 0 -5 -5h-4"
  }));
}

var _excluded$oh = ["size", "color", "stroke"];

function IconArrowLeftSquare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oh);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-left-square",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12h-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9l-3 3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14h-4v-4h4z"
  }));
}

var _excluded$og = ["size", "color", "stroke"];

function IconArrowLeftTail(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$og);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-left-tail",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12h-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9l-3 3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9l-3 3l3 3"
  }));
}

var _excluded$of = ["size", "color", "stroke"];

function IconArrowLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$of);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 11,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 11,
    y2: 6
  }));
}

var _excluded$oe = ["size", "color", "stroke"];

function IconArrowLoopLeft2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oe);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-loop-left-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21v-6m0 -6v-1a4 4 0 1 1 4 4h-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16l-4 -4l4 -4"
  }));
}

var _excluded$od = ["size", "color", "stroke"];

function IconArrowLoopLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$od);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-loop-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21v-13a4 4 0 1 1 4 4h-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16l-4 -4l4 -4"
  }));
}

var _excluded$oc = ["size", "color", "stroke"];

function IconArrowLoopRight2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oc);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-loop-right-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-6m0 -6v-1a4 4 0 1 0 -4 4h13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16l4 -4l-4 -4"
  }));
}

var _excluded$ob = ["size", "color", "stroke"];

function IconArrowLoopRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ob);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-loop-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-13a4 4 0 1 0 -4 4h13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16l4 -4l-4 -4"
  }));
}

var _excluded$oa = ["size", "color", "stroke"];

function IconArrowMerge(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$oa);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-merge",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7l4 -4l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v5.394a6.737 6.737 0 0 1 -3 5.606a6.737 6.737 0 0 0 -3 5.606v1.394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v5.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v1.394"
  }));
}

var _excluded$o9 = ["size", "color", "stroke"];

function IconArrowNarrowDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$o9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-narrow-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 15,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 15,
    x2: 12,
    y2: 19
  }));
}

var _excluded$o8 = ["size", "color", "stroke"];

function IconArrowNarrowLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$o8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-narrow-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 9,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 9,
    y2: 8
  }));
}

var _excluded$o7 = ["size", "color", "stroke"];

function IconArrowNarrowRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$o7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-narrow-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 19,
    y2: 12
  }));
}

var _excluded$o6 = ["size", "color", "stroke"];

function IconArrowNarrowUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$o6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-narrow-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 9,
    x2: 12,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 12,
    y2: 5
  }));
}

var _excluded$o5 = ["size", "color", "stroke"];

function IconArrowRampLeft2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$o5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-ramp-left-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 3v8.707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14l-4 -4l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 21c0 -6.075 -4.925 -11 -11 -11h-3"
  }));
}

var _excluded$o4 = ["size", "color", "stroke"];

function IconArrowRampLeft3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$o4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-ramp-left-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 3v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16l-4 -4l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 21v-6a3 3 0 0 0 -3 -3h-11"
  }));
}

var _excluded$o3 = ["size", "color", "stroke"];

function IconArrowRampLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$o3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-ramp-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 3,
    x2: 17,
    y2: 11.707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7l4 -4l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14l-4 -4l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21a11 11 0 0 0 -11 -11h-3"
  }));
}

var _excluded$o2 = ["size", "color", "stroke"];

function IconArrowRampRight2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$o2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-ramp-right-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3v8.707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14l4 -4l-4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21c0 -6.075 4.925 -11 11 -11h3"
  }));
}

var _excluded$o1 = ["size", "color", "stroke"];

function IconArrowRampRight3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$o1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-ramp-right-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16l4 -4l-4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21v-6a3 3 0 0 1 3 -3h11"
  }));
}

var _excluded$o0 = ["size", "color", "stroke"];

function IconArrowRampRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$o0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-ramp-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 3,
    x2: 7,
    y2: 11.707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7l-4 -4l-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 14l4 -4l-4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21a11 11 0 0 1 11 -11h3"
  }));
}

var _excluded$n$ = ["size", "color", "stroke"];

function IconArrowRightBar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$n$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-right-bar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l3 -3l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9v6"
  }));
}

var _excluded$n_ = ["size", "color", "stroke"];

function IconArrowRightCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$n_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-right-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l3 -3l-3 -3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12h14"
  }));
}

var _excluded$nZ = ["size", "color", "stroke"];

function IconArrowRightSquare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-right-square",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 21,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l3 -3l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10h4v4h-4z"
  }));
}

var _excluded$nY = ["size", "color", "stroke"];

function IconArrowRightTail(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-right-tail",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l3 -3l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 15l3 -3l-3 -3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 21,
    y2: 12
  }));
}

var _excluded$nX = ["size", "color", "stroke"];

function IconArrowRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 18,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 6,
    x2: 19,
    y2: 12
  }));
}

var _excluded$nW = ["size", "color", "stroke"];

function IconArrowRotaryFirstLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-first-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 32 0)",
    cx: 16,
    cy: 7,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.5l-8.5 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18h-5v-5"
  }));
}

var _excluded$nV = ["size", "color", "stroke"];

function IconArrowRotaryFirstRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-first-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.5l8.5 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 18h5v-5"
  }));
}

var _excluded$nU = ["size", "color", "stroke"];

function IconArrowRotaryLastLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-last-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 30 0)",
    cx: 15,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.5l-6.5 -6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 3h-5v5"
  }));
}

var _excluded$nT = ["size", "color", "stroke"];

function IconArrowRotaryLastRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-last-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.5l6.5 -6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3h5v5"
  }));
}

var _excluded$nS = ["size", "color", "stroke"];

function IconArrowRotaryLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 32 0)",
    cx: 16,
    cy: 7,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7h-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11l-4 -4l4 -4"
  }));
}

var _excluded$nR = ["size", "color", "stroke"];

function IconArrowRotaryRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11l4 -4l-4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7h10"
  }));
}

var _excluded$nQ = ["size", "color", "stroke"];

function IconArrowRotaryStraight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-rotary-straight",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3v7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7l4 -4l4 4"
  }));
}

var _excluded$nP = ["size", "color", "stroke"];

function IconArrowSharpTurnLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-sharp-turn-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18v-11.31a0.7 .7 0 0 0 -1.195 -.495l-9.805 9.805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16h-5v-5"
  }));
}

var _excluded$nO = ["size", "color", "stroke"];

function IconArrowSharpTurnRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-sharp-turn-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18v-11.31a0.7 .7 0 0 1 1.195 -.495l9.805 9.805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16h5v-5"
  }));
}

var _excluded$nN = ["size", "color", "stroke"];

function IconArrowTopBar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-top-bar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6l-3 -3l-3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 21,
    x2: 15,
    y2: 21
  }));
}

var _excluded$nM = ["size", "color", "stroke"];

function IconArrowTopCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-top-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6l-3 -3l-3 3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 2
  }));
}

var _excluded$nL = ["size", "color", "stroke"];

function IconArrowTopSquare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-top-square",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6l-3 -3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21v-4h4v4z"
  }));
}

var _excluded$nK = ["size", "color", "stroke"];

function IconArrowTopTail(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-top-tail",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6l-3 -3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 21l-3 -3l-3 3"
  }));
}

var _excluded$nJ = ["size", "color", "stroke"];

function IconArrowUpCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 8,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 12,
    y2: 8
  }));
}

var _excluded$nI = ["size", "color", "stroke"];

function IconArrowUpLeftCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-left-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 15
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 9 9 9 9 15"
  }));
}

var _excluded$nH = ["size", "color", "stroke"];

function IconArrowUpLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 17,
    y2: 17
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 7 7 7 7 16"
  }));
}

var _excluded$nG = ["size", "color", "stroke"];

function IconArrowUpRightCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-right-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 9,
    y2: 15
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 15 15 9 9 9"
  }));
}

var _excluded$nF = ["size", "color", "stroke"];

function IconArrowUpRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 7,
    y2: 17
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 7 17 7 17 16"
  }));
}

var _excluded$nE = ["size", "color", "stroke"];

function IconArrowUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 11,
    x2: 12,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 11,
    x2: 12,
    y2: 5
  }));
}

var _excluded$nD = ["size", "color", "stroke"];

function IconArrowWaveLeftDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-wave-left-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13.998h-4v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11.998c-.887 1.284 -2.48 2.033 -4 2c-1.52 .033 -3.113 -.716 -4 -2s-2.48 -2.033 -4 -2c-1.52 -.033 -3 1 -4 2l-2 2"
  }));
}

var _excluded$nC = ["size", "color", "stroke"];

function IconArrowWaveLeftUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-wave-left-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9.996h-4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11.996c-.887 -1.285 -2.48 -2.033 -4 -2c-1.52 -.033 -3.113 .715 -4 2c-.887 1.284 -2.48 2.033 -4 2c-1.52 .033 -3 -1 -4 -2l-2 -2"
  }));
}

var _excluded$nB = ["size", "color", "stroke"];

function IconArrowWaveRightDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-wave-right-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13.998h4v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11.998c.887 1.284 2.48 2.033 4 2c1.52 .033 3.113 -.716 4 -2s2.48 -2.033 4 -2c1.52 -.033 3 1 4 2l2 2"
  }));
}

var _excluded$nA = ["size", "color", "stroke"];

function IconArrowWaveRightUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrow-wave-right-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10h4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12c.887 -1.284 2.48 -2.033 4 -2c1.52 -.033 3.113 .716 4 2s2.48 2.033 4 2c1.52 .033 3 -1 4 -2l2 -2"
  }));
}

var _excluded$nz = ["size", "color", "stroke"];

function IconArrowsCross(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-cross",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9l5 -5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20l5 -5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h4v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4l16 16"
  }));
}

var _excluded$ny = ["size", "color", "stroke"];

function IconArrowsDiagonal2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ny);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-diagonal-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 20 20 20 20 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 4 4 4 4 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 10,
    y2: 10
  }));
}

var _excluded$nx = ["size", "color", "stroke"];

function IconArrowsDiagonalMinimize2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nx);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-diagonal-minimize-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10h-4v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4l-6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14h4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14l-6 6"
  }));
}

var _excluded$nw = ["size", "color", "stroke"];

function IconArrowsDiagonalMinimize(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-diagonal-minimize",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10h4v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4l6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14h-4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14l6 6"
  }));
}

var _excluded$nv = ["size", "color", "stroke"];

function IconArrowsDiagonal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nv);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-diagonal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 4 20 4 20 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 10,
    x2: 20,
    y2: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 20 4 20 4 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 10,
    y2: 14
  }));
}

var _excluded$nu = ["size", "color", "stroke"];

function IconArrowsDoubleNeSw(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nu);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-double-ne-sw",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14l11 -11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3h4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17v4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10l-11 11"
  }));
}

var _excluded$nt = ["size", "color", "stroke"];

function IconArrowsDoubleNwSe(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nt);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-double-nw-se",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 21l-11 -11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14v-4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 14h4v-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 3,
    x2: 21,
    y2: 14
  }));
}

var _excluded$ns = ["size", "color", "stroke"];

function IconArrowsDoubleSeNw(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ns);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-double-se-nw",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 14,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17v4h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3h-4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14l-11 -11"
  }));
}

var _excluded$nr = ["size", "color", "stroke"];

function IconArrowsDoubleSwNe(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nr);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-double-sw-ne",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3l-11 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10v4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10h4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21l11 -11"
  }));
}

var _excluded$nq = ["size", "color", "stroke"];

function IconArrowsDownUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-down-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 3,
    x2: 17,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18l-3 3l-3 -3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 21,
    x2: 7,
    y2: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6l-3 -3l-3 3"
  }));
}

var _excluded$np = ["size", "color", "stroke"];

function IconArrowsDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$np);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 21,
    x2: 7,
    y2: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18l-3 3l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18l3 3l3 -3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 21,
    x2: 17,
    y2: 3
  }));
}

var _excluded$no = ["size", "color", "stroke"];

function IconArrowsHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$no);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 8 3 12 7 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 8 21 12 17 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12
  }));
}

var _excluded$nn = ["size", "color", "stroke"];

function IconArrowsJoin2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nn);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-join-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7h1.948c1.913 0 3.705 .933 4.802 2.5a5.861 5.861 0 0 0 4.802 2.5h6.448"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17h1.95a5.854 5.854 0 0 0 4.798 -2.5a5.854 5.854 0 0 1 4.798 -2.5h5.454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l3 -3l-3 -3"
  }));
}

var _excluded$nm = ["size", "color", "stroke"];

function IconArrowsJoin(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nm);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-join",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7h5l3.5 5h9.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17h5l3.495 -5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l3 -3l-3 -3"
  }));
}

var _excluded$nl = ["size", "color", "stroke"];

function IconArrowsLeftDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nl);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-left-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3l-4 4l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7h11a3 3 0 0 1 3 3v11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17l4 4l4 -4"
  }));
}

var _excluded$nk = ["size", "color", "stroke"];

function IconArrowsLeftRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nk);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-left-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 17,
    x2: 3,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10l-3 -3l3 -3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 7,
    x2: 21,
    y2: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }));
}

var _excluded$nj = ["size", "color", "stroke"];

function IconArrowsLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 7,
    x2: 21,
    y2: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20l-3 -3l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4l-3 3l3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 17,
    x2: 21,
    y2: 17
  }));
}

var _excluded$ni = ["size", "color", "stroke"];

function IconArrowsMaximize(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ni);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-maximize",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 4 20 4 20 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 10,
    x2: 20,
    y2: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 20 4 20 4 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 10,
    y2: 14
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 20 20 20 20 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 4 4 4 4 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 10,
    y2: 10
  }));
}

var _excluded$nh = ["size", "color", "stroke"];

function IconArrowsMinimize(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nh);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-minimize",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5 9 9 9 9 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 9,
    y2: 9
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5 15 9 15 9 19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 9,
    y2: 15
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "19 9 15 9 15 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 21,
    y2: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "19 15 15 15 15 19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 21,
    y2: 21
  }));
}

var _excluded$ng = ["size", "color", "stroke"];

function IconArrowsRightDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ng);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-right-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17l4 4l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21v-11a3 3 0 0 1 3 -3h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11l4 -4l-4 -4"
  }));
}

var _excluded$nf = ["size", "color", "stroke"];

function IconArrowsRightLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nf);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-right-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 7,
    x2: 3,
    y2: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10l3 -3l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20l-3 -3l3 -3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 17,
    x2: 21,
    y2: 17
  }));
}

var _excluded$ne = ["size", "color", "stroke"];

function IconArrowsRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ne);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 17,
    x2: 3,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 7,
    x2: 3,
    y2: 7
  }));
}

var _excluded$nd = ["size", "color", "stroke"];

function IconArrowsShuffle2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nd);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-shuffle-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7h3a5 5 0 0 1 5 5a5 5 0 0 0 5 5h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17h3a5 5 0 0 0 5 -5a5 5 0 0 1 5 -5h5"
  }));
}

var _excluded$nc = ["size", "color", "stroke"];

function IconArrowsShuffle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nc);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-shuffle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7h3a5 5 0 0 1 5 5a5 5 0 0 0 5 5h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 7h-5a4.978 4.978 0 0 0 -2.998 .998m-4.002 8.003a4.984 4.984 0 0 1 -3 .999h-3"
  }));
}

var _excluded$nb = ["size", "color", "stroke"];

function IconArrowsSort(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$nb);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-sort",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9l4 -4l4 4m-4 -4v14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15l-4 4l-4 -4m4 4v-14"
  }));
}

var _excluded$na = ["size", "color", "stroke"];

function IconArrowsSplit2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$na);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-split-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17h-5.397a5 5 0 0 1 -4.096 -2.133l-.514 -.734a5 5 0 0 0 -4.096 -2.133h-3.897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 7h-5.395a5 5 0 0 0 -4.098 2.135l-.51 .73a5 5 0 0 1 -4.097 2.135h-3.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10l3 -3l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }));
}

var _excluded$n9 = ["size", "color", "stroke"];

function IconArrowsSplit(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$n9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-split",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17h-8l-3.5 -5h-6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 7h-8l-3.495 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10l3 -3l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }));
}

var _excluded$n8 = ["size", "color", "stroke"];

function IconArrowsUpDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$n8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-up-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 3,
    x2: 7,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6l-3 -3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18l-3 3l-3 -3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 21,
    x2: 17,
    y2: 3
  }));
}

var _excluded$n7 = ["size", "color", "stroke"];

function IconArrowsUpLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$n7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-up-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 7l-4 -4l-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3v11a3 3 0 0 1 -3 3h-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13l-4 4l4 4"
  }));
}

var _excluded$n6 = ["size", "color", "stroke"];

function IconArrowsUpRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$n6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-up-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21l4 -4l-4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 17h-11a3 3 0 0 1 -3 -3v-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7l-4 -4l-4 4"
  }));
}

var _excluded$n5 = ["size", "color", "stroke"];

function IconArrowsUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$n5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 3,
    x2: 17,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6l3 -3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6l-3 -3l-3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 3,
    x2: 7,
    y2: 21
  }));
}

var _excluded$n4 = ["size", "color", "stroke"];

function IconArrowsVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$n4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-arrows-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 7 12 3 16 7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 17 12 21 16 17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }));
}

var _excluded$n3 = ["size", "color", "stroke"];

function IconArtboard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$n3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-artboard",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 8,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 8,
    x2: 4,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 16,
    x2: 4,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 21,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 21,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 21
  }));
}

var _excluded$n2 = ["size", "color", "stroke"];

function IconAspectRatio(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$n2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-aspect-ratio",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12v-3h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12v3h-3"
  }));
}

var _excluded$n1 = ["size", "color", "stroke"];

function IconAsteriskSimple(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$n1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-asterisk-simple",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l-9 -2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l9 -2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l6 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l-6 8.5"
  }));
}

var _excluded$n0 = ["size", "color", "stroke"];

function IconAsterisk(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$n0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-asterisk",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l8 -4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l-8 -4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l8 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l-8 4.5"
  }));
}

var _excluded$m$ = ["size", "color", "stroke"];

function IconAt(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$m$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-at",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12v1.5a2.5 2.5 0 0 0 5 0v-1.5a9 9 0 1 0 -5.5 8.28"
  }));
}

var _excluded$m_ = ["size", "color", "stroke"];

function IconAtom2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$m_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-atom-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 21.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 9,
    x2: 3,
    y2: 9.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 9,
    x2: 21,
    y2: 9.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20.1a9 9 0 0 1 -5 -7.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.1a9 9 0 0 0 5 -7.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2 5a9 9 0 0 1 11.4 0"
  }));
}

var _excluded$mZ = ["size", "color", "stroke"];

function IconAtom(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-atom",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a4 10 0 0 0 -4 10a4 10 0 0 0 4 10a4 10 0 0 0 4 -10a4 10 0 0 0 -4 -10",
    transform: "rotate(45 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a4 10 0 0 0 -4 10a4 10 0 0 0 4 10a4 10 0 0 0 4 -10a4 10 0 0 0 -4 -10",
    transform: "rotate(-45 12 12)"
  }));
}

var _excluded$mY = ["size", "color", "stroke"];

function IconAugmentedReality(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-augmented-reality",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5l4 -2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10l4 2.5v4.5l4 -2.5v-4.5l-4 -2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10v4.5l4 2.5"
  }));
}

var _excluded$mX = ["size", "color", "stroke"];

function IconAward(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-award",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 14.2 9 21 12 19 15 21 15 14.2",
    transform: "rotate(-30 12 9)"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 14.2 9 21 12 19 15 21 15 14.2",
    transform: "rotate(30 12 9)"
  }));
}

var _excluded$mW = ["size", "color", "stroke"];

function IconAxe(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-axe",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66 15.66l-3.32 -3.32a1.25 1.25 0 0 1 .42 -2.044l3.24 -1.296l6 -6l3 3l-6 6l-1.296 3.24a1.25 1.25 0 0 1 -2.044 .42z"
  }));
}

var _excluded$mV = ["size", "color", "stroke"];

function IconAxisX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-axis-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 9v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20l3 -3l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17h16"
  }));
}

var _excluded$mU = ["size", "color", "stroke"];

function IconAxisY(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-axis-y",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 20h-.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20h-.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 20h-.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7l3 -3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20v-16"
  }));
}

var _excluded$mT = ["size", "color", "stroke"];

function IconBabyCarriage(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-baby-carriage",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5h2.5l1.632 4.897a6 6 0 0 0 5.693 4.103h2.675a5.5 5.5 0 0 0 0 -11h-.5v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17l1 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14l1 3"
  }));
}

var _excluded$mS = ["size", "color", "stroke"];

function IconBackhoe(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-backhoe",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 19,
    x2: 4,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 13,
    y2: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12v-5h2a3 3 0 0 1 3 3v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15v-2a1 1 0 0 1 1 -1h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.12 9.88l-3.12 -4.88l-5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.12 9.88a3 3 0 0 1 -2.12 5.12a3 3 0 0 1 -2.12 -.88l4.24 -4.24z"
  }));
}

var _excluded$mR = ["size", "color", "stroke"];

function IconBackpack(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-backpack",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7h2a6 6 0 0 1 6 6v6a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-6a6 6 0 0 1 6 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7v-1a2 2 0 1 1 4 0v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15h4"
  }));
}

var _excluded$mQ = ["size", "color", "stroke"];

function IconBackspace(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-backspace",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-11l-5 -5a1.5 1.5 0 0 1 0 -2l5 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10l4 4m0 -4l-4 4"
  }));
}

var _excluded$mP = ["size", "color", "stroke"];

function IconBadge(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badge",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v-13l-5 3l-5 -3v13l5 3z"
  }));
}

var _excluded$mO = ["size", "color", "stroke"];

function IconBadges(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-badges",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v-4l-5 3l-5 -3v4l5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8v-4l-5 3l-5 -3v4l5 3z"
  }));
}

var _excluded$mN = ["size", "color", "stroke"];

function IconBallAmericanFootball(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-american-football",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 9,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 12,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 14,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 21a5 5 0 0 0 -5 -5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3c-7.18 0 -13 5.82 -13 13a5 5 0 0 0 5 5c7.18 0 13 -5.82 13 -13a5 5 0 0 0 -5 -5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3a5 5 0 0 0 5 5"
  }));
}

var _excluded$mM = ["size", "color", "stroke"];

function IconBallBaseball(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-baseball",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.636 18.364a9 9 0 1 0 12.728 -12.728a9 9 0 0 0 -12.728 12.728z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.495 3.02a9 9 0 0 1 -9.475 9.475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.98 11.505a9 9 0 0 0 -9.475 9.475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9l2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13l2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7l2 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11l1 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11l1 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16l2 1"
  }));
}

var _excluded$mL = ["size", "color", "stroke"];

function IconBallBasketball(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-basketball",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.65,
    y1: 5.65,
    x2: 18.35,
    y2: 18.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.65,
    y1: 18.35,
    x2: 18.35,
    y2: 5.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 0 0 9 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12a9 9 0 0 1 9 9"
  }));
}

var _excluded$mK = ["size", "color", "stroke"];

function IconBallBowling(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-bowling",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 9,
    x2: 11,
    y2: 9.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 15,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 14,
    y2: 12.01
  }));
}

var _excluded$mJ = ["size", "color", "stroke"];

function IconBallFootballOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-football-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.041 16.046a9 9 0 0 0 -12.084 -12.09m-2.323 1.683a9 9 0 0 0 12.726 12.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7l4.755 3.455l-.566 1.743l-.98 3.014l-.209 .788h-6l-1.755 -5.545l1.86 -1.351l2.313 -1.681z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 17.5,
    y2: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.755 10.455l3.745 -1.455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.061 16.045l-2.561 2.955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.245 10.455l-3.745 -1.455"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$mI = ["size", "color", "stroke"];

function IconBallFootball(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-football",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7l4.76 3.45l-1.76 5.55h-6l-1.76 -5.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m3 13l2.5 3m-.74 -8.55l3.74 -1.45m-11.44 7.05l-2.56 2.95m.74 -8.55l-3.74 -1.45"
  }));
}

var _excluded$mH = ["size", "color", "stroke"];

function IconBallTennis(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-tennis",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5.3a9 9 0 0 1 0 13.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5.3a9 9 0 0 0 0 13.4"
  }));
}

var _excluded$mG = ["size", "color", "stroke"];

function IconBallVolleyball(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ball-volleyball",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12a8 8 0 0 0 8 4m-12.5 -2.5a12 12 0 0 0 8.5 6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12a8 8 0 0 0 8 4m-12.5 -2.5a12 12 0 0 0 8.5 6.5",
    transform: "rotate(120 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12a8 8 0 0 0 8 4m-12.5 -2.5a12 12 0 0 0 8.5 6.5",
    transform: "rotate(240 12 12)"
  }));
}

var _excluded$mF = ["size", "color", "stroke"];

function IconBallon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ballon",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8a2 2 0 0 0 -2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8a6 6 0 1 1 12 0c0 4.97 -2.686 9 -6 9s-6 -4.03 -6 -9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17v1a2 2 0 0 1 -2 2h-3a2 2 0 0 0 -2 2"
  }));
}

var _excluded$mE = ["size", "color", "stroke"];

function IconBallpen(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ballpen",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6l7 7l-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.828 18.172a2.828 2.828 0 0 0 4 0l10.586 -10.586a2 2 0 0 0 0 -2.829l-1.171 -1.171a2 2 0 0 0 -2.829 0l-10.586 10.586a2.828 2.828 0 0 0 0 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20l1.768 -1.768"
  }));
}

var _excluded$mD = ["size", "color", "stroke"];

function IconBan(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ban",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.7,
    y1: 5.7,
    x2: 18.3,
    y2: 18.3
  }));
}

var _excluded$mC = ["size", "color", "stroke"];

function IconBandage(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bandage",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 14,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 10,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 12,
    y2: 10.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 14.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7"
  }));
}

var _excluded$mB = ["size", "color", "stroke"];

function IconBarbell(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-barbell",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-10a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-10a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12h-1"
  }));
}

var _excluded$mA = ["size", "color", "stroke"];

function IconBarcode(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-barcode",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7v-1a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17v1a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 10,
    y2: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 1,
    height: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 11,
    x2: 19,
    y2: 13
  }));
}

var _excluded$mz = ["size", "color", "stroke"];

function IconBarell(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-barell",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.222 4h11.556c1.481 2.37 2.222 5.037 2.222 8s-.74 5.63 -2.222 8h-11.556c-1.481 -2.37 -2.222 -5.037 -2.222 -8s.74 -5.63 2.222 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4c.667 2.667 1 5.333 1 8s-.333 5.333 -1 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4c-.667 2.667 -1 5.333 -1 8s.333 5.333 1 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16h15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8h-15"
  }));
}

var _excluded$my = ["size", "color", "stroke"];

function IconBarrierBlock(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$my);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-barrier-block",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 16,
    height: 9,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 16v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16l9 -9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16l6.5 -6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13.5l6.5 -6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 20h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 7v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7v-2"
  }));
}

var _excluded$mx = ["size", "color", "stroke"];

function IconBaseline(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mx);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-baseline",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16v-8a4 4 0 1 1 8 0v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10h8"
  }));
}

var _excluded$mw = ["size", "color", "stroke"];

function IconBasket(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-basket",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 10 12 4 17 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10l-2 8a2 2.5 0 0 1 -2 2h-10a2 2.5 0 0 1 -2 -2l-2 -8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 2
  }));
}

var _excluded$mv = ["size", "color", "stroke"];

function IconBath(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mv);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bath",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h16a1 1 0 0 1 1 1v3a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4v-3a1 1 0 0 1 1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12v-7a2 2 0 0 1 2 -2h3v2.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21l1 -1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 21l-1 -1.5"
  }));
}

var _excluded$mu = ["size", "color", "stroke"];

function IconBattery1(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mu);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-1",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 7,
    y2: 14
  }));
}

var _excluded$mt = ["size", "color", "stroke"];

function IconBattery2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mt);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 7,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10,
    y2: 14
  }));
}

var _excluded$ms = ["size", "color", "stroke"];

function IconBattery3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ms);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 7,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 10,
    x2: 13,
    y2: 14
  }));
}

var _excluded$mr = ["size", "color", "stroke"];

function IconBattery4(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mr);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-4",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 7,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 10,
    x2: 13,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 10,
    x2: 16,
    y2: 14
  }));
}

var _excluded$mq = ["size", "color", "stroke"];

function IconBatteryAutomotive(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-automotive",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 18,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6v-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 4,
    x2: 19,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 13,
    x2: 9.5,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 13,
    x2: 17.5,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 11.5,
    x2: 16,
    y2: 14.5
  }));
}

var _excluded$mp = ["size", "color", "stroke"];

function IconBatteryCharging2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mp);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-charging-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 9a2 2 0 0 1 2 -2h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 15h6v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 22v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15v-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15v-2.5"
  }));
}

var _excluded$mo = ["size", "color", "stroke"];

function IconBatteryCharging(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mo);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-charging",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7h1a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7h-2a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8l-2 4h3l-2 4"
  }));
}

var _excluded$mn = ["size", "color", "stroke"];

function IconBatteryEco(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mn);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-eco",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 9a2 2 0 0 1 2 -2h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16.143c0 -2.84 2.09 -5.143 4.667 -5.143h2.333v.857c0 2.84 -2.09 5.143 -4.667 5.143h-2.333v-.857z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 20v-3"
  }));
}

var _excluded$mm = ["size", "color", "stroke"];

function IconBatteryOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mm);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7h6a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5m-2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h1"
  }));
}

var _excluded$ml = ["size", "color", "stroke"];

function IconBattery(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ml);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-battery",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
  }));
}

var _excluded$mk = ["size", "color", "stroke"];

function IconBeach(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mk);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-beach",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.553 16.75a7.5 7.5 0 0 0 -10.606 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 3.804a6 6 0 0 0 -8.196 2.196l10.392 6a6 6 0 0 0 -2.196 -8.196z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.732 10c1.658 -2.87 2.225 -5.644 1.268 -6.196c-.957 -.552 -3.075 1.326 -4.732 4.196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9l-3 5.196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19.25a2.4 2.4 0 0 1 1 -.25a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 1 .25"
  }));
}

var _excluded$mj = ["size", "color", "stroke"];

function IconBed(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bed",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7v11m0 -4h18m0 4v-8a2 2 0 0 0 -2 -2h-8v6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 10,
    r: 1
  }));
}

var _excluded$mi = ["size", "color", "stroke"];

function IconBeer(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mi);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-beer",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20h6v-4.111a8 8 0 0 1 .845 -3.578l.31 -.622a8 8 0 0 0 .845 -3.578v-4.111h-10v4.111a8 8 0 0 0 .845 3.578l.31 .622a8 8 0 0 1 .845 3.578v4.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8h10"
  }));
}

var _excluded$mh = ["size", "color", "stroke"];

function IconBellMinus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mh);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-minus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 14,
    y2: 11
  }));
}

var _excluded$mg = ["size", "color", "stroke"];

function IconBellOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mg);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17h-13a4 4 0 0 0 2 -3v-3a7 7 0 0 1 1.279 -3.716m2.072 -1.934c.209 -.127 .425 -.244 .649 -.35a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }));
}

var _excluded$mf = ["size", "color", "stroke"];

function IconBellPlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mf);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 14,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 13
  }));
}

var _excluded$me = ["size", "color", "stroke"];

function IconBellRinging2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$me);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-ringing-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.364 4.636a2 2 0 0 1 0 2.828a7 7 0 0 1 -1.414 7.072l-2.122 2.12a4 4 0 0 0 -.707 3.536l-11.313 -11.312a4 4 0 0 0 3.535 -.707l2.121 -2.123a7 7 0 0 1 7.072 -1.414a2 2 0 0 1 2.828 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.343 12.414l-.707 .707a3 3 0 0 0 4.243 4.243l.707 -.707"
  }));
}

var _excluded$md = ["size", "color", "stroke"];

function IconBellRinging(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$md);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-ringing",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6.727a11.05 11.05 0 0 0 -2.794 -3.727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.727a11.05 11.05 0 0 1 2.792 -3.727"
  }));
}

var _excluded$mc = ["size", "color", "stroke"];

function IconBellSchool(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mc);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-school",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15h.5a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-1a2 2 0 0 1 2 -2h.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17a5.698 5.698 0 0 0 4.467 -7.932l-.467 -1.068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10v.01"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 8,
    r: 1
  }));
}

var _excluded$mb = ["size", "color", "stroke"];

function IconBellX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$mb);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.5l3 3m0 -3l-3 3"
  }));
}

var _excluded$ma = ["size", "color", "stroke"];

function IconBellZ(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ma);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell-z",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9h4l-4 4h4"
  }));
}

var _excluded$m9 = ["size", "color", "stroke"];

function IconBell(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$m9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bell",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17v1a3 3 0 0 0 6 0v-1"
  }));
}

var _excluded$m8 = ["size", "color", "stroke"];

function IconBible(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$m8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bible",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16h-12a2 2 0 0 0 -2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9h4"
  }));
}

var _excluded$m7 = ["size", "color", "stroke"];

function IconBike(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$m7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bike",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 19 12 15 9 12 14 8 16 11 19 11"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 5,
    r: 1
  }));
}

var _excluded$m6 = ["size", "color", "stroke"];

function IconBinary(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$m6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-binary",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10v-5h-1m8 14v-5h-1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 3,
    height: 5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 3,
    height: 5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10h.01m-.01 9h.01"
  }));
}

var _excluded$m5 = ["size", "color", "stroke"];

function IconBiohazard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$m5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-biohazard",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.939 14c0 .173 .048 .351 .056 .533l0 .217a4.75 4.75 0 0 1 -4.533 4.745l-.217 0m-4.75 -4.75a4.75 4.75 0 0 1 7.737 -3.693m6.513 8.443a4.75 4.75 0 0 1 -4.69 -5.503l-.06 0m1.764 -2.944a4.75 4.75 0 0 1 7.731 3.477l0 .217m-11.195 -3.813a4.75 4.75 0 0 1 -1.828 -7.624l.164 -.172m6.718 0a4.75 4.75 0 0 1 -1.665 7.798"
  }));
}

var _excluded$m4 = ["size", "color", "stroke"];

function IconBlockquote(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$m4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-blockquote",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15h15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 19h-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 7h-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"
  }));
}

var _excluded$m3 = ["size", "color", "stroke"];

function IconBluetoothConnected(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$m3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bluetooth-connected",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 8 17 16 12 20 12 4 17 8 7 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 5,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 19,
    y2: 12
  }));
}

var _excluded$m2 = ["size", "color", "stroke"];

function IconBluetoothOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$m2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bluetooth-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.438 16.45l-4.438 3.55v-8m0 -4v-4l5 4l-2.776 2.22m-2.222 1.779l-5 4"
  }));
}

var _excluded$m1 = ["size", "color", "stroke"];

function IconBluetoothX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$m1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bluetooth-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8l10 8l-5 4v-16l1.003 .802m0 6.396l-6.003 4.802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6l-4 4"
  }));
}

var _excluded$m0 = ["size", "color", "stroke"];

function IconBluetooth(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$m0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bluetooth",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 8 17 16 12 20 12 4 17 8 7 16"
  }));
}

var _excluded$l$ = ["size", "color", "stroke"];

function IconBlur(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$l$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-blur",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21a9.01 9.01 0 0 0 2.32 -.302a9.004 9.004 0 0 0 1.74 -16.733a9 9 0 1 0 -4.06 17.035z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15h8"
  }));
}

var _excluded$l_ = ["size", "color", "stroke"];

function IconBold(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$l_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bold",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5h6a3.5 3.5 0 0 1 0 7h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7"
  }));
}

var _excluded$lZ = ["size", "color", "stroke"];

function IconBoltOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bolt-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.212 15.21l-4.212 5.79v-7h-6l3.79 -5.21m1.685 -2.32l2.525 -3.47v6m1 1h5l-2.104 2.893"
  }));
}

var _excluded$lY = ["size", "color", "stroke"];

function IconBolt(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bolt",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "13 3 13 10 19 10 11 21 11 14 5 14 13 3"
  }));
}

var _excluded$lX = ["size", "color", "stroke"];

function IconBone(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bone",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3a3 3 0 0 1 3 3a3 3 0 1 1 -2.12 5.122l-4.758 4.758a3 3 0 1 1 -5.117 2.297l-.005 -.177l-.176 -.005a3 3 0 1 1 2.298 -5.115l4.758 -4.758a3 3 0 0 1 2.12 -5.122z"
  }));
}

var _excluded$lW = ["size", "color", "stroke"];

function IconBook2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-book-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16h-12a2 2 0 0 0 -2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8h6"
  }));
}

var _excluded$lV = ["size", "color", "stroke"];

function IconBookDownload(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-book-download",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16h-7a2 2 0 0 0 -2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19l3 3l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 22v-9"
  }));
}

var _excluded$lU = ["size", "color", "stroke"];

function IconBookUpload(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-book-upload",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16h-5a2 2 0 0 0 -2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16l3 -3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13v9"
  }));
}

var _excluded$lT = ["size", "color", "stroke"];

function IconBook(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-book",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 3,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 6,
    x2: 21,
    y2: 19
  }));
}

var _excluded$lS = ["size", "color", "stroke"];

function IconBookmarkOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bookmark-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v3l-5 -3l-5 3v-13m1.178 -2.818c.252 -.113 .53 -.176 .822 -.176h6a2 2 0 0 1 2 2v7"
  }));
}

var _excluded$lR = ["size", "color", "stroke"];

function IconBookmark(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bookmark",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4h6a2 2 0 0 1 2 2v14l-5 -3l-5 3v-14a2 2 0 0 1 2 -2"
  }));
}

var _excluded$lQ = ["size", "color", "stroke"];

function IconBookmarks(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bookmarks",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7a2 2 0 0 1 2 2v12l-5 -3l-5 3v-12a2 2 0 0 1 2 -2h6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.265 4a2 2 0 0 1 1.735 -1h6a2 2 0 0 1 2 2v12l-1 -.6"
  }));
}

var _excluded$lP = ["size", "color", "stroke"];

function IconBooks(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-books",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 4,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 4,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16h4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-13 27.054 -55.827)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12h4"
  })));
}

var _excluded$lO = ["size", "color", "stroke"];

function IconBorderAll(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-all",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }));
}

var _excluded$lN = ["size", "color", "stroke"];

function IconBorderBottom(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-bottom",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 4,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 4,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }));
}

var _excluded$lM = ["size", "color", "stroke"];

function IconBorderHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}

var _excluded$lL = ["size", "color", "stroke"];

function IconBorderInner(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-inner",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}

var _excluded$lK = ["size", "color", "stroke"];

function IconBorderLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}

var _excluded$lJ = ["size", "color", "stroke"];

function IconBorderNone(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-none",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 4,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}

var _excluded$lI = ["size", "color", "stroke"];

function IconBorderOuter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-outer",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }));
}

var _excluded$lH = ["size", "color", "stroke"];

function IconBorderRadius(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-radius",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v-4a4 4 0 0 1 4 -4h4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}

var _excluded$lG = ["size", "color", "stroke"];

function IconBorderRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 4,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }));
}

var _excluded$lF = ["size", "color", "stroke"];

function IconBorderStyle2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-style-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6h16"
  }));
}

var _excluded$lE = ["size", "color", "stroke"];

function IconBorderStyle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-style",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20v-14a2 2 0 0 1 2 -2h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20v.01"
  }));
}

var _excluded$lD = ["size", "color", "stroke"];

function IconBorderTop(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-top",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 20,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 4,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}

var _excluded$lC = ["size", "color", "stroke"];

function IconBorderVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-border-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 4,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 16,
    x2: 20,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 4,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 20,
    y2: 20.01
  }));
}

var _excluded$lB = ["size", "color", "stroke"];

function IconBottle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bottle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5h4v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3.5c0 1.626 .507 3.212 1.45 4.537l.05 .07a8.093 8.093 0 0 1 1.5 4.694v6.199a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-6.2c0 -1.682 .524 -3.322 1.5 -4.693l.05 -.07a7.823 7.823 0 0 0 1.45 -4.537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.003 14.803a2.4 2.4 0 0 0 .997 -.803a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 1 -.805"
  }));
}

var _excluded$lA = ["size", "color", "stroke"];

function IconBoxMargin(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-margin",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h8v8h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v.01"
  }));
}

var _excluded$lz = ["size", "color", "stroke"];

function IconBoxModel2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-model-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h8v8h-8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$ly = ["size", "color", "stroke"];

function IconBoxModel(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ly);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-model",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h8v8h-8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16l3.3 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8l3.3 -3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8l-3.3 -3.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16l-3.3 3.3"
  }));
}

var _excluded$lx = ["size", "color", "stroke"];

function IconBoxMultiple0(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lx);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-0",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}

var _excluded$lw = ["size", "color", "stroke"];

function IconBoxMultiple1(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-1",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14v-8l-2 2"
  }));
}

var _excluded$lv = ["size", "color", "stroke"];

function IconBoxMultiple2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lv);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
  }));
}

var _excluded$lu = ["size", "color", "stroke"];

function IconBoxMultiple3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lu);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10a2 2 0 1 0 -2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12a2 2 0 1 0 2 -2"
  }));
}

var _excluded$lt = ["size", "color", "stroke"];

function IconBoxMultiple4(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lt);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-4",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14v-8l-4 6h5"
  }));
}

var _excluded$ls = ["size", "color", "stroke"];

function IconBoxMultiple5(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ls);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-5",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14h2a2 2 0 1 0 0 -4h-2v-4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}

var _excluded$lr = ["size", "color", "stroke"];

function IconBoxMultiple6(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lr);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-6",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8a2 2 0 1 0 -4 0v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}

var _excluded$lq = ["size", "color", "stroke"];

function IconBoxMultiple7(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-7",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6h4l-2 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}

var _excluded$lp = ["size", "color", "stroke"];

function IconBoxMultiple8(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lp);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-8",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}

var _excluded$lo = ["size", "color", "stroke"];

function IconBoxMultiple9(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lo);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple-9",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12a2 2 0 1 0 4 0v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}

var _excluded$ln = ["size", "color", "stroke"];

function IconBoxMultiple(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ln);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-multiple",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}

var _excluded$lm = ["size", "color", "stroke"];

function IconBoxPadding(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lm);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box-padding",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16v.01"
  }));
}

var _excluded$ll = ["size", "color", "stroke"];

function IconBox(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ll);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-box",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 20,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 4,
    y2: 7.5
  }));
}

var _excluded$lk = ["size", "color", "stroke"];

function IconBraces(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lk);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-braces",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4a2 2 0 0 0 -2 2v3a2 3 0 0 1 -2 3a2 3 0 0 1 2 3v3a2 2 0 0 0 2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4a2 2 0 0 1 2 2v3a2 3 0 0 0 2 3a2 3 0 0 0 -2 3v3a2 2 0 0 1 -2 2"
  }));
}

var _excluded$lj = ["size", "color", "stroke"];

function IconBrackets(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brackets",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4h-3v16h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h3v16h-3"
  }));
}

var _excluded$li = ["size", "color", "stroke"];

function IconBrandAirbnb(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$li);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-airbnb",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10c-2 0 -3 1 -3 3c0 1.5 1.494 3.535 3 5.5c1 1 1.5 1.5 2.5 2s2.5 1 4.5 -.5s1.5 -3.5 .5 -6s-2.333 -5.5 -5 -9.5c-.834 -1 -1.5 -1.5 -2.503 -1.5c-1 0 -1.623 .45 -2.497 1.5c-2.667 4 -4 7 -5 9.5s-1.5 4.5 .5 6s3.5 1 4.5 .5s1.5 -1 2.5 -2c1.506 -1.965 3 -4 3 -5.5c0 -2 -1 -3 -3 -3z"
  }));
}

var _excluded$lh = ["size", "color", "stroke"];

function IconBrandAirtable(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lh);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-airtable",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10v8l7 -3v-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6l9 3l9 -3l-9 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12.3v8.7l7 -3v-8z"
  }));
}

var _excluded$lg = ["size", "color", "stroke"];

function IconBrandAndroid(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lg);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-android",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 10,
    x2: 4,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 10,
    x2: 20,
    y2: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9h10v8a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-8a5 5 0 0 1 10 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 9,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 15,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 18,
    x2: 9,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 18,
    x2: 15,
    y2: 21
  }));
}

var _excluded$lf = ["size", "color", "stroke"];

function IconBrandAngular(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lf);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-angular",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.428 17.245l6.076 3.471a1 1 0 0 0 .992 0l6.076 -3.471a1 1 0 0 0 .495 -.734l1.323 -9.704a1 1 0 0 0 -.658 -1.078l-7.4 -2.612a1 1 0 0 0 -.665 0l-7.399 2.613a1 1 0 0 0 -.658 1.078l1.323 9.704a1 1 0 0 0 .495 .734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15l3 -8l3 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13h4"
  }));
}

var _excluded$le = ["size", "color", "stroke"];

function IconBrandAppleArcade(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$le);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-apple-arcade",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5v4.75a0.734 .734 0 0 1 -.055 .325a0.704 .704 0 0 1 -.348 .366l-5.462 2.58a4.998 4.998 0 0 1 -4.27 0l-5.462 -2.58a0.705 .705 0 0 1 -.401 -.691l-.002 -4.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.431 12.216l5.634 -2.332a5.065 5.065 0 0 1 3.87 0l5.634 2.332a0.692 .692 0 0 1 .028 1.269l-5.462 2.543a5.064 5.064 0 0 1 -4.27 0l-5.462 -2.543a0.691 .691 0 0 1 .028 -1.27z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 13
  }));
}

var _excluded$ld = ["size", "color", "stroke"];

function IconBrandApple(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ld);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-apple",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7c-3 0 -4 3 -4 5.5c0 3 2 7.5 4 7.5c1.088 -.046 1.679 -.5 3 -.5c1.312 0 1.5 .5 3 .5s4 -3 4 -5c-.028 -.01 -2.472 -.403 -2.5 -3c-.019 -2.17 2.416 -2.954 2.5 -3c-1.023 -1.492 -2.951 -1.963 -3.5 -2c-1.433 -.111 -2.83 1 -3.5 1c-.68 0 -1.9 -1 -3 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4a2 2 0 0 0 2 -2a2 2 0 0 0 -2 2"
  }));
}

var _excluded$lc = ["size", "color", "stroke"];

function IconBrandAppstore(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lc);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-appstore",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16l1.106 -1.99m1.4 -2.522l2.494 -4.488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14h5m2.9 0h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16l-2.51 -4.518m-1.487 -2.677l-1.003 -1.805"
  }));
}

var _excluded$lb = ["size", "color", "stroke"];

function IconBrandAsana(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$lb);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-asana",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 16,
    r: 3
  }));
}

var _excluded$la = ["size", "color", "stroke"];

function IconBrandBehance(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$la);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-behance",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18v-12h4.5a3 3 0 0 1 0 6a3 3 0 0 1 0 6h-4.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 7.5,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13h7a3.5 3.5 0 0 0 -7 0v2a3.5 3.5 0 0 0 6.64 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 6,
    x2: 19,
    y2: 6
  }));
}

var _excluded$l9 = ["size", "color", "stroke"];

function IconBrandBing(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$l9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-bing",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3l4 1.5v12l6 -2.5l-2 -1l-1 -4l7 2.5v4.5l-10 5l-4 -2z"
  }));
}

var _excluded$l8 = ["size", "color", "stroke"];

function IconBrandBitbucket(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$l8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-bitbucket",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.648 4a0.64 .64 0 0 0 -.64 .744l3.14 14.528c.07 .417 .43 .724 .852 .728h10a0.644 .644 0 0 0 .642 -.539l3.35 -14.71a0.641 .641 0 0 0 -.64 -.744l-16.704 -.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15h-4l-1 -6h6z"
  }));
}

var _excluded$l7 = ["size", "color", "stroke"];

function IconBrandBooking(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$l7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-booking",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18v-9.5a4.5 4.5 0 0 1 4.5 -4.5h7a4.5 4.5 0 0 1 4.5 4.5v7a4.5 4.5 0 0 1 -4.5 4.5h-9.5a2 2 0 0 1 -2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12h3.5a2 2 0 1 1 0 4h-3.5v-7a1 1 0 0 1 1 -1h1.5a2 2 0 1 1 0 4h-1.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 16.01,
    y2: 16
  }));
}

var _excluded$l6 = ["size", "color", "stroke"];

function IconBrandBootstrap(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$l6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-bootstrap",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12a2 2 0 0 0 2 -2v-4a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-4a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16v-8h3.5a2 2 0 1 1 0 4h-3.5h4a2 2 0 1 1 0 4h-4z"
  }));
}

var _excluded$l5 = ["size", "color", "stroke"];

function IconBrandChrome(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$l5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-chrome",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 20.4,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 20.4,
    y2: 9,
    transform: "rotate(120 12 12)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 20.4,
    y2: 9,
    transform: "rotate(240 12 12)"
  }));
}

var _excluded$l4 = ["size", "color", "stroke"];

function IconBrandCodepen(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$l4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-codepen",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 15l9 6l9 -6l-9 -6l-9 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9l9 6l9 -6l-9 -6l-9 6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 9,
    x2: 3,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 9,
    x2: 21,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 21
  }));
}

var _excluded$l3 = ["size", "color", "stroke"];

function IconBrandCodesandbox(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$l3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-codesandbox",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 7.5v9l-4 2.25l-4 2.25l-4 -2.25l-4 -2.25v-9l4 -2.25l4 -2.25l4 2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l4 -2.25l4 -2.25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l-4 -2.25l-4 -2.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12l-4 2v4.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12l4 2l0 4.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.25l4 2.25l4 -2.25"
  }));
}

var _excluded$l2 = ["size", "color", "stroke"];

function IconBrandCss3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$l2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-css3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8h7l-4.5 4h4l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5"
  }));
}

var _excluded$l1 = ["size", "color", "stroke"];

function IconBrandCucumber(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$l1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-cucumber",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.99c-.01 5.52 -4.48 10 -10 10.01v-2.26l-.01 -.01c-4.28 -1.11 -6.86 -5.47 -5.76 -9.75a8.001 8.001 0 0 1 9.74 -5.76c3.53 .91 6.03 4.13 6.03 7.78v-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8l-.5 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14l.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5l-1 .5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14l-.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8l.5 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12.5l-1 -.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10l-1 -.5"
  }));
}

var _excluded$l0 = ["size", "color", "stroke"];

function IconBrandDebian(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$l0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-debian",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17c-2.397 -.943 -4 -3.153 -4 -5.635c0 -2.19 1.039 -3.14 1.604 -3.595c2.646 -2.133 6.396 -.27 6.396 3.23c0 2.5 -2.905 2.121 -3.5 1.5c-.595 -.621 -1 -1.5 -.5 -2.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$k$ = ["size", "color", "stroke"];

function IconBrandDeviantart(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$k$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-deviantart",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 3v4l-3.857 6h3.857v4h-6.429l-2.571 4h-3v-4l3.857 -6h-3.857v-4h6.429l2.571 -4z"
  }));
}

var _excluded$k_ = ["size", "color", "stroke"];

function IconBrandDiscord(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$k_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-discord",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5c3.5 -1 5.5 -1 9 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5c3.5 1 6.5 1 10 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17c0 1 1.5 3 2 3c1.5 0 2.833 -1.667 3.5 -3c.667 -1.667 .5 -5.833 -1.5 -11.5c-1.457 -1.015 -3 -1.34 -4.5 -1.5l-1 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17c0 1 -1.356 3 -1.832 3c-1.429 0 -2.698 -1.667 -3.333 -3c-.635 -1.667 -.476 -5.833 1.428 -11.5c1.388 -1.015 2.782 -1.34 4.237 -1.5l1 2.5"
  }));
}

var _excluded$kZ = ["size", "color", "stroke"];

function IconBrandDisqus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-disqus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.847 21c-2.259 0 -4.323 -.667 -5.919 -2h-3.928l1.708 -3.266c-.545 -1.174 -.759 -2.446 -.758 -3.734c0 -4.97 3.84 -9 8.898 -9c5.052 0 9.152 4.03 9.152 9c0 4.972 -4.098 9 -9.153 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.485 15h-1.485v-6h1.485c2.112 0 3.515 .823 3.515 2.981v.035c0 2.18 -1.403 2.984 -3.515 2.984z"
  }));
}

var _excluded$kY = ["size", "color", "stroke"];

function IconBrandDocker(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-docker",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12.54c-1.804 -.345 -2.701 -1.08 -3.523 -2.94c-.487 .696 -1.102 1.568 -.92 2.4c.028 .238 -.32 1.002 -.557 1h-14c0 5.208 3.164 7 6.196 7c4.124 .022 7.828 -1.376 9.854 -5c1.146 -.101 2.296 -1.505 2.95 -2.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.571 18c1.5 0 2.047 -.074 2.958 -.78"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 10,
    y2: 16.01
  }));
}

var _excluded$kX = ["size", "color", "stroke"];

function IconBrandDoctrine(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-doctrine",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3l6.9 6"
  }));
}

var _excluded$kW = ["size", "color", "stroke"];

function IconBrandDribbble(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-dribbble",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3.6c5 6 7 10.5 7.5 16.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4 19c3.5 -3.5 6 -6.5 14.5 -6.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1 10.75c5 0 9.814 -.38 15.314 -5"
  }));
}

var _excluded$kV = ["size", "color", "stroke"];

function IconBrandEdge(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-edge",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.978 11.372a9 9 0 1 0 -1.593 5.773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.978 11.372c.21 2.993 -5.034 2.413 -6.913 1.486c1.392 -1.6 .402 -4.038 -2.274 -3.851c-1.745 .122 -2.927 1.157 -2.784 3.202c.28 3.99 4.444 6.205 10.36 4.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.022 12.628c-.283 -4.043 8.717 -7.228 11.248 -2.688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.628 20.978c-2.993 .21 -5.162 -4.725 -3.567 -9.748"
  }));
}

var _excluded$kU = ["size", "color", "stroke"];

function IconBrandFacebook(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-facebook",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3"
  }));
}

var _excluded$kT = ["size", "color", "stroke"];

function IconBrandFigma(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-figma",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 12,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9a3 3 0 0 0 0 6h3m-3 0a3 3 0 1 0 3 3v-15"
  }));
}

var _excluded$kS = ["size", "color", "stroke"];

function IconBrandFirebase(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-firebase",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.53 17.05l6.15 -11.72h-.02c.38 -.74 1.28 -1.02 2.01 -.63c.26 .14 .48 .36 .62 .62l1.06 2.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.47 6.45c.58 -.59 1.53 -.59 2.11 -.01c.22 .22 .36 .5 .41 .81l1.5 9.11c.1 .62 -.2 1.24 -.76 1.54l-6.07 2.9c-.46 .25 -1.01 .26 -1.46 0l-6.02 -2.92c-.55 -.31 -.85 -.92 -.75 -1.54l1.96 -12.04c.12 -.82 .89 -1.38 1.7 -1.25c.46 .07 .87 .36 1.09 .77l1.24 1.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57 17.18l10.93 -10.68"
  }));
}

var _excluded$kR = ["size", "color", "stroke"];

function IconBrandFirefox(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-firefox",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.028 7.82a9 9 0 1 0 12.823 -3.4c-1.636 -1.02 -3.064 -1.02 -4.851 -1.02h-1.647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.914 9.485c-1.756 -1.569 -.805 -5.38 .109 -6.17c.086 .896 .585 1.208 1.111 1.685c.88 -.275 1.313 -.282 1.867 0c.82 -.91 1.694 -2.354 2.628 -2.093c-1.082 1.741 -.07 3.733 1.371 4.173c-.17 .975 -1.484 1.913 -2.76 2.686c-1.296 .938 -.722 1.85 0 2.234c.949 .506 3.611 -.995 4.545 .354c-1.698 .102 -1.536 3.107 -3.983 2.727c2.523 .957 4.345 .462 5.458 -.34c1.965 -1.52 2.879 -3.542 2.879 -5.557c-.014 -1.398 .194 -2.695 -1.26 -4.75"
  }));
}

var _excluded$kQ = ["size", "color", "stroke"];

function IconBrandFlickr(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-flickr",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 12,
    r: 3
  }));
}

var _excluded$kP = ["size", "color", "stroke"];

function IconBrandFoursquare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-foursquare",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3h10c.644 0 1.11 .696 .978 1.33l-1.984 9.859a1.014 1.014 0 0 1 -.994 .811h-2.254c-.308 0 -.6 .141 -.793 .382l-4.144 5.25c-.599 .752 -1.809 .331 -1.809 -.632v-16c0 -.564 .44 -1 1 -1z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 17,
    y2: 9
  }));
}

var _excluded$kO = ["size", "color", "stroke"];

function IconBrandFramer(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-framer",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15h12l-12 -12h12v6h-12v6l6 6v-6"
  }));
}

var _excluded$kN = ["size", "color", "stroke"];

function IconBrandGit(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-git",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11l-2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7l-1.9 -1.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
  }));
}

var _excluded$kM = ["size", "color", "stroke"];

function IconBrandGithub(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-github",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5"
  }));
}

var _excluded$kL = ["size", "color", "stroke"];

function IconBrandGitlab(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-gitlab",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14l-9 7l-9 -7l3 -11l3 7h6l3 -7z"
  }));
}

var _excluded$kK = ["size", "color", "stroke"];

function IconBrandGmail(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-gmail",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h3a1 1 0 0 0 1 -1v-14a1 1 0 0 0 -1 -1h-3v16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 20h3v-16h-3a1 1 0 0 0 -1 1v14a1 1 0 0 0 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4l-4 4l-4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5l8 7.5l8 -7.5"
  }));
}

var _excluded$kJ = ["size", "color", "stroke"];

function IconBrandGoogleAnalytics(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google-analytics",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 4,
    height: 12,
    rx: 1.105
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3,
    width: 4,
    height: 18,
    rx: 1.105
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }));
}

var _excluded$kI = ["size", "color", "stroke"];

function IconBrandGoogleDrive(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google-drive",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10l-6 10l-3 -5l6 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15h12l-3 5h-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15l-6 -10h6l6 10z"
  }));
}

var _excluded$kH = ["size", "color", "stroke"];

function IconBrandGooglePlay(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google-play",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 3.71v16.58a0.7 .7 0 0 0 1.05 .606l14.622 -8.42a0.55 .55 0 0 0 0 -.953l-14.622 -8.419a0.7 .7 0 0 0 -1.05 .607z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 4.5,
    y2: 20.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 3.5,
    x2: 15,
    y2: 15
  }));
}

var _excluded$kG = ["size", "color", "stroke"];

function IconBrandGoogle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-google",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.788 5.108a9 9 0 1 0 3.212 6.892h-8"
  }));
}

var _excluded$kF = ["size", "color", "stroke"];

function IconBrandGravatar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-gravatar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64 5.632a9 9 0 1 0 6.36 -2.632v7.714"
  }));
}

var _excluded$kE = ["size", "color", "stroke"];

function IconBrandHipchat(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-hipchat",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.802 17.292s.077 -.055 .2 -.149c1.843 -1.425 2.998 -3.49 2.998 -5.789c0 -4.286 -4.03 -7.764 -8.998 -7.764c-4.97 0 -9.002 3.478 -9.002 7.764c0 4.288 4.03 7.646 9 7.646c.424 0 1.12 -.028 2.088 -.084c1.262 .82 3.104 1.493 4.716 1.493c.499 0 .734 -.41 .414 -.828c-.486 -.596 -1.156 -1.551 -1.416 -2.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5c2.5 2.5 6.5 2.5 9 0"
  }));
}

var _excluded$kD = ["size", "color", "stroke"];

function IconBrandHtml5(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-html5",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8h-7l.5 4h6l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5"
  }));
}

var _excluded$kC = ["size", "color", "stroke"];

function IconBrandInstagram(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-instagram",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 7.5,
    x2: 16.5,
    y2: 7.501
  }));
}

var _excluded$kB = ["size", "color", "stroke"];

function IconBrandJavascript(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-javascript",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8h3v8l-2 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8h-2.5a0.5 .5 0 0 0 -.5 .5v3a0.5 .5 0 0 0 .5 .5h1.423a0.5 .5 0 0 1 .495 .57l-.418 2.93l-2 .5"
  }));
}

var _excluded$kA = ["size", "color", "stroke"];

function IconBrandKickstarter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-kickstarter",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9l2.975 -4.65c.615 -.9 1.405 -1.35 2.377 -1.35c.79 0 1.474 .286 2.054 .858c.576 .574 .866 1.256 .866 2.054c0 .588 -.153 1.109 -.46 1.559l-2.812 4.029l3.465 4.912c.356 .46 .535 .998 .535 1.613a2.92 2.92 0 0 1 -.843 2.098c-.561 .584 -1.242 .877 -2.04 .877c-.876 0 -1.545 -.29 -2.005 -.87l-4.112 -5.697v3.067c0 .876 -.313 1.69 -.611 2.175c-.543 .883 -1.35 1.325 -2.389 1.325c-.944 0 -1.753 -.327 -2.271 -.974c-.486 -.6 -.729 -1.392 -.729 -2.38v-11.371c0 -.934 .247 -1.706 .74 -2.313c.512 -.641 1.347 -.962 2.26 -.962c.868 0 1.821 .321 2.4 .962c.323 .356 .515 .714 .6 1.08c.052 .224 0 .643 0 1.26v2.698z"
  }));
}

var _excluded$kz = ["size", "color", "stroke"];

function IconBrandKotlin(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-kotlin",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20h-16v-16h16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12l8 -8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 20,
    y2: 20
  }));
}

var _excluded$ky = ["size", "color", "stroke"];

function IconBrandLastfm(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ky);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-lastfm",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8c-.83 -1 -1.388 -1 -2 -1c-.612 0 -2 .271 -2 2s1.384 2.233 3 3c1.616 .767 2.125 1.812 2 3s-1 2 -3 2s-3 -1 -3.5 -2s-1.585 -4.78 -2.497 -5.997a5 5 0 1 0 -1.003 6.997"
  }));
}

var _excluded$kx = ["size", "color", "stroke"];

function IconBrandLinkedin(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kx);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-linkedin",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 8,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 8,
    x2: 8,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16v-3a2 2 0 0 0 -4 0"
  }));
}

var _excluded$kw = ["size", "color", "stroke"];

function IconBrandLoom(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-loom",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.464 6.518a6.001 6.001 0 1 0 -3.023 7.965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.482 17.464a6.001 6.001 0 1 0 -7.965 -3.023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54 17.482a6.001 6.001 0 1 0 3.024 -7.965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.518 6.54a6.001 6.001 0 1 0 7.965 3.024"
  }));
}

var _excluded$kv = ["size", "color", "stroke"];

function IconBrandMastercard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kv);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-mastercard",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.765a3 3 0 1 0 0 4.47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }));
}

var _excluded$ku = ["size", "color", "stroke"];

function IconBrandMedium(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ku);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-medium",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9h1l3 3l3 -3h1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 15,
    x2: 10,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 15,
    x2: 16,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 15,
    y2: 15
  }));
}

var _excluded$kt = ["size", "color", "stroke"];

function IconBrandMercedes(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kt);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-mercedes",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l7 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l-7 5"
  }));
}

var _excluded$ks = ["size", "color", "stroke"];

function IconBrandMessenger(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ks);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-messenger",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13l3 -2l2 2l3 -2"
  }));
}

var _excluded$kr = ["size", "color", "stroke"];

function IconBrandMeta(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kr);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-meta",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.174c1.766 -2.784 3.315 -4.174 4.648 -4.174c2 0 3.263 2.213 4 5.217c.704 2.869 .5 6.783 -2 6.783c-1.114 0 -2.648 -1.565 -4.148 -3.652a27.627 27.627 0 0 1 -2.5 -4.174z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.174c-1.766 -2.784 -3.315 -4.174 -4.648 -4.174c-2 0 -3.263 2.213 -4 5.217c-.704 2.869 -.5 6.783 2 6.783c1.114 0 2.648 -1.565 4.148 -3.652c1 -1.391 1.833 -2.783 2.5 -4.174z"
  }));
}

var _excluded$kq = ["size", "color", "stroke"];

function IconBrandNetbeans(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-netbeans",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573h-.029z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.43a1 1 0 0 1 .5 .874v3.268a1 1 0 0 1 -.515 .874l-3 1.917a1 1 0 0 1 -.97 0l-3 -1.917a1 1 0 0 1 -.515 -.873v-3.269a1 1 0 0 1 .514 -.874l3 -1.786c.311 -.173 .69 -.173 1 0l3 1.787h-.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-9l-7.5 -4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l7.5 -4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16l-3.5 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14l-3.5 2"
  }));
}

var _excluded$kp = ["size", "color", "stroke"];

function IconBrandNetflix(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kp);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-netflix",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20v-16l7 16v-16"
  }));
}

var _excluded$ko = ["size", "color", "stroke"];

function IconBrandNotion(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ko);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-notion",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7h3l6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7v10h-1l-7 -7"
  }));
}

var _excluded$kn = ["size", "color", "stroke"];

function IconBrandNytimes(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kn);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-nytimes",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.036 5.058a8.001 8.001 0 1 0 8.706 9.965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-11l-7.5 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3a2.5 2.5 0 1 1 0 5l-11 -5a2.5 2.5 0 0 0 -.67 4.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13h-.01"
  }));
}

var _excluded$km = ["size", "color", "stroke"];

function IconBrandOpenSource(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$km);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-open-source",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 0 1 3.618 17.243l-2.193 -5.602a3 3 0 1 0 -2.849 0l-2.193 5.603a9 9 0 0 1 3.617 -17.244z"
  }));
}

var _excluded$kl = ["size", "color", "stroke"];

function IconBrandOpera(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kl);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-opera",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 3,
    ry: 5
  }));
}

var _excluded$kk = ["size", "color", "stroke"];

function IconBrandPagekit(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kk);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-pagekit",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.077 20h-5.077v-16h11v14h-5.077"
  }));
}

var _excluded$kj = ["size", "color", "stroke"];

function IconBrandPatreon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-patreon",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3h3v18h-3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 9.5,
    r: 6.5
  }));
}

var _excluded$ki = ["size", "color", "stroke"];

function IconBrandPaypal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ki);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-paypal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13l2.5 0c2.5 0 5 -2.5 5 -5c0 -3 -1.9 -5 -5 -5h-5.5c-.5 0 -1 .5 -1 1l-2 14c0 .5 .5 1 1 1h2.8l1.2 -5c.1 -.6 .4 -1 1 -1zm7.5 -5.8c1.7 1 2.5 2.8 2.5 4.8c0 2.5 -2.5 4.5 -5 4.5h-2.6l-.6 3.6a1 1 0 0 1 -1 .8l-2.7 0a0.5 .5 0 0 1 -.5 -.6l.2 -1.4"
  }));
}

var _excluded$kh = ["size", "color", "stroke"];

function IconBrandPhp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kh);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-php",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 10,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15l.395 -1.974l.605 -3.026h1.32a1 1 0 0 1 .986 1.164l-.167 1a1 1 0 0 1 -.986 .836h-1.653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15l.395 -1.974l.605 -3.026h1.32a1 1 0 0 1 .986 1.164l-.167 1a1 1 0 0 1 -.986 .836h-1.653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5l-1 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6 10h2.4l-.5 3"
  }));
}

var _excluded$kg = ["size", "color", "stroke"];

function IconBrandPinterest(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kg);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-pinterest",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 12,
    y2: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7 14c.437 1.263 1.43 2 2.55 2c2.071 0 3.75 -1.554 3.75 -4a5 5 0 1 0 -9.7 1.7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$kf = ["size", "color", "stroke"];

function IconBrandPocket(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kf);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-pocket",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h14a2 2 0 0 1 2 2v6a9 9 0 0 1 -18 0v-6a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 11 12 15 16 11"
  }));
}

var _excluded$ke = ["size", "color", "stroke"];

function IconBrandProducthunt(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ke);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-producthunt",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16v-8h2.5a2.5 2.5 0 1 1 0 5h-2.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$kd = ["size", "color", "stroke"];

function IconBrandPython(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kd);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-python",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9h-7a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15h7a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9v-4a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v5a2 2 0 0 1 -2 2h-4a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 6,
    x2: 11,
    y2: 6.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 18,
    x2: 13,
    y2: 18.01
  }));
}

var _excluded$kc = ["size", "color", "stroke"];

function IconBrandReactNative(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kc);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-react-native",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.357 9c-2.637 .68 -4.357 1.845 -4.357 3.175c0 2.107 4.405 3.825 9.85 3.825c.74 0 1.26 -.039 1.95 -.097"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.837 15.9c-.413 -.596 -.806 -1.133 -1.18 -1.8c-2.751 -4.9 -3.488 -9.77 -1.63 -10.873c1.15 -.697 3.047 .253 4.974 2.254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.429 15.387c-.702 2.688 -.56 4.716 .56 5.395c1.783 1.08 5.387 -1.958 8.043 -6.804c.36 -.67 .683 -1.329 .968 -1.978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.52c1.928 2 3.817 2.95 4.978 2.253c1.85 -1.102 1.121 -5.972 -1.633 -10.873c-.384 -.677 -.777 -1.204 -1.18 -1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.66 15c2.612 -.687 4.34 -1.85 4.34 -3.176c0 -2.11 -4.408 -3.824 -9.845 -3.824c-.747 0 -1.266 .029 -1.955 .087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12c.285 -.66 .607 -1.308 .968 -1.978c2.647 -4.844 6.253 -7.89 8.046 -6.801c1.11 .679 1.262 2.706 .56 5.393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.26 12.015h-.01c-.01 .13 -.12 .24 -.26 .24a0.263 .263 0 0 1 -.25 -.26c0 -.14 .11 -.25 .24 -.25h-.01c.13 -.01 .25 .11 .25 .24"
  }));
}

var _excluded$kb = ["size", "color", "stroke"];

function IconBrandReddit(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$kb);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-reddit",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8c2.648 0 5.028 .826 6.675 2.14a2.5 2.5 0 0 1 2.326 4.36c0 3.59 -4.03 6.5 -9 6.5c-4.875 0 -8.845 -2.8 -9 -6.294l-1 -.206a2.5 2.5 0 0 1 2.326 -4.36c1.646 -1.313 4.026 -2.14 6.674 -2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8l1 -5l6 1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 13,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 13,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17c.667 .333 1.333 .5 2 .5s1.333 -.167 2 -.5"
  }));
}

var _excluded$ka = ["size", "color", "stroke"];

function IconBrandSafari(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ka);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-safari",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 16 10 10 16 8 14 14 8 16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$k9 = ["size", "color", "stroke"];

function IconBrandSass(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$k9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-sass",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.523c2.46 -.826 4.002 -.826 4.002 -2.155c0 -1.366 -1.347 -1.366 -2.735 -1.366c-1.91 0 -3.352 .49 -4.537 1.748c-.848 .902 -1.027 2.449 -.153 3.307c.973 .956 3.206 1.789 2.884 3.493c-.233 1.235 -1.469 1.823 -2.617 1.202c-.782 -.424 -.454 -1.746 .626 -2.512s2.822 -.992 4.1 -.24c.98 .575 1.046 1.724 .434 2.193"
  }));
}

var _excluded$k8 = ["size", "color", "stroke"];

function IconBrandSentry(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$k8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-sentry",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18a1.93 1.93 0 0 0 .306 1.076a2 2 0 0 0 1.584 .924c.646 .033 -.537 0 .11 0h3a4.992 4.992 0 0 0 -3.66 -4.81c.558 -.973 1.24 -2.149 2.04 -3.531a8.997 8.997 0 0 1 5.62 8.341h4c.663 0 2.337 .005 3 0a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-1.84 3.176c4.482 2.05 7.6 6.571 7.6 11.824"
  }));
}

var _excluded$k7 = ["size", "color", "stroke"];

function IconBrandShazam(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$k7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-shazam",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12l2 -2a2.828 2.828 0 0 1 4 0a2.828 2.828 0 0 1 0 4l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12l-2 2a2.828 2.828 0 1 1 -4 -4l3 -3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$k6 = ["size", "color", "stroke"];

function IconBrandSketch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$k6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-sketch",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.262 10.878l8 8.789c.4 .44 1.091 .44 1.491 0l8 -8.79c.313 -.344 .349 -.859 .087 -1.243l-3.537 -5.194a1 1 0 0 0 -.823 -.436h-8.926a1 1 0 0 0 -.823 .436l-3.54 5.192c-.263 .385 -.227 .901 .087 1.246z"
  }));
}

var _excluded$k5 = ["size", "color", "stroke"];

function IconBrandSkype(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$k5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-skype",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 0 1 8.603 11.65a4.5 4.5 0 0 1 -5.953 5.953a9 9 0 0 1 -11.253 -11.253a4.5 4.5 0 0 1 5.953 -5.954a8.987 8.987 0 0 1 2.65 -.396z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5c.5 2 2.358 2.5 4 2.5c2.905 0 4 -1.187 4 -2.5c0 -1.503 -1.927 -2.5 -4 -2.5s-4 -.997 -4 -2.5c0 -1.313 1.095 -2.5 4 -2.5c1.642 0 3.5 .5 4 2.5"
  }));
}

var _excluded$k4 = ["size", "color", "stroke"];

function IconBrandSlack(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$k4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-slack",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v-6a2 2 0 0 1 4 0v6m0 -2a2 2 0 1 1 2 2h-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h6a2 2 0 0 1 0 4h-6m2 0a2 2 0 1 1 -2 2v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v6a2 2 0 0 1 -4 0v-6m0 2a2 2 0 1 1 -2 -2h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h-6a2 2 0 0 1 0 -4h6m-2 0a2 2 0 1 1 2 -2v6"
  }));
}

var _excluded$k3 = ["size", "color", "stroke"];

function IconBrandSnapchat(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$k3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-snapchat",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.882 7.842a4.882 4.882 0 0 0 -9.764 0c0 4.273 -.213 6.409 -4.118 8.118c2 .882 2 .882 3 3c3 0 4 2 6 2s3 -2 6 -2c1 -2.118 1 -2.118 3 -3c-3.906 -1.709 -4.118 -3.845 -4.118 -8.118zm-13.882 8.119c4 -2.118 4 -4.118 1 -7.118m17 7.118c-4 -2.118 -4 -4.118 -1 -7.118"
  }));
}

var _excluded$k2 = ["size", "color", "stroke"];

function IconBrandSoundcloud(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$k2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-soundcloud",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11h1c1.38 0 3 1.274 3 3c0 1.657 -1.5 3 -3 3l-6 0v-10c3 0 4.5 1.5 5 4z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 8,
    x2: 9,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 17,
    x2: 6,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 16,
    x2: 3,
    y2: 14
  }));
}

var _excluded$k1 = ["size", "color", "stroke"];

function IconBrandSpotify(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$k1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-spotify",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.973c2.5 -1.473 5.5 -.973 7.5 .527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15c1.5 -1 4 -1 5 .5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9c2 -1 6 -2 10 .5"
  }));
}

var _excluded$k0 = ["size", "color", "stroke"];

function IconBrandStackoverflow(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$k0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-stackoverflow",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.322 12.582l7.956 .836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.787 9.168l7.826 1.664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.096 5.764l7.608 2.472"
  }));
}

var _excluded$j$ = ["size", "color", "stroke"];

function IconBrandSteam(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$j$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-steam",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5a4.5 4.5 0 1 1 -.653 8.953l-4.347 3.009l0 .038a3 3 0 0 1 -2.824 2.995l-.176 .005a3 3 0 0 1 -2.94 -2.402l-2.56 -1.098v-3.5l3.51 1.755a2.989 2.989 0 0 1 2.834 -.635l2.727 -3.818a4.5 4.5 0 0 1 4.429 -5.302z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 16.5,
    cy: 9.5,
    r: 1
  }));
}

var _excluded$j_ = ["size", "color", "stroke"];

function IconBrandStripe(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$j_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-stripe",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.453 8.056c0 -.623 .518 -.979 1.442 -.979c1.69 0 3.41 .343 4.605 .923l.5 -4c-.948 -.449 -2.82 -1 -5.5 -1c-1.895 0 -3.373 .087 -4.5 1c-1.172 .956 -2 2.33 -2 4c0 3.03 1.958 4.906 5 6c1.961 .69 3 .743 3 1.5c0 .735 -.851 1.5 -2 1.5c-1.423 0 -3.963 -.609 -5.5 -1.5l-.5 4c1.321 .734 3.474 1.5 6 1.5c2.004 0 3.957 -.468 5.084 -1.36c1.263 -.979 1.916 -2.268 1.916 -4.14c0 -3.096 -1.915 -4.547 -5.003 -5.637c-1.646 -.605 -2.544 -1.07 -2.544 -1.807z"
  }));
}

var _excluded$jZ = ["size", "color", "stroke"];

function IconBrandSublimeText(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-sublime-text",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8l-14 4.5v-5.5l14 -4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 17l-14 4.5v-5.5l14 -4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11.5l-14 -4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5l14 4.5"
  }));
}

var _excluded$jY = ["size", "color", "stroke"];

function IconBrandTabler(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tabler",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 15,
    x2: 16,
    y2: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 4
  }));
}

var _excluded$jX = ["size", "color", "stroke"];

function IconBrandTailwind(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tailwind",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.667 6c-2.49 0 -4.044 1.222 -4.667 3.667c.933 -1.223 2.023 -1.68 3.267 -1.375c.71 .174 1.217 .68 1.778 1.24c.916 .912 2 1.968 4.288 1.968c2.49 0 4.044 -1.222 4.667 -3.667c-.933 1.223 -2.023 1.68 -3.267 1.375c-.71 -.174 -1.217 -.68 -1.778 -1.24c-.916 -.912 -1.975 -1.968 -4.288 -1.968zm-4 6.5c-2.49 0 -4.044 1.222 -4.667 3.667c.933 -1.223 2.023 -1.68 3.267 -1.375c.71 .174 1.217 .68 1.778 1.24c.916 .912 1.975 1.968 4.288 1.968c2.49 0 4.044 -1.222 4.667 -3.667c-.933 1.223 -2.023 1.68 -3.267 1.375c-.71 -.174 -1.217 -.68 -1.778 -1.24c-.916 -.912 -1.975 -1.968 -4.288 -1.968z"
  }));
}

var _excluded$jW = ["size", "color", "stroke"];

function IconBrandTelegram(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-telegram",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4"
  }));
}

var _excluded$jV = ["size", "color", "stroke"];

function IconBrandTidal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tidal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7l-2.5 2.5l2.5 2.5l2.5 -2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14l-2.5 2.5l2.5 2.5l2.5 -2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 7l-2.5 2.5l2.5 2.5l2.5 -2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7l-2.5 2.5l2.5 2.5l2.5 -2.5z"
  }));
}

var _excluded$jU = ["size", "color", "stroke"];

function IconBrandTiktok(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tiktok",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12a4 4 0 1 0 4 4v-12a5 5 0 0 0 5 5"
  }));
}

var _excluded$jT = ["size", "color", "stroke"];

function IconBrandTinder(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tinder",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.918 8.174c2.56 4.982 .501 11.656 -5.38 12.626c-7.702 1.687 -12.84 -7.716 -7.054 -13.229c.309 -.305 1.161 -1.095 1.516 -1.349c0 .528 .27 3.475 1 3.167c3 0 4 -4.222 3.587 -7.389c2.7 1.411 4.987 3.376 6.331 6.174z"
  }));
}

var _excluded$jS = ["size", "color", "stroke"];

function IconBrandTripadvisor(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tripadvisor",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 13.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 13.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9a4.5 4.5 0 1 0 3.5 1.671l1 -1.671h-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9a4.5 4.5 0 1 1 -3.5 1.671l-1 -1.671h4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.5l1.5 2l1.5 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6.75c2 -.667 4 -.667 6 0"
  }));
}

var _excluded$jR = ["size", "color", "stroke"];

function IconBrandTumblr(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-tumblr",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 21h4v-4h-4v-6h4v-4h-4v-4h-4v1a3 3 0 0 1 -3 3h-1v4h4v6a4 4 0 0 0 4 4"
  }));
}

var _excluded$jQ = ["size", "color", "stroke"];

function IconBrandTwitch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-twitch",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5v11a1 1 0 0 0 1 1h2v4l4 -4h5.584c.266 0 .52 -.105 .707 -.293l2.415 -2.414c.187 -.188 .293 -.442 .293 -.708v-8.585a1 1 0 0 0 -1 -1h-14a1 1 0 0 0 -1 1z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 8,
    x2: 16,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 12
  }));
}

var _excluded$jP = ["size", "color", "stroke"];

function IconBrandTwitter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-twitter",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 4.01c-1 .49 -1.98 .689 -3 .99c-1.121 -1.265 -2.783 -1.335 -4.38 -.737s-2.643 2.06 -2.62 3.737v1c-3.245 .083 -6.135 -1.395 -8 -4c0 0 -4.182 7.433 4 11c-1.872 1.247 -3.739 2.088 -6 2c3.308 1.803 6.913 2.423 10.034 1.517c3.58 -1.04 6.522 -3.723 7.651 -7.742a13.84 13.84 0 0 0 .497 -3.753c-.002 -.249 1.51 -2.772 1.818 -4.013z"
  }));
}

var _excluded$jO = ["size", "color", "stroke"];

function IconBrandUber(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-uber",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h6"
  }));
}

var _excluded$jN = ["size", "color", "stroke"];

function IconBrandUbuntu(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-ubuntu",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.723 7.41a7.992 7.992 0 0 0 -3.74 -2.162m-3.971 0a7.993 7.993 0 0 0 -3.789 2.216m-1.881 3.215a8 8 0 0 0 -.342 2.32c0 .738 .1 1.453 .287 2.132m1.96 3.428a7.993 7.993 0 0 0 3.759 2.19m3.998 -.003a7.993 7.993 0 0 0 3.747 -2.186m1.962 -3.43a8.008 8.008 0 0 0 .287 -2.131c0 -.764 -.107 -1.503 -.307 -2.203"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 17,
    r: 2
  }));
}

var _excluded$jM = ["size", "color", "stroke"];

function IconBrandUnsplash(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-unsplash",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11h5v4h6v-4h5v9h-16zm5 -7h6v4h-6z"
  }));
}

var _excluded$jL = ["size", "color", "stroke"];

function IconBrandVercel(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-vercel",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19h18l-9 -15z"
  }));
}

var _excluded$jK = ["size", "color", "stroke"];

function IconBrandVimeo(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-vimeo",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8.5l1 1s1.5 -1.102 2 -.5c.509 .609 1.863 7.65 2.5 9c.556 1.184 1.978 2.89 4 1.5c2 -1.5 7.5 -5.5 8.5 -11.5c.444 -2.661 -1 -4 -2.5 -4c-2 0 -4.047 1.202 -4.5 4c2.05 -1.254 2.551 1.003 1.5 3c-1.052 2.005 -2 3 -2.5 3c-.49 0 -.924 -1.165 -1.5 -3.5c-.59 -2.42 -.5 -6.5 -3 -6.5s-5.5 4.5 -5.5 4.5z"
  }));
}

var _excluded$jJ = ["size", "color", "stroke"];

function IconBrandVisualStudio(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-visual-studio",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8l2 -1l10 13l4 -2v-12l-4 -2l-10 13l-2 -1z"
  }));
}

var _excluded$jI = ["size", "color", "stroke"];

function IconBrandVk(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-vk",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6h2v12c-4.5 -1 -8 -6.5 -9 -12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6c-1 2 -3 5 -5 6h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18c-1 -2 -3 -5 -5 -6"
  }));
}

var _excluded$jH = ["size", "color", "stroke"];

function IconBrandWhatsapp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-whatsapp",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10a0.5 .5 0 0 0 1 0v-1a0.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a0.5 .5 0 0 0 0 -1h-1a0.5 .5 0 0 0 0 1"
  }));
}

var _excluded$jG = ["size", "color", "stroke"];

function IconBrandWindows(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-windows",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8 20l-12 -1.5c-1 -.1 -1.8 -.9 -1.8 -1.9v-9.2c0 -1 .8 -1.8 1.8 -1.9l12 -1.5c1.2 -.1 2.2 .8 2.2 1.9v12.1c0 1.2 -1.1 2.1 -2.2 1.9z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }));
}

var _excluded$jF = ["size", "color", "stroke"];

function IconBrandYahoo(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-yahoo",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 8,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 18,
    x2: 14,
    y2: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6l5.5 7v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13l6 -5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 8,
    x2: 17.5,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 11,
    x2: 20,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 18,
    x2: 20,
    y2: 18.01
  }));
}

var _excluded$jE = ["size", "color", "stroke"];

function IconBrandYcombinator(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-ycombinator",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.002l4 5.998l4 -6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 13
  }));
}

var _excluded$jD = ["size", "color", "stroke"];

function IconBrandYoutube(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brand-youtube",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9l5 3l-5 3z"
  }));
}

var _excluded$jC = ["size", "color", "stroke"];

function IconBread(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bread",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 5a3 3 0 0 1 2 5.235v6.765a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6.764a3 3 0 0 1 1.824 -5.231l.176 -.005h10z"
  }));
}

var _excluded$jB = ["size", "color", "stroke"];

function IconBriefcase(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-briefcase",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 18,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13a20 20 0 0 0 18 0"
  }));
}

var _excluded$jA = ["size", "color", "stroke"];

function IconBrightness2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brightness-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z"
  }));
}

var _excluded$jz = ["size", "color", "stroke"];

function IconBrightnessDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brightness-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 5.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 17,
    y2: 7.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 19,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 17,
    y2: 17.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 19.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 17,
    x2: 7,
    y2: 17.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 5,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 7,
    y2: 7.01
  }));
}

var _excluded$jy = ["size", "color", "stroke"];

function IconBrightnessHalf(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jy);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brightness-half",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9a3 3 0 0 0 0 6v-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z"
  }));
}

var _excluded$jx = ["size", "color", "stroke"];

function IconBrightnessUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jx);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brightness-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 18.4,
    y2: 5.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 21,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 18.4,
    y2: 18.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 17,
    x2: 5.6,
    y2: 18.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 4,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 5.6,
    y2: 5.6
  }));
}

var _excluded$jw = ["size", "color", "stroke"];

function IconBrightness(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brightness",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 16.65,
    y2: 4.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14.3,
    x2: 19.37,
    y2: 6.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19.6,
    x2: 20.85,
    y2: 10.75
  }));
}

var _excluded$jv = ["size", "color", "stroke"];

function IconBrowserCheck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jv);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-browser-check",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.5l1.5 1.5l3 -3"
  }));
}

var _excluded$ju = ["size", "color", "stroke"];

function IconBrowserPlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ju);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-browser-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v4"
  }));
}

var _excluded$jt = ["size", "color", "stroke"];

function IconBrowserX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jt);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-browser-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16l-4 -4"
  }));
}

var _excluded$js = ["size", "color", "stroke"];

function IconBrowser(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$js);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-browser",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 20,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 8
  }));
}

var _excluded$jr = ["size", "color", "stroke"];

function IconBrush(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jr);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-brush",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21v-4a4 4 0 1 1 4 4h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3a16 16 0 0 0 -12.8 10.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3a16 16 0 0 1 -10.2 12.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6 9a9 9 0 0 1 4.4 4.4"
  }));
}

var _excluded$jq = ["size", "color", "stroke"];

function IconBucket(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bucket",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9l-2 9a2 2.5 0 0 1 -2 2h-6a2 2.5 0 0 1 -2 -2l-2 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9a5 5 0 0 1 10 0"
  }));
}

var _excluded$jp = ["size", "color", "stroke"];

function IconBug(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jp);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bug",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9v-1a3 3 0 0 1 6 0v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9h8a6 6 0 0 1 1 3v3a5 5 0 0 1 -10 0v-3a6 6 0 0 1 1 -3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 13,
    x2: 7,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 13,
    x2: 21,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 7.35,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 19,
    x2: 16.65,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 7,
    x2: 7.75,
    y2: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 7,
    x2: 16.25,
    y2: 9.4
  }));
}

var _excluded$jo = ["size", "color", "stroke"];

function IconBuildingArch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jo);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-arch",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21v-15a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21v-8a3 3 0 0 1 6 0v8"
  }));
}

var _excluded$jn = ["size", "color", "stroke"];

function IconBuildingBank(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jn);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-bank",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 21,
    y2: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5 6 12 3 19 6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 10,
    x2: 4,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 10,
    x2: 20,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 14,
    x2: 8,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 14,
    x2: 16,
    y2: 17
  }));
}

var _excluded$jm = ["size", "color", "stroke"];

function IconBuildingBridge2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jm);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-bridge-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7h12a2 2 0 0 1 2 2v9a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a4 4 0 0 0 -8 0v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-9a2 2 0 0 1 2 -2"
  }));
}

var _excluded$jl = ["size", "color", "stroke"];

function IconBuildingBridge(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jl);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-bridge",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 5,
    x2: 6,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 5,
    x2: 18,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 15,
    x2: 22,
    y2: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8a7.5 7.5 0 0 0 3 -2a6.5 6.5 0 0 0 12 0a7.5 7.5 0 0 0 3 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 12,
    y2: 15
  }));
}

var _excluded$jk = ["size", "color", "stroke"];

function IconBuildingCarousel(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jk);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-carousel",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 16,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 16,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 22l4 -10l4 10"
  }));
}

var _excluded$jj = ["size", "color", "stroke"];

function IconBuildingCastle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-castle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19v-2a3 3 0 0 0 -6 0v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14h4v3h3v-3h4v3h3v-3h4v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 11,
    x2: 21,
    y2: 11
  }));
}

var _excluded$ji = ["size", "color", "stroke"];

function IconBuildingChurch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ji);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-church",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21v-4a2 2 0 0 1 4 0v4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 5,
    x2: 14,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21v-7m-2 2l8 -8l8 8m-2 -2v7"
  }));
}

var _excluded$jh = ["size", "color", "stroke"];

function IconBuildingCommunity(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jh);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-community",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9l5 5v7h-5v-4m0 4h-5v-7l5 -5m1 1v-6a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v17h-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 7,
    x2: 13,
    y2: 7.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 17,
    y2: 7.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 11,
    x2: 17,
    y2: 11.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 15,
    x2: 17,
    y2: 15.01
  }));
}

var _excluded$jg = ["size", "color", "stroke"];

function IconBuildingCottage(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jg);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-cottage",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21v-11l2.5 -4.5l5.5 -2.5l5.5 2.5l2.5 4.5v11"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21v-5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v5"
  }));
}

var _excluded$jf = ["size", "color", "stroke"];

function IconBuildingFactory2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jf);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-factory-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21v-12l5 4v-4l5 4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21v-8l-1.436 -9.574a0.5 .5 0 0 0 -.495 -.426h-1.145a0.5 .5 0 0 0 -.494 .418l-1.43 8.582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17h1"
  }));
}

var _excluded$je = ["size", "color", "stroke"];

function IconBuildingFactory(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$je);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-factory",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21c1.147 -4.02 1.983 -8.027 2 -12h6c.017 3.973 .853 7.98 2 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13h4.5c.025 2.612 .894 5.296 2 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 22,
    y2: 21
  }));
}

var _excluded$jd = ["size", "color", "stroke"];

function IconBuildingFortress(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jd);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-fortress",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21h1a1 1 0 0 0 1 -1v-1h0a3 3 0 0 1 6 0m3 2h1a1 1 0 0 0 1 -1v-15l-3 -2l-3 2v6h-4v-6l-3 -2l-3 2v15a1 1 0 0 0 1 1h2m8 -2v1a1 1 0 0 0 1 1h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7h0v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10h0v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13h0v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 7h0v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10h0v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13h0v.01"
  }));
}

var _excluded$jc = ["size", "color", "stroke"];

function IconBuildingHospital(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jc);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-hospital",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 9,
    x2: 14,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 11
  }));
}

var _excluded$jb = ["size", "color", "stroke"];

function IconBuildingLighthouse(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$jb);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-lighthouse",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3l2 3l2 15h-8l2 -15z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 16,
    y2: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11l2 -2l-2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11l-2 -2l2 -2"
  }));
}

var _excluded$ja = ["size", "color", "stroke"];

function IconBuildingMonument(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ja);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-monument",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18l2 -13l2 -2l2 2l2 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21v-3h14v3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }));
}

var _excluded$j9 = ["size", "color", "stroke"];

function IconBuildingPavilon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$j9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-pavilon",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21h7v-3a2 2 0 0 1 4 0v3h7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 21,
    x2: 6,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 21,
    x2: 18,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12h12a3 3 0 0 0 3 -3a9 8 0 0 1 -9 -6a9 8 0 0 1 -9 6a3 3 0 0 0 3 3"
  }));
}

var _excluded$j8 = ["size", "color", "stroke"];

function IconBuildingSkyscraper(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$j8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-skyscraper",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21v-14l8 -4v18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21v-10l-6 -4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9,
    y2: 9.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 9,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 9,
    y2: 15.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 18,
    x2: 9,
    y2: 18.01
  }));
}

var _excluded$j7 = ["size", "color", "stroke"];

function IconBuildingStore(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$j7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-store",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 21,
    x2: 5,
    y2: 10.85
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 21,
    x2: 19,
    y2: 10.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
  }));
}

var _excluded$j6 = ["size", "color", "stroke"];

function IconBuildingWarehouse(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$j6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building-warehouse",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21v-13l9 -4l9 4v13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13h4v8h-10v-6h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21v-9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v3"
  }));
}

var _excluded$j5 = ["size", "color", "stroke"];

function IconBuilding(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$j5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-building",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 8,
    x2: 10,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 10,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 10,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 8,
    x2: 15,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 15,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 16,
    x2: 15,
    y2: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16"
  }));
}

var _excluded$j4 = ["size", "color", "stroke"];

function IconBulbOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$j4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bulb-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.7,
    y1: 17,
    x2: 14.3,
    y2: 17
  }));
}

var _excluded$j3 = ["size", "color", "stroke"];

function IconBulb(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$j3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bulb",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.7,
    y1: 17,
    x2: 14.3,
    y2: 17
  }));
}

var _excluded$j2 = ["size", "color", "stroke"];

function IconBulldozer(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$j2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bulldozer",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13v6h3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 19,
    x2: 4,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 13,
    y2: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12v-5h2a3 3 0 0 1 3 3v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15v-2a1 1 0 0 1 1 -1h7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 17,
    x2: 15,
    y2: 17
  }));
}

var _excluded$j1 = ["size", "color", "stroke"];

function IconBus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$j1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-bus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17h-2v-11a1 1 0 0 1 1 -1h14a5 7 0 0 1 5 7v5h-2m-4 0h-8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 5 17.5 12 22 12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 10,
    x2: 17,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 7,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 10
  }));
}

var _excluded$j0 = ["size", "color", "stroke"];

function IconBusinessplan(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$j0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-businessplan",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 6,
    rx: 5,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15v1m0 -8v1"
  }));
}

var _excluded$i$ = ["size", "color", "stroke"];

function IconButterfly(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$i$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-butterfly",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.995 18.176a3 3 0 1 1 -4.953 -2.449l-.025 .023a4.502 4.502 0 0 1 1.483 -8.75c1.414 0 2.675 .652 3.5 1.671a4.5 4.5 0 1 1 4.983 7.079a3 3 0 1 1 -4.983 2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19v-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3l3 2l3 -2"
  }));
}

var _excluded$i_ = ["size", "color", "stroke"];

function IconCSharp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$i_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-c-sharp",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9a3 3 0 0 0 -3 -3h-.5a3.5 3.5 0 0 0 -3.5 3.5v5a3.5 3.5 0 0 0 3.5 3.5h.5a3 3 0 0 0 3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7l-1 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 7l-1 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10h7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14h-7.5"
  }));
}

var _excluded$iZ = ["size", "color", "stroke"];

function IconCake(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cake",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 20h18v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3v8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.996 14.803c.312 .135 .654 .204 1.004 .197a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1c.35 .007 .692 -.062 1.004 -.197"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z"
  }));
}

var _excluded$iY = ["size", "color", "stroke"];

function IconCalculator(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calculator",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 16,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 8,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 14,
    x2: 8,
    y2: 14.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 14.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 14,
    x2: 16,
    y2: 14.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 17,
    x2: 8,
    y2: 17.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 17.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 17,
    x2: 16,
    y2: 17.01
  }));
}

var _excluded$iX = ["size", "color", "stroke"];

function IconCalendarEvent(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-event",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 20,
    y2: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 2,
    height: 2
  }));
}

var _excluded$iW = ["size", "color", "stroke"];

function IconCalendarMinus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-minus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 20,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 14,
    y2: 16
  }));
}

var _excluded$iV = ["size", "color", "stroke"];

function IconCalendarOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.823 19.824a2 2 0 0 1 -1.823 1.176h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 1.175 -1.823m3.825 -.177h9a2 2 0 0 1 2 2v9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11h7m4 0h5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 15,
    x2: 12,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$iU = ["size", "color", "stroke"];

function IconCalendarPlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 20,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 14,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 18
  }));
}

var _excluded$iT = ["size", "color", "stroke"];

function IconCalendarStats(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-stats",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14v4h4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11h16"
  }));
}

var _excluded$iS = ["size", "color", "stroke"];

function IconCalendarTime(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar-time",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16.496v1.504l1 1"
  }));
}

var _excluded$iR = ["size", "color", "stroke"];

function IconCalendar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-calendar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 20,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 15,
    x2: 12,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 18
  }));
}

var _excluded$iQ = ["size", "color", "stroke"];

function IconCameraMinus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-camera-minus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h3m9 6v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 6,
    x2: 21,
    y2: 6
  }));
}

var _excluded$iP = ["size", "color", "stroke"];

function IconCameraOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-camera-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29 4.296a1 1 0 0 1 .71 -.296h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v8m-1.179 2.824c-.25 .113 -.528 .176 -.821 .176h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1c.292 0 .568 -.062 .818 -.175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.436 10.44a3 3 0 1 0 4.126 4.122"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$iO = ["size", "color", "stroke"];

function IconCameraPlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-camera-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7h2a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h2m9 7v7a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 6,
    x2: 21,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 3,
    x2: 18,
    y2: 9
  }));
}

var _excluded$iN = ["size", "color", "stroke"];

function IconCameraRotate(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-camera-rotate",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.245 15.904a3 3 0 0 0 3.755 -2.904m-2.25 -2.905a3 3 0 0 0 -3.75 2.905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13h2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13h-2v-2"
  }));
}

var _excluded$iM = ["size", "color", "stroke"];

function IconCameraSelfie(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-camera-selfie",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 11,
    x2: 15.01,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 11,
    x2: 9.01,
    y2: 11
  }));
}

var _excluded$iL = ["size", "color", "stroke"];

function IconCamera(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-camera",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 3
  }));
}

var _excluded$iK = ["size", "color", "stroke"];

function IconCandle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-candle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21h6v-9a1 1 0 0 0 -1 -1h-4a1 1 0 0 0 -1 1v9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z"
  }));
}

var _excluded$iJ = ["size", "color", "stroke"];

function IconCandy(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-candy",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05 11.293l4.243 -4.243a2 2 0 0 1 2.828 0l2.829 2.83a2 2 0 0 1 0 2.828l-4.243 4.243a2 2 0 0 1 -2.828 0l-2.829 -2.831a2 2 0 0 1 0 -2.828z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.243 9.172l3.086 -.772a1.5 1.5 0 0 0 .697 -2.516l-2.216 -2.217a1.5 1.5 0 0 0 -2.44 .47l-1.248 2.913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.172 16.243l-.772 3.086a1.5 1.5 0 0 1 -2.516 .697l-2.217 -2.216a1.5 1.5 0 0 1 .47 -2.44l2.913 -1.248"
  }));
}

var _excluded$iI = ["size", "color", "stroke"];

function IconCapture(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-capture",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }));
}

var _excluded$iH = ["size", "color", "stroke"];

function IconCarCrane(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-car-crane",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18h8m4 0h2v-6a5 5 0 0 0 -5 -5h-1l1.5 5h4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18v-11h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17v-5h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v-6l18 -3v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12v-4l-4 -2"
  }));
}

var _excluded$iG = ["size", "color", "stroke"];

function IconCarCrash(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-car-crash",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-5m0 -6h8m-6 0v-5m2 0h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 12h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.5l1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.5l1.5 -1.5"
  }));
}

var _excluded$iF = ["size", "color", "stroke"];

function IconCar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-car",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5"
  }));
}

var _excluded$iE = ["size", "color", "stroke"];

function IconCaravan(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-caravan",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 17,
    x2: 13,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17h-5a1 1 0 0 1 -1 -1v-9a2 2 0 0 1 2 -2h10l4 4v8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 6,
    height: 4,
    rx: 1
  }));
}

var _excluded$iD = ["size", "color", "stroke"];

function IconCardboards(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cardboards",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7v8.5a2.5 2.5 0 0 0 2.5 2.5h1.06a3 3 0 0 0 2.34 -1.13l1.54 -1.92a2 2 0 0 1 3.12 0l1.54 1.92a3 3 0 0 0 2.34 1.13h1.06a2.5 2.5 0 0 0 2.5 -2.5v-8.5a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 11,
    r: 1
  }));
}

var _excluded$iC = ["size", "color", "stroke"];

function IconCaretDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-caret-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l-6 -6l-6 6h12",
    transform: "rotate(180 12 12)"
  }));
}

var _excluded$iB = ["size", "color", "stroke"];

function IconCaretLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-caret-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l-6 -6l-6 6h12",
    transform: "rotate(270 12 12)"
  }));
}

var _excluded$iA = ["size", "color", "stroke"];

function IconCaretRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-caret-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l-6 -6l-6 6h12",
    transform: "rotate(90 12 12)"
  }));
}

var _excluded$iz = ["size", "color", "stroke"];

function IconCaretUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-caret-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l-6 -6l-6 6h12"
  }));
}

var _excluded$iy = ["size", "color", "stroke"];

function IconCashBanknoteOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iy);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cash-banknote-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88 9.878a3 3 0 1 0 4.242 4.243m.58 -3.425a3.012 3.012 0 0 0 -1.412 -1.405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6h9a2 2 0 0 1 2 2v8c0 .294 -.064 .574 -.178 .825m-2.822 1.175h-13a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 18.01,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 6.01,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$ix = ["size", "color", "stroke"];

function IconCashBanknote(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ix);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cash-banknote",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 18,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 18.01,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 6.01,
    y2: 12
  }));
}

var _excluded$iw = ["size", "color", "stroke"];

function IconCash(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cash",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 14,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9v-2a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2"
  }));
}

var _excluded$iv = ["size", "color", "stroke"];

function IconCast(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iv);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cast",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 19,
    x2: 3.01,
    y2: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 19a4 4 0 0 0 -4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 19a8 8 0 0 0 -8 -8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19h3a3 3 0 0 0 3 -3v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -2.8 2"
  }));
}

var _excluded$iu = ["size", "color", "stroke"];

function IconCe(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iu);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ce",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4a8 8 0 1 0 0 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4a8 8 0 1 0 0 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 20,
    y2: 12
  }));
}

var _excluded$it = ["size", "color", "stroke"];

function IconCellSignal1(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$it);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell-signal-1",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
  }));
}

var _excluded$is = ["size", "color", "stroke"];

function IconCellSignal2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$is);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell-signal-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20v-5"
  }));
}

var _excluded$ir = ["size", "color", "stroke"];

function IconCellSignal3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ir);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell-signal-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20v-9"
  }));
}

var _excluded$iq = ["size", "color", "stroke"];

function IconCellSignal4(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$iq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell-signal-4",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7v13"
  }));
}

var _excluded$ip = ["size", "color", "stroke"];

function IconCellSignal5(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ip);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell-signal-5",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a0.731 .731 0 0 1 1.249 .517v15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7v13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20v-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20v-5"
  }));
}

var _excluded$io = ["size", "color", "stroke"];

function IconCellSignalOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$io);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell-signal-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20h-15.269a0.731 .731 0 0 1 -.517 -1.249l7.265 -7.264m2 -2.001l5.272 -5.272a0.731 .731 0 0 1 1.249 .517v11.269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$in = ["size", "color", "stroke"];

function IconCell(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$in);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cell",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4l-4 2v5l4 2l4 -2v-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11l4 2l4 -2v-5l-4 -2l-4 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v5l4 2l4 -2v-5"
  }));
}

var _excluded$im = ["size", "color", "stroke"];

function IconCertificate2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$im);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-certificate-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18v4l2 -1l2 1v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19h-2a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-2"
  }));
}

var _excluded$il = ["size", "color", "stroke"];

function IconCertificate(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$il);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-certificate",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17.5v4.5l2 -1.5l2 1.5v-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -1 1.73"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 9,
    x2: 18,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 9,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 15,
    x2: 8,
    y2: 15
  }));
}

var _excluded$ik = ["size", "color", "stroke"];

function IconChargingPile(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ik);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-charging-pile",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 7,
    x2: 17,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.5l-1.5 2.5h3l-1.5 2.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 20,
    x2: 15,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 14,
    y2: 8
  }));
}

var _excluded$ij = ["size", "color", "stroke"];

function IconChartArcs3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ij);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-arcs-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12a5 5 0 1 0 5 -5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29 18.957a9 9 0 1 0 5.71 -15.957"
  }));
}

var _excluded$ii = ["size", "color", "stroke"];

function IconChartArcs(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ii);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-arcs",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.924 11.132a5 5 0 1 0 -4.056 5.792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12a9 9 0 1 0 9 -9"
  }));
}

var _excluded$ih = ["size", "color", "stroke"];

function IconChartAreaLine(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ih);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-area-line",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "4 19 8 13 12 15 16 10 20 14 20 19 4 19"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "4 12 7 8 11 10 16 4 20 8"
  }));
}

var _excluded$ig = ["size", "color", "stroke"];

function IconChartArea(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ig);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-area",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 20,
    y2: 19
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "4 15 8 9 12 11 16 6 20 10 20 15 4 15"
  }));
}

var _excluded$if = ["size", "color", "stroke"];

function IconChartArrowsVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$if);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-arrows-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 21v-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15l3 -3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10l3 -3l3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6l3 -3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21v-18"
  }));
}

var _excluded$ie = ["size", "color", "stroke"];

function IconChartArrows(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ie);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-arrows",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 18,
    x2: 17,
    y2: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 3,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 3l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 21,
    y2: 6
  }));
}

var _excluded$id = ["size", "color", "stroke"];

function IconChartBar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$id);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-bar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 6,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 6,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 4,
    width: 6,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 18,
    y2: 20
  }));
}

var _excluded$ic = ["size", "color", "stroke"];

function IconChartBubble(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ic);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-bubble",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 7.5,
    r: 4.5
  }));
}

var _excluded$ib = ["size", "color", "stroke"];

function IconChartCandle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ib);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-candle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 4,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 6,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 11,
    x2: 6,
    y2: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 4,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5,
    width: 4,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 4,
    x2: 18,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 11,
    x2: 18,
    y2: 20
  }));
}

var _excluded$ia = ["size", "color", "stroke"];

function IconChartCircles(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ia);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-circles",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 5.5
  }));
}

var _excluded$i9 = ["size", "color", "stroke"];

function IconChartDonut2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$i9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-donut-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v5m4 4h5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$i8 = ["size", "color", "stroke"];

function IconChartDonut3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$i8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-donut-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v5m4 4h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.929 14.582l-3.429 2.918"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$i7 = ["size", "color", "stroke"];

function IconChartDonut4(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$i7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-donut-4",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.848 14.667l-3.348 2.833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v5m4 4h5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.219 15.328l2.781 4.172"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }));
}

var _excluded$i6 = ["size", "color", "stroke"];

function IconChartDonut(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$i6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-donut",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-3.8a4.1 4.1 0 1 1 -5 -5v-4a0.9 .9 0 0 0 -1 -.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a9 9 0 0 0 -1 -1v-4.5"
  }));
}

var _excluded$i5 = ["size", "color", "stroke"];

function IconChartDots(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$i5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-dots",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3v18h18"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 7,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 15,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.16,
    y1: 10.62,
    x2: 12.5,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.088 13.328l2.837 -4.586"
  }));
}

var _excluded$i4 = ["size", "color", "stroke"];

function IconChartInfographic(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$i4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-infographic",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3v4h4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 17,
    x2: 9,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 14,
    x2: 17,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 13,
    x2: 13,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 21,
    y2: 21
  }));
}

var _excluded$i3 = ["size", "color", "stroke"];

function IconChartLine(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$i3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-line",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 20,
    y2: 19
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "4 15 8 9 12 11 16 6 20 10"
  }));
}

var _excluded$i2 = ["size", "color", "stroke"];

function IconChartPie2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$i2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-pie-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v9h9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$i1 = ["size", "color", "stroke"];

function IconChartPie3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$i1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-pie-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l-6.5 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v9h9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$i0 = ["size", "color", "stroke"];

function IconChartPie4(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$i0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-pie-4",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l-6.5 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v9h9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l5 7.5"
  }));
}

var _excluded$h$ = ["size", "color", "stroke"];

function IconChartPie(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$h$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-pie",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-6.8a2 2 0 0 1 -2 -2v-7a0.9 .9 0 0 0 -1 -.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a1 1 0 0 1 -1 -1v-4.5"
  }));
}

var _excluded$h_ = ["size", "color", "stroke"];

function IconChartRadar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$h_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chart-radar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3l9.5 7l-3.5 11h-12l-3.5 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5l5.5 4l-2.5 5.5h-6.5l-2 -5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10l9.5 3l9.5 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v10l6 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21l6 -8"
  }));
}

var _excluded$hZ = ["size", "color", "stroke"];

function IconCheck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-check",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12l5 5l10 -10"
  }));
}

var _excluded$hY = ["size", "color", "stroke"];

function IconCheckbox(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-checkbox",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 11 12 14 20 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9"
  }));
}

var _excluded$hX = ["size", "color", "stroke"];

function IconChecklist(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-checklist",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.615 20h-2.615a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19l2 2l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12h2"
  }));
}

var _excluded$hW = ["size", "color", "stroke"];

function IconChecks(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-checks",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12l5 5l10 -10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12l5 5m5 -5l5 -5"
  }));
}

var _excluded$hV = ["size", "color", "stroke"];

function IconCheckupList(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-checkup-list",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16l1 1l3 -3"
  }));
}

var _excluded$hU = ["size", "color", "stroke"];

function IconCheese(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cheese",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.519 20.008l16.481 -.008v-3.5a2 2 0 1 1 0 -4v-3.5h-16.722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9l-9.385 -4.992c-2.512 .12 -4.758 1.42 -6.327 3.425c-1.423 1.82 -2.288 4.221 -2.288 6.854c0 2.117 .56 4.085 1.519 5.721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16v.01"
  }));
}

var _excluded$hT = ["size", "color", "stroke"];

function IconChevronDownLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-down-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8v8h8"
  }));
}

var _excluded$hS = ["size", "color", "stroke"];

function IconChevronDownRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-down-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8v8h-8"
  }));
}

var _excluded$hR = ["size", "color", "stroke"];

function IconChevronDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6 9 12 15 18 9"
  }));
}

var _excluded$hQ = ["size", "color", "stroke"];

function IconChevronLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 6 9 12 15 18"
  }));
}

var _excluded$hP = ["size", "color", "stroke"];

function IconChevronRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 6 15 12 9 18"
  }));
}

var _excluded$hO = ["size", "color", "stroke"];

function IconChevronUpLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-up-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16v-8h8"
  }));
}

var _excluded$hN = ["size", "color", "stroke"];

function IconChevronUpRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-up-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h8v8"
  }));
}

var _excluded$hM = ["size", "color", "stroke"];

function IconChevronUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevron-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6 15 12 9 18 15"
  }));
}

var _excluded$hL = ["size", "color", "stroke"];

function IconChevronsDownLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-down-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5v8h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9v8h8"
  }));
}

var _excluded$hK = ["size", "color", "stroke"];

function IconChevronsDownRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-down-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5v8h-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9v8h-8"
  }));
}

var _excluded$hJ = ["size", "color", "stroke"];

function IconChevronsDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 7 12 12 17 7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 13 12 18 17 13"
  }));
}

var _excluded$hI = ["size", "color", "stroke"];

function IconChevronsLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "11 7 6 12 11 17"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 7 12 12 17 17"
  }));
}

var _excluded$hH = ["size", "color", "stroke"];

function IconChevronsRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 7 12 12 7 17"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "13 7 18 12 13 17"
  }));
}

var _excluded$hG = ["size", "color", "stroke"];

function IconChevronsUpLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-up-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 15v-8h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 19v-8h8"
  }));
}

var _excluded$hF = ["size", "color", "stroke"];

function IconChevronsUpRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-up-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7h8v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11h8v8"
  }));
}

var _excluded$hE = ["size", "color", "stroke"];

function IconChevronsUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-chevrons-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 11 12 6 17 11"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 17 12 12 17 17"
  }));
}

var _excluded$hD = ["size", "color", "stroke"];

function IconChristmasTree(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-christmas-tree",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3l4 4l-2 1l4 4l-3 1l4 4h-14l4 -4l-3 -1l4 -4l-2 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-3"
  }));
}

var _excluded$hC = ["size", "color", "stroke"];

function IconCircle0(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-0",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$hB = ["size", "color", "stroke"];

function IconCircle1(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-1",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16v-8l-2 2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$hA = ["size", "color", "stroke"];

function IconCircle2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$hz = ["size", "color", "stroke"];

function IconCircle3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12a2 2 0 1 0 -2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14a2 2 0 1 0 2 -2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$hy = ["size", "color", "stroke"];

function IconCircle4(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hy);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-4",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16v-8l-4 6h5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$hx = ["size", "color", "stroke"];

function IconCircle5(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hx);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-5",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16h2a2 2 0 1 0 0 -4h-2v-4h4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$hw = ["size", "color", "stroke"];

function IconCircle6(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-6",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10a2 2 0 1 0 -4 0v4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$hv = ["size", "color", "stroke"];

function IconCircle7(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hv);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-7",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8h4l-2 8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$hu = ["size", "color", "stroke"];

function IconCircle8(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hu);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-8",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$ht = ["size", "color", "stroke"];

function IconCircle9(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ht);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-9",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14a2 2 0 1 0 4 0v-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$hs = ["size", "color", "stroke"];

function IconCircleCheck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hs);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-check",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12l2 2l4 -4"
  }));
}

var _excluded$hr = ["size", "color", "stroke"];

function IconCircleDashed(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hr);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-dashed",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56 3.69a9 9 0 0 0 -2.92 1.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69 8.56a9 9 0 0 0 -.69 3.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69 15.44a9 9 0 0 0 1.95 2.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56 20.31a9 9 0 0 0 3.44 .69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.31 15.44a9 9 0 0 0 .69 -3.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
  }));
}

var _excluded$hq = ["size", "color", "stroke"];

function IconCircleDot(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-dot",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$hp = ["size", "color", "stroke"];

function IconCircleDotted(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hp);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-dotted",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 4.21,
    x2: 7.5,
    y2: 4.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.21,
    y1: 7.5,
    x2: 4.21,
    y2: 7.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 3,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.21,
    y1: 16.5,
    x2: 4.21,
    y2: 16.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 19.79,
    x2: 7.5,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 21.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 19.79,
    x2: 16.5,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.79,
    y1: 16.5,
    x2: 19.79,
    y2: 16.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 21,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.79,
    y1: 7.5,
    x2: 19.79,
    y2: 7.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 4.21,
    x2: 16.5,
    y2: 4.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 3.01
  }));
}

var _excluded$ho = ["size", "color", "stroke"];

function IconCircleHalf2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ho);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-half-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14l7 -7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19l8.5 -8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9l4.5 -4.5"
  }));
}

var _excluded$hn = ["size", "color", "stroke"];

function IconCircleHalfVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hn);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-half-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h18"
  }));
}

var _excluded$hm = ["size", "color", "stroke"];

function IconCircleHalf(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hm);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-half",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v18"
  }));
}

var _excluded$hl = ["size", "color", "stroke"];

function IconCircleMinus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hl);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-minus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }));
}

var _excluded$hk = ["size", "color", "stroke"];

function IconCircleOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hk);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$hj = ["size", "color", "stroke"];

function IconCirclePlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 15
  }));
}

var _excluded$hi = ["size", "color", "stroke"];

function IconCircleRectangle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hi);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-rectangle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10h10v4h-10z"
  }));
}

var _excluded$hh = ["size", "color", "stroke"];

function IconCircleSquare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hh);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-square",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 11,
    height: 11,
    rx: 2
  }));
}

var _excluded$hg = ["size", "color", "stroke"];

function IconCircleTriangle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hg);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-triangle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20l7 -12h-14z"
  }));
}

var _excluded$hf = ["size", "color", "stroke"];

function IconCircleX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hf);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10l4 4m0 -4l-4 4"
  }));
}

var _excluded$he = ["size", "color", "stroke"];

function IconCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$he);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$hd = ["size", "color", "stroke"];

function IconCircles(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hd);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-circles",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 17,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17,
    r: 4
  }));
}

var _excluded$hc = ["size", "color", "stroke"];

function IconClearAll(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hc);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clear-all",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18h12"
  }));
}

var _excluded$hb = ["size", "color", "stroke"];

function IconClearFormatting(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$hb);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clear-formatting",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15l4 4m0 -4l-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6v-1h11v1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 11,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 5,
    x2: 9,
    y2: 19
  }));
}

var _excluded$ha = ["size", "color", "stroke"];

function IconClick(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ha);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-click",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 6,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.8,
    y1: 7.8,
    x2: 5.6,
    y2: 5.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.2,
    y1: 7.8,
    x2: 18.4,
    y2: 5.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.8,
    y1: 16.2,
    x2: 5.6,
    y2: 18.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l9 3l-4 2l-2 4l-3 -9"
  }));
}

var _excluded$h9 = ["size", "color", "stroke"];

function IconClipboardCheck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$h9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-check",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14l2 2l4 -4"
  }));
}

var _excluded$h8 = ["size", "color", "stroke"];

function IconClipboardList(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$h8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-list",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 9.01,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 12,
    x2: 15,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9.01,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 16,
    x2: 15,
    y2: 16
  }));
}

var _excluded$h7 = ["size", "color", "stroke"];

function IconClipboardPlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$h7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v4"
  }));
}

var _excluded$h6 = ["size", "color", "stroke"];

function IconClipboardText(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$h6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-text",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16h6"
  }));
}

var _excluded$h5 = ["size", "color", "stroke"];

function IconClipboardX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$h5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12l4 4m0 -4l-4 4"
  }));
}

var _excluded$h4 = ["size", "color", "stroke"];

function IconClipboard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$h4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clipboard",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }));
}

var _excluded$h3 = ["size", "color", "stroke"];

function IconClock(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$h3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clock",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 7 12 12 15 15"
  }));
}

var _excluded$h2 = ["size", "color", "stroke"];

function IconCloudDownload(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$h2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-download",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 13,
    x2: 12,
    y2: 22
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 19 12 22 15 19"
  }));
}

var _excluded$h1 = ["size", "color", "stroke"];

function IconCloudFog(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$h1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-fog",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 16a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 20,
    x2: 19,
    y2: 20
  }));
}

var _excluded$h0 = ["size", "color", "stroke"];

function IconCloudLockOpen(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$h0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-lock-open",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18a3.5 3.5 0 0 0 0 -7h-1c.397 -1.768 -.285 -3.593 -1.788 -4.787c-1.503 -1.193 -3.6 -1.575 -5.5 -1s-3.315 2.019 -3.712 3.787c-2.199 -.088 -4.155 1.326 -4.666 3.373c-.512 2.047 .564 4.154 2.566 5.027"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 8,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15v-2a2 2 0 0 1 3.736 -.994"
  }));
}

var _excluded$g$ = ["size", "color", "stroke"];

function IconCloudLock(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$g$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-lock",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18a3.5 3.5 0 0 0 0 -7h-1c.397 -1.768 -.285 -3.593 -1.788 -4.787c-1.503 -1.193 -3.6 -1.575 -5.5 -1s-3.315 2.019 -3.712 3.787c-2.199 -.088 -4.155 1.326 -4.666 3.373c-.512 2.047 .564 4.154 2.566 5.027"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 8,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15v-2a2 2 0 1 1 4 0v2"
  }));
}

var _excluded$g_ = ["size", "color", "stroke"];

function IconCloudOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$g_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18h-11c-2.598 0 -4.705 -2.015 -4.705 -4.5s2.107 -4.5 4.705 -4.5c.112 -.5 .305 -.973 .568 -1.408m2.094 -1.948c.329 -.174 .68 -.319 1.05 -.43c1.9 -.576 3.997 -.194 5.5 1c1.503 1.192 2.185 3.017 1.788 4.786h1a3.5 3.5 0 0 1 2.212 6.212"
  }));
}

var _excluded$gZ = ["size", "color", "stroke"];

function IconCloudRain(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-rain",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13v2m0 3v2m4 -5v2m0 3v2"
  }));
}

var _excluded$gY = ["size", "color", "stroke"];

function IconCloudSnow(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-snow",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15v.01m0 3v.01m0 3v.01m4 -4v.01m0 3v.01"
  }));
}

var _excluded$gX = ["size", "color", "stroke"];

function IconCloudStorm(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-storm",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "13 14 11 18 14 18 12 22"
  }));
}

var _excluded$gW = ["size", "color", "stroke"];

function IconCloudUpload(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud-upload",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 15 12 12 15 15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 21
  }));
}

var _excluded$gV = ["size", "color", "stroke"];

function IconCloud(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cloud",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-12"
  }));
}

var _excluded$gU = ["size", "color", "stroke"];

function IconClubs(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-clubs",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a4 4 0 0 1 3.164 6.447a4 4 0 1 1 -1.164 6.198v1.355l1 4h-6l1 -4l.001 -1.355a4 4 0 1 1 -1.164 -6.199a4 4 0 0 1 3.163 -6.446z"
  }));
}

var _excluded$gT = ["size", "color", "stroke"];

function IconCodeMinus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-code-minus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
  }));
}

var _excluded$gS = ["size", "color", "stroke"];

function IconCodePlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-code-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
  }));
}

var _excluded$gR = ["size", "color", "stroke"];

function IconCode(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-code",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 8 3 12 7 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 8 21 12 17 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 4,
    x2: 10,
    y2: 20
  }));
}

var _excluded$gQ = ["size", "color", "stroke"];

function IconCoffee(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coffee",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14c.83 .642 2.077 1.017 3.5 1c1.423 .017 2.67 -.358 3.5 -1c.83 -.642 2.077 -1.017 3.5 -1c1.423 -.017 2.67 .358 3.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10h14v5a6 6 0 0 1 -6 6h-2a6 6 0 0 1 -6 -6v-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.746 16.726a3 3 0 1 0 .252 -5.555"
  }));
}

var _excluded$gP = ["size", "color", "stroke"];

function IconCoin(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-coin",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4h-2a2 2 0 0 1 -1.8 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6v2m0 8v2"
  }));
}

var _excluded$gO = ["size", "color", "stroke"];

function IconColorPicker(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-color-picker",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7l6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16l11.7 -11.7a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-11.7 11.7h-4v-4z"
  }));
}

var _excluded$gN = ["size", "color", "stroke"];

function IconColorSwatch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-color-swatch",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 3h-4a2 2 0 0 0 -2 2v12a4 4 0 0 0 8 0v-12a2 2 0 0 0 -2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7.35l-2 -2a2 2 0 0 0 -2.828 0l-2.828 2.828a2 2 0 0 0 0 2.828l9 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3 13h-2.3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 17,
    y2: 17.01
  }));
}

var _excluded$gM = ["size", "color", "stroke"];

function IconColumnInsertLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-column-insert-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 9,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 7,
    y2: 14
  }));
}

var _excluded$gL = ["size", "color", "stroke"];

function IconColumnInsertRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-column-insert-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 10,
    x2: 17,
    y2: 14
  }));
}

var _excluded$gK = ["size", "color", "stroke"];

function IconColumns(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-columns",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 9.5,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 10,
    x2: 9.5,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 14,
    x2: 9.5,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 9.5,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 10,
    x2: 20,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 14,
    x2: 20,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 18,
    x2: 20,
    y2: 18
  }));
}

var _excluded$gJ = ["size", "color", "stroke"];

function IconComet(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-comet",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 11,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 4,
    x2: 12.5,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 9,
    x2: 7.5,
    y2: 12.5
  }));
}

var _excluded$gI = ["size", "color", "stroke"];

function IconCommand(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-command",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9a2 2 0 1 1 2 -2v10a2 2 0 1 1 -2 -2h10a2 2 0 1 1 -2 2v-10a2 2 0 1 1 2 2h-10"
  }));
}

var _excluded$gH = ["size", "color", "stroke"];

function IconCompass(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-compass",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 16 10 10 16 8 14 14 8 16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 5,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 21,
    y2: 12
  }));
}

var _excluded$gG = ["size", "color", "stroke"];

function IconComponents(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-components",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12l3 3l3 -3l-3 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12l3 3l3 -3l-3 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6l3 3l3 -3l-3 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18l3 3l3 -3l-3 -3z"
  }));
}

var _excluded$gF = ["size", "color", "stroke"];

function IconCone2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cone-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 7,
    rx: 7,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 7v.5l-7 12.5l-7 -12.5v-.5"
  }));
}

var _excluded$gE = ["size", "color", "stroke"];

function IconCone(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cone",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 0 0 -1 0 34)",
    cx: 12,
    cy: 17,
    rx: 7,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 17v-.5l-7 -12.5l-7 12.5v.5"
  }));
}

var _excluded$gD = ["size", "color", "stroke"];

function IconConfetti(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-confetti",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4l-.5 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9l-1 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13l2 -.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16.518l-6.518 -6.518l-4.39 9.58a1.003 1.003 0 0 0 1.329 1.329l9.579 -4.39z"
  }));
}

var _excluded$gC = ["size", "color", "stroke"];

function IconContainer(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-container",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8v.01"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 8,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v.01"
  }));
}

var _excluded$gB = ["size", "color", "stroke"];

function IconContrast2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-contrast-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18h2a6 6 0 0 0 6 -6a6 6 0 0 1 6 -6h2"
  }));
}

var _excluded$gA = ["size", "color", "stroke"];

function IconContrast(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-contrast",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17a5 5 0 0 0 0 -10v10"
  }));
}

var _excluded$gz = ["size", "color", "stroke"];

function IconCookie(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cookie",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.148 3.476l2.667 1.104a4 4 0 0 0 4.656 6.14l.053 .132a3 3 0 0 1 0 2.296c-.497 .786 -.838 1.404 -1.024 1.852c-.189 .456 -.409 1.194 -.66 2.216a3 3 0 0 1 -1.624 1.623c-1.048 .263 -1.787 .483 -2.216 .661c-.475 .197 -1.092 .538 -1.852 1.024a3 3 0 0 1 -2.296 0c-.802 -.503 -1.419 -.844 -1.852 -1.024c-.471 -.195 -1.21 -.415 -2.216 -.66a3 3 0 0 1 -1.623 -1.624c-.265 -1.052 -.485 -1.79 -.661 -2.216c-.198 -.479 -.54 -1.096 -1.024 -1.852a3 3 0 0 1 0 -2.296c.48 -.744 .82 -1.361 1.024 -1.852c.171 -.413 .391 -1.152 .66 -2.216a3 3 0 0 1 1.624 -1.623c1.032 -.256 1.77 -.476 2.216 -.661c.458 -.19 1.075 -.531 1.852 -1.024a3 3 0 0 1 2.296 0z"
  }));
}

var _excluded$gy = ["size", "color", "stroke"];

function IconCopy(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gy);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-copy",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 12,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
  }));
}

var _excluded$gx = ["size", "color", "stroke"];

function IconCopyleft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gx);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-copyleft",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.75a3.016 3.016 0 0 1 4.163 .173a2.993 2.993 0 0 1 0 4.154a3.016 3.016 0 0 1 -4.163 .173"
  }));
}

var _excluded$gw = ["size", "color", "stroke"];

function IconCopyright(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-copyright",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9.75a3.016 3.016 0 0 0 -4.163 .173a2.993 2.993 0 0 0 0 4.154a3.016 3.016 0 0 0 4.163 .173"
  }));
}

var _excluded$gv = ["size", "color", "stroke"];

function IconCornerDownLeftDouble(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gv);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-down-left-double",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 5v6a3 3 0 0 1 -3 3h-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10l-4 4l4 4m-5 -8l-4 4l4 4"
  }));
}

var _excluded$gu = ["size", "color", "stroke"];

function IconCornerDownLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gu);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-down-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6v6a3 3 0 0 1 -3 3h-10l4 -4m0 8l-4 -4"
  }));
}

var _excluded$gt = ["size", "color", "stroke"];

function IconCornerDownRightDouble(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gt);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-down-right-double",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5v6a3 3 0 0 0 3 3h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10l4 4l-4 4m5 -8l4 4l-4 4"
  }));
}

var _excluded$gs = ["size", "color", "stroke"];

function IconCornerDownRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gs);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-down-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6v6a3 3 0 0 0 3 3h10l-4 -4m0 8l4 -4"
  }));
}

var _excluded$gr = ["size", "color", "stroke"];

function IconCornerLeftDownDouble(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gr);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-left-down-double",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4h-6a3 3 0 0 0 -3 3v7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10l-4 4l-4 -4m8 5l-4 4l-4 -4"
  }));
}

var _excluded$gq = ["size", "color", "stroke"];

function IconCornerLeftDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-left-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6h-6a3 3 0 0 0 -3 3v10l-4 -4m8 0l-4 4"
  }));
}

var _excluded$gp = ["size", "color", "stroke"];

function IconCornerLeftUpDouble(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gp);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-left-up-double",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19h-6a3 3 0 0 1 -3 -3v-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13l-4 -4l-4 4m8 -5l-4 -4l-4 4"
  }));
}

var _excluded$go = ["size", "color", "stroke"];

function IconCornerLeftUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$go);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-left-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18h-6a3 3 0 0 1 -3 -3v-10l-4 4m8 0l-4 -4"
  }));
}

var _excluded$gn = ["size", "color", "stroke"];

function IconCornerRightDownDouble(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gn);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-right-down-double",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h6a3 3 0 0 1 3 3v7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10l4 4l4 -4m-8 5l4 4l4 -4"
  }));
}

var _excluded$gm = ["size", "color", "stroke"];

function IconCornerRightDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gm);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-right-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6h6a3 3 0 0 1 3 3v10l-4 -4m8 0l-4 4"
  }));
}

var _excluded$gl = ["size", "color", "stroke"];

function IconCornerRightUpDouble(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gl);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-right-up-double",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19h6a3 3 0 0 0 3 -3v-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13l4 -4l4 4m-8 -5l4 -4l4 4"
  }));
}

var _excluded$gk = ["size", "color", "stroke"];

function IconCornerRightUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gk);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-right-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18h6a3 3 0 0 0 3 -3v-10l-4 4m8 0l-4 -4"
  }));
}

var _excluded$gj = ["size", "color", "stroke"];

function IconCornerUpLeftDouble(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-up-left-double",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18v-6a3 3 0 0 0 -3 -3h-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13l-4 -4l4 -4m-5 8l-4 -4l4 -4"
  }));
}

var _excluded$gi = ["size", "color", "stroke"];

function IconCornerUpLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gi);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-up-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18v-6a3 3 0 0 0 -3 -3h-10l4 -4m0 8l-4 -4"
  }));
}

var _excluded$gh = ["size", "color", "stroke"];

function IconCornerUpRightDouble(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gh);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-up-right-double",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18v-6a3 3 0 0 1 3 -3h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13l4 -4l-4 -4m5 8l4 -4l-4 -4"
  }));
}

var _excluded$gg = ["size", "color", "stroke"];

function IconCornerUpRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gg);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-corner-up-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18v-6a3 3 0 0 1 3 -3h10l-4 -4m0 8l4 -4"
  }));
}

var _excluded$gf = ["size", "color", "stroke"];

function IconCpu2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gf);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cpu-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10v-2h2m6 6v2h-2m-4 0h-2v-2m8 -4v-2h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 21v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21v-2"
  }));
}

var _excluded$ge = ["size", "color", "stroke"];

function IconCpu(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ge);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cpu",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9h6v6h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 21v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21v-2"
  }));
}

var _excluded$gd = ["size", "color", "stroke"];

function IconCrane(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gd);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crane",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21v-18l-6 6h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3l10 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9v4a2 2 0 1 1 -2 2"
  }));
}

var _excluded$gc = ["size", "color", "stroke"];

function IconCreativeCommons(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gc);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-creative-commons",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
  }));
}

var _excluded$gb = ["size", "color", "stroke"];

function IconCreditCardOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$gb);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-credit-card-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5h9a3 3 0 0 1 3 3v8a3 3 0 0 1 -.128 .87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.87 18.872a3 3 0 0 1 -.87 .128h-12a3 3 0 0 1 -3 -3v-8c0 -1.352 .894 -2.495 2.124 -2.87"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 11,
    x2: 11,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 11,
    x2: 21,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 15,
    x2: 7.01,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 15,
    x2: 13,
    y2: 15
  }));
}

var _excluded$ga = ["size", "color", "stroke"];

function IconCreditCard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ga);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-credit-card",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 21,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 15,
    x2: 7.01,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 15,
    x2: 13,
    y2: 15
  }));
}

var _excluded$g9 = ["size", "color", "stroke"];

function IconCrop(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$g9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crop",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5v10a1 1 0 0 0 1 1h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8h10a1 1 0 0 1 1 1v10"
  }));
}

var _excluded$g8 = ["size", "color", "stroke"];

function IconCross(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$g8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cross",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21h4v-9h5v-4h-5v-5h-4v5h-5v4h5z"
  }));
}

var _excluded$g7 = ["size", "color", "stroke"];

function IconCrosshair(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$g7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crosshair",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 15
  }));
}

var _excluded$g6 = ["size", "color", "stroke"];

function IconCrownOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$g6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crown-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18h-13l-1.865 -9.327a0.25 .25 0 0 1 .4 -.244l4.465 3.571l1.6 -2.4m1.596 -2.394l.804 -1.206l4 6l4.464 -3.571a0.25 .25 0 0 1 .401 .244l-1.363 6.818"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$g5 = ["size", "color", "stroke"];

function IconCrown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$g5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crown",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4z"
  }));
}

var _excluded$g4 = ["size", "color", "stroke"];

function IconCrutches(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$g4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-crutches",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 8,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 21h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-4.092a3 3 0 0 1 .504 -1.664l.992 -1.488a3 3 0 0 0 .504 -1.664v-5.092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-4.092a3 3 0 0 0 -.504 -1.664l-.992 -1.488a3 3 0 0 1 -.504 -1.664v-5.092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11h4"
  }));
}

var _excluded$g3 = ["size", "color", "stroke"];

function IconCup(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$g3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cup",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11h14v-3h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11l-1.5 10h-8l-1.5 -10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5v-2"
  }));
}

var _excluded$g2 = ["size", "color", "stroke"];

function IconCurling(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$g2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-curling",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 16,
    height: 10,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5h6a2 2 0 0 1 2 2v2"
  }));
}

var _excluded$g1 = ["size", "color", "stroke"];

function IconCurlyLoop(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$g1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-curly-loop",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 8c-4 0 -7 2 -7 5a3 3 0 0 0 6 0c0 -3 -2.5 -5 -8 -5s-8 2 -8 5a3 3 0 0 0 6 0c0 -3 -3 -5 -7 -5"
  }));
}

var _excluded$g0 = ["size", "color", "stroke"];

function IconCurrencyBahraini(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$g0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-bahraini",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10v1a4 4 0 0 0 4 4h2a2 2 0 0 0 2 -2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 19.01v-.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15.01v-.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15h2.004a2 2 0 0 0 1.649 -3.131l-2.653 -3.869"
  }));
}

var _excluded$f$ = ["size", "color", "stroke"];

function IconCurrencyBaht(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$f$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-baht",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6h5a3 3 0 0 1 3 3v.143a2.857 2.857 0 0 1 -2.857 2.857h-5.143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12h5a3 3 0 0 1 3 3v.143a2.857 2.857 0 0 1 -2.857 2.857h-5.143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18v2"
  }));
}

var _excluded$f_ = ["size", "color", "stroke"];

function IconCurrencyBitcoin(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$f_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-bitcoin",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6h8a3 3 0 0 1 0 6a3 3 0 0 1 0 6h-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 6,
    x2: 8,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 14,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 3,
    x2: 9,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 3,
    x2: 13,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 18,
    x2: 9,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 18,
    x2: 13,
    y2: 21
  }));
}

var _excluded$fZ = ["size", "color", "stroke"];

function IconCurrencyCent(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-cent",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.007 7.54a5.965 5.965 0 0 0 -4.008 -1.54a5.996 5.996 0 0 0 -5.992 6c0 3.314 2.682 6 5.992 6a5.965 5.965 0 0 0 4.004 -1.536"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6v-2"
  }));
}

var _excluded$fY = ["size", "color", "stroke"];

function IconCurrencyDinar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dinar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20.01v-.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 13l2.386 -.9a1 1 0 0 0 -.095 -1.902l-1.514 -.404a1 1 0 0 1 -.102 -1.9l2.325 -.894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14v1a3 3 0 0 0 3 3h4.161a3 3 0 0 0 2.983 -3.32l-1.144 -10.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17l1 1h2.004a2 2 0 0 0 1.649 -3.131l-2.653 -3.869"
  }));
}

var _excluded$fX = ["size", "color", "stroke"];

function IconCurrencyDirham(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dirham",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19h-3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.599 16.479a1.5 1.5 0 1 0 -1.099 2.521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13h1.888a1.5 1.5 0 0 0 1.296 -2.256l-2.184 -3.744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13.01v-.01"
  }));
}

var _excluded$fW = ["size", "color", "stroke"];

function IconCurrencyDogecoin(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dogecoin",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18h6a6 6 0 1 0 0 -12h-6"
  }));
}

var _excluded$fV = ["size", "color", "stroke"];

function IconCurrencyDollarAustralian(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dollar-australian",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18l3.279 -11.476a0.75 .75 0 0 1 1.442 0l3.279 11.476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14h5"
  }));
}

var _excluded$fU = ["size", "color", "stroke"];

function IconCurrencyDollarCanadian(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dollar-canadian",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18h-1a6 6 0 1 1 0 -12h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6v-2"
  }));
}

var _excluded$fT = ["size", "color", "stroke"];

function IconCurrencyDollarSingapore(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dollar-singapore",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6h-4a3 3 0 1 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6v-2"
  }));
}

var _excluded$fS = ["size", "color", "stroke"];

function IconCurrencyDollar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-dollar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v3m0 12v3"
  }));
}

var _excluded$fR = ["size", "color", "stroke"];

function IconCurrencyEthereum(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-ethereum",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12l6 -9l6 9l-6 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12l6 -3l6 3l-6 2z"
  }));
}

var _excluded$fQ = ["size", "color", "stroke"];

function IconCurrencyEuro(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-euro",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 7a6 7 0 1 0 0 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10h-8m0 4h8"
  }));
}

var _excluded$fP = ["size", "color", "stroke"];

function IconCurrencyForint(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-forint",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4h-4a3 3 0 0 0 -3 3v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11h-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4v13a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9h-5"
  }));
}

var _excluded$fO = ["size", "color", "stroke"];

function IconCurrencyFrank(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-frank",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 5h-6a2 2 0 0 0 -2 2v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 15h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11h7"
  }));
}

var _excluded$fN = ["size", "color", "stroke"];

function IconCurrencyKroneCzech(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-krone-czech",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12c3.5 0 6 -3 6 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12c3.5 0 6 3 6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6l-2 2l-2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 12h-2a3 3 0 0 0 0 6h2"
  }));
}

var _excluded$fM = ["size", "color", "stroke"];

function IconCurrencyKroneDanish(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-krone-danish",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12c3.5 0 6 -3 6 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12c3.5 0 6 3 6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10a4 4 0 0 0 -4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18.01v-.01"
  }));
}

var _excluded$fL = ["size", "color", "stroke"];

function IconCurrencyKroneSwedish(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-krone-swedish",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12c3.5 0 6 -3 6 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12c3.5 0 6 3 6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10a4 4 0 0 0 -4 4"
  }));
}

var _excluded$fK = ["size", "color", "stroke"];

function IconCurrencyLeu(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-leu",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18h-7a3 3 0 0 1 -3 -3v-10"
  }));
}

var _excluded$fJ = ["size", "color", "stroke"];

function IconCurrencyLira(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-lira",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5v15a7 7 0 0 0 7 -7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15l8 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7l-8 4"
  }));
}

var _excluded$fI = ["size", "color", "stroke"];

function IconCurrencyLitecoin(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-litecoin",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19h-8.194a2 2 0 0 1 -1.98 -2.283l1.674 -11.717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9l-9 4"
  }));
}

var _excluded$fH = ["size", "color", "stroke"];

function IconCurrencyNaira(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-naira",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18v-10.948a1.05 1.05 0 0 1 1.968 -.51l6.064 10.916a1.05 1.05 0 0 0 1.968 -.51v-10.948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 14h14"
  }));
}

var _excluded$fG = ["size", "color", "stroke"];

function IconCurrencyPound(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-pound",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18.5a6 6 0 0 1 -5 0a6 6 0 0 0 -5 .5a3 3 0 0 0 2 -2.5v-7.5a4 4 0 0 1 7.45 -2m-2.55 6h-7"
  }));
}

var _excluded$fF = ["size", "color", "stroke"];

function IconCurrencyReal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-real",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18v-12h3a3 3 0 1 1 0 6h-3c5.5 0 5 4 6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20v-2"
  }));
}

var _excluded$fE = ["size", "color", "stroke"];

function IconCurrencyRenminbi(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-renminbi",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9v8a2 2 0 1 0 4 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9h-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 5h-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9v4c0 2.5 -.667 4 -2 6"
  }));
}

var _excluded$fD = ["size", "color", "stroke"];

function IconCurrencyRipple(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-ripple",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 7,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12h3l2 -2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14.5l-2 -2.5"
  }));
}

var _excluded$fC = ["size", "color", "stroke"];

function IconCurrencyRiyal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-riyal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9v2a2 2 0 1 1 -4 0v-1v1a2 2 0 1 1 -4 0v-1v4a2 2 0 1 1 -4 0v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.01v-.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 10v1a5 5 0 0 1 -5 5"
  }));
}

var _excluded$fB = ["size", "color", "stroke"];

function IconCurrencyRubel(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-rubel",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 19v-14h6a3 3 0 0 1 0 6h-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15h-8"
  }));
}

var _excluded$fA = ["size", "color", "stroke"];

function IconCurrencyRupee(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-rupee",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5h-11h3a4 4 0 0 1 0 8h-3l6 6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 9,
    x2: 18,
    y2: 9
  }));
}

var _excluded$fz = ["size", "color", "stroke"];

function IconCurrencyShekel(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-shekel",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18v-12h4a4 4 0 0 1 4 4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6v12h-4a4 4 0 0 1 -4 -4v-4"
  }));
}

var _excluded$fy = ["size", "color", "stroke"];

function IconCurrencyTaka(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fy);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-taka",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 15.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7a2 2 0 1 1 4 0v9a3 3 0 0 0 6 0v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11h6"
  }));
}

var _excluded$fx = ["size", "color", "stroke"];

function IconCurrencyTugrik(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fx);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-tugrik",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6v13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 17l8 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10l-8 3"
  }));
}

var _excluded$fw = ["size", "color", "stroke"];

function IconCurrencyWon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-won",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6l3.245 11.358a0.85 .85 0 0 0 1.624 .035l3.131 -9.393l3.131 9.393a0.85 .85 0 0 0 1.624 -.035l3.245 -11.358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10h-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14h-18"
  }));
}

var _excluded$fv = ["size", "color", "stroke"];

function IconCurrencyYen(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fv);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-yen",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19v-7l-5 -7m10 0l-5 7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 17,
    x2: 16,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 16,
    y2: 13
  }));
}

var _excluded$fu = ["size", "color", "stroke"];

function IconCurrencyZloty(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fu);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency-zloty",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18h-7l7 -7h-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18v-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5l6 -3.5"
  }));
}

var _excluded$ft = ["size", "color", "stroke"];

function IconCurrency(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ft);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-currency",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20l-3 -3"
  }));
}

var _excluded$fs = ["size", "color", "stroke"];

function IconCurrentLocation(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fs);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-current-location",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 22,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 12,
    x2: 4,
    y2: 12
  }));
}

var _excluded$fr = ["size", "color", "stroke"];

function IconCursorText(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fr);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cursor-text",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3"
  }));
}

var _excluded$fq = ["size", "color", "stroke"];

function IconCut(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-cut",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.15,
    y1: 14.85,
    x2: 18,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 14.85,
    y2: 14.85
  }));
}

var _excluded$fp = ["size", "color", "stroke"];

function IconDashboard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fp);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dashboard",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.45,
    y1: 11.55,
    x2: 15.5,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4 20a9 9 0 1 1 11.2 0z"
  }));
}

var _excluded$fo = ["size", "color", "stroke"];

function IconDatabaseExport(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fo);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-database-export",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 6,
    rx: 8,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6v6c0 1.657 3.582 3 8 3a19.84 19.84 0 0 0 3.302 -.267m4.698 -2.733v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v6c0 1.599 3.335 2.905 7.538 2.995m8.462 -6.995v-2m-6 7h7m-3 -3l3 3l-3 3"
  }));
}

var _excluded$fn = ["size", "color", "stroke"];

function IconDatabaseImport(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fn);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-database-import",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 6,
    rx: 8,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6v8m5.009 .783c.924 .14 1.933 .217 2.991 .217c4.418 0 8 -1.343 8 -3v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.252 20.987c.246 .009 .496 .013 .748 .013c4.418 0 8 -1.343 8 -3v-6m-18 7h7m-3 -3l3 3l-3 3"
  }));
}

var _excluded$fm = ["size", "color", "stroke"];

function IconDatabaseOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fm);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-database-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.983 8.978c3.955 -.182 7.017 -1.446 7.017 -2.978c0 -1.657 -3.582 -3 -8 -3c-1.661 0 -3.204 .19 -4.483 .515m-2.783 1.228c-.471 .382 -.734 .808 -.734 1.257c0 1.22 1.944 2.271 4.734 2.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6v6c0 1.657 3.582 3 8 3c.986 0 1.93 -.067 2.802 -.19m3.187 -.82c1.251 -.53 2.011 -1.228 2.011 -1.99v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v6c0 1.657 3.582 3 8 3c3.217 0 5.991 -.712 7.261 -1.74m.739 -3.26v-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$fl = ["size", "color", "stroke"];

function IconDatabase(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fl);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-database",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 6,
    rx: 8,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6v6a8 3 0 0 0 16 0v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v6a8 3 0 0 0 16 0v-6"
  }));
}

var _excluded$fk = ["size", "color", "stroke"];

function IconDental(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fk);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dental",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5c-1.074 -.586 -2.583 -1.5 -4 -1.5c-2.1 -.001 -4 1.247 -4 5c0 4.899 1.056 8.41 2.671 10.537c.573 .756 1.97 .521 2.567 -.236c.398 -.505 .819 -1.439 1.262 -2.801c.292 -.771 .892 -1.504 1.5 -1.5c.602 .004 1.21 .737 1.5 1.5c.443 1.362 .864 2.295 1.262 2.8c.597 .759 1.994 .993 2.567 .237c1.615 -2.127 2.671 -5.637 2.671 -10.537c0 -3.74 -1.908 -4.994 -4 -5c-1.423 -.004 -2.92 .911 -4 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5l3 1.5"
  }));
}

var _excluded$fj = ["size", "color", "stroke"];

function IconDetails(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-details",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v16"
  }));
}

var _excluded$fi = ["size", "color", "stroke"];

function IconDeviceAnalytics(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fi);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-analytics",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 20,
    x2: 17,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 15,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12l3 -3l2 2l3 -3"
  }));
}

var _excluded$fh = ["size", "color", "stroke"];

function IconDeviceAudioTape(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fh);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-audio-tape",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17l4 -3h10l4 3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 9.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 9.5,
    r: 0.5,
    fill: "currentColor"
  }));
}

var _excluded$fg = ["size", "color", "stroke"];

function IconDeviceCctv(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fg);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-cctv",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 7v7a7 7 0 0 1 -14 0v-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12.01,
    y2: 14
  }));
}

var _excluded$ff = ["size", "color", "stroke"];

function IconDeviceComputerCameraOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ff);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-computer-camera-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15 6.153a7 7 0 0 0 9.696 9.696m2 -2a7 7 0 0 0 -9.699 -9.695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13 9.122a3 3 0 0 0 3.743 3.749m2 -2a3 3 0 0 0 -3.737 -3.736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16l-2.091 3.486a1 1 0 0 0 .857 1.514h10.468a1 1 0 0 0 .857 -1.514l-2.091 -3.486"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$fe = ["size", "color", "stroke"];

function IconDeviceComputerCamera(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fe);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-computer-camera",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16l-2.091 3.486a1 1 0 0 0 .857 1.514h10.468a1 1 0 0 0 .857 -1.514l-2.091 -3.486"
  }));
}

var _excluded$fd = ["size", "color", "stroke"];

function IconDeviceDesktopAnalytics(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fd);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-desktop-analytics",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v-1"
  }));
}

var _excluded$fc = ["size", "color", "stroke"];

function IconDeviceDesktopOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fc);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-desktop-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4h12a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1m-4 0h-12a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 20,
    x2: 17,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 15,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$fb = ["size", "color", "stroke"];

function IconDeviceDesktop(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fb);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-desktop",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 20,
    x2: 17,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 15,
    y2: 20
  }));
}

var _excluded$fa = ["size", "color", "stroke"];

function IconDeviceFloppy(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$fa);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-floppy",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 4 14 8 8 8 8 4"
  }));
}

var _excluded$f9 = ["size", "color", "stroke"];

function IconDeviceGamepad(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$f9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-gamepad",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 20,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12h4m-2 -2v4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 11,
    x2: 15,
    y2: 11.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 13,
    x2: 18,
    y2: 13.01
  }));
}

var _excluded$f8 = ["size", "color", "stroke"];

function IconDeviceHeartMonitor(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$f8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-heart-monitor",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 9h6l1 -2l2 4l1 -2h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v.01"
  }));
}

var _excluded$f7 = ["size", "color", "stroke"];

function IconDeviceLaptopOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$f7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-laptop-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6h8a1 1 0 0 1 1 1v8m-3 1h-10a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$f6 = ["size", "color", "stroke"];

function IconDeviceLaptop(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$f6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-laptop",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 19,
    x2: 21,
    y2: 19
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 14,
    height: 10,
    rx: 1
  }));
}

var _excluded$f5 = ["size", "color", "stroke"];

function IconDeviceMobileMessage(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$f5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-mobile-message",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 3h10v8h-3l-4 2v-2h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16v4a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18v.01"
  }));
}

var _excluded$f4 = ["size", "color", "stroke"];

function IconDeviceMobileOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$f4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-mobile-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.174 3.178c.252 -.114 .531 -.178 .826 -.178h8a2 2 0 0 1 2 2v9m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$f3 = ["size", "color", "stroke"];

function IconDeviceMobileRotated(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$f3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-mobile-rotated",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 18,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12h-.01"
  }));
}

var _excluded$f2 = ["size", "color", "stroke"];

function IconDeviceMobileVibration(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$f2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-mobile-vibration",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 12,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 10,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 17,
    x2: 9,
    y2: 17.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6l-2 3l2 3l-2 3l2 3"
  }));
}

var _excluded$f1 = ["size", "color", "stroke"];

function IconDeviceMobile(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$f1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-mobile",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 12,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 4,
    x2: 13,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 17.01
  }));
}

var _excluded$f0 = ["size", "color", "stroke"];

function IconDeviceNintendo(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$f0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-nintendo",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20v-16h-3a4 4 0 0 0 -4 4v8a4 4 0 0 0 4 4h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20v-16h3a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 15.5,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 8.5,
    r: 1,
    fill: "currentColor"
  }));
}

var _excluded$e$ = ["size", "color", "stroke"];

function IconDeviceSpeaker(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$e$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-speaker",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 7.01
  }));
}

var _excluded$e_ = ["size", "color", "stroke"];

function IconDeviceTabletOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$e_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-tablet-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3h11a1 1 0 0 1 1 1v11m0 4v1a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$eZ = ["size", "color", "stroke"];

function IconDeviceTablet(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-tablet",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1
  }));
}

var _excluded$eY = ["size", "color", "stroke"];

function IconDeviceTvOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-tv-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7h8a2 2 0 0 1 2 2v8m-1.178 2.824c-.25 .113 -.529 .176 -.822 .176h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3l-4 4l-4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$eX = ["size", "color", "stroke"];

function IconDeviceTv(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-tv",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 18,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 3 12 7 8 3"
  }));
}

var _excluded$eW = ["size", "color", "stroke"];

function IconDeviceWatchOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-watch-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6h5a3 3 0 0 1 3 3v5m-.882 3.125a2.99 2.99 0 0 1 -2.118 .875h-6a3 3 0 0 1 -3 -3v-6c0 -.828 .336 -1.578 .878 -2.121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18v3h6v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5v-2h6v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$eV = ["size", "color", "stroke"];

function IconDeviceWatchStats2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-watch-stats-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18v3h6v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6v-3h6v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10a2 2 0 1 0 2 2"
  }));
}

var _excluded$eU = ["size", "color", "stroke"];

function IconDeviceWatchStats(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-watch-stats",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18v3h6v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6v-3h6v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14v-3"
  }));
}

var _excluded$eT = ["size", "color", "stroke"];

function IconDeviceWatch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-device-watch",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18v3h6v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6v-3h6v3"
  }));
}

var _excluded$eS = ["size", "color", "stroke"];

function IconDevices2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-devices-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15h-6a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 8,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 10,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 8,
    x2: 17,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 16,
    r: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 9,
    y2: 19
  }));
}

var _excluded$eR = ["size", "color", "stroke"];

function IconDevicesOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-devices-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v8m-1 3h-6a1 1 0 0 1 -1 -1v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8v-3a1 1 0 0 0 -1 -1h-9m-4 0a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$eQ = ["size", "color", "stroke"];

function IconDevicesPc(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-devices-pc",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5h6v14h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9h10v7h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 13v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16v.01"
  }));
}

var _excluded$eP = ["size", "color", "stroke"];

function IconDevices(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-devices",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 8,
    width: 8,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 9,
    x2: 18,
    y2: 9
  }));
}

var _excluded$eO = ["size", "color", "stroke"];

function IconDialpad(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dialpad",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17h4v4h-4z"
  }));
}

var _excluded$eN = ["size", "color", "stroke"];

function IconDiamond(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-diamond",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5h12l3 5l-8.5 9.5a0.7 .7 0 0 1 -1 0l-8.5 -9.5l3 -5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12l-2 -2.2l.6 -1"
  }));
}

var _excluded$eM = ["size", "color", "stroke"];

function IconDiamonds(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-diamonds",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.831 20.413l-5.375 -6.91c-.608 -.783 -.608 -2.223 0 -3.005l5.375 -6.911a1.457 1.457 0 0 1 2.338 0l5.375 6.91c.608 .783 .608 2.223 0 3.005l-5.375 6.911a1.457 1.457 0 0 1 -2.338 0z"
  }));
}

var _excluded$eL = ["size", "color", "stroke"];

function IconDice1(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice-1",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 0.5,
    fill: "currentColor"
  }));
}

var _excluded$eK = ["size", "color", "stroke"];

function IconDice2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 0.5,
    fill: "currentColor"
  }));
}

var _excluded$eJ = ["size", "color", "stroke"];

function IconDice3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 0.5,
    fill: "currentColor"
  }));
}

var _excluded$eI = ["size", "color", "stroke"];

function IconDice4(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice-4",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 8.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 15.5,
    r: 0.5,
    fill: "currentColor"
  }));
}

var _excluded$eH = ["size", "color", "stroke"];

function IconDice5(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice-5",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 8.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 15.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 0.5,
    fill: "currentColor"
  }));
}

var _excluded$eG = ["size", "color", "stroke"];

function IconDice6(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice-6",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 7.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 12,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 12,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 16.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 16.5,
    r: 0.5,
    fill: "currentColor"
  }));
}

var _excluded$eF = ["size", "color", "stroke"];

function IconDice(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dice",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 8.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 15.5,
    r: 0.5,
    fill: "currentColor"
  }));
}

var _excluded$eE = ["size", "color", "stroke"];

function IconDimensions(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dimensions",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7l2 -2l-2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3l-2 2l2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10v11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 19l2 2l2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12l-2 -2l-2 2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 11,
    height: 11,
    rx: 2
  }));
}

var _excluded$eD = ["size", "color", "stroke"];

function IconDirectionHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-direction-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9l-3 3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9l3 3l-3 3"
  }));
}

var _excluded$eC = ["size", "color", "stroke"];

function IconDirection(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-direction",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10l3 -3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14l3 3l3 -3"
  }));
}

var _excluded$eB = ["size", "color", "stroke"];

function IconDirections(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-directions",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5v4h11l2 -2l-2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13v4h-8l-2 -2l2 -2z"
  }));
}

var _excluded$eA = ["size", "color", "stroke"];

function IconDisabled2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-disabled-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11a5 5 0 1 0 3.95 7.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 20l-4 -5h-4l3 -5l-4 -3l-4 1"
  }));
}

var _excluded$ez = ["size", "color", "stroke"];

function IconDisabled(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ez);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-disabled",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "11 7 11 15 15 15 19 20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 11,
    x2: 16,
    y2: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5a5 5 0 1 0 6 7.5"
  }));
}

var _excluded$ey = ["size", "color", "stroke"];

function IconDisc(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ey);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-disc",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12a5 5 0 0 1 5 -5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17a5 5 0 0 0 5 -5"
  }));
}

var _excluded$ex = ["size", "color", "stroke"];

function IconDiscount2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ex);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-discount-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
  }));
}

var _excluded$ew = ["size", "color", "stroke"];

function IconDiscount(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ew);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-discount",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$ev = ["size", "color", "stroke"];

function IconDivide(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ev);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-divide",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 12,
    cy: 6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 12,
    cy: 18,
    r: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }));
}

var _excluded$eu = ["size", "color", "stroke"];

function IconDna2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eu);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dna-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3v1c-.01 3.352 -1.68 6.023 -5.008 8.014c-3.328 1.99 3.336 -2.005 .008 -.014c-3.328 1.99 -4.997 4.662 -5.008 8.014v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21.014v-1c-.01 -3.352 -1.68 -6.023 -5.008 -8.014c-3.328 -1.99 3.336 2.005 .008 .014c-3.328 -1.991 -4.997 -4.662 -5.008 -8.014v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16h8"
  }));
}

var _excluded$et = ["size", "color", "stroke"];

function IconDna(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$et);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dna",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45 12 12)",
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.172 20.485a4 4 0 1 0 -5.657 -5.657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.828 3.515a4 4 0 1 0 5.657 5.657"
  }));
}

var _excluded$es = ["size", "color", "stroke"];

function IconDogBowl(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$es);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dog-bowl",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15l5.586 -5.585a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-3.587 3.586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13l-3.586 -3.585a2 2 0 1 0 -3.414 -1.415a2 2 0 1 0 1.413 3.414l3.587 3.586"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 20h18c-.175 -1.671 -.046 -3.345 -2 -5h-14c-1.333 1 -2 2.667 -2 5z"
  }));
}

var _excluded$er = ["size", "color", "stroke"];

function IconDoorEnter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$er);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-door-enter",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h6m4 10.5v7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 7h-7m3 -3l-3 3l3 3"
  }));
}

var _excluded$eq = ["size", "color", "stroke"];

function IconDoorExit(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-door-exit",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h7.5m2.5 10.5v7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7h7m-3 -3l3 3l-3 3"
  }));
}

var _excluded$ep = ["size", "color", "stroke"];

function IconDoor(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ep);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-door",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21v-16a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v16"
  }));
}

var _excluded$eo = ["size", "color", "stroke"];

function IconDotsCircleHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eo);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dots-circle-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }));
}

var _excluded$en = ["size", "color", "stroke"];

function IconDotsDiagonal2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$en);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dots-diagonal-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 1
  }));
}

var _excluded$em = ["size", "color", "stroke"];

function IconDotsDiagonal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$em);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dots-diagonal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 7,
    r: 1
  }));
}

var _excluded$el = ["size", "color", "stroke"];

function IconDotsVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$el);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dots-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 1
  }));
}

var _excluded$ek = ["size", "color", "stroke"];

function IconDots(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ek);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-dots",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 1
  }));
}

var _excluded$ej = ["size", "color", "stroke"];

function IconDownload(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ej);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-download",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 11 12 16 17 11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 16
  }));
}

var _excluded$ei = ["size", "color", "stroke"];

function IconDragDrop2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ei);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-drag-drop-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 12,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 4.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 4,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 4,
    y2: 16.01
  }));
}

var _excluded$eh = ["size", "color", "stroke"];

function IconDragDrop(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eh);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-drag-drop",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13l9 3l-4 2l-2 4l-3 -9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 3,
    y2: 3.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 3,
    x2: 7,
    y2: 3.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 3,
    x2: 11,
    y2: 3.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 3,
    x2: 15,
    y2: 3.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 7,
    x2: 3,
    y2: 7.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 11,
    x2: 3,
    y2: 11.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 15,
    x2: 3,
    y2: 15.01
  }));
}

var _excluded$eg = ["size", "color", "stroke"];

function IconDroneOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eg);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-drone-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14h-4v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10l-3.5 -3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.957 5.95a3.503 3.503 0 0 0 -2.917 -2.91m-3.02 .989a3.5 3.5 0 0 0 1.98 5.936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10l3.5 -3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.965a3.5 3.5 0 1 0 -3.966 -3.965"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 17.5,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.035 18a3.5 3.5 0 0 0 5.936 1.98m.987 -3.026a3.503 3.503 0 0 0 -2.918 -2.913"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 6.5,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14.035a3.5 3.5 0 1 0 3.966 3.965"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$ef = ["size", "color", "stroke"];

function IconDrone(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ef);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-drone",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h4v4h-4z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 6.5,
    y2: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96 6a3.5 3.5 0 1 0 -3.96 3.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10l3.5 -3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.96a3.5 3.5 0 1 0 -3.96 -3.96"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 17.5,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.04 18a3.5 3.5 0 1 0 3.96 -3.96"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 6.5,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14.04a3.5 3.5 0 1 0 3.96 3.96"
  }));
}

var _excluded$ee = ["size", "color", "stroke"];

function IconDropCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ee);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-drop-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.07 15.34c1.115 .88 2.74 .88 3.855 0c1.115 -.88 1.398 -2.388 .671 -3.575l-2.596 -3.765l-2.602 3.765c-.726 1.187 -.443 2.694 .672 3.575z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$ed = ["size", "color", "stroke"];

function IconDropletFilled2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ed);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-droplet-filled-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.305 17.695l3.695 -3.695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.26 19.74l5.74 -5.74l-5.74 5.74z"
  }));
}

var _excluded$ec = ["size", "color", "stroke"];

function IconDropletFilled(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ec);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-droplet-filled",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l3.544 -3.544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.3l5.558 -5.558"
  }));
}

var _excluded$eb = ["size", "color", "stroke"];

function IconDropletHalf2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$eb);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-droplet-half-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14h12"
  }));
}

var _excluded$ea = ["size", "color", "stroke"];

function IconDropletHalf(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ea);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-droplet-half",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v17"
  }));
}

var _excluded$e9 = ["size", "color", "stroke"];

function IconDropletOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$e9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-droplet-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.454 8.458l-1.653 2.545a6 6 0 0 0 10.32 6.123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14a5.971 5.971 0 0 0 -.803 -3l-5.197 -8l-1.968 3.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$e8 = ["size", "color", "stroke"];

function IconDroplet(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$e8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-droplet",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
  }));
}

var _excluded$e7 = ["size", "color", "stroke"];

function IconEarOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$e7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ear-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10c0 -1.146 .277 -2.245 .78 -3.219m1.792 -2.208a7 7 0 0 1 10.428 9.027a10 10 0 0 1 -.633 .762m-2.045 1.96a8 8 0 0 0 -1.322 2.278a4.5 4.5 0 0 1 -6.8 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.42 7.414a3 3 0 0 1 4.131 4.13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$e6 = ["size", "color", "stroke"];

function IconEar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$e6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ear",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10a7 7 0 1 1 13 3.6a10 10 0 0 1 -2 2a8 8 0 0 0 -2 3a4.5 4.5 0 0 1 -6.8 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10a3 3 0 1 1 5 2.2"
  }));
}

var _excluded$e5 = ["size", "color", "stroke"];

function IconEditCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$e5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-edit-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15l8.385 -8.415a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7.07a7.002 7.002 0 0 0 1 13.93a7.002 7.002 0 0 0 6.929 -5.999"
  }));
}

var _excluded$e4 = ["size", "color", "stroke"];

function IconEdit(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$e4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-edit",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 5,
    x2: 19,
    y2: 8
  }));
}

var _excluded$e3 = ["size", "color", "stroke"];

function IconEgg(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$e3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-egg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.514 14.639c0 3.513 2.904 6.361 6.486 6.361s6.486 -2.848 6.486 -6.361a12.574 12.574 0 0 0 -3.243 -9.012a4.025 4.025 0 0 0 -3.243 -1.627a4.025 4.025 0 0 0 -3.243 1.627a12.574 12.574 0 0 0 -3.243 9.012"
  }));
}

var _excluded$e2 = ["size", "color", "stroke"];

function IconElevator(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$e2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-elevator",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 14,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10l2 -2l2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14l2 2l2 -2"
  }));
}

var _excluded$e1 = ["size", "color", "stroke"];

function IconEmergencyBed(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$e1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-emergency-bed",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8l2.1 2.8a3 3 0 0 0 2.4 1.2h11.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v2l-2.5 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16.5l-2.5 -2.5"
  }));
}

var _excluded$e0 = ["size", "color", "stroke"];

function IconEmphasis(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$e0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-emphasis",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5h-8v10h8m-1 -5h-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 20,
    x2: 6,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 20,
    x2: 10,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 20,
    x2: 14,
    y2: 20.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 20,
    x2: 18,
    y2: 20.01
  }));
}

var _excluded$d$ = ["size", "color", "stroke"];

function IconEngine(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$d$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-engine",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10h2l2 -2h3.382a1 1 0 0 1 .894 .553l1.448 2.894a1 1 0 0 0 .894 .553h1.382v-2h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2v-2h-3v2a1 1 0 0 1 -1 1h-3.465a1 1 0 0 1 -.832 -.445l-1.703 -2.555h-2v-6z"
  }));
}

var _excluded$d_ = ["size", "color", "stroke"];

function IconEqualNot(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$d_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-equal-not",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9h14m-14 6h14m0 -10l-14 14"
  }));
}

var _excluded$dZ = ["size", "color", "stroke"];

function IconEqual(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-equal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9h14m-14 6h14"
  }));
}

var _excluded$dY = ["size", "color", "stroke"];

function IconEraser(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eraser",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19h-11l-4 -4a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9 9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 12.3,
    x2: 11.7,
    y2: 6
  }));
}

var _excluded$dX = ["size", "color", "stroke"];

function IconError404(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-error-404",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7v4a1 1 0 0 0 1 1h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 7v4a1 1 0 0 0 1 1h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 7v10"
  }));
}

var _excluded$dW = ["size", "color", "stroke"];

function IconExchange(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exchange",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8v5a5 5 0 0 1 -5 5h-3l3 -3m0 6l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16v-5a5 5 0 0 1 5 -5h3l-3 -3m0 6l3 -3"
  }));
}

var _excluded$dV = ["size", "color", "stroke"];

function IconExclamationMark(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exclamation-mark",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15v-10"
  }));
}

var _excluded$dU = ["size", "color", "stroke"];

function IconExposure(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-exposure",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.6,
    y1: 19.4,
    x2: 19.4,
    y2: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9h4m-2 -2v4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 16,
    x2: 17,
    y2: 16
  }));
}

var _excluded$dT = ["size", "color", "stroke"];

function IconExternalLink(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-external-link",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7h-5a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 20,
    y2: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 4 20 4 20 9"
  }));
}

var _excluded$dS = ["size", "color", "stroke"];

function IconEyeCheck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eye-check",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19c-4 0 -7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7c-.42 .736 -.858 1.414 -1.311 2.033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19l2 2l4 -4"
  }));
}

var _excluded$dR = ["size", "color", "stroke"];

function IconEyeOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eye-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.584 10.587a2 2 0 0 0 2.828 2.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.363 5.365a9.466 9.466 0 0 1 2.637 -.365c4 0 7.333 2.333 10 7c-.778 1.361 -1.612 2.524 -2.503 3.488m-2.14 1.861c-1.631 1.1 -3.415 1.651 -5.357 1.651c-4 0 -7.333 -2.333 -10 -7c1.369 -2.395 2.913 -4.175 4.632 -5.341"
  }));
}

var _excluded$dQ = ["size", "color", "stroke"];

function IconEyeTable(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eye-table",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.003 18.003h-.011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.003 18.002h-.011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.003 18.002h-.011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 3h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3v17a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11v-4"
  }));
}

var _excluded$dP = ["size", "color", "stroke"];

function IconEye(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eye",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12c-2.667 4.667 -6 7 -10 7s-7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7"
  }));
}

var _excluded$dO = ["size", "color", "stroke"];

function IconEyeglass2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eyeglass-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4h-2l-3 10v2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2l3 10v2.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 14,
    y2: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 16.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 16.5,
    r: 3.5
  }));
}

var _excluded$dN = ["size", "color", "stroke"];

function IconEyeglass(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-eyeglass",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4h-2l-3 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2l3 10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 14,
    y2: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
  }));
}

var _excluded$dM = ["size", "color", "stroke"];

function IconFaceIdError(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-face-id-error",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.05a3.5 3.5 0 0 1 5 0"
  }));
}

var _excluded$dL = ["size", "color", "stroke"];

function IconFaceId(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-face-id",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }));
}

var _excluded$dK = ["size", "color", "stroke"];

function IconFaceMask(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-face-mask",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.002 14.5h-.222c-1.535 0 -2.778 -1.12 -2.778 -2.5s1.243 -2.5 2.778 -2.5h.222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.002 14.5h.222c1.534 0 2.778 -1.12 2.778 -2.5s-1.244 -2.5 -2.778 -2.5h-.222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.55 18.843l5 -1.429a2 2 0 0 0 1.45 -1.923v-6.981a2 2 0 0 0 -1.45 -1.923l-5 -1.429a2 2 0 0 0 -1.1 0l-5 1.429a2 2 0 0 0 -1.45 1.922v6.982a2 2 0 0 0 1.45 1.923l5 1.429a2 2 0 0 0 1.1 0z"
  }));
}

var _excluded$dJ = ["size", "color", "stroke"];

function IconFall(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fall",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 21l1 -5l-1 -4l-3 -4h4l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16l-1 -4l3 -4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12h2.5l4 2"
  }));
}

var _excluded$dI = ["size", "color", "stroke"];

function IconFeather(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-feather",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20l10 -10m0 -5v5h5m-9 -1v5h5m-9 -1v5h5m-5 -5l4 -4l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10c.638 -.636 1 -1.515 1 -2.486a3.515 3.515 0 0 0 -3.517 -3.514c-.97 0 -1.847 .367 -2.483 1m-3 13l4 -4l4 -4"
  }));
}

var _excluded$dH = ["size", "color", "stroke"];

function IconFence(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fence",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v4h16v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6"
  }));
}

var _excluded$dG = ["size", "color", "stroke"];

function IconFidgetSpinner(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fidget-spinner",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17a3 3 0 1 1 -1.543 -2.623l2.087 -3.754a3 3 0 0 1 1.456 -5.623a3 3 0 0 1 1.457 5.623l2.087 3.754a3 3 0 1 1 -1.538 2.8l-.006 -.177h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v.01"
  }));
}

var _excluded$dF = ["size", "color", "stroke"];

function IconFile3d(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-3d",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5l4 -1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.846l4 1.654v4.5l4 -1.846v-4.308l-4 -1.846z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12v4.2l4 1.8"
  }));
}

var _excluded$dE = ["size", "color", "stroke"];

function IconFileAlert(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-alert",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12.01,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 11,
    x2: 12,
    y2: 14
  }));
}

var _excluded$dD = ["size", "color", "stroke"];

function IconFileAnalytics(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-analytics",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 17,
    x2: 9,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 17,
    x2: 15,
    y2: 14
  }));
}

var _excluded$dC = ["size", "color", "stroke"];

function IconFileArrowLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-arrow-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15h-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.5l-2.5 -2.5l2.5 -2.5"
  }));
}

var _excluded$dB = ["size", "color", "stroke"];

function IconFileArrowRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-arrow-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5l2.5 -2.5l-2.5 -2.5"
  }));
}

var _excluded$dA = ["size", "color", "stroke"];

function IconFileBarcode(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-barcode",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13h1v3h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13h1v3h-1z"
  }));
}

var _excluded$dz = ["size", "color", "stroke"];

function IconFileCertificate(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-certificate",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8v-3a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 14,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17l-1.5 5l3 -1.5l3 1.5l-1.5 -5"
  }));
}

var _excluded$dy = ["size", "color", "stroke"];

function IconFileChart(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dy);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-chart",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10v4h4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 4
  }));
}

var _excluded$dx = ["size", "color", "stroke"];

function IconFileCheck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dx);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-check",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15l2 2l4 -4"
  }));
}

var _excluded$dw = ["size", "color", "stroke"];

function IconFileCode2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-code-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12h-1v5h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12h1v5h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }));
}

var _excluded$dv = ["size", "color", "stroke"];

function IconFileCode(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dv);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-code",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13l-1 2l1 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13l1 2l-1 2"
  }));
}

var _excluded$du = ["size", "color", "stroke"];

function IconFileDatabase(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$du);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-database",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12.75,
    rx: 4,
    ry: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5v3.75c0 .966 1.79 1.75 4 1.75s4 -.784 4 -1.75v-3.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }));
}

var _excluded$dt = ["size", "color", "stroke"];

function IconFileDescription(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dt);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-description",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13h6"
  }));
}

var _excluded$ds = ["size", "color", "stroke"];

function IconFileDiff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ds);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-diff",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 12,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 14,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 17,
    x2: 14,
    y2: 17
  }));
}

var _excluded$dr = ["size", "color", "stroke"];

function IconFileDigit(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dr);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-digit",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 3,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12v5"
  }));
}

var _excluded$dq = ["size", "color", "stroke"];

function IconFileDislike(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-dislike",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 3,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15a1 1 0 0 1 1 -1h3.756a1 1 0 0 1 .958 .713l1.2 3c.09 .303 .133 .63 -.056 .884c-.188 .254 -.542 .403 -.858 .403h-2v2.467a1.1 1.1 0 0 1 -2.015 .61l-1.985 -3.077v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.5"
  }));
}

var _excluded$dp = ["size", "color", "stroke"];

function IconFileDollar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dp);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-dollar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17v1m0 -8v1"
  }));
}

var _excluded$do = ["size", "color", "stroke"];

function IconFileDots(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$do);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-dots",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14v.01"
  }));
}

var _excluded$dn = ["size", "color", "stroke"];

function IconFileDownload(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dn);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-download",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.5l2.5 2.5l2.5 -2.5"
  }));
}

var _excluded$dm = ["size", "color", "stroke"];

function IconFileEuro(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dm);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-euro",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.004 11.172a3 3 0 1 0 -.001 5.656"
  }));
}

var _excluded$dl = ["size", "color", "stroke"];

function IconFileExport(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dl);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-export",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v5m-5 6h7m-3 -3l3 3l-3 3"
  }));
}

var _excluded$dk = ["size", "color", "stroke"];

function IconFileHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dk);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
  }));
}

var _excluded$dj = ["size", "color", "stroke"];

function IconFileImport(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-import",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13v-8a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5.5m-9.5 -2h7m-3 -3l3 3l-3 3"
  }));
}

var _excluded$di = ["size", "color", "stroke"];

function IconFileInfo(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$di);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-info",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14h1v4h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11h.01"
  }));
}

var _excluded$dh = ["size", "color", "stroke"];

function IconFileInvoice(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dh);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-invoice",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 7,
    x2: 10,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 13,
    x2: 15,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 17,
    x2: 15,
    y2: 17
  }));
}

var _excluded$dg = ["size", "color", "stroke"];

function IconFileLike(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dg);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-like",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 16,
    width: 3,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20a1 1 0 0 0 1 1h3.756a1 1 0 0 0 .958 -.713l1.2 -3c.09 -.303 .133 -.63 -.056 -.884c-.188 -.254 -.542 -.403 -.858 -.403h-2v-2.467a1.1 1.1 0 0 0 -2.015 -.61l-1.985 3.077v4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12.1v-7.1a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.3"
  }));
}

var _excluded$df = ["size", "color", "stroke"];

function IconFileMinus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$df);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-minus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14,
    x2: 15,
    y2: 14
  }));
}

var _excluded$de = ["size", "color", "stroke"];

function IconFileMusic(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$de);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-music",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 16,
    r: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 16 12 11 14 12"
  }));
}

var _excluded$dd = ["size", "color", "stroke"];

function IconFileOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dd);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3h7l5 5v7m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
  }));
}

var _excluded$dc = ["size", "color", "stroke"];

function IconFilePencil(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$dc);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-pencil",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18l5 -5a1.414 1.414 0 0 0 -2 -2l-5 5v2h2z"
  }));
}

var _excluded$db = ["size", "color", "stroke"];

function IconFilePhone(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$db);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-phone",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12a0.5 .5 0 0 0 1 0v-1a0.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a0.5 .5 0 0 0 0 -1h-1a0.5 .5 0 0 0 0 1"
  }));
}

var _excluded$da = ["size", "color", "stroke"];

function IconFilePlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$da);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 11,
    x2: 12,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14,
    x2: 15,
    y2: 14
  }));
}

var _excluded$d9 = ["size", "color", "stroke"];

function IconFilePower(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$d9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-power",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11l-2 3h4l-2 3"
  }));
}

var _excluded$d8 = ["size", "color", "stroke"];

function IconFileReport(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$d8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-report",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13v4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v2m0 3v4"
  }));
}

var _excluded$d7 = ["size", "color", "stroke"];

function IconFileRss(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$d7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-rss",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17a3 3 0 0 0 -3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17a6 6 0 0 0 -6 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17h.01"
  }));
}

var _excluded$d6 = ["size", "color", "stroke"];

function IconFileScissors(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$d6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-scissors",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17l6 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17l-6 -6"
  }));
}

var _excluded$d5 = ["size", "color", "stroke"];

function IconFileSearch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$d5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-search",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v4.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 19.5,
    x2: 21,
    y2: 22
  }));
}

var _excluded$d4 = ["size", "color", "stroke"];

function IconFileSettings(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$d4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-settings",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.031 12.25l-1.299 .75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.268 15l-1.3 .75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15.803l-1.285 -.773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.285 12.97l-1.285 -.773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }));
}

var _excluded$d3 = ["size", "color", "stroke"];

function IconFileShredder(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$d3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-shredder",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 16,
    x2: 6,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 10,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 16,
    x2: 14,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 16,
    x2: 18,
    y2: 20
  }));
}

var _excluded$d2 = ["size", "color", "stroke"];

function IconFileSignal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$d2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-signal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.525 11.525a3.5 3.5 0 0 0 0 4.95m4.95 0a3.5 3.5 0 0 0 0 -4.95"
  }));
}

var _excluded$d1 = ["size", "color", "stroke"];

function IconFileSpreadsheet(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$d1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-spreadsheet",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11h8v7h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11v7"
  }));
}

var _excluded$d0 = ["size", "color", "stroke"];

function IconFileStar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$d0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-star",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8 16.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
  }));
}

var _excluded$c$ = ["size", "color", "stroke"];

function IconFileSymlink(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$c$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-symlink",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21v-4a3 3 0 0 1 3 -3h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17l3 -3l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-9.5"
  }));
}

var _excluded$c_ = ["size", "color", "stroke"];

function IconFileText(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$c_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-text",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 10,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 13,
    x2: 15,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 17,
    x2: 15,
    y2: 17
  }));
}

var _excluded$cZ = ["size", "color", "stroke"];

function IconFileTime(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-time",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.496v1.504l1 1"
  }));
}

var _excluded$cY = ["size", "color", "stroke"];

function IconFileTypography(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-typography",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18v-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12v-1h6v1"
  }));
}

var _excluded$cX = ["size", "color", "stroke"];

function IconFileUnknown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-unknown",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14a1.5 1.5 0 1 0 -1.14 -2.474"
  }));
}

var _excluded$cW = ["size", "color", "stroke"];

function IconFileUpload(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-upload",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.5l2.5 -2.5l2.5 2.5"
  }));
}

var _excluded$cV = ["size", "color", "stroke"];

function IconFileVector(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-vector",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 16.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 12.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15a2.5 2.5 0 0 1 2.5 -2.5h1"
  }));
}

var _excluded$cU = ["size", "color", "stroke"];

function IconFileX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12l4 4m0 -4l-4 4"
  }));
}

var _excluded$cT = ["size", "color", "stroke"];

function IconFileZip(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file-zip",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20.735a2 2 0 0 1 -1 -1.735v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17a2 2 0 0 1 2 2v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a2 2 0 0 1 2 -2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 5,
    x2: 10,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 7,
    x2: 12,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 9,
    x2: 10,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 11,
    x2: 12,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 13,
    x2: 10,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 15,
    x2: 12,
    y2: 15
  }));
}

var _excluded$cS = ["size", "color", "stroke"];

function IconFile(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-file",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
  }));
}

var _excluded$cR = ["size", "color", "stroke"];

function IconFilesOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-files-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17h-6a2 2 0 0 1 -2 -2v-6m0 -4a2 2 0 0 1 2 -2h4l5 5v7c0 .294 -.063 .572 -.177 .823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$cQ = ["size", "color", "stroke"];

function IconFiles(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-files",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 17h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h4l5 5v7a2 2 0 0 1 -2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }));
}

var _excluded$cP = ["size", "color", "stroke"];

function IconFilterOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-filter-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5h9.5a1 1 0 0 1 .5 1.5l-4.049 4.454m-.951 3.046v5l-4 -3v-4l-5 -5.5a1 1 0 0 1 .18 -1.316"
  }));
}

var _excluded$cO = ["size", "color", "stroke"];

function IconFilter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-filter",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5h13a1 1 0 0 1 .5 1.5l-5 5.5l0 7l-4 -3l0 -4l-5 -5.5a1 1 0 0 1 .5 -1.5"
  }));
}

var _excluded$cN = ["size", "color", "stroke"];

function IconFingerprint(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fingerprint",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11a4 4 0 0 1 8 0v1a10 10 0 0 0 2 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11v2a14 14 0 0 0 2.5 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15a18 18 0 0 0 1.8 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 12 -6.95"
  }));
}

var _excluded$cM = ["size", "color", "stroke"];

function IconFiretruck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-firetruck",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18h8m4 0h2v-6a5 5 0 0 0 -5 -5h-1l1.5 5h4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18v-11h3"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3 17 3 12 12 12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 9,
    x2: 21,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 6,
    y2: 8
  }));
}

var _excluded$cL = ["size", "color", "stroke"];

function IconFirstAidKit(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-first-aid-kit",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 16,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v4"
  }));
}

var _excluded$cK = ["size", "color", "stroke"];

function IconFish(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fish",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.69 7.44a6.973 6.973 0 0 0 -1.69 4.56c0 1.747 .64 3.345 1.699 4.571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9.504c7.715 8.647 14.75 10.265 20 2.498c-5.25 -7.761 -12.285 -6.142 -20 2.504"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.5c-.667 1 -.667 2 0 3"
  }));
}

var _excluded$cJ = ["size", "color", "stroke"];

function IconFlag2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flag-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 14h14v-9h-14v16"
  }));
}

var _excluded$cI = ["size", "color", "stroke"];

function IconFlag3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flag-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16"
  }));
}

var _excluded$cH = ["size", "color", "stroke"];

function IconFlag(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flag",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 5,
    x2: 5,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 5,
    x2: 19,
    y2: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 14a5 5 0 0 1 7 0a5 5 0 0 0 7 0"
  }));
}

var _excluded$cG = ["size", "color", "stroke"];

function IconFlame(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flame",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12c2 -2.96 0 -7 -1 -8c0 3.038 -1.773 4.741 -3 6c-1.226 1.26 -2 3.24 -2 5a6 6 0 1 0 12 0c0 -1.532 -1.056 -3.94 -2 -5c-1.786 3 -2.791 3 -4 2z"
  }));
}

var _excluded$cF = ["size", "color", "stroke"];

function IconFlare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flare",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h4m5 -9v4m5 5h4m-9 5v4m-4.5 -13.5l1 1m8 -1l-1 1m0 7l1 1m-8 -1l-1 1"
  }));
}

var _excluded$cE = ["size", "color", "stroke"];

function IconFlask2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flask-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1 15h11.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v7.342a6.002 6.002 0 0 1 1.318 10.658h-6.635a6.002 6.002 0 0 1 1.317 -10.66v-7.34h4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3h6"
  }));
}

var _excluded$cD = ["size", "color", "stroke"];

function IconFlask(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flask",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 3,
    x2: 15,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 9,
    x2: 14,
    y2: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3v6l-4 11a0.7 .7 0 0 0 .5 1h11a0.7 .7 0 0 0 .5 -1l-4 -11v-6"
  }));
}

var _excluded$cC = ["size", "color", "stroke"];

function IconFlipHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flip-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 16 17 16 7 21 7 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 8 17 8 7 3 7 8"
  }));
}

var _excluded$cB = ["size", "color", "stroke"];

function IconFlipVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flip-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 7 16 17 21 17 16 7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 7 8 17 3 17 8 7"
  }));
}

var _excluded$cA = ["size", "color", "stroke"];

function IconFloatCenter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-float-center",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 9,
    y: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 7,
    x2: 5,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 5,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 7,
    x2: 20,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 11,
    x2: 20,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 20,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 20,
    y2: 19
  }));
}

var _excluded$cz = ["size", "color", "stroke"];

function IconFloatLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-float-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 4,
    y: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 7,
    x2: 20,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 11,
    x2: 20,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 20,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 20,
    y2: 19
  }));
}

var _excluded$cy = ["size", "color", "stroke"];

function IconFloatNone(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cy);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-float-none",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 4,
    y: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 20,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 20,
    y2: 19
  }));
}

var _excluded$cx = ["size", "color", "stroke"];

function IconFloatRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cx);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-float-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 14,
    y: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 7,
    x2: 10,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 10,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 20,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 19,
    x2: 20,
    y2: 19
  }));
}

var _excluded$cw = ["size", "color", "stroke"];

function IconFlower(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-flower",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a3 3 0 0 1 3 3c0 .562 -.259 1.442 -.776 2.64l-.724 1.36l1.76 -1.893c.499 -.6 .922 -1.002 1.27 -1.205a2.968 2.968 0 0 1 4.07 1.099a3.011 3.011 0 0 1 -1.09 4.098c-.374 .217 -.99 .396 -1.846 .535l-2.664 .366l2.4 .326c.995 .145 1.698 .337 2.11 .576a3.011 3.011 0 0 1 1.09 4.098a2.968 2.968 0 0 1 -4.07 1.098c-.348 -.202 -.771 -.604 -1.27 -1.205l-1.76 -1.893l.724 1.36c.516 1.199 .776 2.079 .776 2.64a3 3 0 0 1 -6 0c0 -.562 .259 -1.442 .776 -2.64l.724 -1.36l-1.76 1.893c-.499 .601 -.922 1.003 -1.27 1.205a2.968 2.968 0 0 1 -4.07 -1.098a3.011 3.011 0 0 1 1.09 -4.098c.374 -.218 .99 -.396 1.846 -.536l2.664 -.366l-2.4 -.325c-.995 -.145 -1.698 -.337 -2.11 -.576a3.011 3.011 0 0 1 -1.09 -4.099a2.968 2.968 0 0 1 4.07 -1.099c.348 .203 .771 .604 1.27 1.205l1.76 1.894c-1 -2.292 -1.5 -3.625 -1.5 -4a3 3 0 0 1 3 -3z"
  }));
}

var _excluded$cv = ["size", "color", "stroke"];

function IconFocus2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cv);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-focus-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 5,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 21,
    y2: 12
  }));
}

var _excluded$cu = ["size", "color", "stroke"];

function IconFocusCentered(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cu);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-focus-centered",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }));
}

var _excluded$ct = ["size", "color", "stroke"];

function IconFocus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ct);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-focus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$cs = ["size", "color", "stroke"];

function IconFoldDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cs);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fold-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11v8l3 -3m-6 0l3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 7,
    x2: 10,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 7,
    x2: 15,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 7,
    x2: 20,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 7,
    x2: 5,
    y2: 7
  }));
}

var _excluded$cr = ["size", "color", "stroke"];

function IconFoldUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cr);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fold-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13v-8l-3 3m6 0l-3 -3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 17,
    x2: 10,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 17,
    x2: 15,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 17,
    x2: 20,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 17,
    x2: 5,
    y2: 17
  }));
}

var _excluded$cq = ["size", "color", "stroke"];

function IconFold(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-fold",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v6l3 -3m-6 0l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-6l3 3m-6 0l3 -3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 5,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 10,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 15,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 20,
    y2: 12
  }));
}

var _excluded$cp = ["size", "color", "stroke"];

function IconFolderMinus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cp);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-folder-minus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 13,
    x2: 15,
    y2: 13
  }));
}

var _excluded$co = ["size", "color", "stroke"];

function IconFolderOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$co);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-folder-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 1.172 -1.821m3.828 -.179h1l3 3h7a2 2 0 0 1 2 2v8"
  }));
}

var _excluded$cn = ["size", "color", "stroke"];

function IconFolderPlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cn);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-folder-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 13,
    x2: 15,
    y2: 13
  }));
}

var _excluded$cm = ["size", "color", "stroke"];

function IconFolderX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cm);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-folder-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11l4 4m0 -4l-4 4"
  }));
}

var _excluded$cl = ["size", "color", "stroke"];

function IconFolder(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cl);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-folder",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
  }));
}

var _excluded$ck = ["size", "color", "stroke"];

function IconFolders(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ck);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-folders",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4h3l2 2h5a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
  }));
}

var _excluded$cj = ["size", "color", "stroke"];

function IconForbid2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-forbid-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 9
  }));
}

var _excluded$ci = ["size", "color", "stroke"];

function IconForbid(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ci);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-forbid",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 15
  }));
}

var _excluded$ch = ["size", "color", "stroke"];

function IconForklift(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ch);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-forklift",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 17,
    x2: 12,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17v-6h13v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11v-4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11v-6h4l3 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 15h-3v-10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 13,
    x2: 19,
    y2: 13
  }));
}

var _excluded$cg = ["size", "color", "stroke"];

function IconForms(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cg);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-forms",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7h7a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7h-1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12h.01"
  }));
}

var _excluded$cf = ["size", "color", "stroke"];

function IconFrame(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cf);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-frame",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 7,
    x2: 20,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 17,
    x2: 20,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 7,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 17,
    y2: 20
  }));
}

var _excluded$ce = ["size", "color", "stroke"];

function IconFreeRights(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ce);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-free-rights",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.867 9.75c-.246 -.48 -.708 -.769 -1.2 -.75h-1.334c-.736 0 -1.333 .67 -1.333 1.5c0 .827 .597 1.499 1.333 1.499h1.334c.736 0 1.333 .671 1.333 1.5c0 .828 -.597 1.499 -1.333 1.499h-1.334c-.492 .019 -.954 -.27 -1.2 -.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6l1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5l1.5 1.5"
  }));
}

var _excluded$cd = ["size", "color", "stroke"];

function IconFriends(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cd);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-friends",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 22v-4h-2l2 -6a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1l2 6h-2v4"
  }));
}

var _excluded$cc = ["size", "color", "stroke"];

function IconGasStation(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cc);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gas-station",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 20,
    x2: 15,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 7v1a1 1 0 0 0 1 1h1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 14,
    y2: 11
  }));
}

var _excluded$cb = ["size", "color", "stroke"];

function IconGauge(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$cb);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gauge",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.41,
    y1: 10.59,
    x2: 16,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12a5 5 0 0 1 5 -5"
  }));
}

var _excluded$ca = ["size", "color", "stroke"];

function IconGavel(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ca);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gavel",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10l-4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.793 15.793l-3.586 -3.586a1 1 0 0 1 0 -1.414l2.293 -2.293l.5 .5l3 -3l-.5 -.5l2.293 -2.293a1 1 0 0 1 1.414 0l3.586 3.586a1 1 0 0 1 0 1.414l-2.293 2.293l-.5 -.5l-3 3l.5 .5l-2.293 2.293a1 1 0 0 1 -1.414 0z"
  }));
}

var _excluded$c9 = ["size", "color", "stroke"];

function IconGeometry(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$c9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-geometry",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21l4 -12m2 0l1.48 4.439m.949 2.847l1.571 4.714"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12c1.526 2.955 4.588 5 8 5c3.41 0 6.473 -2.048 8 -5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v-2"
  }));
}

var _excluded$c8 = ["size", "color", "stroke"];

function IconGhost(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$c8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ghost",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11a7 7 0 0 1 14 0v7a1.78 1.78 0 0 1 -3.1 1.4a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 10,
    x2: 14.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14a3.5 3.5 0 0 0 4 0"
  }));
}

var _excluded$c7 = ["size", "color", "stroke"];

function IconGift(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$c7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gift",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    width: 18,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5"
  }));
}

var _excluded$c6 = ["size", "color", "stroke"];

function IconGitBranch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$c6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-branch",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 8,
    x2: 7,
    y2: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18h6a2 2 0 0 0 2 -2v-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 14 17 11 20 14"
  }));
}

var _excluded$c5 = ["size", "color", "stroke"];

function IconGitCommit(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$c5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-commit",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 21
  }));
}

var _excluded$c4 = ["size", "color", "stroke"];

function IconGitCompare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$c4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-compare",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6h5a2 2 0 0 1 2 2v8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 9 11 6 14 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 18h-5a2 2 0 0 1 -2 -2v-8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "10 15 13 18 10 21"
  }));
}

var _excluded$c3 = ["size", "color", "stroke"];

function IconGitFork(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$c3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-fork",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 16
  }));
}

var _excluded$c2 = ["size", "color", "stroke"];

function IconGitMerge(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$c2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-merge",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 8,
    x2: 7,
    y2: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8a4 4 0 0 0 4 4h4"
  }));
}

var _excluded$c1 = ["size", "color", "stroke"];

function IconGitPullRequestClosed(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$c1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-pull-request-closed",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4l4 4m0 -4l-4 4"
  }));
}

var _excluded$c0 = ["size", "color", "stroke"];

function IconGitPullRequestDraft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$c0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-pull-request-draft",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6h.01"
  }));
}

var _excluded$b$ = ["size", "color", "stroke"];

function IconGitPullRequest(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$b$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-git-pull-request",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 8,
    x2: 6,
    y2: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6h5a2 2 0 0 1 2 2v8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 9 11 6 14 3"
  }));
}

var _excluded$b_ = ["size", "color", "stroke"];

function IconGizmo(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$b_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gizmo",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 19l-8 -5.5l-8 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v9.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 19,
    r: 1
  }));
}

var _excluded$bZ = ["size", "color", "stroke"];

function IconGlassFull(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-glass-full",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10a5 5 0 0 1 6 0a5 5 0 0 0 6 0"
  }));
}

var _excluded$bY = ["size", "color", "stroke"];

function IconGlassOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-glass-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3h10l1 7a4.511 4.511 0 0 1 -1.053 2.94m-2.386 1.625a7.48 7.48 0 0 1 -2.561 .435c-3.314 0 -6 -1.988 -6 -5l.5 -3.495"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$bX = ["size", "color", "stroke"];

function IconGlass(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-glass",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z"
  }));
}

var _excluded$bW = ["size", "color", "stroke"];

function IconGlobe(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-globe",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 16a8.015 8.015 0 1 0 9.25 -13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 22,
    x2: 16,
    y2: 22
  }));
}

var _excluded$bV = ["size", "color", "stroke"];

function IconGolf(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-golf",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18v-15l7 4l-7 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17.67c-.62 .36 -1 .82 -1 1.33c0 1.1 1.8 2 4 2s4 -.9 4 -2c0 -.5 -.38 -.97 -1 -1.33"
  }));
}

var _excluded$bU = ["size", "color", "stroke"];

function IconGps(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-gps",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17l-1 -4l-4 -1l9 -4z"
  }));
}

var _excluded$bT = ["size", "color", "stroke"];

function IconGrain(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grain",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 9.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 14.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 19.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 9.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 4.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 19.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 14.5,
    r: 1
  }));
}

var _excluded$bS = ["size", "color", "stroke"];

function IconGridDots(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grid-dots",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 1
  }));
}

var _excluded$bR = ["size", "color", "stroke"];

function IconGridPattern(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grid-pattern",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14h8"
  }));
}

var _excluded$bQ = ["size", "color", "stroke"];

function IconGrill(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grill",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8h-14a6 6 0 0 0 6 6h2a6 6 0 0 0 5.996 -5.775l.004 -.225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14l1 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14l-3 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18h-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5v-1"
  }));
}

var _excluded$bP = ["size", "color", "stroke"];

function IconGripHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grip-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 15,
    r: 1
  }));
}

var _excluded$bO = ["size", "color", "stroke"];

function IconGripVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-grip-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 19,
    r: 1
  }));
}

var _excluded$bN = ["size", "color", "stroke"];

function IconGrowth(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-growth",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15a4.5 4.5 0 0 0 -4.5 4.5m4.5 -8.5a4.5 4.5 0 0 0 -4.5 4.5m4.5 -8.5a4.5 4.5 0 0 0 -4.5 4.5m-4 3.5c2.21 0 4 2.015 4 4.5m-4 -8.5c2.21 0 4 2.015 4 4.5m-4 -8.5c2.21 0 4 2.015 4 4.5m0 -7.5v6"
  }));
}

var _excluded$bM = ["size", "color", "stroke"];

function IconH1(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-h-1",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18v-8l-2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6h2"
  }));
}

var _excluded$bL = ["size", "color", "stroke"];

function IconH2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-h-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6h2"
  }));
}

var _excluded$bK = ["size", "color", "stroke"];

function IconH3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-h-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 14a2 2 0 1 0 -2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16a2 2 0 1 0 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6h2"
  }));
}

var _excluded$bJ = ["size", "color", "stroke"];

function IconH4(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-h-4",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18v-8l-4 6h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6h2"
  }));
}

var _excluded$bI = ["size", "color", "stroke"];

function IconH5(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-h-5",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18h2a2 2 0 1 0 0 -4h-2v-4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6h2"
  }));
}

var _excluded$bH = ["size", "color", "stroke"];

function IconH6(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-h-6",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(180 19 16)",
    cx: 19,
    cy: 16,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12a2 2 0 1 0 -4 0v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6h2"
  }));
}

var _excluded$bG = ["size", "color", "stroke"];

function IconHammer(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hammer",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.293 15.293l-2.586 -2.586a1 1 0 0 1 0 -1.414l7.586 -7.586a1 1 0 0 1 1.414 0l2.586 2.586a1 1 0 0 1 0 1.414l-7.586 7.586a1 1 0 0 1 -1.414 0z"
  }));
}

var _excluded$bF = ["size", "color", "stroke"];

function IconHandClick(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-click",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3l-1 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3l1 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6h1"
  }));
}

var _excluded$bE = ["size", "color", "stroke"];

function IconHandFinger(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-finger",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }));
}

var _excluded$bD = ["size", "color", "stroke"];

function IconHandGrab(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-grab",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11v-3.5a1.5 1.5 0 0 1 3 0v2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9.5v-3a1.5 1.5 0 0 1 3 0v3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7.5a1.5 1.5 0 0 1 3 0v2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }));
}

var _excluded$bC = ["size", "color", "stroke"];

function IconHandLittleFinger(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-little-finger",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5v-1a1.5 1.5 0 0 1 3 0v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12v-5.5a1.5 1.5 0 0 1 3 0v9.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }));
}

var _excluded$bB = ["size", "color", "stroke"];

function IconHandMiddleFinger(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-middle-finger",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5v-8a1.5 1.5 0 1 1 3 0v8.5"
  }));
}

var _excluded$bA = ["size", "color", "stroke"];

function IconHandMove(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-move",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.541 5.594a13.487 13.487 0 0 1 2.46 -1.427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3.458c1.32 .354 2.558 .902 3.685 1.612"
  }));
}

var _excluded$bz = ["size", "color", "stroke"];

function IconHandOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bz);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5v-5.5m.44 -3.562a1.5 1.5 0 0 1 2.56 1.062v1.5m0 4.008v.992m0 -6.5v-2a1.5 1.5 0 1 1 3 0v6.5m0 -4.5a1.5 1.5 0 0 1 3 0v6.5m0 -4.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2c-2.114 -.292 -3.956 -1.397 -5 -3l-2.7 -5.25a1.7 1.7 0 0 1 2.75 -2l.9 1.75"
  }));
}

var _excluded$by = ["size", "color", "stroke"];

function IconHandRingFinger(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$by);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-ring-finger",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12v-6.5a1.5 1.5 0 0 1 3 0v6.5"
  }));
}

var _excluded$bx = ["size", "color", "stroke"];

function IconHandRock(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bx);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-rock",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5v-1a1.5 1.5 0 0 1 3 0v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12v-6.5a1.5 1.5 0 0 1 3 0v10.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
  }));
}

var _excluded$bw = ["size", "color", "stroke"];

function IconHandStop(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-stop",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v-7.5a1.5 1.5 0 0 1 3 0v6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5a1.5 1.5 0 0 1 3 0v6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 7.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }));
}

var _excluded$bv = ["size", "color", "stroke"];

function IconHandThreeFingers(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bv);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-three-fingers",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5a1.5 1.5 0 0 1 3 0v6.5"
  }));
}

var _excluded$bu = ["size", "color", "stroke"];

function IconHandTwoFingers(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bu);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hand-two-fingers",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
  }));
}

var _excluded$bt = ["size", "color", "stroke"];

function IconHanger(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bt);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hanger",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7a3 3 0 1 0 -3 3v2m0 0l-8.624 5.488a0.82 .82 0 0 0 .44 1.512h16.368a0.82 .82 0 0 0 .44 -1.512l-8.624 -5.488z"
  }));
}

var _excluded$bs = ["size", "color", "stroke"];

function IconHash(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bs);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hash",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 9,
    x2: 19,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 15,
    x2: 19,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 4,
    x2: 7,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 13,
    y2: 20
  }));
}

var _excluded$br = ["size", "color", "stroke"];

function IconHaze(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$br);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-haze",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6 5.6l.7 .7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 5.6l-.7 .7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12a4 4 0 1 1 8 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 20h18"
  }));
}

var _excluded$bq = ["size", "color", "stroke"];

function IconHeading(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heading",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5v14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 5v14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5h4"
  }));
}

var _excluded$bp = ["size", "color", "stroke"];

function IconHeadphonesOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bp);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-headphones-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 5,
    height: 7,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13h1a2 2 0 0 1 2 2v1m-.589 3.417c-.361 .36 -.86 .583 -1.411 .583h-1a2 2 0 0 1 -2 -2v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15v-3c0 -2.21 .896 -4.21 2.344 -5.658m2.369 -1.638a8 8 0 0 1 11.287 7.296v3"
  }));
}

var _excluded$bo = ["size", "color", "stroke"];

function IconHeadphones(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bo);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-headphones",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    rx: 2,
    width: 5,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13,
    rx: 2,
    width: 5,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15v-3a8 8 0 0 1 16 0v3"
  }));
}

var _excluded$bn = ["size", "color", "stroke"];

function IconHeadset(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bn);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-headset",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    rx: 2,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 13,
    rx: 2,
    width: 4,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15v-3a8 8 0 0 1 16 0v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19a6 3 0 0 1 -6 3"
  }));
}

var _excluded$bm = ["size", "color", "stroke"];

function IconHeartBroken(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bm);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heart-broken",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7l-2 4l4 3l-2 4v3"
  }));
}

var _excluded$bl = ["size", "color", "stroke"];

function IconHeartRateMonitor(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bl);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heart-rate-monitor",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10h2l2 3l2 -6l1 3h3"
  }));
}

var _excluded$bk = ["size", "color", "stroke"];

function IconHeart(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bk);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heart",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13.572l-7.5 7.428l-7.5 -7.428m0 0a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
  }));
}

var _excluded$bj = ["size", "color", "stroke"];

function IconHeartbeat(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-heartbeat",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13.572l-7.5 7.428l-2.896 -2.868m-6.117 -8.104a5 5 0 0 1 9.013 -3.022a5 5 0 1 1 7.5 6.572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13h2l2 3l2 -6l1 3h3"
  }));
}

var _excluded$bi = ["size", "color", "stroke"];

function IconHelicopterLanding(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bi);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-helicopter-landing",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 8,
    x2: 9,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 15,
    y2: 16
  }));
}

var _excluded$bh = ["size", "color", "stroke"];

function IconHelicopter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bh);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-helicopter",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10l1 2h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9a2 2 0 0 0 -2 2v3c0 1.1 .9 2 2 2h7a2 2 0 0 0 2 -2c0 -3.31 -3.13 -5 -7 -5h-2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 9,
    x2: 13,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.1v3.9h5.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 19,
    x2: 15,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 19,
    x2: 11,
    y2: 19
  }));
}

var _excluded$bg = ["size", "color", "stroke"];

function IconHelmet(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bg);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-helmet",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4a9 9 0 0 1 5.656 16h-11.312a9 9 0 0 1 5.656 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9h-8.8a1 1 0 0 0 -.968 1.246c.507 2 1.596 3.418 3.268 4.254c2 1 4.333 1.5 7 1.5"
  }));
}

var _excluded$bf = ["size", "color", "stroke"];

function IconHelp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bf);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-help",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 17.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4"
  }));
}

var _excluded$be = ["size", "color", "stroke"];

function IconHexagonOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$be);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.693 4.69l2.336 -1.39a2.056 2.056 0 0 1 2 0l6 3.573h-.029a2 2 0 0 1 1 1.747v6.536c0 .246 -.045 .485 -.13 .707m-2.16 1.847l-4.739 3.027a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l1.154 -.687"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$bd = ["size", "color", "stroke"];

function IconHexagon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bd);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hexagon",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6.873a2 2 0 0 1 1 1.747v6.536a2 2 0 0 1 -1.029 1.748l-6 3.833a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l6 -3.572a2.056 2.056 0 0 1 2 0l6 3.573z"
  }));
}

var _excluded$bc = ["size", "color", "stroke"];

function IconHierarchy2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bc);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hierarchy-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17l5 -4l5 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 13
  }));
}

var _excluded$bb = ["size", "color", "stroke"];

function IconHierarchy(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$bb);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hierarchy",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.5l5.5 -4.5l5.5 4.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 13
  }));
}

var _excluded$ba = ["size", "color", "stroke"];

function IconHighlight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ba);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-highlight",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.5l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15v4h-8l4 -4z"
  }));
}

var _excluded$b9 = ["size", "color", "stroke"];

function IconHistory(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$b9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-history",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 8 12 12 14 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5"
  }));
}

var _excluded$b8 = ["size", "color", "stroke"];

function IconHome2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$b8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5 12 3 12 12 3 21 12 19 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 4,
    height: 4
  }));
}

var _excluded$b7 = ["size", "color", "stroke"];

function IconHome(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$b7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-home",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5 12 3 12 12 3 21 12 19 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"
  }));
}

var _excluded$b6 = ["size", "color", "stroke"];

function IconHotelService(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$b6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hotel-service",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10a1.5 1.5 0 0 1 -1.5 -1.5a5.5 5.5 0 0 1 11 0v10.5a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2c0 -1.38 .71 -2.444 1.88 -3.175l4.424 -2.765c1.055 -.66 1.696 -1.316 1.696 -2.56a2.5 2.5 0 1 0 -5 0a1.5 1.5 0 0 1 -1.5 1.5z"
  }));
}

var _excluded$b5 = ["size", "color", "stroke"];

function IconHourglassHigh(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$b5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hourglass-high",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
  }));
}

var _excluded$b4 = ["size", "color", "stroke"];

function IconHourglassLow(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$b4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hourglass-low",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
  }));
}

var _excluded$b3 = ["size", "color", "stroke"];

function IconHourglass(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$b3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-hourglass",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
  }));
}

var _excluded$b2 = ["size", "color", "stroke"];

function IconIceCream2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$b2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ice-cream-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.657 11.004a6 6 0 1 0 -11.315 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.342 11l5.658 11l5.657 -10.996z"
  }));
}

var _excluded$b1 = ["size", "color", "stroke"];

function IconIceCream(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$b1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ice-cream",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5v-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 17h8v-10a4 4 0 1 0 -8 0v10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5l8 -3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5l8 -3.5"
  }));
}

var _excluded$b0 = ["size", "color", "stroke"];

function IconIceSkating(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$b0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ice-skating",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.905 5h3.418a1 1 0 0 1 .928 .629l1.143 2.856a3 3 0 0 0 2.207 1.83l4.717 .926a2.084 2.084 0 0 1 1.682 2.045v.714a1 1 0 0 1 -1 1h-13.895a1 1 0 0 1 -.995 -1.1l.8 -8a1 1 0 0 1 .995 -.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19h17a1 1 0 0 0 1 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15v4"
  }));
}

var _excluded$a$ = ["size", "color", "stroke"];

function IconIdBadge2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$a$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-id-badge-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12h3v4h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6h-6a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1h-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 4,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12h4"
  }));
}

var _excluded$a_ = ["size", "color", "stroke"];

function IconIdBadge(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$a_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-id-badge",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18h6"
  }));
}

var _excluded$aZ = ["size", "color", "stroke"];

function IconId(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aZ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-id",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 16,
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 17,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 17,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 16,
    x2: 17,
    y2: 16
  }));
}

var _excluded$aY = ["size", "color", "stroke"];

function IconInbox(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aY);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-inbox",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13h3l3 3h4l3 -3h3"
  }));
}

var _excluded$aX = ["size", "color", "stroke"];

function IconIndentDecrease(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aX);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-indent-decrease",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 6,
    x2: 13,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 11,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 18,
    x2: 13,
    y2: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8l-4 4l4 4"
  }));
}

var _excluded$aW = ["size", "color", "stroke"];

function IconIndentIncrease(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aW);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-indent-increase",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 6,
    x2: 9,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 13,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 18,
    x2: 9,
    y2: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8l4 4l-4 4"
  }));
}

var _excluded$aV = ["size", "color", "stroke"];

function IconInfinity(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aV);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-infinity",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.828 9.172a4 4 0 1 0 0 5.656a10 10 0 0 0 2.172 -2.828a10 10 0 0 1 2.172 -2.828a4 4 0 1 1 0 5.656a10 10 0 0 1 -2.172 -2.828a10 10 0 0 0 -2.172 -2.828"
  }));
}

var _excluded$aU = ["size", "color", "stroke"];

function IconInfoCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aU);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-info-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12.01,
    y2: 8
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "11 12 12 12 12 16 13 16"
  }));
}

var _excluded$aT = ["size", "color", "stroke"];

function IconInfoSquare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aT);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-info-square",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12.01,
    y2: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "11 12 12 12 12 16 13 16"
  }));
}

var _excluded$aS = ["size", "color", "stroke"];

function IconItalic(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aS);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-italic",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 5,
    x2: 17,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 13,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 5,
    x2: 10,
    y2: 19
  }));
}

var _excluded$aR = ["size", "color", "stroke"];

function IconJumpRope(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aR);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-jump-rope",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14v-6a3 3 0 1 1 6 0v8a3 3 0 0 0 6 0v-6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 3,
    width: 4,
    height: 7,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 4,
    height: 7,
    rx: 2
  }));
}

var _excluded$aQ = ["size", "color", "stroke"];

function IconKarate(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aQ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-karate",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9l4.5 1l3 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21v-8l3 -5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5l4 2l4 1l4 3.5l-2 3.5"
  }));
}

var _excluded$aP = ["size", "color", "stroke"];

function IconKering(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aP);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-kering",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15v-3.5a2.5 2.5 0 1 1 5 0v3.5m0 -2h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9l3 6l3 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20l6 -16"
  }));
}

var _excluded$aO = ["size", "color", "stroke"];

function IconKey(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aO);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-key",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 15,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.85,
    y1: 12.15,
    x2: 19,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 5,
    x2: 20,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 17,
    y2: 10
  }));
}

var _excluded$aN = ["size", "color", "stroke"];

function IconKeyboardHide(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aN);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-keyboard-hide",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 20,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 7,
    x2: 6,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 7,
    x2: 10,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 7,
    x2: 14,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 7,
    x2: 18,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 11,
    x2: 6,
    y2: 11.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 11,
    x2: 18,
    y2: 11.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 14,
    y2: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21l2 -2l2 2"
  }));
}

var _excluded$aM = ["size", "color", "stroke"];

function IconKeyboardOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aM);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-keyboard-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18h-14a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2m4 0h10a2 2 0 0 1 2 2v8c0 .554 -.226 1.056 -.59 1.418"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 10,
    x2: 6,
    y2: 10.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10,
    y2: 10.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 10,
    x2: 14,
    y2: 10.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 10,
    x2: 18,
    y2: 10.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 14,
    x2: 6,
    y2: 14.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 14,
    x2: 18,
    y2: 14.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 14,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$aL = ["size", "color", "stroke"];

function IconKeyboardShow(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aL);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-keyboard-show",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 20,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 7,
    x2: 6,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 7,
    x2: 10,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 7,
    x2: 14,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 7,
    x2: 18,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 11,
    x2: 6,
    y2: 11.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 11,
    x2: 18,
    y2: 11.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 14,
    y2: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19l2 2l2 -2"
  }));
}

var _excluded$aK = ["size", "color", "stroke"];

function IconKeyboard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aK);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-keyboard",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 20,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 10,
    x2: 6,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 10,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 10,
    x2: 14,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 10,
    x2: 18,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 14,
    x2: 6,
    y2: 14.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 14,
    x2: 18,
    y2: 14.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 14,
    y2: 14
  }));
}

var _excluded$aJ = ["size", "color", "stroke"];

function IconLadder(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aJ);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ladder",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3v18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3v18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18h8"
  }));
}

var _excluded$aI = ["size", "color", "stroke"];

function IconLamp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aI);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lamp",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20v-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14l-4 -8h-6z"
  }));
}

var _excluded$aH = ["size", "color", "stroke"];

function IconLanguageHiragana(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aH);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-language-hiragana",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4c0 4.846 0 7 .5 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5c0 2.286 -2 4.5 -3.5 4.5s-2.5 -1.135 -2.5 -2c0 -2 1 -3 3 -3s5 .57 5 2.857c0 1.524 -.667 2.571 -2 3.143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20l4 -9l4 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 18h-6.2"
  }));
}

var _excluded$aG = ["size", "color", "stroke"];

function IconLanguageKatakana(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aG);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-language-katakana",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5h6.586a1 1 0 0 1 .707 1.707l-1.293 1.293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8c0 1.5 .5 3 -2 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20l4 -9l4 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 18h-6.2"
  }));
}

var _excluded$aF = ["size", "color", "stroke"];

function IconLanguage(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aF);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-language",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3v2c0 4.418 -2.239 8 -5 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9c-.003 2.144 2.952 3.908 6.7 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20l4 -9l4 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1 18h-6.2"
  }));
}

var _excluded$aE = ["size", "color", "stroke"];

function IconLasso(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aE);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lasso",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.028 13.252c-.657 -.972 -1.028 -2.078 -1.028 -3.252c0 -3.866 4.03 -7 9 -7s9 3.134 9 7s-4.03 7 -9 7c-1.913 0 -3.686 -.464 -5.144 -1.255"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 15,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17c0 1.42 .316 2.805 1 4"
  }));
}

var _excluded$aD = ["size", "color", "stroke"];

function IconLayersDifference(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aD);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layers-difference",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "10 8 8 8 8 10"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 14 8 16 10 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 8 16 8 16 10"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 14 16 16 14 16"
  }));
}

var _excluded$aC = ["size", "color", "stroke"];

function IconLayersIntersect2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aC);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layers-intersect-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 12,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 12,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15l6 -6"
  }));
}

var _excluded$aB = ["size", "color", "stroke"];

function IconLayersIntersect(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aB);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layers-intersect",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 12,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 12,
    height: 12,
    rx: 2
  }));
}

var _excluded$aA = ["size", "color", "stroke"];

function IconLayersLinked(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aA);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layers-linked",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8.268a2 2 0 0 1 1 1.732v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.003 15.734a2 2 0 0 1 -1.003 -1.734v-8a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-3"
  }));
}

var _excluded$az = ["size", "color", "stroke"];

function IconLayersSubtract(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$az);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layers-subtract",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 12,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2"
  }));
}

var _excluded$ay = ["size", "color", "stroke"];

function IconLayersUnion(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ay);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layers-union",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2"
  }));
}

var _excluded$ax = ["size", "color", "stroke"];

function IconLayout2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ax);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 6,
    height: 7,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 7,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 6,
    height: 5,
    rx: 2
  }));
}

var _excluded$aw = ["size", "color", "stroke"];

function IconLayoutAlignBottom(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aw);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-align-bottom",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 6,
    height: 12,
    rx: 2
  }));
}

var _excluded$av = ["size", "color", "stroke"];

function IconLayoutAlignCenter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$av);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-align-center",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 12,
    height: 6,
    rx: 2
  }));
}

var _excluded$au = ["size", "color", "stroke"];

function IconLayoutAlignLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$au);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-align-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 12,
    height: 6,
    rx: 2
  }));
}

var _excluded$at = ["size", "color", "stroke"];

function IconLayoutAlignMiddle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$at);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-align-middle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 9,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 6,
    height: 12,
    rx: 2
  }));
}

var _excluded$as = ["size", "color", "stroke"];

function IconLayoutAlignRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$as);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-align-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 12,
    height: 6,
    rx: 2
  }));
}

var _excluded$ar = ["size", "color", "stroke"];

function IconLayoutAlignTop(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ar);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-align-top",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 20,
    y2: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 6,
    height: 12,
    rx: 2
  }));
}

var _excluded$aq = ["size", "color", "stroke"];

function IconLayoutBoardSplit(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aq);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-board-split",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v16"
  }));
}

var _excluded$ap = ["size", "color", "stroke"];

function IconLayoutBoard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ap);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-board",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 9h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v16"
  }));
}

var _excluded$ao = ["size", "color", "stroke"];

function IconLayoutBottombar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ao);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-bottombar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 20,
    y2: 15
  }));
}

var _excluded$an = ["size", "color", "stroke"];

function IconLayoutCards(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$an);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-cards",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 10,
    rx: 2
  }));
}

var _excluded$am = ["size", "color", "stroke"];

function IconLayoutColumns(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$am);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-columns",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }));
}

var _excluded$al = ["size", "color", "stroke"];

function IconLayoutDashboard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$al);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-dashboard",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h6v8h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16h6v4h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12h6v8h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4h6v4h-6z"
  }));
}

var _excluded$ak = ["size", "color", "stroke"];

function IconLayoutDistributeHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ak);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-distribute-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 20,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 12,
    height: 6,
    rx: 2
  }));
}

var _excluded$aj = ["size", "color", "stroke"];

function IconLayoutDistributeVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aj);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-distribute-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 4,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 6,
    height: 12,
    rx: 2
  }));
}

var _excluded$ai = ["size", "color", "stroke"];

function IconLayoutGridAdd(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ai);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-grid-add",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17h6m-3 -3v6"
  }));
}

var _excluded$ah = ["size", "color", "stroke"];

function IconLayoutGrid(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ah);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-grid",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }));
}

var _excluded$ag = ["size", "color", "stroke"];

function IconLayoutKanban(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ag);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-kanban",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 10,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 4,
    x2: 20,
    y2: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 6,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    width: 6,
    height: 6,
    rx: 2
  }));
}

var _excluded$af = ["size", "color", "stroke"];

function IconLayoutList(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$af);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-list",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 16,
    height: 6,
    rx: 2
  }));
}

var _excluded$ae = ["size", "color", "stroke"];

function IconLayoutNavbar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ae);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-navbar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 9,
    x2: 20,
    y2: 9
  }));
}

var _excluded$ad = ["size", "color", "stroke"];

function IconLayoutRows(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ad);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-rows",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }));
}

var _excluded$ac = ["size", "color", "stroke"];

function IconLayoutSidebarLeftCollapse(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ac);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-sidebar-left-collapse",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4v16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10l-2 2l2 2"
  }));
}

var _excluded$ab = ["size", "color", "stroke"];

function IconLayoutSidebarLeftExpand(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$ab);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-sidebar-left-expand",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4v16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10l2 2l-2 2"
  }));
}

var _excluded$aa = ["size", "color", "stroke"];

function IconLayoutSidebarRightCollapse(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$aa);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-sidebar-right-collapse",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4v16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10l2 2l-2 2"
  }));
}

var _excluded$a9 = ["size", "color", "stroke"];

function IconLayoutSidebarRightExpand(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$a9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-sidebar-right-expand",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4v16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10l-2 2l2 2"
  }));
}

var _excluded$a8 = ["size", "color", "stroke"];

function IconLayoutSidebarRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$a8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-sidebar-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 4,
    x2: 15,
    y2: 20
  }));
}

var _excluded$a7 = ["size", "color", "stroke"];

function IconLayoutSidebar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$a7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout-sidebar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 4,
    x2: 9,
    y2: 20
  }));
}

var _excluded$a6 = ["size", "color", "stroke"];

function IconLayout(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$a6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-layout",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 6,
    height: 7,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 16,
    rx: 2
  }));
}

var _excluded$a5 = ["size", "color", "stroke"];

function IconLeaf(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$a5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-leaf",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21c.5 -4.5 2.5 -8 7 -10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18c6.218 0 10.5 -3.288 11 -12v-2h-4.014c-9 0 -11.986 4 -12 9c0 1 0 3 2 5h3z"
  }));
}

var _excluded$a4 = ["size", "color", "stroke"];

function IconLego(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$a4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lego",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 11,
    x2: 9.51,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 11,
    x2: 14.51,
    y2: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5h1v-2h8v2h1a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3v1h-10v-1a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3"
  }));
}

var _excluded$a3 = ["size", "color", "stroke"];

function IconLemon2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$a3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lemon-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4a2 2 0 0 1 1.185 3.611c1.55 2.94 .873 6.917 -1.892 9.682c-2.765 2.765 -6.743 3.442 -9.682 1.892a2 2 0 1 1 -2.796 -2.796c-1.55 -2.94 -.873 -6.917 1.892 -9.682c2.765 -2.765 6.743 -3.442 9.682 -1.892a1.999 1.999 0 0 1 1.611 -.815z"
  }));
}

var _excluded$a2 = ["size", "color", "stroke"];

function IconLemon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$a2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lemon",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.536 3.393c3.905 3.906 3.905 10.237 0 14.143c-3.906 3.905 -10.237 3.905 -14.143 0l14.143 -14.143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.868 15.06a6.5 6.5 0 0 0 9.193 -9.192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.464 10.464l4.597 4.597"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.464 10.464v6.364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.464 10.464h6.364"
  }));
}

var _excluded$a1 = ["size", "color", "stroke"];

function IconLetterA(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$a1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-a",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20v-12a4 4 0 0 1 4 -4h2a4 4 0 0 1 4 4v12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 13,
    x2: 17,
    y2: 13
  }));
}

var _excluded$a0 = ["size", "color", "stroke"];

function IconLetterB(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$a0);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-b",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20v-16h6a4 4 0 0 1 0 8a4 4 0 0 1 0 8h-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 13,
    y2: 12
  }));
}

var _excluded$9$ = ["size", "color", "stroke"];

function IconLetterC(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-c",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5"
  }));
}

var _excluded$9_ = ["size", "color", "stroke"];

function IconLetterCaseLower(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-case-lower",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 15.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12v7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 15.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12v7"
  }));
}

var _excluded$9Z = ["size", "color", "stroke"];

function IconLetterCaseToggle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-case-toggle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 15.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12v7"
  }));
}

var _excluded$9Y = ["size", "color", "stroke"];

function IconLetterCaseUpper(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-case-upper",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13h7"
  }));
}

var _excluded$9X = ["size", "color", "stroke"];

function IconLetterCase(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-case",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 15.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12v7"
  }));
}

var _excluded$9W = ["size", "color", "stroke"];

function IconLetterD(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-d",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4h6a5 5 0 0 1 5 5v6a5 5 0 0 1 -5 5h-6v-16"
  }));
}

var _excluded$9V = ["size", "color", "stroke"];

function IconLetterE(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-e",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4h-10v16h10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 15,
    y2: 12
  }));
}

var _excluded$9U = ["size", "color", "stroke"];

function IconLetterF(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-f",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4h-10v16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 15,
    y2: 12
  }));
}

var _excluded$9T = ["size", "color", "stroke"];

function IconLetterG(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-g",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-2h-4"
  }));
}

var _excluded$9S = ["size", "color", "stroke"];

function IconLetterH(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-h",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 17,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 17,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 7,
    y2: 20
  }));
}

var _excluded$9R = ["size", "color", "stroke"];

function IconLetterI(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-i",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }));
}

var _excluded$9Q = ["size", "color", "stroke"];

function IconLetterJ(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-j",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4v12a4 4 0 0 1 -4 4h-2a4 4 0 0 1 -4 -4"
  }));
}

var _excluded$9P = ["size", "color", "stroke"];

function IconLetterK(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-k",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 7,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12h2l8 -8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 17,
    y2: 20
  }));
}

var _excluded$9O = ["size", "color", "stroke"];

function IconLetterL(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-l",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4v16h10"
  }));
}

var _excluded$9N = ["size", "color", "stroke"];

function IconLetterM(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-m",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20v-16l6 14l6 -14v16"
  }));
}

var _excluded$9M = ["size", "color", "stroke"];

function IconLetterN(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-n",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20v-16l10 16v-16"
  }));
}

var _excluded$9L = ["size", "color", "stroke"];

function IconLetterO(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-o",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-6"
  }));
}

var _excluded$9K = ["size", "color", "stroke"];

function IconLetterP(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-p",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5"
  }));
}

var _excluded$9J = ["size", "color", "stroke"];

function IconLetterQ(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-q",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 15,
    x2: 18,
    y2: 20
  }));
}

var _excluded$9I = ["size", "color", "stroke"];

function IconLetterR(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-r",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 13,
    x2: 17,
    y2: 20
  }));
}

var _excluded$9H = ["size", "color", "stroke"];

function IconLetterS(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-s",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8a4 4 0 0 0 -4 -4h-2a4 4 0 0 0 0 8h2a4 4 0 0 1 0 8h-2a4 4 0 0 1 -4 -4"
  }));
}

var _excluded$9G = ["size", "color", "stroke"];

function IconLetterSpacing(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-spacing",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 4l3 8l3 -8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 18h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20l2 -2l-2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 16l-2 2l2 2"
  }));
}

var _excluded$9F = ["size", "color", "stroke"];

function IconLetterT(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-t",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 18,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }));
}

var _excluded$9E = ["size", "color", "stroke"];

function IconLetterU(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-u",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4v11a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-11"
  }));
}

var _excluded$9D = ["size", "color", "stroke"];

function IconLetterV(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-v",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4l6 16l6 -16"
  }));
}

var _excluded$9C = ["size", "color", "stroke"];

function IconLetterW(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-w",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4l4 16l4 -14l4 14l4 -16"
  }));
}

var _excluded$9B = ["size", "color", "stroke"];

function IconLetterX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 17,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 4,
    x2: 7,
    y2: 20
  }));
}

var _excluded$9A = ["size", "color", "stroke"];

function IconLetterY(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-y",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4l5 9l5 -9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 13,
    x2: 12,
    y2: 20
  }));
}

var _excluded$9z = ["size", "color", "stroke"];

function IconLetterZ(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-letter-z",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4h10l-10 16h10"
  }));
}

var _excluded$9y = ["size", "color", "stroke"];

function IconLicense(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-license",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 0 0 4 0v-14a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -3 3v11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 7,
    x2: 13,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 11,
    x2: 13,
    y2: 11
  }));
}

var _excluded$9x = ["size", "color", "stroke"];

function IconLifebuoy(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lifebuoy",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 18.35,
    y2: 18.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 5.65,
    y2: 18.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.65,
    y1: 5.65,
    x2: 9,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.35,
    y1: 5.65,
    x2: 15,
    y2: 9
  }));
}

var _excluded$9w = ["size", "color", "stroke"];

function IconLineDashed(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-line-dashed",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12h2"
  }));
}

var _excluded$9v = ["size", "color", "stroke"];

function IconLineDotted(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-line-dotted",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12v.01"
  }));
}

var _excluded$9u = ["size", "color", "stroke"];

function IconLineHeight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-line-height",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3 8 6 5 9 8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3 16 6 19 9 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 5,
    x2: 6,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 18,
    x2: 20,
    y2: 18
  }));
}

var _excluded$9t = ["size", "color", "stroke"];

function IconLine(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-line",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 16.5,
    x2: 16.5,
    y2: 7.5
  }));
}

var _excluded$9s = ["size", "color", "stroke"];

function IconLink(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-link",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5"
  }));
}

var _excluded$9r = ["size", "color", "stroke"];

function IconListCheck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-list-check",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.5l1.5 1.5l2.5 -2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.5l1.5 1.5l2.5 -2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17.5l1.5 1.5l2.5 -2.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 18,
    x2: 20,
    y2: 18
  }));
}

var _excluded$9q = ["size", "color", "stroke"];

function IconListDetails(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-list-details",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 19h5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }));
}

var _excluded$9p = ["size", "color", "stroke"];

function IconListNumbers(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-list-numbers",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10v-6l-2 2"
  }));
}

var _excluded$9o = ["size", "color", "stroke"];

function IconListSearch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-list-search",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18.5l2.5 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18h4"
  }));
}

var _excluded$9n = ["size", "color", "stroke"];

function IconList(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-list",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 18,
    x2: 20,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 6,
    x2: 5,
    y2: 6.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 5,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 18,
    x2: 5,
    y2: 18.01
  }));
}

var _excluded$9m = ["size", "color", "stroke"];

function IconLivePhoto(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-live-photo",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.9,
    y1: 20.11,
    x2: 15.9,
    y2: 20.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.04,
    y1: 17.61,
    x2: 19.04,
    y2: 17.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.77,
    y1: 14,
    x2: 20.77,
    y2: 14.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.77,
    y1: 10,
    x2: 20.77,
    y2: 10.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.04,
    y1: 6.39,
    x2: 19.04,
    y2: 6.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.9,
    y1: 3.89,
    x2: 15.9,
    y2: 3.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 3.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.1,
    y1: 3.89,
    x2: 8.1,
    y2: 3.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.96,
    y1: 6.39,
    x2: 4.96,
    y2: 6.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.23,
    y1: 10,
    x2: 3.23,
    y2: 10.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.23,
    y1: 14,
    x2: 3.23,
    y2: 14.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.96,
    y1: 17.61,
    x2: 4.96,
    y2: 17.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.1,
    y1: 20.11,
    x2: 8.1,
    y2: 20.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 21.01
  }));
}

var _excluded$9l = ["size", "color", "stroke"];

function IconLiveView(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-live-view",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 11,
    x2: 12,
    y2: 11.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18l-3.5 -5a4 4 0 1 1 7 0l-3.5 5"
  }));
}

var _excluded$9k = ["size", "color", "stroke"];

function IconLoaderQuarter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-loader-quarter",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 3,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.75,
    y1: 7.75,
    x2: 5.6,
    y2: 5.6
  }));
}

var _excluded$9j = ["size", "color", "stroke"];

function IconLoader(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-loader",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.25,
    y1: 7.75,
    x2: 18.4,
    y2: 5.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 21,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.25,
    y1: 16.25,
    x2: 18.4,
    y2: 18.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.75,
    y1: 16.25,
    x2: 5.6,
    y2: 18.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 3,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.75,
    y1: 7.75,
    x2: 5.6,
    y2: 5.6
  }));
}

var _excluded$9i = ["size", "color", "stroke"];

function IconLocation(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-location",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5"
  }));
}

var _excluded$9h = ["size", "color", "stroke"];

function IconLockAccess(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lock-access",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 8,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11v-2a2 2 0 1 1 4 0v2"
  }));
}

var _excluded$9g = ["size", "color", "stroke"];

function IconLockOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lock-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h4m4 0h2a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11v-3m.712 -3.278a4 4 0 0 1 7.288 2.278v4"
  }));
}

var _excluded$9f = ["size", "color", "stroke"];

function IconLockOpen(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lock-open",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 14,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11v-5a4 4 0 0 1 8 0"
  }));
}

var _excluded$9e = ["size", "color", "stroke"];

function IconLockSquare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lock-square",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 8,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11v-2a2 2 0 1 1 4 0v2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$9d = ["size", "color", "stroke"];

function IconLock(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lock",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 14,
    height: 10,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11v-4a4 4 0 0 1 8 0v4"
  }));
}

var _excluded$9c = ["size", "color", "stroke"];

function IconLogin(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-login",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12h-13l3 -3m0 6l-3 -3"
  }));
}

var _excluded$9b = ["size", "color", "stroke"];

function IconLogout(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-logout",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12h14l-3 -3m0 6l3 -3"
  }));
}

var _excluded$9a = ["size", "color", "stroke"];

function IconLollipop(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lollipop",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10a3.5 3.5 0 0 0 -7 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10a3.5 3.5 0 0 1 -7 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17a3.5 3.5 0 0 0 0 -7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3a3.5 3.5 0 0 0 0 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21l6 -6"
  }));
}

var _excluded$99 = ["size", "color", "stroke"];

function IconLuggage(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$99);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-luggage",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6v-1a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20v1"
  }));
}

var _excluded$98 = ["size", "color", "stroke"];

function IconLungs(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$98);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-lungs",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.081 20c1.612 0 2.919 -1.335 2.919 -2.98v-9.763c0 -.694 -.552 -1.257 -1.232 -1.257c-.205 0 -.405 .052 -.584 .15l-.13 .083c-1.46 1.059 -2.432 2.647 -3.404 5.824c-.42 1.37 -.636 2.962 -.648 4.775c-.012 1.675 1.261 3.054 2.877 3.161l.203 .007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.92 20c-1.613 0 -2.92 -1.335 -2.92 -2.98v-9.763c0 -.694 .552 -1.257 1.233 -1.257c.204 0 .405 .052 .584 .15l.13 .083c1.46 1.059 2.432 2.647 3.405 5.824c.42 1.37 .636 2.962 .648 4.775c.012 1.675 -1.261 3.054 -2.878 3.161l-.202 .007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12a3 3 0 0 0 3 -3a3 3 0 0 0 3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v5"
  }));
}

var _excluded$97 = ["size", "color", "stroke"];

function IconMacro(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$97);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-macro",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15a6 6 0 1 0 12 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15a6 6 0 0 0 -6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21a6 6 0 0 0 -6 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11a5 5 0 0 1 -5 -5v-3l3 2l2 -2l2 2l3 -2v3a5 5 0 0 1 -5 5z"
  }));
}

var _excluded$96 = ["size", "color", "stroke"];

function IconMagnet(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$96);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-magnet",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a2 2 0 0 0 6 0v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a8 8 0 0 1 -16 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 9,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 19,
    y2: 8
  }));
}

var _excluded$95 = ["size", "color", "stroke"];

function IconMailFast(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$95);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mail-fast",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02 8.801l-.6 6a2 2 0 0 0 1.99 2.199h7.98a2 2 0 0 0 1.99 -1.801l.6 -6a2 2 0 0 0 -1.99 -2.199h-7.98a2 2 0 0 0 -1.99 1.801z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8 7.5l2.982 3.28a3 3 0 0 0 4.238 .202l3.28 -2.982"
  }));
}

var _excluded$94 = ["size", "color", "stroke"];

function IconMailForward(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$94);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mail-forward",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6l9 6l9 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l3 3l-3 3"
  }));
}

var _excluded$93 = ["size", "color", "stroke"];

function IconMailOpened(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$93);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mail-opened",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3 9 12 15 21 9 12 3 3 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 19,
    x2: 9,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 13,
    x2: 21,
    y2: 19
  }));
}

var _excluded$92 = ["size", "color", "stroke"];

function IconMail(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$92);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mail",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3 7 12 13 21 7"
  }));
}

var _excluded$91 = ["size", "color", "stroke"];

function IconMailbox(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$91);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mailbox",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21v-6.5a3.5 3.5 0 0 0 -7 0v6.5h18v-6a4 4 0 0 0 -4 -4h-10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11v-8h4l2 2l-2 2h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15h1"
  }));
}

var _excluded$90 = ["size", "color", "stroke"];

function IconMan(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$90);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-man",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5"
  }));
}

var _excluded$8$ = ["size", "color", "stroke"];

function IconManualGearbox(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-manual-gearbox",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 8,
    x2: 5,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8v2a2 2 0 0 1 -2 2h-12"
  }));
}

var _excluded$8_ = ["size", "color", "stroke"];

function IconMap2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-map-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 6,
    x2: 18,
    y2: 6.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13l-3.5 -5a4 4 0 1 1 7 0l-3.5 5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "10.5 4.75 9 4 3 7 3 20 9 17 15 20 21 17 21 15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 4,
    x2: 9,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 15,
    y2: 20
  }));
}

var _excluded$8Z = ["size", "color", "stroke"];

function IconMapPinOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-map-pin-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44 9.435a3 3 0 0 0 4.126 4.124m1.434 -2.559a3 3 0 0 0 -3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.048 4.042a8 8 0 0 1 10.912 10.908m-1.8 2.206l-3.745 3.744a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 0 1 -.48 -10.79"
  }));
}

var _excluded$8Y = ["size", "color", "stroke"];

function IconMapPin(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-map-pin",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"
  }));
}

var _excluded$8X = ["size", "color", "stroke"];

function IconMapPins(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-map-pins",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.828 9.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 7,
    x2: 8,
    y2: 7.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.828 17.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 15,
    x2: 16,
    y2: 15.01
  }));
}

var _excluded$8W = ["size", "color", "stroke"];

function IconMapSearch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-map-search",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4v13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7v5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19.5l2.5 2.5"
  }));
}

var _excluded$8V = ["size", "color", "stroke"];

function IconMap(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-map",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3 7 9 4 15 7 21 4 21 17 15 20 9 17 3 20 3 7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 4,
    x2: 9,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 7,
    x2: 15,
    y2: 20
  }));
}

var _excluded$8U = ["size", "color", "stroke"];

function IconMarkdown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-markdown",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 15v-6l2 2l2 -2v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13l2 2l2 -2m-2 2v-6"
  }));
}

var _excluded$8T = ["size", "color", "stroke"];

function IconMarquee2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-marquee-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1m-5 0h-2m-5 0h-1a1 1 0 0 1 -1 -1v-1m0 -5v-2"
  }));
}

var _excluded$8S = ["size", "color", "stroke"];

function IconMarquee(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-marquee",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6a2 2 0 0 1 2 -2m3 0h1.5m3 0h1.5m3 0a2 2 0 0 1 2 2m0 3v1.5m0 3v1.5m0 3a2 2 0 0 1 -2 2m-3 0h-1.5m-3 0h-1.5m-3 0a2 2 0 0 1 -2 -2m0 -3v-1.5m0 -3v-1.5m0 -3"
  }));
}

var _excluded$8R = ["size", "color", "stroke"];

function IconMars(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mars",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 14,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 5,
    x2: 13.6,
    y2: 10.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 5,
    x2: 14,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 5,
    x2: 19,
    y2: 10
  }));
}

var _excluded$8Q = ["size", "color", "stroke"];

function IconMaskOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mask-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.42 19.41a2 2 0 0 1 -1.42 .59h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.055 .588 -1.417m3.412 -.583h10a2 2 0 0 1 2 2v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.885 9.872a3 3 0 1 0 4.245 4.24m.582 -3.396a3.012 3.012 0 0 0 -1.438 -1.433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$8P = ["size", "color", "stroke"];

function IconMask(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mask",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$8O = ["size", "color", "stroke"];

function IconMassage(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-massage",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 22l4 -2v-3h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 20h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14l3 -2l1 -4c3 1 3 4 3 6"
  }));
}

var _excluded$8N = ["size", "color", "stroke"];

function IconMathFunction(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-function",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19c0 1.5 .5 2 2 2s2 -4 3 -9s1.5 -9 3 -9s2 .5 2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 11,
    y2: 12
  }));
}

var _excluded$8M = ["size", "color", "stroke"];

function IconMathSymbols(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math-symbols",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 4.5,
    x2: 19.5,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 4.5,
    x2: 16.5,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 8,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 16,
    x2: 18.01,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 20,
    x2: 18.01,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 8,
    y2: 18
  }));
}

var _excluded$8L = ["size", "color", "stroke"];

function IconMath(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-math",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13l4 4m0 -4l-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 5h-7l-4 14l-3 -6h-2"
  }));
}

var _excluded$8K = ["size", "color", "stroke"];

function IconMaximize(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-maximize",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v-2a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v2a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-2"
  }));
}

var _excluded$8J = ["size", "color", "stroke"];

function IconMeat(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-meat",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.62 8.382l1.966 -1.967a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-1.82 1.821"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(45 8.025 16.475)",
    cx: 8.025,
    cy: 16.475,
    rx: 7,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16l1 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.975 21.425c3.905 -3.906 4.855 -9.288 2.121 -12.021c-2.733 -2.734 -8.115 -1.784 -12.02 2.121"
  }));
}

var _excluded$8I = ["size", "color", "stroke"];

function IconMedal2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-medal-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3h6l3 7l-6 2l-6 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l-3 -9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11l-3 -8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
  }));
}

var _excluded$8H = ["size", "color", "stroke"];

function IconMedal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-medal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v3m-4 -3v6m8 -6v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
  }));
}

var _excluded$8G = ["size", "color", "stroke"];

function IconMedicalCross(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-medical-cross",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3a1 1 0 0 1 1 1v4.535l3.928 -2.267a1 1 0 0 1 1.366 .366l1 1.732a1 1 0 0 1 -.366 1.366l-3.927 2.268l3.927 2.269a1 1 0 0 1 .366 1.366l-1 1.732a1 1 0 0 1 -1.366 .366l-3.928 -2.269v4.536a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-4.536l-3.928 2.268a1 1 0 0 1 -1.366 -.366l-1 -1.732a1 1 0 0 1 .366 -1.366l3.927 -2.268l-3.927 -2.268a1 1 0 0 1 -.366 -1.366l1 -1.732a1 1 0 0 1 1.366 -.366l3.928 2.267v-4.535a1 1 0 0 1 1 -1h2z"
  }));
}

var _excluded$8F = ["size", "color", "stroke"];

function IconMedicineSyrup(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-medicine-syrup",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 21h8a1 1 0 0 0 1 -1v-10a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v10a1 1 0 0 0 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7v-3a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3"
  }));
}

var _excluded$8E = ["size", "color", "stroke"];

function IconMenu2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-menu-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 20,
    y2: 18
  }));
}

var _excluded$8D = ["size", "color", "stroke"];

function IconMenu(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-menu",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 20,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 20,
    y2: 16
  }));
}

var _excluded$8C = ["size", "color", "stroke"];

function IconMessage2Code(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-2-code",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9l-2 2l2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9l2 2l-2 2"
  }));
}

var _excluded$8B = ["size", "color", "stroke"];

function IconMessage2Share(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-2-share",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4h4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11v3a3 3 0 0 1 -3 3h-2l-3 3l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9l5 -5"
  }));
}

var _excluded$8A = ["size", "color", "stroke"];

function IconMessage2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20l-3 -3h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-2l-3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 16,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 14,
    y2: 13
  }));
}

var _excluded$8z = ["size", "color", "stroke"];

function IconMessageCircle2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-circle-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }));
}

var _excluded$8y = ["size", "color", "stroke"];

function IconMessageCircleOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-circle-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.585 4.581c3.225 -1.181 7.032 -.616 9.66 1.626c2.983 2.543 3.602 6.525 1.634 9.662m-1.908 2.108c-2.786 2.19 -6.89 2.665 -10.271 1.023l-4.7 1l1.3 -3.9c-2.237 -3.308 -1.489 -7.54 1.714 -10.084"
  }));
}

var _excluded$8x = ["size", "color", "stroke"];

function IconMessageCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 12.01
  }));
}

var _excluded$8w = ["size", "color", "stroke"];

function IconMessageCode(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-code",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9l-2 2l2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9l2 2l-2 2"
  }));
}

var _excluded$8v = ["size", "color", "stroke"];

function IconMessageDots(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-dots",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 11,
    x2: 12,
    y2: 11.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 8,
    y2: 11.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 11,
    x2: 16,
    y2: 11.01
  }));
}

var _excluded$8u = ["size", "color", "stroke"];

function IconMessageLanguage(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-language",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14v-4a2 2 0 1 1 4 0v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12h-4"
  }));
}

var _excluded$8t = ["size", "color", "stroke"];

function IconMessageOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17h-9l-4 4v-13c0 -1.086 .577 -2.036 1.44 -2.563m3.561 -.437h8a3 3 0 0 1 3 3v6c0 .575 -.162 1.112 -.442 1.568"
  }));
}

var _excluded$8s = ["size", "color", "stroke"];

function IconMessagePlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 14,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 13
  }));
}

var _excluded$8r = ["size", "color", "stroke"];

function IconMessageReport(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-report",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 14.01
  }));
}

var _excluded$8q = ["size", "color", "stroke"];

function IconMessageShare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message-share",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11v3a3 3 0 0 1 -3 3h-9l-4 4v-13a3 3 0 0 1 3 -3h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4h4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9l5 -5"
  }));
}

var _excluded$8p = ["size", "color", "stroke"];

function IconMessage(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-message",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 16,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 14,
    y2: 13
  }));
}

var _excluded$8o = ["size", "color", "stroke"];

function IconMessagesOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-messages-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11a1 1 0 0 1 -1 -1m0 -3.968v-2.032a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10l-3 -3h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2"
  }));
}

var _excluded$8n = ["size", "color", "stroke"];

function IconMessages(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-messages",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 14l-3 -3h-7a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2"
  }));
}

var _excluded$8m = ["size", "color", "stroke"];

function IconMicrophone2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-microphone-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.002 12.9a5 5 0 1 0 -3.902 -3.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.002 12.9l-3.902 -3.899l-7.513 8.584a2 2 0 1 0 2.827 2.83l8.588 -7.515z"
  }));
}

var _excluded$8l = ["size", "color", "stroke"];

function IconMicrophoneOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-microphone-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5a3 3 0 0 1 6 0v5a3 3 0 0 1 -.13 .874m-2 2a3 3 0 0 1 -3.87 -2.872v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10a7 7 0 0 0 10.846 5.85m2.002 -2a6.967 6.967 0 0 0 1.152 -3.85"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 21
  }));
}

var _excluded$8k = ["size", "color", "stroke"];

function IconMicrophone(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-microphone",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2,
    width: 6,
    height: 11,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10a7 7 0 0 0 14 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 21
  }));
}

var _excluded$8j = ["size", "color", "stroke"];

function IconMicroscope(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-microscope",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11l3 3l6 -6l-3 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.5l-1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21a6 6 0 0 0 3.715 -10.712"
  }));
}

var _excluded$8i = ["size", "color", "stroke"];

function IconMilitaryAward(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-military-award",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10l-1 -2h-5l2.48 5.788a2 2 0 0 0 1.84 1.212h1.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10l1 -2h5l-2.48 5.788a2 2 0 0 1 -1.84 1.212h-1.18"
  }));
}

var _excluded$8h = ["size", "color", "stroke"];

function IconMilitaryRank(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-military-rank",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 7v13h-10v-13l5 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13l2 -1l2 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17l2 -1l2 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9l2 -1l2 1"
  }));
}

var _excluded$8g = ["size", "color", "stroke"];

function IconMilk(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-milk",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6h8v-2a1 1 0 0 0 -1 -1h-6a1 1 0 0 0 -1 1v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6l1.094 1.759a6 6 0 0 1 .906 3.17v8.071a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8.071a6 6 0 0 1 .906 -3.17l1.094 -1.759"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h4"
  }));
}

var _excluded$8f = ["size", "color", "stroke"];

function IconMinimize(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-minimize",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19v-2a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5v2a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15h2a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9h2a2 2 0 0 0 2 -2v-2"
  }));
}

var _excluded$8e = ["size", "color", "stroke"];

function IconMinusVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-minus-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v14"
  }));
}

var _excluded$8d = ["size", "color", "stroke"];

function IconMinus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-minus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }));
}

var _excluded$8c = ["size", "color", "stroke"];

function IconMist(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mist",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5h3m4 0h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10h11m4 0h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15h5m4 0h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 20h9m4 0h3"
  }));
}

var _excluded$8b = ["size", "color", "stroke"];

function IconMoodBoy(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-boy",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4.5a9 9 0 0 1 3.864 5.89a2.5 2.5 0 0 1 -.29 4.36a9 9 0 0 1 -17.137 0a2.5 2.5 0 0 1 -.29 -4.36a9 9 0 0 1 3.746 -5.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16a3.5 3.5 0 0 0 5 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2c1.5 1 2.5 3.5 2.5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2c1.5 2 2 3.5 2 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 9.01,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 15.01,
    y2: 12
  }));
}

var _excluded$8a = ["size", "color", "stroke"];

function IconMoodConfuzed(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-confuzed",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16a10 10 0 0 1 6 -1.5"
  }));
}

var _excluded$89 = ["size", "color", "stroke"];

function IconMoodCrazyHappy(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$89);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-crazy-happy",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 8.5,
    x2: 10,
    y2: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5l3 -3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 8.5,
    x2: 17,
    y2: 11.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11.5l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }));
}

var _excluded$88 = ["size", "color", "stroke"];

function IconMoodCry(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$88);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-cry",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.25a3.5 3.5 0 0 1 5 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.566 17.606a2 2 0 1 0 2.897 .03l-1.463 -1.636l-1.434 1.606z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.865 13.517a8.937 8.937 0 0 0 .135 -1.517a9 9 0 1 0 -9 9c.69 0 1.36 -.076 2 -.222"
  }));
}

var _excluded$87 = ["size", "color", "stroke"];

function IconMoodEmpty(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$87);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-empty",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 15
  }));
}

var _excluded$86 = ["size", "color", "stroke"];

function IconMoodHappy(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$86);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-happy",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9.01,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 15.01,
    y2: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13a4 4 0 1 0 8 0m0 0h-8"
  }));
}

var _excluded$85 = ["size", "color", "stroke"];

function IconMoodKid(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$85);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-kid",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a2 2 0 0 0 0 4"
  }));
}

var _excluded$84 = ["size", "color", "stroke"];

function IconMoodNervous(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$84);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-nervous",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16l2 -2l2 2l2 -2l2 2"
  }));
}

var _excluded$83 = ["size", "color", "stroke"];

function IconMoodNeutral(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$83);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-neutral",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }));
}

var _excluded$82 = ["size", "color", "stroke"];

function IconMoodSad(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$82);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-sad",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.25a3.5 3.5 0 0 1 5 0"
  }));
}

var _excluded$81 = ["size", "color", "stroke"];

function IconMoodSmile(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$81);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-smile",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }));
}

var _excluded$80 = ["size", "color", "stroke"];

function IconMoodSuprised(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$80);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-suprised",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9.01,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 15.01,
    y2: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 2
  }));
}

var _excluded$7$ = ["size", "color", "stroke"];

function IconMoodTongue(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mood-tongue",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 10,
    x2: 15.01,
    y2: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14v2a2 2 0 0 0 4 0v-2m1.5 0h-7"
  }));
}

var _excluded$7_ = ["size", "color", "stroke"];

function IconMoon2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-moon-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.418 4.157a8 8 0 0 0 0 15.686"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$7Z = ["size", "color", "stroke"];

function IconMoonStars(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-moon-stars",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11h2m-1 -1v2"
  }));
}

var _excluded$7Y = ["size", "color", "stroke"];

function IconMoon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-moon",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"
  }));
}

var _excluded$7X = ["size", "color", "stroke"];

function IconMoped(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-moped",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16v1a2 2 0 0 0 4 0v-5h-3a3 3 0 0 0 -3 3v1h10a6 6 0 0 1 5 -4v-5a2 2 0 0 0 -2 -2h-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 9,
    x2: 9,
    y2: 9
  }));
}

var _excluded$7W = ["size", "color", "stroke"];

function IconMotorbike(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-motorbike",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14h5l4 -4h-10.5m1.5 4l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6h2l1.5 3l2 4"
  }));
}

var _excluded$7V = ["size", "color", "stroke"];

function IconMountain(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mountain",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 20h18l-6.921 -14.612a2.3 2.3 0 0 0 -4.158 0l-6.921 14.612z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11l2 2.5l2.5 -2.5l2 3l2.5 -2"
  }));
}

var _excluded$7U = ["size", "color", "stroke"];

function IconMouse(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mouse",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 12,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 11
  }));
}

var _excluded$7T = ["size", "color", "stroke"];

function IconMovie(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-movie",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 8,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 8,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 8,
    x2: 20,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 20,
    y2: 16
  }));
}

var _excluded$7S = ["size", "color", "stroke"];

function IconMug(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mug",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.083 5h10.834a1.08 1.08 0 0 1 1.083 1.077v8.615c0 2.38 -1.94 4.308 -4.333 4.308h-4.334c-2.393 0 -4.333 -1.929 -4.333 -4.308v-8.615a1.08 1.08 0 0 1 1.083 -1.077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8h2.5c1.38 0 2.5 1.045 2.5 2.333v2.334c0 1.288 -1.12 2.333 -2.5 2.333h-2.5"
  }));
}

var _excluded$7R = ["size", "color", "stroke"];

function IconMultiplier05x(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-multiplier-0-5x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16h2a2 2 0 1 0 0 -4h-2v-4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16l-4 -4"
  }));
}

var _excluded$7Q = ["size", "color", "stroke"];

function IconMultiplier15x(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-multiplier-1-5x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16v-8l-2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16h2a2 2 0 1 0 0 -4h-2v-4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 16v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16l-4 -4"
  }));
}

var _excluded$7P = ["size", "color", "stroke"];

function IconMultiplier1x(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-multiplier-1x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16v-8l-2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16l-4 -4"
  }));
}

var _excluded$7O = ["size", "color", "stroke"];

function IconMultiplier2x(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-multiplier-2x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16l-4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
  }));
}

var _excluded$7N = ["size", "color", "stroke"];

function IconMushroom(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-mushroom",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11.1c0 -4.474 -3.582 -8.1 -8 -8.1s-8 3.626 -8 8.1a0.9 .9 0 0 0 .9 .9h14.2a0.9 .9 0 0 0 .9 -.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12v7a2 2 0 1 0 4 0v-7"
  }));
}

var _excluded$7M = ["size", "color", "stroke"];

function IconMusic(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-music",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 17,
    r: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 17 9 4 19 4 19 17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 8,
    x2: 19,
    y2: 8
  }));
}

var _excluded$7L = ["size", "color", "stroke"];

function IconNewSection(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-new-section",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1m-5 0h-2m-5 0h-1a1 1 0 0 1 -1 -1v-1m0 -5v-2m0 -5"
  }));
}

var _excluded$7K = ["size", "color", "stroke"];

function IconNews(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-news",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1 -4 0v-13a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v12a3 3 0 0 0 3 3h11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 8,
    x2: 12,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 16,
    x2: 12,
    y2: 16
  }));
}

var _excluded$7J = ["size", "color", "stroke"];

function IconNfc(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-nfc",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 20a3 3 0 0 1 -3 -3v-11l5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 4a3 3 0 0 1 3 3v11l-5 -5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 3
  }));
}

var _excluded$7I = ["size", "color", "stroke"];

function IconNoCopyright(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-no-copyright",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9.75a3.016 3.016 0 0 0 -4.163 .173a2.993 2.993 0 0 0 0 4.154a3.016 3.016 0 0 0 4.163 .173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6l1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5l1.5 1.5"
  }));
}

var _excluded$7H = ["size", "color", "stroke"];

function IconNoCreativeCommons(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-no-creative-commons",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6l1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5l1.5 1.5"
  }));
}

var _excluded$7G = ["size", "color", "stroke"];

function IconNoDerivatives(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-no-derivatives",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14h6"
  }));
}

var _excluded$7F = ["size", "color", "stroke"];

function IconNorthStar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-north-star",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5l9 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.5l9 -9"
  }));
}

var _excluded$7E = ["size", "color", "stroke"];

function IconNote(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-note",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 20,
    x2: 20,
    y2: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 20v-6a1 1 0 0 1 1 -1h6v-7a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7"
  }));
}

var _excluded$7D = ["size", "color", "stroke"];

function IconNotebook(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-notebook",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 8,
    x2: 15,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 12,
    x2: 15,
    y2: 12
  }));
}

var _excluded$7C = ["size", "color", "stroke"];

function IconNotes(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-notes",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 7,
    x2: 15,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 11,
    x2: 15,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 13,
    y2: 15
  }));
}

var _excluded$7B = ["size", "color", "stroke"];

function IconNotification(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-notification",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 7,
    r: 3
  }));
}

var _excluded$7A = ["size", "color", "stroke"];

function IconNumber0(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-0",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16v-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20a4 4 0 0 0 4 -4v-8a4 4 0 1 0 -8 0v8a4 4 0 0 0 4 4z"
  }));
}

var _excluded$7z = ["size", "color", "stroke"];

function IconNumber1(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-1",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 20v-16l-5 5"
  }));
}

var _excluded$7y = ["size", "color", "stroke"];

function IconNumber2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 9.185h8"
  }));
}

var _excluded$7x = ["size", "color", "stroke"];

function IconNumber3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12a4 4 0 1 0 -4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16a4 4 0 1 0 4 -4"
  }));
}

var _excluded$7w = ["size", "color", "stroke"];

function IconNumber4(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-4",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20v-15l-8 11h10"
  }));
}

var _excluded$7v = ["size", "color", "stroke"];

function IconNumber5(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-5",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20h4a4 4 0 1 0 0 -8h-4v-8h8"
  }));
}

var _excluded$7u = ["size", "color", "stroke"];

function IconNumber6(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-6",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16a4 4 0 1 0 8 0v-1a4 4 0 1 0 -8 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8a4 4 0 1 0 -8 0v8"
  }));
}

var _excluded$7t = ["size", "color", "stroke"];

function IconNumber7(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-7",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4h8l-4 16"
  }));
}

var _excluded$7s = ["size", "color", "stroke"];

function IconNumber8(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-8",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 4
  }));
}

var _excluded$7r = ["size", "color", "stroke"];

function IconNumber9(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-number-9",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8a4 4 0 1 0 -8 0v1a4 4 0 1 0 8 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16a4 4 0 1 0 8 0v-8"
  }));
}

var _excluded$7q = ["size", "color", "stroke"];

function IconNumbers(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-numbers",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10v-7l-2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16a2 2 0 1 1 4 0c0 .591 -.601 1.46 -1 2l-3 3.001h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14a2 2 0 1 0 2 -2a2 2 0 1 0 -2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10h3"
  }));
}

var _excluded$7p = ["size", "color", "stroke"];

function IconNurse(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-nurse",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6c2.941 0 5.685 .847 8 2.31l-2 9.69h-12l-2 -9.691a14.93 14.93 0 0 1 8 -2.309z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10v4"
  }));
}

var _excluded$7o = ["size", "color", "stroke"];

function IconOctagonOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-octagon-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.647 3.653l.353 -.353c.2 -.2 .4 -.3 .7 -.3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-.35 .35m-1.997 1.997l-2.353 2.353c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l2.35 -2.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$7n = ["size", "color", "stroke"];

function IconOctagon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-octagon",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7 3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-4.7 4.7c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l4.7 -4.7c.2 -.2 .4 -.3 .7 -.3z"
  }));
}

var _excluded$7m = ["size", "color", "stroke"];

function IconOld(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-old",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 21l-1 -4l-2 -3v-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 14l-1 -3l4 -3l3 2l3 .5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17l-2 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-8.5a1.5 1.5 0 0 1 3 0v.5"
  }));
}

var _excluded$7l = ["size", "color", "stroke"];

function IconOlympics(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-olympics",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 9,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 9,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 15,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 3
  }));
}

var _excluded$7k = ["size", "color", "stroke"];

function IconOmega(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-omega",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 19h5v-1a7.35 7.35 0 1 1 6 0v1h5"
  }));
}

var _excluded$7j = ["size", "color", "stroke"];

function IconOutlet(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-outlet",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 12,
    r: 0.5,
    fill: "currentColor"
  }));
}

var _excluded$7i = ["size", "color", "stroke"];

function IconOvalVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-oval-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0 -1 -1 0 24 24)",
    cx: 12,
    cy: 12,
    rx: 6,
    ry: 9
  }));
}

var _excluded$7h = ["size", "color", "stroke"];

function IconOval(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-oval",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 6,
    ry: 9
  }));
}

var _excluded$7g = ["size", "color", "stroke"];

function IconOverline(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-overline",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9v5a5 5 0 0 0 10 0v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5h14"
  }));
}

var _excluded$7f = ["size", "color", "stroke"];

function IconPackage(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-package",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 20,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 4,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 5.25,
    x2: 8,
    y2: 9.75
  }));
}

var _excluded$7e = ["size", "color", "stroke"];

function IconPackgeExport(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-packge-export",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l8 -4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l-8 -4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 18h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 15l3 3l-3 3"
  }));
}

var _excluded$7d = ["size", "color", "stroke"];

function IconPackgeImport(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-packge-import",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l8 -4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l-8 -4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 18h-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15l-3 3l3 3"
  }));
}

var _excluded$7c = ["size", "color", "stroke"];

function IconPacman(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pacman",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.636 5.636a9 9 0 0 1 13.397 .747l-5.619 5.617l5.619 5.617a9 9 0 1 1 -13.397 -11.981z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 7.5,
    r: 1,
    fill: "currentColor"
  }));
}

var _excluded$7b = ["size", "color", "stroke"];

function IconPageBreak(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-page-break",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3v4a1 1 0 0 0 1 1h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14h3m4.5 0h3m4.5 0h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10v-5a2 2 0 0 1 2 -2h7l5 5v2"
  }));
}

var _excluded$7a = ["size", "color", "stroke"];

function IconPaint(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-paint",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6h1a2 2 0 0 1 2 2a5 5 0 0 1 -5 5l-5 0v2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 4,
    height: 6,
    rx: 1
  }));
}

var _excluded$79 = ["size", "color", "stroke"];

function IconPalette(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$79);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-palette",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21a9 9 0 1 1 0 -18a9 8 0 0 1 9 8a4.5 4 0 0 1 -4.5 4h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 10.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 10.5,
    r: 0.5,
    fill: "currentColor"
  }));
}

var _excluded$78 = ["size", "color", "stroke"];

function IconPanoramaHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$78);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-panorama-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.338 5.53c5.106 1.932 10.211 1.932 15.317 .002a1 1 0 0 1 1.345 .934v11c0 .692 -.692 1.2 -1.34 .962c-5.107 -1.932 -10.214 -1.932 -15.321 0c-.648 .246 -1.339 -.242 -1.339 -.935v-11.027a1 1 0 0 1 1.338 -.935z"
  }));
}

var _excluded$77 = ["size", "color", "stroke"];

function IconPanoramaVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$77);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-panorama-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.463 4.338c-1.932 5.106 -1.932 10.211 0 15.317a1 1 0 0 1 -.934 1.345h-11c-.692 0 -1.208 -.692 -.962 -1.34c1.932 -5.107 1.932 -10.214 0 -15.321c-.246 -.648 .243 -1.339 .935 -1.339h11.028c.693 0 1.18 .691 .935 1.338z"
  }));
}

var _excluded$76 = ["size", "color", "stroke"];

function IconPaperBag(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$76);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-paper-bag",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3h8a2 2 0 0 1 2 2v1.82a5 5 0 0 0 .528 2.236l.944 1.888a5 5 0 0 1 .528 2.236v5.82a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-5.82a5 5 0 0 1 .528 -2.236l1.472 -2.944v-3a2 2 0 0 1 2 -2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 15,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21a2 2 0 0 0 2 -2v-5.82a5 5 0 0 0 -.528 -2.236l-1.472 -2.944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7h2"
  }));
}

var _excluded$75 = ["size", "color", "stroke"];

function IconPaperclip(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$75);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-paperclip",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7l-6.5 6.5a1.5 1.5 0 0 0 3 3l6.5 -6.5a3 3 0 0 0 -6 -6l-6.5 6.5a4.5 4.5 0 0 0 9 9l6.5 -6.5"
  }));
}

var _excluded$74 = ["size", "color", "stroke"];

function IconParachute(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$74);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-parachute",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12a10 10 0 1 0 -20 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3c0 -1.66 -1.57 -3 -3.5 -3s-3.5 1.34 -3.5 3c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12l10 10l-3.5 -10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12l-3.5 10l10 -10"
  }));
}

var _excluded$73 = ["size", "color", "stroke"];

function IconParentheses(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$73);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-parentheses",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4a12.25 12.25 0 0 0 0 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4a12.25 12.25 0 0 1 0 16"
  }));
}

var _excluded$72 = ["size", "color", "stroke"];

function IconParking(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$72);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-parking",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16v-8h4a2 2 0 0 1 0 4h-4"
  }));
}

var _excluded$71 = ["size", "color", "stroke"];

function IconPaw(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$71);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-paw",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 13.5c-1.1 -1.996 -1.441 -2.5 -2.7 -2.5c-1.259 0 -1.736 .755 -2.836 2.747c-.942 1.703 -2.846 1.845 -3.321 3.291c-.097 .265 -.145 .677 -.143 .962c0 1.176 .787 2 1.8 2c1.259 0 3.004 -1 4.5 -1s3.241 1 4.5 1c1.013 0 1.8 -.823 1.8 -2c0 -.285 -.049 -.697 -.146 -.962c-.475 -1.451 -2.512 -1.835 -3.454 -3.538z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.188 8.082a1.039 1.039 0 0 0 -.406 -.082h-.015c-.735 .012 -1.56 .75 -1.993 1.866c-.519 1.335 -.28 2.7 .538 3.052c.129 .055 .267 .082 .406 .082c.739 0 1.575 -.742 2.011 -1.866c.516 -1.335 .273 -2.7 -.54 -3.052z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.474 9c.055 0 .109 -.004 .163 -.011c.944 -.128 1.533 -1.346 1.32 -2.722c-.203 -1.297 -1.047 -2.267 -1.932 -2.267c-.055 0 -.109 .004 -.163 .011c-.944 .128 -1.533 1.346 -1.32 2.722c.204 1.293 1.048 2.267 1.933 2.267z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.456 6.733c.214 -1.376 -.375 -2.594 -1.32 -2.722a1.164 1.164 0 0 0 -.162 -.011c-.885 0 -1.728 .97 -1.93 2.267c-.214 1.376 .375 2.594 1.32 2.722c.054 .007 .108 .011 .162 .011c.885 0 1.73 -.974 1.93 -2.267z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69 12.918c.816 -.352 1.054 -1.719 .536 -3.052c-.436 -1.124 -1.271 -1.866 -2.009 -1.866c-.14 0 -.277 .027 -.407 .082c-.816 .352 -1.054 1.719 -.536 3.052c.436 1.124 1.271 1.866 2.009 1.866c.14 0 .277 -.027 .407 -.082z"
  }));
}

var _excluded$70 = ["size", "color", "stroke"];

function IconPeace(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$70);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-peace",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 18.3,
    y2: 18.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 5.7,
    y2: 18.3
  }));
}

var _excluded$6$ = ["size", "color", "stroke"];

function IconPencil(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pencil",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 6.5,
    x2: 17.5,
    y2: 10.5
  }));
}

var _excluded$6_ = ["size", "color", "stroke"];

function IconPennant2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pennant-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 21v-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4l-9 4l9 4"
  }));
}

var _excluded$6Z = ["size", "color", "stroke"];

function IconPennant(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pennant",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 21,
    x2: 10,
    y2: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4l9 4l-9 4"
  }));
}

var _excluded$6Y = ["size", "color", "stroke"];

function IconPentagon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pentagon",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 3.394l7.033 5.237a2 2 0 0 1 .7 2.247l-2.973 8.764a2 2 0 0 1 -1.894 1.358h-8.12a2 2 0 0 1 -1.9 -1.373l-2.896 -8.765a2 2 0 0 1 .696 -2.225l6.958 -5.237a2 2 0 0 1 2.397 -.006z"
  }));
}

var _excluded$6X = ["size", "color", "stroke"];

function IconPepper(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pepper",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11c0 2.21 -2.239 4 -5 4s-5 -1.79 -5 -4a8 8 0 1 0 16 0a3 3 0 0 0 -6 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8c0 -2 2 -4 4 -4"
  }));
}

var _excluded$6W = ["size", "color", "stroke"];

function IconPercentage(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-percentage",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 18,
    y2: 6
  }));
}

var _excluded$6V = ["size", "color", "stroke"];

function IconPerspective(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-perspective",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.141 4.163l12 1.714a1 1 0 0 1 .859 .99v10.266a1 1 0 0 1 -.859 .99l-12 1.714a1 1 0 0 1 -1.141 -.99v-13.694a1 1 0 0 1 1.141 -.99z"
  }));
}

var _excluded$6U = ["size", "color", "stroke"];

function IconPhoneCall(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-call",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7a2 2 0 0 1 2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3a6 6 0 0 1 6 6"
  }));
}

var _excluded$6T = ["size", "color", "stroke"];

function IconPhoneCalling(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-calling",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 7,
    x2: 15,
    y2: 7.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 7,
    x2: 18,
    y2: 7.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 7,
    x2: 21,
    y2: 7.01
  }));
}

var _excluded$6S = ["size", "color", "stroke"];

function IconPhoneCheck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-check",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6l2 2l4 -4"
  }));
}

var _excluded$6R = ["size", "color", "stroke"];

function IconPhoneIncoming(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-incoming",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 20,
    y2: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 5 15 9 19 9"
  }));
}

var _excluded$6Q = ["size", "color", "stroke"];

function IconPhoneOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.831 14.161a15.946 15.946 0 0 1 -2.831 -8.161a2 2 0 0 1 2 -2h4l2 5l-2.5 1.5c.108 .22 .223 .435 .345 .645m1.751 2.277c.843 .84 1.822 1.544 2.904 2.078l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a15.963 15.963 0 0 1 -10.344 -4.657"
  }));
}

var _excluded$6P = ["size", "color", "stroke"];

function IconPhoneOutgoing(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-outgoing",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 20,
    y2: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 4 20 4 20 8"
  }));
}

var _excluded$6O = ["size", "color", "stroke"];

function IconPhonePause(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-pause",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 3,
    x2: 20,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 7
  }));
}

var _excluded$6N = ["size", "color", "stroke"];

function IconPhonePlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6h6m-3 -3v6"
  }));
}

var _excluded$6M = ["size", "color", "stroke"];

function IconPhoneX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4l4 4m0 -4l-4 4"
  }));
}

var _excluded$6L = ["size", "color", "stroke"];

function IconPhone(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-phone",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
  }));
}

var _excluded$6K = ["size", "color", "stroke"];

function IconPhotoOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 15.01,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.121 19.122a3 3 0 0 1 -2.121 .878h-10a3 3 0 0 1 -3 -3v-10c0 -.833 .34 -1.587 .888 -2.131m3.112 -.869h9a3 3 0 0 1 3 3v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.32 12.34c.577 -.059 1.162 .162 1.68 .66l2 2"
  }));
}

var _excluded$6J = ["size", "color", "stroke"];

function IconPhoto(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-photo",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 15.01,
    y2: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15l4 -4a3 5 0 0 1 3 0l5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14l1 -1a3 5 0 0 1 3 0l2 2"
  }));
}

var _excluded$6I = ["size", "color", "stroke"];

function IconPhysotherapist(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-physotherapist",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15l-1 -3l4 -2l4 1h3.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17v-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20h7l1 -4l4 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20h3"
  }));
}

var _excluded$6H = ["size", "color", "stroke"];

function IconPictureInPictureOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-picture-in-picture-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 7,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 9,
    x2: 11,
    y2: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12v-3h3"
  }));
}

var _excluded$6G = ["size", "color", "stroke"];

function IconPictureInPictureOn(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-picture-in-picture-on",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 7,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 9,
    x2: 11,
    y2: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13h3v-3"
  }));
}

var _excluded$6F = ["size", "color", "stroke"];

function IconPictureInPictureTop(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-picture-in-picture-top",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-4"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 -1 0 15)",
    x: 14,
    y: 5,
    width: 7,
    height: 5,
    rx: 1
  }));
}

var _excluded$6E = ["size", "color", "stroke"];

function IconPictureInPicture(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-picture-in-picture",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 7,
    height: 5,
    rx: 1
  }));
}

var _excluded$6D = ["size", "color", "stroke"];

function IconPig(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pig",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3l0 3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342a6.008 6.008 0 0 1 -1.658 2.473v2.027a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l.001 -.027a6 6 0 0 1 3.999 -10.473h2.5l4.5 -3z"
  }));
}

var _excluded$6C = ["size", "color", "stroke"];

function IconPill(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pill",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 8.5,
    x2: 15.5,
    y2: 15.5
  }));
}

var _excluded$6B = ["size", "color", "stroke"];

function IconPills(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pills",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5l7 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.5l-5 5"
  }));
}

var _excluded$6A = ["size", "color", "stroke"];

function IconPin(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pin",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4.5l-4 4l-4 1.5l-1.5 1.5l7 7l1.5 -1.5l1.5 -4l4 -4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 4.5,
    y2: 19.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 4,
    x2: 20,
    y2: 9.5
  }));
}

var _excluded$6z = ["size", "color", "stroke"];

function IconPinnedOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pinned-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4.5l-3.249 3.249m-2.57 1.433l-2.181 .818l-1.5 1.5l7 7l1.5 -1.5l.82 -2.186m1.43 -2.563l3.25 -3.251"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 4.5,
    y2: 19.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 4,
    x2: 20,
    y2: 9.5
  }));
}

var _excluded$6y = ["size", "color", "stroke"];

function IconPinned(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pinned",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4v6l-2 4v2h10v-2l-2 -4v-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 16,
    y2: 4
  }));
}

var _excluded$6x = ["size", "color", "stroke"];

function IconPizza(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pizza",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5c-3.04 0 -5.952 -.714 -8.5 -1.983l8.5 -16.517l8.5 16.517a19.09 19.09 0 0 1 -8.5 1.983z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38 15.866a14.94 14.94 0 0 0 6.815 1.634a14.944 14.944 0 0 0 6.502 -1.479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11.01v-.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14v-.01"
  }));
}

var _excluded$6w = ["size", "color", "stroke"];

function IconPlaneArrival(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plane-arrival",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12h5a2 2 0 0 1 0 4h-15l-3 -6h3l2 2h3l-2 -7h3z",
    transform: "rotate(15 12 12) translate(0 -1)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }));
}

var _excluded$6v = ["size", "color", "stroke"];

function IconPlaneDeparture(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plane-departure",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12h5a2 2 0 0 1 0 4h-15l-3 -6h3l2 2h3l-2 -7h3z",
    transform: "rotate(-15 12 12) translate(0 -1)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }));
}

var _excluded$6u = ["size", "color", "stroke"];

function IconPlaneInflight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plane-inflight",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.085h5a2 2 0 1 1 0 4h-15l-3 -6h3l2 2h3l-2 -7h3l4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21h18"
  }));
}

var _excluded$6t = ["size", "color", "stroke"];

function IconPlane(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plane",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10h4a2 2 0 0 1 0 4h-4l-4 7h-3l2 -7h-4l-2 2h-3l2 -4l-2 -4h3l2 2h4l-2 -7h3z"
  }));
}

var _excluded$6s = ["size", "color", "stroke"];

function IconPlanet(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-planet",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.816 13.58c2.292 2.138 3.546 4 3.092 4.9c-.745 1.46 -5.783 -.259 -11.255 -3.838c-5.47 -3.579 -9.304 -7.664 -8.56 -9.123c.464 -.91 2.926 -.444 5.803 .805"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }));
}

var _excluded$6r = ["size", "color", "stroke"];

function IconPlant2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plant-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9a10 10 0 1 0 20 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19a10 10 0 0 1 10 -10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9a10 10 0 0 1 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4a9.7 9.7 0 0 1 2.99 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01 11.5a9.7 9.7 0 0 1 2.99 -7.5"
  }));
}

var _excluded$6q = ["size", "color", "stroke"];

function IconPlant(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plant",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 15h10v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 9
  }));
}

var _excluded$6p = ["size", "color", "stroke"];

function IconPlayCard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-play-card",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90 12 12)",
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 6,
    x2: 8.01,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 18,
    x2: 16.01,
    y2: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16l-3 -4l3 -4l3 4z"
  }));
}

var _excluded$6o = ["size", "color", "stroke"];

function IconPlayerEject(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-eject",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14l-7 -8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16,
    width: 14,
    height: 4,
    rx: 1
  }));
}

var _excluded$6n = ["size", "color", "stroke"];

function IconPlayerPause(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-pause",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 4,
    height: 14,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 5,
    width: 4,
    height: 14,
    rx: 1
  }));
}

var _excluded$6m = ["size", "color", "stroke"];

function IconPlayerPlay(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-play",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4v16l13 -8z"
  }));
}

var _excluded$6l = ["size", "color", "stroke"];

function IconPlayerRecord(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-record",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }));
}

var _excluded$6k = ["size", "color", "stroke"];

function IconPlayerSkipBack(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-skip-back",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 5v14l-12 -7z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 5,
    x2: 4,
    y2: 19
  }));
}

var _excluded$6j = ["size", "color", "stroke"];

function IconPlayerSkipForward(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-skip-forward",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5v14l12 -7z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 5,
    x2: 20,
    y2: 19
  }));
}

var _excluded$6i = ["size", "color", "stroke"];

function IconPlayerStop(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-stop",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    rx: 2
  }));
}

var _excluded$6h = ["size", "color", "stroke"];

function IconPlayerTrackNext(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-track-next",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5v14l8 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5v14l8 -7z"
  }));
}

var _excluded$6g = ["size", "color", "stroke"];

function IconPlayerTrackPrev(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-player-track-prev",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 5v14l-8 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5v14l-8 -7z"
  }));
}

var _excluded$6f = ["size", "color", "stroke"];

function IconPlaylistAdd(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-playlist-add",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8h-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16h-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13v6"
  }));
}

var _excluded$6e = ["size", "color", "stroke"];

function IconPlaylistX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-playlist-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8h-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16h-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14l-4 4"
  }));
}

var _excluded$6d = ["size", "color", "stroke"];

function IconPlaylist(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-playlist",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 17,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17v-13h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5h-10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 9,
    x2: 13,
    y2: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13h-6"
  }));
}

var _excluded$6c = ["size", "color", "stroke"];

function IconPlugConnected(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plug-connected",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21l2.5 -2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.5l2.5 -2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11l-2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14l-2 2"
  }));
}

var _excluded$6b = ["size", "color", "stroke"];

function IconPlug(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plug",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6l8 8l-2 2a5.657 5.657 0 1 1 -8 -8l2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4l-3.5 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9l-3.5 3.5"
  }));
}

var _excluded$6a = ["size", "color", "stroke"];

function IconPlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }));
}

var _excluded$69 = ["size", "color", "stroke"];

function IconPoint(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$69);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-point",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }));
}

var _excluded$68 = ["size", "color", "stroke"];

function IconPokeball(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$68);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pokeball",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h6m6 0h6"
  }));
}

var _excluded$67 = ["size", "color", "stroke"];

function IconPolaroid(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$67);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-polaroid",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 20,
    y2: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12l3 -3c.928 -.893 2.072 -.893 3 0l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12l2 -2c.928 -.893 2.072 -.893 3 0l2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 7,
    x2: 14.01,
    y2: 7
  }));
}

var _excluded$66 = ["size", "color", "stroke"];

function IconPolygon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$66);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-polygon",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 11,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.5l3.5 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5l3 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10l-2.5 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.5l-7 -5"
  }));
}

var _excluded$65 = ["size", "color", "stroke"];

function IconPool(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$65);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pool",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 16a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12v-7.5a1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12v-7.5a1.5 1.5 0 0 0 -3 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 5,
    x2: 9,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 15,
    y2: 10
  }));
}

var _excluded$64 = ["size", "color", "stroke"];

function IconPower(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$64);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-power",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6a7.75 7.75 0 1 0 10 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 12
  }));
}

var _excluded$63 = ["size", "color", "stroke"];

function IconPray(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$63);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pray",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20h8l-4 -4v-7l4 3l2 -2"
  }));
}

var _excluded$62 = ["size", "color", "stroke"];

function IconPremiumRights(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$62);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-premium-rights",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.867 9.75c-.246 -.48 -.708 -.769 -1.2 -.75h-1.334c-.736 0 -1.333 .67 -1.333 1.5c0 .827 .597 1.499 1.333 1.499h1.334c.736 0 1.333 .671 1.333 1.5c0 .828 -.597 1.499 -1.333 1.499h-1.334c-.492 .019 -.954 -.27 -1.2 -.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15v2"
  }));
}

var _excluded$61 = ["size", "color", "stroke"];

function IconPrescription(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$61);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-prescription",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 19v-16h4.5a4.5 4.5 0 1 1 0 9h-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21l-9 -9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21l6 -6"
  }));
}

var _excluded$60 = ["size", "color", "stroke"];

function IconPresentationAnalytics(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$60);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-presentation-analytics",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 4h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20h6"
  }));
}

var _excluded$5$ = ["size", "color", "stroke"];

function IconPresentation(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-presentation",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 4,
    x2: 21,
    y2: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 20,
    x2: 15,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12l3 -3l2 2l3 -3"
  }));
}

var _excluded$5_ = ["size", "color", "stroke"];

function IconPrinter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-printer",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 10,
    height: 8,
    rx: 2
  }));
}

var _excluded$5Z = ["size", "color", "stroke"];

function IconPrison(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-prison",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4v16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4v16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9h-6v6h6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12h-.01"
  }));
}

var _excluded$5Y = ["size", "color", "stroke"];

function IconPrompt(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-prompt",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5 7 10 12 5 17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 17,
    x2: 19,
    y2: 17
  }));
}

var _excluded$5X = ["size", "color", "stroke"];

function IconPropeller(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-propeller",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.167 10.5c.722 -1.538 1.156 -3.043 1.303 -4.514c.22 -1.63 -.762 -2.986 -3.47 -2.986s-3.69 1.357 -3.47 2.986c.147 1.471 .581 2.976 1.303 4.514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.169 16.751c.97 1.395 2.057 2.523 3.257 3.386c1.3 1.006 2.967 .833 4.321 -1.512c1.354 -2.345 .67 -3.874 -.85 -4.498c-1.348 -.608 -2.868 -.985 -4.562 -1.128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.664 12.999c-1.693 .143 -3.213 .52 -4.56 1.128c-1.522 .623 -2.206 2.153 -.852 4.498s3.02 2.517 4.321 1.512c1.2 -.863 2.287 -1.991 3.258 -3.386"
  }));
}

var _excluded$5W = ["size", "color", "stroke"];

function IconPuzzle2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-puzzle-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v2.5a0.5 .5 0 0 1 -.5 .5a1.5 1.5 0 0 0 0 3a0.5 .5 0 0 1 .5 .5v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v1.5a0.5 .5 0 0 0 .5 .5a1.5 1.5 0 0 1 0 3a0.5 .5 0 0 0 -.5 .5v2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12h-2.5a0.5 .5 0 0 1 -.5 -.5a1.5 1.5 0 0 0 -3 0a0.5 .5 0 0 1 -.5 .5h-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h-1.5a0.5 .5 0 0 0 -.5 .5a1.5 1.5 0 0 1 -3 0a0.5 .5 0 0 0 -.5 -.5h-2.5"
  }));
}

var _excluded$5V = ["size", "color", "stroke"];

function IconPuzzle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-puzzle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h3a1 1 0 0 0 1 -1v-1a2 2 0 0 1 4 0v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 0 4h-1a1 1 0 0 0 -1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-1a2 2 0 0 0 -4 0v1a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h1a2 2 0 0 0 0 -4h-1a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1"
  }));
}

var _excluded$5U = ["size", "color", "stroke"];

function IconPyramid(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-pyramid",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17l9 4l9 -4l-9 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v18"
  }));
}

var _excluded$5T = ["size", "color", "stroke"];

function IconQrcode(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-qrcode",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 17,
    x2: 7,
    y2: 17.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 7,
    y2: 7.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 17,
    y2: 7.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 17,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 14,
    x2: 20,
    y2: 14.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 14,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 20,
    x2: 17,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 20,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 17,
    x2: 20,
    y2: 20
  }));
}

var _excluded$5S = ["size", "color", "stroke"];

function IconQuestionMark(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-question-mark",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8a3.5 3 0 0 1 3.5 -3h1a3.5 3 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 19.01
  }));
}

var _excluded$5R = ["size", "color", "stroke"];

function IconQuote(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-quote",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
  }));
}

var _excluded$5Q = ["size", "color", "stroke"];

function IconRadar2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radar-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.51 15.56a5 5 0 1 0 -3.51 1.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.832 17.86a9 9 0 1 0 -6.832 3.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v9"
  }));
}

var _excluded$5P = ["size", "color", "stroke"];

function IconRadar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radar",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12h-8a1 1 0 1 0 -1 1v8a9 9 0 0 0 9 -9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.999 8.998a5 5 0 1 0 -6.999 7.003"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.486 8.995a9 9 0 1 0 -11.482 11.495"
  }));
}

var _excluded$5O = ["size", "color", "stroke"];

function IconRadio(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radio",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3l-9.371 3.749a1 1 0 0 0 -.629 .928v11.323a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-11a1 1 0 0 0 -1 -1h-14.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16v.01"
  }));
}

var _excluded$5N = ["size", "color", "stroke"];

function IconRadioactive(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radioactive",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.6l3 5.19a9 9 0 0 0 4.5 -7.79h-6a3 3 0 0 1 -1.5 2.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.4l3 -5.19a9 9 0 0 0 -9 0l3 5.19a3 3 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.6l-3 5.19a9 9 0 0 1 -4.5 -7.79h6a3 3 0 0 0 1.5 2.6"
  }));
}

var _excluded$5M = ["size", "color", "stroke"];

function IconRadiusBottomLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radius-bottom-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19h-6a8 8 0 0 1 -8 -8v-6"
  }));
}

var _excluded$5L = ["size", "color", "stroke"];

function IconRadiusBottomRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radius-bottom-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 5v6a8 8 0 0 1 -8 8h-6"
  }));
}

var _excluded$5K = ["size", "color", "stroke"];

function IconRadiusTopLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radius-top-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19v-6a8 8 0 0 1 8 -8h6"
  }));
}

var _excluded$5J = ["size", "color", "stroke"];

function IconRadiusTopRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-radius-top-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5h6a8 8 0 0 1 8 8v6"
  }));
}

var _excluded$5I = ["size", "color", "stroke"];

function IconRainbow(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rainbow",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 17c0 -5.523 -4.477 -10 -10 -10s-10 4.477 -10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 17a6 6 0 1 0 -12 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17a2 2 0 1 0 -4 0"
  }));
}

var _excluded$5H = ["size", "color", "stroke"];

function IconReceipt2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-receipt-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5m2 0v1.5m0 -9v1.5"
  }));
}

var _excluded$5G = ["size", "color", "stroke"];

function IconReceiptOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-receipt-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21v-16m2 -2h10a2 2 0 0 1 2 2v10m0 4.01v1.99l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 7,
    x2: 15,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 11,
    x2: 11,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 15,
    x2: 15,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 11,
    x2: 15,
    y2: 11.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$5F = ["size", "color", "stroke"];

function IconReceiptRefund(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-receipt-refund",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14v-2a2 2 0 0 0 -2 -2h-4l2 -2m0 4l-2 -2"
  }));
}

var _excluded$5E = ["size", "color", "stroke"];

function IconReceiptTax(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-receipt-tax",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14,
    x2: 15,
    y2: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 8.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 13.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
  }));
}

var _excluded$5D = ["size", "color", "stroke"];

function IconReceipt(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-receipt",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2m4 -14h6m-6 4h6m-2 4h2"
  }));
}

var _excluded$5C = ["size", "color", "stroke"];

function IconRecharging(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-recharging",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.038 4.5a9 9 0 0 0 -2.495 2.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.186 10.209a9 9 0 0 0 0 3.508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 16.962a9 9 0 0 0 2.47 2.495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.209 20.814a9 9 0 0 0 3.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.962 19.5a9 9 0 0 0 2.495 -2.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.814 13.791a9 9 0 0 0 0 -3.508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.038a9 9 0 0 0 -2.47 -2.495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.791 3.186a9 9 0 0 0 -3.508 -.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8l-2 4h4l-2 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21a9 9 0 0 0 0 -18"
  }));
}

var _excluded$5B = ["size", "color", "stroke"];

function IconRecordMail(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-record-mail",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 15,
    x2: 17,
    y2: 15
  }));
}

var _excluded$5A = ["size", "color", "stroke"];

function IconRectangleVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rectangle-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 2
  }));
}

var _excluded$5z = ["size", "color", "stroke"];

function IconRectangle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rectangle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }));
}

var _excluded$5y = ["size", "color", "stroke"];

function IconRecycle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-recycle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17l-2 2l2 2m-2 -2h9a2 2 0 0 0 1.75 -2.75l-.55 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17l-2 2l2 2m-2 -2h9a2 2 0 0 0 1.75 -2.75l-.55 -1",
    transform: "rotate(120 12 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17l-2 2l2 2m-2 -2h9a2 2 0 0 0 1.75 -2.75l-.55 -1",
    transform: "rotate(240 12 13)"
  }));
}

var _excluded$5x = ["size", "color", "stroke"];

function IconRefreshAlert(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-refresh-alert",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12.01,
    y2: 15
  }));
}

var _excluded$5w = ["size", "color", "stroke"];

function IconRefreshDot(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-refresh-dot",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }));
}

var _excluded$5v = ["size", "color", "stroke"];

function IconRefresh(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-refresh",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
  }));
}

var _excluded$5u = ["size", "color", "stroke"];

function IconRegistered(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-registered",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15v-6h2a2 2 0 1 1 0 4h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15l-2 -2"
  }));
}

var _excluded$5t = ["size", "color", "stroke"];

function IconRelationManyToMany(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-relation-many-to-many",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14v-4l3 4v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14v-4l3 4v-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10.5,
    x2: 12,
    y2: 10.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 13.5,
    x2: 12,
    y2: 13.51
  }));
}

var _excluded$5s = ["size", "color", "stroke"];

function IconRelationOneToMany(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-relation-one-to-many",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10h1v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14v-4l3 4v-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 10.5,
    x2: 11,
    y2: 10.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 13.5,
    x2: 11,
    y2: 13.51
  }));
}

var _excluded$5r = ["size", "color", "stroke"];

function IconRelationOneToOne(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-relation-one-to-one",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10h1v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10h1v4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10.5,
    x2: 12,
    y2: 10.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 13.5,
    x2: 12,
    y2: 13.51
  }));
}

var _excluded$5q = ["size", "color", "stroke"];

function IconRepeatOnce(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-repeat-once",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11l1 -1v4"
  }));
}

var _excluded$5p = ["size", "color", "stroke"];

function IconRepeat(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-repeat",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"
  }));
}

var _excluded$5o = ["size", "color", "stroke"];

function IconReplace(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-replace",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3"
  }));
}

var _excluded$5n = ["size", "color", "stroke"];

function IconReportAnalytics(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-report-analytics",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17v-3"
  }));
}

var _excluded$5m = ["size", "color", "stroke"];

function IconReportMedical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-report-medical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 14,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 16
  }));
}

var _excluded$5l = ["size", "color", "stroke"];

function IconReportMoney(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-report-money",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17v1m0 -8v1"
  }));
}

var _excluded$5k = ["size", "color", "stroke"];

function IconReportSearch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-report-search",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12v-5a2 2 0 0 0 -2 -2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15h3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19.5l2.5 2.5"
  }));
}

var _excluded$5j = ["size", "color", "stroke"];

function IconReport(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-report",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14v4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11v-4a2 2 0 0 0 -2 -2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 6,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15h3"
  }));
}

var _excluded$5i = ["size", "color", "stroke"];

function IconResize(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-resize",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11v8a1 1 0 0 0 1 1h8m-9 -14v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h7a1 1 0 0 1 1 1v7"
  }));
}

var _excluded$5h = ["size", "color", "stroke"];

function IconRipple(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ripple",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7c3 -2 6 -2 9 0s6 2 9 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17c3 -2 6 -2 9 0s6 2 9 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12c3 -2 6 -2 9 0s6 2 9 0"
  }));
}

var _excluded$5g = ["size", "color", "stroke"];

function IconRoadSign(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-road-sign",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14v-2c0 -.59 .414 -1 1 -1h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9l2 2l-2 2"
  }));
}

var _excluded$5f = ["size", "color", "stroke"];

function IconRoad(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-road",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 19l4 -14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5l4 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18v-2"
  }));
}

var _excluded$5e = ["size", "color", "stroke"];

function IconRobot(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-robot",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7h10a2 2 0 0 1 2 2v1l1 1v3l-1 1v3a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-3l-1 -1v-3l1 -1v-1a2 2 0 0 1 2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16h4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 11.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 11.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7l-1 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7l1 -4"
  }));
}

var _excluded$5d = ["size", "color", "stroke"];

function IconRocket(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rocket",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13a8 8 0 0 1 7 7a6 6 0 0 0 3 -5a9 9 0 0 0 6 -8a3 3 0 0 0 -3 -3a9 9 0 0 0 -8 6a6 6 0 0 0 -5 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 9,
    r: 1
  }));
}

var _excluded$5c = ["size", "color", "stroke"];

function IconRollerSkating(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-roller-skating",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.905 5h3.418a1 1 0 0 1 .928 .629l1.143 2.856a3 3 0 0 0 2.207 1.83l4.717 .926a2.084 2.084 0 0 1 1.682 2.045v.714a1 1 0 0 1 -1 1h-13.895a1 1 0 0 1 -.995 -1.1l.8 -8a1 1 0 0 1 .995 -.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 17,
    r: 2
  }));
}

var _excluded$5b = ["size", "color", "stroke"];

function IconRotate2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4.55a8 8 0 0 0 -6 14.9m0 -4.45v5h-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.37,
    y1: 7.16,
    x2: 18.37,
    y2: 7.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 19.94,
    x2: 13,
    y2: 19.95
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.84,
    y1: 18.37,
    x2: 16.84,
    y2: 18.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.37,
    y1: 15.1,
    x2: 19.37,
    y2: 15.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.94,
    y1: 11,
    x2: 19.94,
    y2: 11.01
  }));
}

var _excluded$5a = ["size", "color", "stroke"];

function IconRotate360(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate-360",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16h4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.458 11.042c.86 -2.366 .722 -4.58 -.6 -5.9c-2.272 -2.274 -7.185 -1.045 -10.973 2.743c-3.788 3.788 -5.017 8.701 -2.744 10.974c2.227 2.226 6.987 1.093 10.74 -2.515"
  }));
}

var _excluded$59 = ["size", "color", "stroke"];

function IconRotateClockwise2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$59);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate-clockwise-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.55a8 8 0 0 1 6 14.9m0 -4.45v5h5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.63,
    y1: 7.16,
    x2: 5.63,
    y2: 7.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.06,
    y1: 11,
    x2: 4.06,
    y2: 11.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.63,
    y1: 15.1,
    x2: 4.63,
    y2: 15.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.16,
    y1: 18.37,
    x2: 7.16,
    y2: 18.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 19.94,
    x2: 11,
    y2: 19.95
  }));
}

var _excluded$58 = ["size", "color", "stroke"];

function IconRotateClockwise(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$58);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate-clockwise",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5"
  }));
}

var _excluded$57 = ["size", "color", "stroke"];

function IconRotateDot(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$57);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate-dot",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }));
}

var _excluded$56 = ["size", "color", "stroke"];

function IconRotateRectangle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$56);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate-rectangle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3 5h.7a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h5l-2.82 -2.82m0 5.64l2.82 -2.82",
    transform: "rotate(-45 12 12)"
  }));
}

var _excluded$55 = ["size", "color", "stroke"];

function IconRotate(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$55);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rotate",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5"
  }));
}

var _excluded$54 = ["size", "color", "stroke"];

function IconRoute(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$54);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-route",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19h4.5a3.5 3.5 0 0 0 0 -7h-8a3.5 3.5 0 0 1 0 -7h3.5"
  }));
}

var _excluded$53 = ["size", "color", "stroke"];

function IconRouter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$53);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-router",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 18,
    height: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 17,
    y2: 17.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 17,
    x2: 13,
    y2: 17.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 13,
    x2: 15,
    y2: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.75a4 4 0 0 1 6.5 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.5a8 8 0 0 1 13 0"
  }));
}

var _excluded$52 = ["size", "color", "stroke"];

function IconRowInsertBottom(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$52);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-row-insert-bottom",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 17,
    x2: 10,
    y2: 17
  }));
}

var _excluded$51 = ["size", "color", "stroke"];

function IconRowInsertTop(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$51);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-row-insert-top",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9v-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 7,
    x2: 14,
    y2: 7
  }));
}

var _excluded$50 = ["size", "color", "stroke"];

function IconRss(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$50);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-rss",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4a16 16 0 0 1 16 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11a9 9 0 0 1 9 9"
  }));
}

var _excluded$4$ = ["size", "color", "stroke"];

function IconRuler2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ruler-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3l4 4l-14 14l-4 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7l-1.5 -1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10l-1.5 -1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13l-1.5 -1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 16l-1.5 -1.5"
  }));
}

var _excluded$4_ = ["size", "color", "stroke"];

function IconRuler(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ruler",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h14a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-7a1 1 0 0 0 -1 1v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 6,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 7,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 16,
    x2: 6,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4,
    x2: 8,
    y2: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 4 12 7 "
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 4 16 6 "
  }));
}

var _excluded$4Z = ["size", "color", "stroke"];

function IconRun(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-run",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17l5 1l.75 -1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 21l0 -4l-4 -3l1 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12l0 -3l5 -1l3 3l3 1"
  }));
}

var _excluded$4Y = ["size", "color", "stroke"];

function IconSailboat(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sailboat",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18l-1 -3h18l-1 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12h7l-7 -9v9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 7,
    x2: 6,
    y2: 12
  }));
}

var _excluded$4X = ["size", "color", "stroke"];

function IconSalt(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-salt",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8h9l-.281 -2.248a2 2 0 0 0 -1.985 -1.752h-4.468a2 2 0 0 0 -1.986 1.752l-.28 2.248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8l-1.612 9.671a2 2 0 0 0 1.973 2.329h8.278a2 2 0 0 0 1.973 -2.329l-1.612 -9.671"
  }));
}

var _excluded$4W = ["size", "color", "stroke"];

function IconSatellite(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-satellite",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.707 6.293l2.586 -2.586a1 1 0 0 1 1.414 0l5.586 5.586a1 1 0 0 1 0 1.414l-2.586 2.586a1 1 0 0 1 -1.414 0l-5.586 -5.586a1 1 0 0 1 0 -1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10l-3 3l3 3l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6l3 -3l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 13.5,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17a2.5 2.5 0 0 0 2.5 -2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 21a6 6 0 0 0 6 -6"
  }));
}

var _excluded$4V = ["size", "color", "stroke"];

function IconSausage(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sausage",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.5a2.5 2.5 0 0 0 -2.5 2.5c0 7.18 5.82 13 13 13a2.5 2.5 0 1 0 0 -5a8 8 0 0 1 -8 -8a2.5 2.5 0 0 0 -2.5 -2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.195 5.519l-1.243 -1.989a1 1 0 0 1 .848 -1.53h1.392a1 1 0 0 1 .848 1.53l-1.245 1.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.482 18.225l1.989 -1.243a1 1 0 0 1 1.53 .848v1.392a1 1 0 0 1 -1.53 .848l-1.991 -1.245"
  }));
}

var _excluded$4U = ["size", "color", "stroke"];

function IconScaleOutline(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scale-outline",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7c1.956 0 3.724 .802 4.994 2.095l-2.956 2.904a3 3 0 0 0 -2.038 -.799a3 3 0 0 0 -2.038 .798l-2.956 -2.903a6.979 6.979 0 0 1 4.994 -2.095z"
  }));
}

var _excluded$4T = ["size", "color", "stroke"];

function IconScale(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scale",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 20,
    x2: 17,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6l6 -1l6 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12l-3 -6l-3 6a3 3 0 0 0 6 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12l-3 -6l-3 6a3 3 0 0 0 6 0"
  }));
}

var _excluded$4S = ["size", "color", "stroke"];

function IconScan(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scan",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7v-1a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17v1a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h2a2 2 0 0 0 2 -2v-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }));
}

var _excluded$4R = ["size", "color", "stroke"];

function IconSchool(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-school",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 9l-10 -4l-10 4l10 4l10 -4v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.6v5.4a6 3 0 0 0 12 0v-5.4"
  }));
}

var _excluded$4Q = ["size", "color", "stroke"];

function IconScissors(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scissors",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 7,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.6,
    y1: 8.6,
    x2: 19,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.6,
    y1: 15.4,
    x2: 19,
    y2: 5
  }));
}

var _excluded$4P = ["size", "color", "stroke"];

function IconScooterElectric(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scooter-electric",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4l-2 4h3l-2 4"
  }));
}

var _excluded$4O = ["size", "color", "stroke"];

function IconScooter(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scooter",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1"
  }));
}

var _excluded$4N = ["size", "color", "stroke"];

function IconScreenShareOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-screen-share-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 20,
    x2: 17,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 15,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8l4 -4m-4 0l4 4"
  }));
}

var _excluded$4M = ["size", "color", "stroke"];

function IconScreenShare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-screen-share",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 20,
    x2: 17,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 16,
    x2: 9,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 15,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4h4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9l5 -5"
  }));
}

var _excluded$4L = ["size", "color", "stroke"];

function IconScubaMask(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-scuba-mask",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h12a1 1 0 0 1 1 1v4.5a2.5 2.5 0 0 1 -2.5 2.5h-.5a2 2 0 0 1 -2 -2a2 2 0 1 0 -4 0a2 2 0 0 1 -2 2h-.5a2.5 2.5 0 0 1 -2.5 -2.5v-4.5a1 1 0 0 1 1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17a2 2 0 0 0 2 2h3.5a5.5 5.5 0 0 0 5.5 -5.5v-9.5"
  }));
}

var _excluded$4K = ["size", "color", "stroke"];

function IconSearch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-search",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 15,
    y2: 15
  }));
}

var _excluded$4J = ["size", "color", "stroke"];

function IconSectionSign(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-section-sign",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.172 19.004a3.001 3.001 0 1 0 2.828 -4.004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.83 5.002a3.001 3.001 0 1 0 -2.83 3.998"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }));
}

var _excluded$4I = ["size", "color", "stroke"];

function IconSection(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-section",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4h.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4l0 0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 16,
    height: 8,
    rx: 1
  }));
}

var _excluded$4H = ["size", "color", "stroke"];

function IconSeeding(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-seeding",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 10
  }));
}

var _excluded$4G = ["size", "color", "stroke"];

function IconSelect(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-select",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11l3 3l3 -3"
  }));
}

var _excluded$4F = ["size", "color", "stroke"];

function IconSelector(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-selector",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 9 12 5 16 9"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 15 12 19 8 15"
  }));
}

var _excluded$4E = ["size", "color", "stroke"];

function IconSend(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-send",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 21,
    y2: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5"
  }));
}

var _excluded$4D = ["size", "color", "stroke"];

function IconSeparatorHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-separator-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 8 12 4 16 8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 16 12 20 8 16"
  }));
}

var _excluded$4C = ["size", "color", "stroke"];

function IconSeparatorVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-separator-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 8 4 12 8 16"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 16 20 12 16 8"
  }));
}

var _excluded$4B = ["size", "color", "stroke"];

function IconSeparator(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-separator",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 3,
    y2: 12.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 17,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 21,
    y2: 12.01
  }));
}

var _excluded$4A = ["size", "color", "stroke"];

function IconServer2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-server-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 8,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 18,
    height: 8,
    rx: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 8,
    x2: 7,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 16,
    x2: 7,
    y2: 16.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16h6"
  }));
}

var _excluded$4z = ["size", "color", "stroke"];

function IconServer(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-server",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 8,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 18,
    height: 8,
    rx: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 8,
    x2: 7,
    y2: 8.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 16,
    x2: 7,
    y2: 16.01
  }));
}

var _excluded$4y = ["size", "color", "stroke"];

function IconServicemark(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-servicemark",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15v-6l3 4l3 -4v6"
  }));
}

var _excluded$4x = ["size", "color", "stroke"];

function IconSettingsAutomation(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-settings-automation",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9v6l5 -3z"
  }));
}

var _excluded$4w = ["size", "color", "stroke"];

function IconSettings(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-settings",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }));
}

var _excluded$4v = ["size", "color", "stroke"];

function IconShadowOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shadow-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.634 5.638a9 9 0 0 0 12.728 12.727m1.68 -2.32a9 9 0 0 0 -12.086 -12.088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 18h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$4u = ["size", "color", "stroke"];

function IconShadow(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shadow",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 18h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6h1"
  }));
}

var _excluded$4t = ["size", "color", "stroke"];

function IconShape2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shape-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 17.5l11 -11m-12.5 .5v10m14 -10v10"
  }));
}

var _excluded$4s = ["size", "color", "stroke"];

function IconShape3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shape-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5h10m-12 2v10m14 -10v10"
  }));
}

var _excluded$4r = ["size", "color", "stroke"];

function IconShape(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shape",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 7,
    x2: 5,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 17,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 17,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 7,
    x2: 19,
    y2: 17
  }));
}

var _excluded$4q = ["size", "color", "stroke"];

function IconShare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-share",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.7,
    y1: 10.7,
    x2: 15.3,
    y2: 7.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.7,
    y1: 13.3,
    x2: 15.3,
    y2: 16.7
  }));
}

var _excluded$4p = ["size", "color", "stroke"];

function IconShieldCheck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-check",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12l2 2l4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }));
}

var _excluded$4o = ["size", "color", "stroke"];

function IconShieldCheckered(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-checkered",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12h17"
  }));
}

var _excluded$4n = ["size", "color", "stroke"];

function IconShieldChevron(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-chevron",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14l8 -3l8 3"
  }));
}

var _excluded$4m = ["size", "color", "stroke"];

function IconShieldLock(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-lock",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 14.5
  }));
}

var _excluded$4l = ["size", "color", "stroke"];

function IconShieldOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.669 17.669a12 12 0 0 1 -5.669 3.331a12 12 0 0 1 -8.5 -15c.797 .036 1.589 0 2.366 -.126m3.092 -.912a12 12 0 0 0 3.042 -1.962a12 12 0 0 0 8.5 3a12 12 0 0 1 -1.117 9.379"
  }));
}

var _excluded$4k = ["size", "color", "stroke"];

function IconShieldX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10l4 4m0 -4l-4 4"
  }));
}

var _excluded$4j = ["size", "color", "stroke"];

function IconShield(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shield",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
  }));
}

var _excluded$4i = ["size", "color", "stroke"];

function IconShip(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ship",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18l-1 -5h18l-2 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13v-6h8l4 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7v-4h-1"
  }));
}

var _excluded$4h = ["size", "color", "stroke"];

function IconShirt(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shirt",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 4l6 2v5h-3v8a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l6 -2a3 3 0 0 0 6 0"
  }));
}

var _excluded$4g = ["size", "color", "stroke"];

function IconShoe(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shoe",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6h5.426a1 1 0 0 1 .863 .496l1.064 1.823a3 3 0 0 0 1.896 1.407l4.677 1.114a4 4 0 0 1 3.074 3.89v2.27a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13l1 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18v-1a4 4 0 0 0 -4 -4h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12l1.5 -3"
  }));
}

var _excluded$4f = ["size", "color", "stroke"];

function IconShoppingCartDiscount(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shopping-cart-discount",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17h-11v-14h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6l-1 7h-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10l6 -6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 4.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 9.5,
    r: 0.5
  }));
}

var _excluded$4e = ["size", "color", "stroke"];

function IconShoppingCartOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shopping-cart-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17a2 2 0 1 0 2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17h-11v-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.239 5.231l10.761 .769l-1 7h-2m-4 0h-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$4d = ["size", "color", "stroke"];

function IconShoppingCartPlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shopping-cart-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17h-11v-14h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5l6.005 .429m7.138 6.573l-.143 .998h-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6h6m-3 -3v6"
  }));
}

var _excluded$4c = ["size", "color", "stroke"];

function IconShoppingCartX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shopping-cart-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17h-11v-14h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5l7.999 .571m5.43 4.43l-.429 2.999h-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3l-4 4"
  }));
}

var _excluded$4b = ["size", "color", "stroke"];

function IconShoppingCart(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shopping-cart",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17h-11v-14h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5l14 1l-1 7h-13"
  }));
}

var _excluded$4a = ["size", "color", "stroke"];

function IconShredder(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-shredder",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 16,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4m5 5v5m4 -5v2m-8 -2v3"
  }));
}

var _excluded$49 = ["size", "color", "stroke"];

function IconSignLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$49);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sign-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 21v-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6h-10l-2 2.5l2 2.5h10z"
  }));
}

var _excluded$48 = ["size", "color", "stroke"];

function IconSignRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$48);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sign-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 21h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21v-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6h10l2 2.5l-2 2.5h-10z"
  }));
}

var _excluded$47 = ["size", "color", "stroke"];

function IconSignature(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$47);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-signature",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17c3.333 -3.333 5 -6 5 -8c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.53 0 2.639 -2 3 -2c.517 0 1.517 .667 3 2"
  }));
}

var _excluded$46 = ["size", "color", "stroke"];

function IconSitemap(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$46);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sitemap",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    width: 6,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 6,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 6,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 12
  }));
}

var _excluded$45 = ["size", "color", "stroke"];

function IconSkateboard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$45);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-skateboard",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 15,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 15,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9a2 1 0 0 0 2 1h14a2 1 0 0 0 2 -1"
  }));
}

var _excluded$44 = ["size", "color", "stroke"];

function IconSleigh(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$44);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sleigh",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19h15a4 4 0 0 0 4 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15h-9a4 4 0 0 1 -4 -4v-6l1.243 1.243a6 6 0 0 0 4.242 1.757h3.515v2a2 2 0 0 0 2 2h.5a1.5 1.5 0 0 0 1.5 -1.5a1.5 1.5 0 0 1 3 0v1.5a3 3 0 0 1 -3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 15v4"
  }));
}

var _excluded$43 = ["size", "color", "stroke"];

function IconSlice(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$43);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-slice",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19l15 -15l3 3l-6 6l2 2a14 14 0 0 1 -14 4"
  }));
}

var _excluded$42 = ["size", "color", "stroke"];

function IconSlideshow(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$42);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-slideshow",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 6,
    x2: 15.01,
    y2: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 14,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13l4 -4a3 5 0 0 1 3 0l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12l2 -2a3 5 0 0 1 3 0l3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 8.01,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12.01,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 21,
    x2: 16.01,
    y2: 21
  }));
}

var _excluded$41 = ["size", "color", "stroke"];

function IconSmartHome(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$41);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-smart-home",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8.71l-5.333 -4.148a2.666 2.666 0 0 0 -3.274 0l-5.334 4.148a2.665 2.665 0 0 0 -1.029 2.105v7.2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-7.2c0 -.823 -.38 -1.6 -1.03 -2.105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15c-2.21 1.333 -5.792 1.333 -8 0"
  }));
}

var _excluded$40 = ["size", "color", "stroke"];

function IconSmokingNo(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$40);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-smoking-no",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 8,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5v.5a2 2 0 0 0 2 2a2 2 0 0 1 2 2v.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 13h3a1 1 0 0 1 1 1v2c0 .28 -.115 .533 -.3 .714m-3.7 .286h-13a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h9"
  }));
}

var _excluded$3$ = ["size", "color", "stroke"];

function IconSmoking(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-smoking",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 18,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 8,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5v.5a2 2 0 0 0 2 2a2 2 0 0 1 2 2v.5"
  }));
}

var _excluded$3_ = ["size", "color", "stroke"];

function IconSnowflake(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-snowflake",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
    transform: "rotate(60 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
    transform: "rotate(120 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
    transform: "rotate(180 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
    transform: "rotate(240 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4l2 1l2 -1m-2 -2v6.5l3 1.72",
    transform: "rotate(300 12 12)"
  }));
}

var _excluded$3Z = ["size", "color", "stroke"];

function IconSoccerField(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-soccer-field",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9h3v6h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9h3v6h-3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 18,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }));
}

var _excluded$3Y = ["size", "color", "stroke"];

function IconSocial(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-social",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.7,
    y1: 17.8,
    x2: 9.5,
    y2: 15.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.3,
    y1: 17.8,
    x2: 14.5,
    y2: 15.8
  }));
}

var _excluded$3X = ["size", "color", "stroke"];

function IconSock(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sock",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3v6l4.798 5.142a4 4 0 0 1 -5.441 5.86l-6.736 -6.41a2 2 0 0 1 -.621 -1.451v-9.141h8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.895 15.768c.708 -.721 1.105 -1.677 1.105 -2.768a4 4 0 0 0 -4 -4"
  }));
}

var _excluded$3W = ["size", "color", "stroke"];

function IconSofa(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sofa",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11a2 2 0 0 1 2 2v1h12v-1a2 2 0 1 1 4 0v5a1 1 0 0 1 -1 1h-18a1 1 0 0 1 -1 -1v-5a2 2 0 0 1 2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11v-3a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v9"
  }));
}

var _excluded$3V = ["size", "color", "stroke"];

function IconSortAscending2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-ascending-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9l3 -3l3 3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 5,
    height: 5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14,
    width: 5,
    height: 5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 6v12"
  }));
}

var _excluded$3U = ["size", "color", "stroke"];

function IconSortAscendingLetters(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-ascending-letters",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21h-4l4 -7h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15l3 3l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6v12"
  }));
}

var _excluded$3T = ["size", "color", "stroke"];

function IconSortAscendingNumbers(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-ascending-numbers",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15l3 3l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3a2 2 0 0 1 2 2v3a2 2 0 1 1 -4 0v-3a2 2 0 0 1 2 -2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 16,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16v3a2 2 0 0 1 -2 2h-1.5"
  }));
}

var _excluded$3S = ["size", "color", "stroke"];

function IconSortAscending(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-ascending",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 11,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 11,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 13,
    y2: 18
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 9 18 6 21 9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 6,
    x2: 18,
    y2: 18
  }));
}

var _excluded$3R = ["size", "color", "stroke"];

function IconSortDescending2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-descending-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 5,
    height: 5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14,
    width: 5,
    height: 5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15l3 3l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18v-12"
  }));
}

var _excluded$3Q = ["size", "color", "stroke"];

function IconSortDescendingLetters(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-descending-letters",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 21v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10h-4l4 -7h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15l3 3l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6v12"
  }));
}

var _excluded$3P = ["size", "color", "stroke"];

function IconSortDescendingNumbers(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-descending-numbers",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15l3 3l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 14a2 2 0 0 1 2 2v3a2 2 0 1 1 -4 0v-3a2 2 0 0 1 2 -2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 5v3a2 2 0 0 1 -2 2h-1.5"
  }));
}

var _excluded$3O = ["size", "color", "stroke"];

function IconSortDescending(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sort-descending",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 13,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 11,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 11,
    y2: 18
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 15 18 18 21 15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 6,
    x2: 18,
    y2: 18
  }));
}

var _excluded$3N = ["size", "color", "stroke"];

function IconSoup(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-soup",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11h18a8 8 0 0 1 -8 8h-2a8 8 0 0 1 -8 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5v3"
  }));
}

var _excluded$3M = ["size", "color", "stroke"];

function IconSpace(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-space",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-3"
  }));
}

var _excluded$3L = ["size", "color", "stroke"];

function IconSpacingHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-spacing-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20h-2a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v8"
  }));
}

var _excluded$3K = ["size", "color", "stroke"];

function IconSpacingVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-spacing-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20v-2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12h-8"
  }));
}

var _excluded$3J = ["size", "color", "stroke"];

function IconSpade(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-spade",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3l4.919 4.5c.61 .587 1.177 1.177 1.703 1.771a5.527 5.527 0 0 1 .264 6.979c-1.18 1.56 -3.338 1.92 -4.886 .75v1l1 3h-6l1 -3v-1c-1.54 1.07 -3.735 .772 -4.886 -.75a5.527 5.527 0 0 1 .264 -6.979a30.883 30.883 0 0 1 1.703 -1.771a1541.72 1541.72 0 0 1 4.919 -4.5z"
  }));
}

var _excluded$3I = ["size", "color", "stroke"];

function IconSpeakerphone(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-speakerphone",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8a3 3 0 0 1 0 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8h0l4.524 -3.77a0.9 .9 0 0 1 1.476 .692v12.156a0.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8"
  }));
}

var _excluded$3H = ["size", "color", "stroke"];

function IconSpeedboat(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-speedboat",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17h13.4a3 3 0 0 0 2.5 -1.34l3.1 -4.66h0h-6.23a4 4 0 0 0 -1.49 .29l-3.56 1.42a4 4 0 0 1 -1.49 .29h-3.73h0h-1l-1.5 4z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 13,
    x2: 7.5,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8h8l2 3"
  }));
}

var _excluded$3G = ["size", "color", "stroke"];

function IconSportBillard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sport-billard",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8
  }));
}

var _excluded$3F = ["size", "color", "stroke"];

function IconSquare0(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-0",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$3E = ["size", "color", "stroke"];

function IconSquare1(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-1",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16v-8l-2 2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$3D = ["size", "color", "stroke"];

function IconSquare2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$3C = ["size", "color", "stroke"];

function IconSquare3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12a2 2 0 1 0 -2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14a2 2 0 1 0 2 -2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$3B = ["size", "color", "stroke"];

function IconSquare4(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-4",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16v-8l-4 6h5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$3A = ["size", "color", "stroke"];

function IconSquare5(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-5",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16h2a2 2 0 1 0 0 -4h-2v-4h4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$3z = ["size", "color", "stroke"];

function IconSquare6(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-6",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(180 12 14)",
    cx: 12,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10a2 2 0 1 0 -4 0v4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$3y = ["size", "color", "stroke"];

function IconSquare7(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-7",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8h4l-2 8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$3x = ["size", "color", "stroke"];

function IconSquare8(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-8",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$3w = ["size", "color", "stroke"];

function IconSquare9(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-9",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14a2 2 0 1 0 4 0v-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$3v = ["size", "color", "stroke"];

function IconSquareAsterisk(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-asterisk",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5v7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10l6 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 14l6 -4"
  }));
}

var _excluded$3u = ["size", "color", "stroke"];

function IconSquareCheck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-check",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12l2 2l4 -4"
  }));
}

var _excluded$3t = ["size", "color", "stroke"];

function IconSquareDot(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-dot",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }));
}

var _excluded$3s = ["size", "color", "stroke"];

function IconSquareForbid2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-forbid-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 9
  }));
}

var _excluded$3r = ["size", "color", "stroke"];

function IconSquareForbid(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-forbid",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 15
  }));
}

var _excluded$3q = ["size", "color", "stroke"];

function IconSquareHalf(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-half",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v16"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13l7.5 -7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18l8 -8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20l5 -5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8l4 -4"
  }));
}

var _excluded$3p = ["size", "color", "stroke"];

function IconSquareMinus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-minus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }));
}

var _excluded$3o = ["size", "color", "stroke"];

function IconSquareOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.584 3.412a1.994 1.994 0 0 1 -1.416 .588h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.052 .586 -1.414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$3n = ["size", "color", "stroke"];

function IconSquarePlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 12,
    x2: 15,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 15
  }));
}

var _excluded$3m = ["size", "color", "stroke"];

function IconSquareRoot2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-root-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h1l3 8l3 -16h10"
  }));
}

var _excluded$3l = ["size", "color", "stroke"];

function IconSquareRoot(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-root",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h2l4 8l4 -16h8"
  }));
}

var _excluded$3k = ["size", "color", "stroke"];

function IconSquareRotatedForbid2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rotated-forbid-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.5l5 5"
  }));
}

var _excluded$3j = ["size", "color", "stroke"];

function IconSquareRotatedForbid(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rotated-forbid",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.5l5 -5"
  }));
}

var _excluded$3i = ["size", "color", "stroke"];

function IconSquareRotatedOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rotated-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.964 16.952l-3.462 3.461c-.782 .783 -2.222 .783 -3.004 0l-6.911 -6.91c-.783 -.783 -.783 -2.223 0 -3.005l3.455 -3.456m2.003 -2.003l1.453 -1.452c.782 -.783 2.222 -.783 3.004 0l6.911 6.91c.783 .783 .783 2.223 0 3.005l-1.448 1.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$3h = ["size", "color", "stroke"];

function IconSquareRotated(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-rotated",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.4l-6.9 -6.9c-.781 -.781 -.781 -2.219 0 -3l6.9 -6.9c.781 -.781 2.219 -.781 3 0l6.9 6.9c.781 .781 .781 2.219 0 3l-6.9 6.9c-.781 .781 -2.219 .781 -3 0z"
  }));
}

var _excluded$3g = ["size", "color", "stroke"];

function IconSquareToggleHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-toggle-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12h-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14v-8a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20a2 2 0 0 0 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18a2 2 0 0 0 2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 20,
    x2: 10,
    y2: 20
  }));
}

var _excluded$3f = ["size", "color", "stroke"];

function IconSquareToggle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-toggle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6a2 2 0 0 0 -2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20a2 2 0 0 0 2 -2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 10,
    x2: 20,
    y2: 14
  }));
}

var _excluded$3e = ["size", "color", "stroke"];

function IconSquareX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10l4 4m0 -4l-4 4"
  }));
}

var _excluded$3d = ["size", "color", "stroke"];

function IconSquare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }));
}

var _excluded$3c = ["size", "color", "stroke"];

function IconSquaresDiagonal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-squares-diagonal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 12,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.586 19.414l10.827 -10.827"
  }));
}

var _excluded$3b = ["size", "color", "stroke"];

function IconSquaresFilled(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-squares-filled",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 12,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5l6.492 -6.492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.496 20.004l6.504 -6.504l-6.504 6.504z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.586 19.414l10.827 -10.827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
  }));
}

var _excluded$3a = ["size", "color", "stroke"];

function IconStack2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stack-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 4 4 8 12 12 20 8 12 4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "4 12 12 16 20 12"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "4 16 12 20 20 16"
  }));
}

var _excluded$39 = ["size", "color", "stroke"];

function IconStack3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$39);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stack-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2l-8 4l8 4l8 -4l-8 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10l8 4l8 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18l8 4l8 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14l8 4l8 -4"
  }));
}

var _excluded$38 = ["size", "color", "stroke"];

function IconStack(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$38);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stack",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6l-8 4l8 4l8 -4l-8 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14l8 4l8 -4"
  }));
}

var _excluded$37 = ["size", "color", "stroke"];

function IconStairsDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$37);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stairs-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20h4v-4h4v-4h4v-4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4l-7 7v-4m4 4h-4"
  }));
}

var _excluded$36 = ["size", "color", "stroke"];

function IconStairsUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$36);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stairs-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20h4v-4h4v-4h4v-4h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11l7 -7v4m-4 -4h4"
  }));
}

var _excluded$35 = ["size", "color", "stroke"];

function IconStairs(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$35);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stairs",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18h4v-4h4v-4h4v-4h4"
  }));
}

var _excluded$34 = ["size", "color", "stroke"];

function IconStarHalf(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$34);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-star-half",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253z"
  }));
}

var _excluded$33 = ["size", "color", "stroke"];

function IconStarOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$33);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-star-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.012 6.016l1.981 -4.014l3.086 6.253l6.9 1l-4.421 4.304m.012 4.01l.588 3.426l-6.158 -3.245l-6.172 3.245l1.179 -6.873l-5 -4.867l6.327 -.917"
  }));
}

var _excluded$32 = ["size", "color", "stroke"];

function IconStar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$32);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-star",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
  }));
}

var _excluded$31 = ["size", "color", "stroke"];

function IconStars(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$31);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stars",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8 19.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2 19.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.817l-2.172 1.138a0.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a0.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a0.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a0.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a0.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
  }));
}

var _excluded$30 = ["size", "color", "stroke"];

function IconSteeringWheel(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$30);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-steering-wheel",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 3.25,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 20.75,
    y2: 10
  }));
}

var _excluded$2$ = ["size", "color", "stroke"];

function IconStepInto(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-step-into",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 11,
    x2: 12,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 12,
    y2: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1
  }));
}

var _excluded$2_ = ["size", "color", "stroke"];

function IconStepOut(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-step-out",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 7,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 7,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1
  }));
}

var _excluded$2Z = ["size", "color", "stroke"];

function IconStethoscope(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-stethoscope",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4h-1a2 2 0 0 0 -2 2v3.5h0a5.5 5.5 0 0 0 11 0v-3.5a2 2 0 0 0 -2 -2h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15a6 6 0 1 0 12 0v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 3v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 10,
    r: 2
  }));
}

var _excluded$2Y = ["size", "color", "stroke"];

function IconSticker(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sticker",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12l-2 .5a6 6 0 0 1 -6.5 -6.5l.5 -2l8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12a8 8 0 1 1 -8 -8"
  }));
}

var _excluded$2X = ["size", "color", "stroke"];

function IconStrikethrough(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-strikethrough",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6.5a4 2 0 0 0 -4 -1.5h-1a3.5 3.5 0 0 0 0 7h2a3.5 3.5 0 0 1 0 7h-1.5a4 2 0 0 1 -4 -1.5"
  }));
}

var _excluded$2W = ["size", "color", "stroke"];

function IconSubmarine(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-submarine",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11v6h2l1 -1.5l3 1.5h10a3 3 0 0 0 0 -6h-10h0l-3 1.5l-1 -1.5h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11l-1 -3h-5l-1 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8v-2a1 1 0 0 1 1 -1h1"
  }));
}

var _excluded$2V = ["size", "color", "stroke"];

function IconSubscript(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-subscript",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7l8 10m-8 0l8 -10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 20h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2"
  }));
}

var _excluded$2U = ["size", "color", "stroke"];

function IconSubtask(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-subtask",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 9,
    x2: 12,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 5,
    x2: 8,
    y2: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5v11a1 1 0 0 0 1 1h5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7,
    width: 8,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15,
    width: 8,
    height: 4,
    rx: 1
  }));
}

var _excluded$2T = ["size", "color", "stroke"];

function IconSum(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sum",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16v2a1 1 0 0 1 -1 1h-11l6 -7l-6 -7h11a1 1 0 0 1 1 1v2"
  }));
}

var _excluded$2S = ["size", "color", "stroke"];

function IconSunOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sun-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12a4 4 0 0 0 -4 -4m-2.834 1.177a4 4 0 0 0 5.66 5.654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"
  }));
}

var _excluded$2R = ["size", "color", "stroke"];

function IconSun(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sun",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"
  }));
}

var _excluded$2Q = ["size", "color", "stroke"];

function IconSunrise(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sunrise",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9v-6l3 3m-6 0l3 -3"
  }));
}

var _excluded$2P = ["size", "color", "stroke"];

function IconSunset(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sunset",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3v6l3 -3m-6 0l3 3"
  }));
}

var _excluded$2O = ["size", "color", "stroke"];

function IconSuperscript(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-superscript",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7l8 10m-8 0l8 -10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2"
  }));
}

var _excluded$2N = ["size", "color", "stroke"];

function IconSwimming(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-swimming",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11l4 -2l3.5 3l-1.5 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16.75a2.4 2.4 0 0 0 1 .25a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 1 -.25"
  }));
}

var _excluded$2M = ["size", "color", "stroke"];

function IconSwitch2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-switch-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17h5l1.67 -2.386m3.66 -5.227l1.67 -2.387h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7h5l7 10h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }));
}

var _excluded$2L = ["size", "color", "stroke"];

function IconSwitch3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-switch-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17h2.397a5 5 0 0 0 4.096 -2.133l.177 -.253m3.66 -5.227l.177 -.254a5 5 0 0 1 4.096 -2.133h3.397"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7h2.397a5 5 0 0 1 4.096 2.133l4.014 5.734a5 5 0 0 0 4.096 2.133h3.397"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  }));
}

var _excluded$2K = ["size", "color", "stroke"];

function IconSwitchHorizontal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-switch-horizontal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 3 20 7 16 11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 7,
    x2: 20,
    y2: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 13 4 17 8 21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 17,
    x2: 13,
    y2: 17
  }));
}

var _excluded$2J = ["size", "color", "stroke"];

function IconSwitchVertical(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-switch-vertical",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3 8 7 4 11 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 7,
    y2: 13
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "13 16 17 20 21 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 10,
    x2: 17,
    y2: 20
  }));
}

var _excluded$2I = ["size", "color", "stroke"];

function IconSwitch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-switch",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 4 19 4 19 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.75,
    y1: 9.25,
    x2: 19,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 19,
    x2: 9,
    y2: 15
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 19 19 19 19 15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 5,
    x2: 19,
    y2: 19
  }));
}

var _excluded$2H = ["size", "color", "stroke"];

function IconSword(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-sword",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4v5l-9 7l-4 4l-3 -3l4 -4l7 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.5l6 6"
  }));
}

var _excluded$2G = ["size", "color", "stroke"];

function IconTableExport(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-table-export",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 20h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7.5m-16 -3.5h16m-10 -6v16m4 -1h7m-3 -3l3 3l-3 3"
  }));
}

var _excluded$2F = ["size", "color", "stroke"];

function IconTableImport(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-table-import",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13.5v-7.5a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6m-8 -10h16m-10 -6v11.5m-8 3.5h7m-3 -3l3 3l-3 3"
  }));
}

var _excluded$2E = ["size", "color", "stroke"];

function IconTableOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-table-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.588 3.417c-.362 .36 -.86 .583 -1.412 .583h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.053 .586 -1.414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10h6m4 0h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4v2m0 4v10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$2D = ["size", "color", "stroke"];

function IconTable(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-table",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 10,
    x2: 20,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 4,
    x2: 10,
    y2: 20
  }));
}

var _excluded$2C = ["size", "color", "stroke"];

function IconTagOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tag-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.792 7.793a1 1 0 0 0 1.414 1.414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88 4.877a2.99 2.99 0 0 0 -.88 2.123v3.859c0 .537 .213 1.052 .593 1.432l8.116 8.116a2.025 2.025 0 0 0 2.864 0l2.416 -2.416m2.002 -2.002l.416 -.416a2.025 2.025 0 0 0 0 -2.864l-8.117 -8.116a2.025 2.025 0 0 0 -1.431 -.593h-2.859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$2B = ["size", "color", "stroke"];

function IconTag(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tag",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7v3.859c0 .537 .213 1.052 .593 1.432l8.116 8.116a2.025 2.025 0 0 0 2.864 0l4.834 -4.834a2.025 2.025 0 0 0 0 -2.864l-8.117 -8.116a2.025 2.025 0 0 0 -1.431 -.593h-3.859a3 3 0 0 0 -3 3z"
  }));
}

var _excluded$2A = ["size", "color", "stroke"];

function IconTagsOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tags-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6h-.975a2.025 2.025 0 0 0 -2.025 2.025v2.834c0 .537 .213 1.052 .593 1.432l6.116 6.116a2.025 2.025 0 0 0 2.864 0l2.834 -2.834c.028 -.028 .055 -.056 .08 -.085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.573 18.407l.418 -.418m1.997 -1.997l.419 -.419a2.025 2.025 0 0 0 0 -2.864l-7.117 -7.116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9h-.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$2z = ["size", "color", "stroke"];

function IconTags(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tags",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.859 6h-2.834a2.025 2.025 0 0 0 -2.025 2.025v2.834c0 .537 .213 1.052 .593 1.432l6.116 6.116a2.025 2.025 0 0 0 2.864 0l2.834 -2.834a2.025 2.025 0 0 0 0 -2.864l-6.117 -6.116a2.025 2.025 0 0 0 -1.431 -.593z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.573 18.407l2.834 -2.834a2.025 2.025 0 0 0 0 -2.864l-7.117 -7.116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9h-.01"
  }));
}

var _excluded$2y = ["size", "color", "stroke"];

function IconTallymark1(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tallymark-1",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }));
}

var _excluded$2x = ["size", "color", "stroke"];

function IconTallymark2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tallymark-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 5,
    x2: 10,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 5,
    x2: 14,
    y2: 19
  }));
}

var _excluded$2w = ["size", "color", "stroke"];

function IconTallymark3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tallymark-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 5,
    x2: 8,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 5,
    x2: 16,
    y2: 19
  }));
}

var _excluded$2v = ["size", "color", "stroke"];

function IconTallymark4(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tallymark-4",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 5,
    x2: 6,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 5,
    x2: 10,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 5,
    x2: 14,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 5,
    x2: 18,
    y2: 19
  }));
}

var _excluded$2u = ["size", "color", "stroke"];

function IconTallymarks(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tallymarks",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 5,
    x2: 6,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 5,
    x2: 10,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 5,
    x2: 14,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 5,
    x2: 18,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 17,
    x2: 21,
    y2: 7
  }));
}

var _excluded$2t = ["size", "color", "stroke"];

function IconTank(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tank",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    width: 18,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12l1 -5h5l3 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 9,
    x2: 13.2,
    y2: 9
  }));
}

var _excluded$2s = ["size", "color", "stroke"];

function IconTarget(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-target",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }));
}

var _excluded$2r = ["size", "color", "stroke"];

function IconTelescope(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-telescope",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21l6 -5l6 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13v8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.294 13.678l.166 .281c.52 .88 1.624 1.265 2.605 .91l14.242 -5.165a1.023 1.023 0 0 0 .565 -1.456l-2.62 -4.705a1.087 1.087 0 0 0 -1.447 -.42l-.056 .032l-12.694 7.618c-1.02 .613 -1.357 1.897 -.76 2.905z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5l3 5.5"
  }));
}

var _excluded$2q = ["size", "color", "stroke"];

function IconTemperatureCelsius(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-temperature-celsius",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9a3 3 0 0 0 -3 -3h-1a3 3 0 0 0 -3 3v6a3 3 0 0 0 3 3h1a3 3 0 0 0 3 -3"
  }));
}

var _excluded$2p = ["size", "color", "stroke"];

function IconTemperatureFahrenheit(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-temperature-fahrenheit",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 12,
    x2: 18,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6h-6a1 1 0 0 0 -1 1v11"
  }));
}

var _excluded$2o = ["size", "color", "stroke"];

function IconTemperatureMinus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-temperature-minus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 12,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 9,
    x2: 22,
    y2: 9
  }));
}

var _excluded$2n = ["size", "color", "stroke"];

function IconTemperaturePlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-temperature-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 12,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 9,
    x2: 22,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 6,
    x2: 19,
    y2: 12
  }));
}

var _excluded$2m = ["size", "color", "stroke"];

function IconTemperature(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-temperature",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 9,
    x2: 14,
    y2: 9
  }));
}

var _excluded$2l = ["size", "color", "stroke"];

function IconTemplate(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-template",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 6,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 16,
    x2: 20,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 20,
    x2: 20,
    y2: 20
  }));
}

var _excluded$2k = ["size", "color", "stroke"];

function IconTent(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tent",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14l4 6h6l-9 -16l-9 16h6l4 -6"
  }));
}

var _excluded$2j = ["size", "color", "stroke"];

function IconTerminal2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-terminal-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 15,
    x2: 16,
    y2: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 16,
    rx: 2
  }));
}

var _excluded$2i = ["size", "color", "stroke"];

function IconTerminal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-terminal",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7l5 5l-5 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 19,
    y2: 19
  }));
}

var _excluded$2h = ["size", "color", "stroke"];

function IconTestPipe(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-test-pipe",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8.04l-12.122 12.124a2.857 2.857 0 1 1 -4.041 -4.04l12.122 -12.124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 15l1.5 1.6a2 2 0 1 1 -3 0l1.5 -1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3l6 6"
  }));
}

var _excluded$2g = ["size", "color", "stroke"];

function IconTextDirectionLtr(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-direction-ltr",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 21l2 -2l-2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h-6.5a3.5 3.5 0 0 0 0 7h.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15v-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15v-11"
  }));
}

var _excluded$2f = ["size", "color", "stroke"];

function IconTextDirectionRtl(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-direction-rtl",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h-6.5a3.5 3.5 0 0 0 0 7h.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15v-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15v-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21l-2 -2l2 -2"
  }));
}

var _excluded$2e = ["size", "color", "stroke"];

function IconTextResize(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-resize",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 19h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 7v10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14v-4"
  }));
}

var _excluded$2d = ["size", "color", "stroke"];

function IconTextWrapDisabled(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-wrap-disabled",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 14,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 14,
    y2: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h17l-3 -3m0 6l3 -3"
  }));
}

var _excluded$2c = ["size", "color", "stroke"];

function IconTextWrap(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-text-wrap",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 9,
    y2: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h13a3 3 0 0 1 0 6h-4l2 -2m0 4l-2 -2"
  }));
}

var _excluded$2b = ["size", "color", "stroke"];

function IconThermometer(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-thermometer",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 5a2.828 2.828 0 0 1 0 4l-8 8h-4v-4l8 -8a2.828 2.828 0 0 1 4 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7l-1.5 -1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10l-1.5 -1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13l-1.5 -1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17l-3 3"
  }));
}

var _excluded$2a = ["size", "color", "stroke"];

function IconThumbDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-thumb-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h3a4 4 0 0 1 4 4v1a2 2 0 0 0 4 0v-5h3a2 2 0 0 0 2 -2l-1 -5a2 3 0 0 0 -2 -2h-7a3 3 0 0 0 -3 3"
  }));
}

var _excluded$29 = ["size", "color", "stroke"];

function IconThumbUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$29);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-thumb-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3"
  }));
}

var _excluded$28 = ["size", "color", "stroke"];

function IconTicket(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$28);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ticket",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 5,
    x2: 15,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 11,
    x2: 15,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 17,
    x2: 15,
    y2: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2"
  }));
}

var _excluded$27 = ["size", "color", "stroke"];

function IconTie(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$27);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tie",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22l4 -4l-2.5 -11l.993 -2.649a1 1 0 0 0 -.936 -1.351h-3.114a1 1 0 0 0 -.936 1.351l.993 2.649l-2.5 11l4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7h3l5 5.5"
  }));
}

var _excluded$26 = ["size", "color", "stroke"];

function IconTiltShift(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$26);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tilt-shift",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56 3.69a9 9 0 0 0 -2.92 1.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69 8.56a9 9 0 0 0 -.69 3.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69 15.44a9 9 0 0 0 1.95 2.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56 20.31a9 9 0 0 0 3.44 .69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.31 15.44a9 9 0 0 0 .69 -3.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }));
}

var _excluded$25 = ["size", "color", "stroke"];

function IconTimeline(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$25);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-timeline",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16l6 -7l5 5l5 -6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 16,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 8,
    r: 1
  }));
}

var _excluded$24 = ["size", "color", "stroke"];

function IconTir(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$24);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tir",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18h8m4 0h2v-6a5 7 0 0 0 -5 -7h-1l1.5 7h4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18v-13h3"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3 17 3 12 12 12"
  }));
}

var _excluded$23 = ["size", "color", "stroke"];

function IconToggleLeft(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$23);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-toggle-left",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 20,
    height: 12,
    rx: 6
  }));
}

var _excluded$22 = ["size", "color", "stroke"];

function IconToggleRight(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$22);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-toggle-right",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 20,
    height: 12,
    rx: 6
  }));
}

var _excluded$21 = ["size", "color", "stroke"];

function IconToiletPaper(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$21);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-toilet-paper",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 10,
    rx: 3,
    ry: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10c0 -3.866 -1.343 -7 -3 -7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10v10l-3 -1l-3 2l-3 -3l-3 2v-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10h.01"
  }));
}

var _excluded$20 = ["size", "color", "stroke"];

function IconTool(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$20);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tool",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5"
  }));
}

var _excluded$1$ = ["size", "color", "stroke"];

function IconToolsKitchen2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tools-kitchen-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 3v12h-5c-.023 -3.681 .184 -7.406 5 -12zm0 12v6h-1v-3m-10 -14v17m-3 -17v3a3 3 0 1 0 6 0v-3"
  }));
}

var _excluded$1_ = ["size", "color", "stroke"];

function IconToolsKitchen(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tools-kitchen",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 3h8l-1 9h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18h2v3h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 3v12h-5c-.023 -3.681 .184 -7.406 5 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15v6h-1v-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 8,
    y2: 18
  }));
}

var _excluded$1Z = ["size", "color", "stroke"];

function IconTools(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tools",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21h4l13 -13a1.5 1.5 0 0 0 -4 -4l-13 13v4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 5.5,
    x2: 18.5,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 8 7 3 3 7 8 12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 8,
    x2: 5.5,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 12 21 17 17 21 12 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 17,
    x2: 14.5,
    y2: 18.5
  }));
}

var _excluded$1Y = ["size", "color", "stroke"];

function IconTornado(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tornado",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 4,
    x2: 3,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 16,
    x2: 7,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 20,
    x2: 15,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 8,
    x2: 20,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 16,
    y2: 12
  }));
}

var _excluded$1X = ["size", "color", "stroke"];

function IconTournament(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tournament",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 14h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7h4a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 20,
    y2: 12
  }));
}

var _excluded$1W = ["size", "color", "stroke"];

function IconTrack(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-track",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15l11 -11m5 5l-11 11m-4 -8l7 7m-3.5 -10.5l7 7m-3.5 -10.5l7 7"
  }));
}

var _excluded$1V = ["size", "color", "stroke"];

function IconTractor(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tractor",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 15,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 15,
    x2: 7,
    y2: 15.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 17,
    x2: 17,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15.2v-4.2a1 1 0 0 0 -1 -1h-6l-2 -5h-6v6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5h-1a1 1 0 0 0 -1 1v4"
  }));
}

var _excluded$1U = ["size", "color", "stroke"];

function IconTrademark(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trademark",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9h5m-2.5 0v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15v-6l3 4l3 -4v6"
  }));
}

var _excluded$1T = ["size", "color", "stroke"];

function IconTrafficCone(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-traffic-cone",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.4,
    y1: 10,
    x2: 14.6,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.8,
    y1: 15,
    x2: 16.2,
    y2: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 20l5 -15h2l5 15"
  }));
}

var _excluded$1S = ["size", "color", "stroke"];

function IconTrafficLights(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-traffic-lights",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2,
    width: 10,
    height: 20,
    rx: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1
  }));
}

var _excluded$1R = ["size", "color", "stroke"];

function IconTrain(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-train",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 13c0 -3.87 -3.37 -7 -10 -7h-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 15h16a2 2 0 0 0 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6v5h17.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 3,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 8,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 11,
    x2: 13,
    y2: 6.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 19,
    x2: 21,
    y2: 19
  }));
}

var _excluded$1Q = ["size", "color", "stroke"];

function IconTransferIn(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-transfer-in",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18v3h16v-14l-8 -4l-8 4v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 14h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11l3 3l-3 3"
  }));
}

var _excluded$1P = ["size", "color", "stroke"];

function IconTransferOut(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-transfer-out",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 19v2h16v-14l-8 -4l-8 4v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14h-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11l-3 3l3 3"
  }));
}

var _excluded$1O = ["size", "color", "stroke"];

function IconTrashOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trash-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h3m4 0h9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 10,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 14,
    x2: 14,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l.077 -.923"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.384,
    y1: 14.373,
    x2: 19,
    y2: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
  }));
}

var _excluded$1N = ["size", "color", "stroke"];

function IconTrashX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trash-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12l4 4m0 -4l-4 4"
  }));
}

var _excluded$1M = ["size", "color", "stroke"];

function IconTrash(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trash",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 7,
    x2: 20,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 10,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 11,
    x2: 14,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
  }));
}

var _excluded$1L = ["size", "color", "stroke"];

function IconTree(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-tree",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13l-2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12l2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.824 15.995a3 3 0 0 1 -2.743 -3.69a2.998 2.998 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a2.997 2.997 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h-4z"
  }));
}

var _excluded$1K = ["size", "color", "stroke"];

function IconTrees(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trees",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5l3 3l-2 1l4 4l-3 1l4 4h-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 21,
    x2: 15,
    y2: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13l-2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12l2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 21v-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.824 15.995a3 3 0 0 1 -2.743 -3.69a2.998 2.998 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a2.997 2.997 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h-4z"
  }));
}

var _excluded$1J = ["size", "color", "stroke"];

function IconTrendingDown2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trending-down-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h5l7 10h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19l3 -3l-3 -3"
  }));
}

var _excluded$1I = ["size", "color", "stroke"];

function IconTrendingDown3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trending-down-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6h2.397a5 5 0 0 1 4.096 2.133l4.014 5.734a5 5 0 0 0 4.096 2.133h3.397"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19l3 -3l-3 -3"
  }));
}

var _excluded$1H = ["size", "color", "stroke"];

function IconTrendingDown(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trending-down",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3 7 9 13 13 9 21 17"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "21 10 21 17 14 17"
  }));
}

var _excluded$1G = ["size", "color", "stroke"];

function IconTrendingUp2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trending-up-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18h5l7 -10h6"
  }));
}

var _excluded$1F = ["size", "color", "stroke"];

function IconTrendingUp3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trending-up-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5l3 3l-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18h2.397a5 5 0 0 0 4.096 -2.133l4.014 -5.734a5 5 0 0 1 4.096 -2.133h3.397"
  }));
}

var _excluded$1E = ["size", "color", "stroke"];

function IconTrendingUp(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trending-up",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3 17 9 11 13 15 21 7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 7 21 7 21 14"
  }));
}

var _excluded$1D = ["size", "color", "stroke"];

function IconTriangleInverted(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-triangle-inverted",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4h14a2 2 0 0 1 1.84 2.75l-7.1 12.25a2 2 0 0 1 -3.5 0l-7.1 -12.25a2 2 0 0 1 1.75 -2.75"
  }));
}

var _excluded$1C = ["size", "color", "stroke"];

function IconTriangleOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-triangle-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19h14m1.986 -2.014a2 2 0 0 0 -.146 -.736l-7.1 -12.25a2 2 0 0 0 -3.5 0l-.825 1.424m-1.467 2.53l-4.808 8.296a2 2 0 0 0 1.75 2.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  }));
}

var _excluded$1B = ["size", "color", "stroke"];

function IconTriangleSquareCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-triangle-square-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3l-4 7h8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 6,
    height: 6,
    rx: 1
  }));
}

var _excluded$1A = ["size", "color", "stroke"];

function IconTriangle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-triangle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
  }));
}

var _excluded$1z = ["size", "color", "stroke"];

function IconTrident(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trident",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6l2 -2v3a7 7 0 0 0 14 0v-3l2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21v-18l-2 2m4 0l-2 -2"
  }));
}

var _excluded$1y = ["size", "color", "stroke"];

function IconTrophy(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trophy",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 4,
    x2: 17,
    y2: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4v8a5 5 0 0 1 -10 0v-8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 9,
    r: 2
  }));
}

var _excluded$1x = ["size", "color", "stroke"];

function IconTruckDelivery(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-truck-delivery",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17h-2v-4m-1 -8h11v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 9,
    x2: 7,
    y2: 9
  }));
}

var _excluded$1w = ["size", "color", "stroke"];

function IconTruckOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-truck-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.585 15.586a2 2 0 0 0 2.826 2.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17h-2v-11a1 1 0 0 1 1 -1h1m3.96 0h4.04v4m0 4v4m-4 0h6m6 0v-6h-6m-2 -5h5l3 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$1v = ["size", "color", "stroke"];

function IconTruckReturn(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-truck-return",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17h-2v-11a1 1 0 0 1 1 -1h9v6h-5l2 2m0 -4l-2 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 17,
    x2: 15,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6h5l3 5v6h-2"
  }));
}

var _excluded$1u = ["size", "color", "stroke"];

function IconTruck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-truck",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
  }));
}

var _excluded$1t = ["size", "color", "stroke"];

function IconTypography(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-typography",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 7,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 20,
    x2: 21,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.9,
    y1: 15,
    x2: 13.8,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.2,
    y1: 6.3,
    x2: 16,
    y2: 20
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5 20 11 4 13 4 20 20"
  }));
}

var _excluded$1s = ["size", "color", "stroke"];

function IconUmbrella(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-umbrella",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12a8 8 0 0 1 16 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12v6a2 2 0 0 0 4 0"
  }));
}

var _excluded$1r = ["size", "color", "stroke"];

function IconUnderline(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-underline",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5v5a5 5 0 0 0 10 0v-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19h14"
  }));
}

var _excluded$1q = ["size", "color", "stroke"];

function IconUnlink(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-unlink",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 21,
    x2: 16,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 16,
    x2: 21,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 8,
    x2: 5,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 3,
    x2: 8,
    y2: 5
  }));
}

var _excluded$1p = ["size", "color", "stroke"];

function IconUpload(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-upload",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 9 12 4 17 9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 16
  }));
}

var _excluded$1o = ["size", "color", "stroke"];

function IconUrgent(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-urgent",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16v-4a4 4 0 0 1 8 0v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 12,
    height: 4,
    rx: 1
  }));
}

var _excluded$1n = ["size", "color", "stroke"];

function IconUsb(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-usb",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17v-11.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10v3l5 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5l5 -2v-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10h2v-2h-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5.5h4l-2 -2.5z"
  }));
}

var _excluded$1m = ["size", "color", "stroke"];

function IconUserCheck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-check",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11l2 2l4 -4"
  }));
}

var _excluded$1l = ["size", "color", "stroke"];

function IconUserCircle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-circle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855"
  }));
}

var _excluded$1k = ["size", "color", "stroke"];

function IconUserExclamation(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-exclamation",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 7,
    x2: 19,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 14,
    x2: 19,
    y2: 14.01
  }));
}

var _excluded$1j = ["size", "color", "stroke"];

function IconUserMinus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-minus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 11,
    x2: 22,
    y2: 11
  }));
}

var _excluded$1i = ["size", "color", "stroke"];

function IconUserOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.274 10.291a4 4 0 1 0 -5.554 -5.58m-.548 3.453a4.01 4.01 0 0 0 2.62 2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 1.147 .167m2.685 2.681a4 4 0 0 1 .168 1.152v2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$1h = ["size", "color", "stroke"];

function IconUserPlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11h6m-3 -3v6"
  }));
}

var _excluded$1g = ["size", "color", "stroke"];

function IconUserSearch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-search",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21v-2a4 4 0 0 1 4 -4h1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19.5l2.5 2.5"
  }));
}

var _excluded$1f = ["size", "color", "stroke"];

function IconUserX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9l4 4m0 -4l-4 4"
  }));
}

var _excluded$1e = ["size", "color", "stroke"];

function IconUser(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-user",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }));
}

var _excluded$1d = ["size", "color", "stroke"];

function IconUsers(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-users",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.13a4 4 0 0 1 0 7.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21v-2a4 4 0 0 0 -3 -3.85"
  }));
}

var _excluded$1c = ["size", "color", "stroke"];

function IconVaccineBottle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vaccine-bottle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 6,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6v.98c0 .877 -.634 1.626 -1.5 1.77c-.866 .144 -1.5 .893 -1.5 1.77v8.48a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-8.48c0 -.877 -.634 -1.626 -1.5 -1.77a1.795 1.795 0 0 1 -1.5 -1.77v-.98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18h10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15h2"
  }));
}

var _excluded$1b = ["size", "color", "stroke"];

function IconVaccine(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vaccine",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3l4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 5l-4.5 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.5l6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.5l-6.5 6.5h-4v-4l6.5 -6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5l1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.5l1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21l3 -3"
  }));
}

var _excluded$1a = ["size", "color", "stroke"];

function IconVariable(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-variable",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4c-2.5 5 -2.5 10 0 16m14 -16c2.5 5 2.5 10 0 16m-10 -11h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
  }));
}

var _excluded$19 = ["size", "color", "stroke"];

function IconVectorBeizer2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$19);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vector-beizer-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 14,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 19,
    x2: 17,
    y2: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 19,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5.5a5 6.5 0 0 1 5 6.5a5 6.5 0 0 0 5 6.5"
  }));
}

var _excluded$18 = ["size", "color", "stroke"];

function IconVectorBezier(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$18);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vector-bezier",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 14,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5a6 6 0 0 0 -5 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8.5a6 6 0 0 1 5 5.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 8,
    x2: 4,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 14,
    y2: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 8,
    r: 1
  }));
}

var _excluded$17 = ["size", "color", "stroke"];

function IconVectorTriangle(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$17);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vector-triangle",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 17.1,
    x2: 11.5,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 17.1,
    x2: 12.5,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 17,
    y2: 19
  }));
}

var _excluded$16 = ["size", "color", "stroke"];

function IconVector(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$16);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vector",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 4,
    height: 4,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 7,
    x2: 5,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 7,
    x2: 19,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 17,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 17,
    y2: 19
  }));
}

var _excluded$15 = ["size", "color", "stroke"];

function IconVenus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$15);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-venus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 18,
    x2: 15,
    y2: 18
  }));
}

var _excluded$14 = ["size", "color", "stroke"];

function IconVersions(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$14);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-versions",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 10,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 7,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 8,
    x2: 4,
    y2: 16
  }));
}

var _excluded$13 = ["size", "color", "stroke"];

function IconVideoMinus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$13);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-video-minus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 12,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 11,
    y2: 12
  }));
}

var _excluded$12 = ["size", "color", "stroke"];

function IconVideoOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$12);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-video-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11v-1l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -.675 .946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6h3a2 2 0 0 1 2 2v3m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1"
  }));
}

var _excluded$11 = ["size", "color", "stroke"];

function IconVideoPlus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$11);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-video-plus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 12,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 12,
    x2: 11,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 10,
    x2: 9,
    y2: 14
  }));
}

var _excluded$10 = ["size", "color", "stroke"];

function IconVideo(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$10);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-video",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 12,
    height: 12,
    rx: 2
  }));
}

var _excluded$$ = ["size", "color", "stroke"];

function IconView360(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$$);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-view-360",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 4,
    ry: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 4,
    ry: 9,
    transform: "rotate(90 12 12)"
  }));
}

var _excluded$_ = ["size", "color", "stroke"];

function IconViewfinder(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$_);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-viewfinder",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 7,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 18,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 12.01
  }));
}

var _excluded$Z = ["size", "color", "stroke"];

function IconViewportNarrow(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$Z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-viewport-narrow",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h7l-3 -3m0 6l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12h-7l3 -3m0 6l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6v-3h6v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18v3h6v-3"
  }));
}

var _excluded$Y = ["size", "color", "stroke"];

function IconViewportWide(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$Y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-viewport-wide",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12h-7l3 -3m0 6l-3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12h7l-3 -3m0 6l3 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6v-3h18v3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18v3h18v-3"
  }));
}

var _excluded$X = ["size", "color", "stroke"];

function IconVinyl(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$X);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vinyl",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.004 3.937a9 9 0 1 0 4.996 8.063"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4l-3.5 10l-2.5 2"
  }));
}

var _excluded$W = ["size", "color", "stroke"];

function IconVirusOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$W);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-virus-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.469 8.46a5 5 0 0 0 7.058 7.084m1.386 -2.608a5 5 0 0 0 -5.826 -5.853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(45 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(90 12 12)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 13,
    y2: 3,
    transform: "rotate(135 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(180 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(225 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(270 12 12)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 11,
    y2: 3,
    transform: "rotate(315 12 12)"
  }));
}

var _excluded$V = ["size", "color", "stroke"];

function IconVirusSearch(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$V);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-virus-search",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12a5 5 0 1 0 -5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(45 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(90 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(180 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(225 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(270 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(315 12 12)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.5,
    y1: 19.5,
    x2: 22,
    y2: 22
  }));
}

var _excluded$U = ["size", "color", "stroke"];

function IconVirus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$U);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-virus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(45 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(90 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(135 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(180 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(225 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(270 12 12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7v-4m-1 0h2",
    transform: "rotate(315 12 12)"
  }));
}

var _excluded$T = ["size", "color", "stroke"];

function IconVocabulary(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$T);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-vocabulary",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19h-6a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h6a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11h1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15h1"
  }));
}

var _excluded$S = ["size", "color", "stroke"];

function IconVolume2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$S);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-volume-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8a5 5 0 0 1 0 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
  }));
}

var _excluded$R = ["size", "color", "stroke"];

function IconVolume3(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$R);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-volume-3",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10l4 4m0 -4l-4 4"
  }));
}

var _excluded$Q = ["size", "color", "stroke"];

function IconVolume(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$Q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-volume",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8a5 5 0 0 1 0 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7 5a9 9 0 0 1 0 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a0.8 .8 0 0 1 1.5 .5v14a0.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
  }));
}

var _excluded$P = ["size", "color", "stroke"];

function IconWalk(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$P);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-walk",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 21,
    x2: 10,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21l-2 -4l-3 -3l1 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12l2 -3l4 -1l3 3l3 1"
  }));
}

var _excluded$O = ["size", "color", "stroke"];

function IconWall(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$O);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wall",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12h-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16h16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16v4"
  }));
}

var _excluded$N = ["size", "color", "stroke"];

function IconWallet(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$N);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wallet",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12v4h-4a2 2 0 0 1 0 -4h4"
  }));
}

var _excluded$M = ["size", "color", "stroke"];

function IconWallpaper(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$M);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wallpaper",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18v-12a2 2 0 1 0 -4 0v12"
  }));
}

var _excluded$L = ["size", "color", "stroke"];

function IconWand(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$L);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wand",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6 21 21 6 18 3 3 18 6 21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 6,
    x2: 18,
    y2: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 13a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
  }));
}

var _excluded$K = ["size", "color", "stroke"];

function IconWaveSawTool(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$K);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wave-saw-tool",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h5l4 8v-16l4 8h5"
  }));
}

var _excluded$J = ["size", "color", "stroke"];

function IconWaveSine(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$J);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wave-sine",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12h-2c-.894 0 -1.662 -.857 -1.761 -2c-.296 -3.45 -.749 -6 -2.749 -6s-2.5 3.582 -2.5 8s-.5 8 -2.5 8s-2.452 -2.547 -2.749 -6c-.1 -1.147 -.867 -2 -1.763 -2h-2"
  }));
}

var _excluded$I = ["size", "color", "stroke"];

function IconWaveSquare(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$I);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wave-square",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h5v8h4v-16h4v8h5"
  }));
}

var _excluded$H = ["size", "color", "stroke"];

function IconWebhook(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$H);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-webhook",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.876 13.61a4 4 0 1 0 6.124 3.39h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.066 20.502a4 4 0 1 0 1.934 -7.502c-.706 0 -1.424 .179 -2 .5l-3 -5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8a4 4 0 1 0 -8 0c0 1.506 .77 2.818 2 3.5l-3 5.5"
  }));
}

var _excluded$G = ["size", "color", "stroke"];

function IconWifi0(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$G);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wifi-0",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  }));
}

var _excluded$F = ["size", "color", "stroke"];

function IconWifi1(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$F);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wifi-1",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }));
}

var _excluded$E = ["size", "color", "stroke"];

function IconWifi2(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$E);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wifi-2",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.343 12.343a8 8 0 0 1 11.314 0"
  }));
}

var _excluded$D = ["size", "color", "stroke"];

function IconWifiOff(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$D);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wifi-off",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.343 12.343a7.963 7.963 0 0 1 3.864 -2.14m4.163 .155a7.965 7.965 0 0 1 3.287 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.515 9.515a12 12 0 0 1 3.544 -2.455m3.101 -.92a12 12 0 0 1 10.325 3.374"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 21,
    y2: 21
  }));
}

var _excluded$C = ["size", "color", "stroke"];

function IconWifi(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$C);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wifi",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.343 12.343a8 8 0 0 1 11.314 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"
  }));
}

var _excluded$B = ["size", "color", "stroke"];

function IconWind(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$B);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wind",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8h8.5a2.5 2.5 0 1 0 -2.34 -3.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h15.5a2.5 2.5 0 1 1 -2.34 3.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24"
  }));
}

var _excluded$A = ["size", "color", "stroke"];

function IconWindmill(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$A);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-windmill",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12c2.76 0 5 -2.01 5 -4.5s-2.24 -4.5 -5 -4.5v9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12c0 2.76 2.01 5 4.5 5s4.5 -2.24 4.5 -5h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12c-2.76 0 -5 2.01 -5 4.5s2.24 4.5 5 4.5v-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12c0 -2.76 -2.01 -5 -4.5 -5s-4.5 2.24 -4.5 5h9z"
  }));
}

var _excluded$z = ["size", "color", "stroke"];

function IconWindow(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$z);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-window",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3c-3.866 0 -7 3.272 -7 7v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-10c0 -3.728 -3.134 -7 -7 -7z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 13,
    x2: 19,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }));
}

var _excluded$y = ["size", "color", "stroke"];

function IconWindsock(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$y);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-windsock",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3v18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11l12 -1v-4l-12 -1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5.5v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6v4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 21h4"
  }));
}

var _excluded$x = ["size", "color", "stroke"];

function IconWiperWash(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$x);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wiper-wash",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11l5.5 5.5a5 5 0 0 1 7 0l5.5 -5.5a12 12 0 0 0 -18 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6a4 4 0 0 1 .4 -1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 2.1a4 4 0 0 1 2 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6a4 4 0 0 0 -.4 -1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6a4 4 0 0 1 .4 -1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 2.1a4 4 0 0 1 2 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6a4 4 0 0 0 -.4 -1.8"
  }));
}

var _excluded$w = ["size", "color", "stroke"];

function IconWiper(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$w);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wiper",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9l5.5 5.5a5 5 0 0 1 7 0l5.5 -5.5a12 12 0 0 0 -18 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 9.8,
    y2: 5.2
  }));
}

var _excluded$v = ["size", "color", "stroke"];

function IconWoman(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$v);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-woman",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 22v-4h-2l2 -6a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1l2 6h-2v4"
  }));
}

var _excluded$u = ["size", "color", "stroke"];

function IconWorldDownload(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$u);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-world-download",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12a9 9 0 1 0 -9 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6 9h16.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6 15h8.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.578 3a17 17 0 0 0 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3c1.719 2.755 2.5 5.876 2.5 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14v7m-3 -3l3 3l3 -3"
  }));
}

var _excluded$t = ["size", "color", "stroke"];

function IconWorldLatitude(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$t);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-world-latitude",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.6,
    y1: 7,
    x2: 19.4,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.6,
    y1: 17,
    x2: 19.4,
    y2: 17
  }));
}

var _excluded$s = ["size", "color", "stroke"];

function IconWorldLongitude(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$s);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-world-longitude",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3a11.2 11.2 0 0 0 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3a11.2 11.2 0 0 1 0 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21
  }));
}

var _excluded$r = ["size", "color", "stroke"];

function IconWorldUpload(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$r);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-world-upload",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12a9 9 0 1 0 -9 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6 9h16.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6 15h8.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.578 3a17 17 0 0 0 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3c1.719 2.755 2.5 5.876 2.5 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 21v-7m3 3l-3 -3l-3 3"
  }));
}

var _excluded$q = ["size", "color", "stroke"];

function IconWorld(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$q);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-world",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 9,
    x2: 20.4,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.6,
    y1: 15,
    x2: 20.4,
    y2: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3a17 17 0 0 0 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3a17 17 0 0 1 0 18"
  }));
}

var _excluded$p = ["size", "color", "stroke"];

function IconWreckingBall(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$p);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-wrecking-ball",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 13,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 17,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 19,
    x2: 4,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 13,
    y2: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12v-5h2a3 3 0 0 1 3 3v5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15v-2a1 1 0 0 1 1 -1h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11v-7l-6 7"
  }));
}

var _excluded$o = ["size", "color", "stroke"];

function IconWritingSign(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$o);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-writing-sign",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 19c3.333 -2 5 -4 5 -6c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 2.877 2.5 4c1.5 2 2.5 2.5 3.5 1c.667 -1 1.167 -1.833 1.5 -2.5c1 2.333 2.333 3.5 4 3.5h2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7h4"
  }));
}

var _excluded$n = ["size", "color", "stroke"];

function IconWriting(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$n);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-writing",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3"
  }));
}

var _excluded$m = ["size", "color", "stroke"];

function IconX(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$m);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-x",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 6,
    x2: 6,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 6,
    x2: 18,
    y2: 18
  }));
}

var _excluded$l = ["size", "color", "stroke"];

function IconYinYang(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$l);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-yin-yang",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a4.5 4.5 0 0 0 0 9a4.5 4.5 0 0 1 0 9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.5,
    r: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16.5,
    r: 0.5,
    fill: "currentColor"
  }));
}

var _excluded$k = ["size", "color", "stroke"];

function IconYoga(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$k);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-yoga",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20h4l1.5 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20l-1 -5h-5l1 -7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10l4 -1l4 -1l4 1.5l4 1.5"
  }));
}

var _excluded$j = ["size", "color", "stroke"];

function IconZodiacAquarius(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$j);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-aquarius",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10l3 -3l3 3l3 -3l3 3l3 -3l3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17l3 -3l3 3l3 -3l3 3l3 -3l3 3"
  }));
}

var _excluded$i = ["size", "color", "stroke"];

function IconZodiacAries(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$i);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-aries",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5a5 5 0 1 0 -4 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13a5 5 0 1 0 -4 -8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 5
  }));
}

var _excluded$h = ["size", "color", "stroke"];

function IconZodiacCancer(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$h);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-cancer",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12a10 6.5 0 0 1 14 -6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12a10 6.5 0 0 1 -14 6.5"
  }));
}

var _excluded$g = ["size", "color", "stroke"];

function IconZodiacCapricorn(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$g);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-capricorn",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4a3 3 0 0 1 3 3v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7a3 3 0 0 1 6 0v11a3 3 0 0 1 -3 3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 17,
    r: 3
  }));
}

var _excluded$f = ["size", "color", "stroke"];

function IconZodiacGemini(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$f);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-gemini",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3a21 21 0 0 0 18 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21a21 21 0 0 1 18 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 4.5,
    x2: 7,
    y2: 19.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 4.5,
    x2: 17,
    y2: 19.5
  }));
}

var _excluded$e = ["size", "color", "stroke"];

function IconZodiacLeo(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$e);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-leo",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17a4 4 0 1 0 8 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7c0 3 2 5 2 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7c0 4 -2 6 -2 10"
  }));
}

var _excluded$d = ["size", "color", "stroke"];

function IconZodiacLibra(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$d);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-libra",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 20,
    x2: 19,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17h5v-.3a7 7 0 1 1 4 0v.3h5"
  }));
}

var _excluded$c = ["size", "color", "stroke"];

function IconZodiacPisces(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$c);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-pisces",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3a21 21 0 0 1 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 3a21 21 0 0 0 0 18"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }));
}

var _excluded$b = ["size", "color", "stroke"];

function IconZodiacSagittarius(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$b);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-sagittarius",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 20,
    y2: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 4h7v7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 12.5,
    x2: 11.5,
    y2: 17.5
  }));
}

var _excluded$a = ["size", "color", "stroke"];

function IconZodiacScorpio(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$a);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-scorpio",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 4a2 2 0 0 1 2 2v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6a2 2 0 0 1 4 0v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6a2 2 0 0 1 4 0v10a3 3 0 0 0 3 3h5l-3 -3m0 6l3 -3"
  }));
}

var _excluded$9 = ["size", "color", "stroke"];

function IconZodiacTaurus(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$9);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-taurus",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3a6 6 0 0 0 12 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 6
  }));
}

var _excluded$8 = ["size", "color", "stroke"];

function IconZodiacVirgo(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$8);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zodiac-virgo",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 4a2 2 0 0 1 2 2v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6a2 2 0 0 1 4 0v9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6a2 2 0 0 1 4 0v10a7 5 0 0 0 7 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21a7 5 0 0 0 7 -5v-2a3 3 0 0 0 -6 0"
  }));
}

var _excluded$7 = ["size", "color", "stroke"];

function IconZoomCancel(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$7);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-cancel",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 8,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 8,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 15,
    y2: 15
  }));
}

var _excluded$6 = ["size", "color", "stroke"];

function IconZoomCheck(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$6);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-check",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21l-6 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10l2 2l4 -4"
  }));
}

var _excluded$5 = ["size", "color", "stroke"];

function IconZoomCode(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$5);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-code",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21l-6 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8l-2 2l2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8l2 2l-2 2"
  }));
}

var _excluded$4 = ["size", "color", "stroke"];

function IconZoomExclamation(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$4);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-exclamation",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21l-6 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13v.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7v3"
  }));
}

var _excluded$3 = ["size", "color", "stroke"];

function IconZoomIn(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$3);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-in",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 13,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 7,
    x2: 10,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 15,
    y2: 15
  }));
}

var _excluded$2 = ["size", "color", "stroke"];

function IconZoomMoney(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$2);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-money",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21l-6 -6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13v1m0 -8v1"
  }));
}

var _excluded$1 = ["size", "color", "stroke"];

function IconZoomOut(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded$1);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-out",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 10,
    x2: 13,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 15,
    y2: 15
  }));
}

var _excluded = ["size", "color", "stroke"];

function IconZoomQuestion(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-zoom-question",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    strokeWidth: stroke,
    stroke: color,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21l-6 -6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 13,
    x2: 10,
    y2: 13.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10a1.5 1.5 0 1 0 -1.14 -2.474"
  }));
}

export { Icon2fa, Icon3dCubeSphere, Icon3dRotate, IconAB, IconAbacus, IconAccessPoint, IconAccessPointOff, IconAccessible, IconActivity, IconAd, IconAd2, IconAddressBook, IconAdjustments, IconAdjustmentsAlt, IconAdjustmentsHorizontal, IconAerialLift, IconAffiliate, IconAlarm, IconAlbum, IconAlertCircle, IconAlertOctagon, IconAlertTriangle, IconAlien, IconAlignCenter, IconAlignJustified, IconAlignLeft, IconAlignRight, IconAmbulance, IconAnchor, IconAngle, IconAntennaBars1, IconAntennaBars2, IconAntennaBars3, IconAntennaBars4, IconAntennaBars5, IconAperture, IconApi, IconApiApp, IconAppWindow, IconApple, IconApps, IconArchive, IconArmchair, IconArmchair2, IconArrowAutofitContent, IconArrowAutofitDown, IconArrowAutofitHeight, IconArrowAutofitLeft, IconArrowAutofitRight, IconArrowAutofitUp, IconArrowAutofitWidth, IconArrowBack, IconArrowBackUp, IconArrowBarDown, IconArrowBarLeft, IconArrowBarRight, IconArrowBarToDown, IconArrowBarToLeft, IconArrowBarToRight, IconArrowBarToUp, IconArrowBarUp, IconArrowBearLeft, IconArrowBearLeft2, IconArrowBearRight, IconArrowBearRight2, IconArrowBigDown, IconArrowBigDownLine, IconArrowBigDownLines, IconArrowBigLeft, IconArrowBigLeftLine, IconArrowBigLeftLines, IconArrowBigRight, IconArrowBigRightLine, IconArrowBigRightLines, IconArrowBigTop, IconArrowBigUpLine, IconArrowBigUpLines, IconArrowBottomBar, IconArrowBottomCircle, IconArrowBottomSquare, IconArrowBottomTail, IconArrowCurveLeft, IconArrowCurveRight, IconArrowDown, IconArrowDownCircle, IconArrowDownLeft, IconArrowDownLeftCircle, IconArrowDownRight, IconArrowDownRightCircle, IconArrowFork, IconArrowForward, IconArrowForwardUp, IconArrowLeft, IconArrowLeftBar, IconArrowLeftCircle, IconArrowLeftRight, IconArrowLeftSquare, IconArrowLeftTail, IconArrowLoopLeft, IconArrowLoopLeft2, IconArrowLoopRight, IconArrowLoopRight2, IconArrowMerge, IconArrowNarrowDown, IconArrowNarrowLeft, IconArrowNarrowRight, IconArrowNarrowUp, IconArrowRampLeft, IconArrowRampLeft2, IconArrowRampLeft3, IconArrowRampRight, IconArrowRampRight2, IconArrowRampRight3, IconArrowRight, IconArrowRightBar, IconArrowRightCircle, IconArrowRightSquare, IconArrowRightTail, IconArrowRotaryFirstLeft, IconArrowRotaryFirstRight, IconArrowRotaryLastLeft, IconArrowRotaryLastRight, IconArrowRotaryLeft, IconArrowRotaryRight, IconArrowRotaryStraight, IconArrowSharpTurnLeft, IconArrowSharpTurnRight, IconArrowTopBar, IconArrowTopCircle, IconArrowTopSquare, IconArrowTopTail, IconArrowUp, IconArrowUpCircle, IconArrowUpLeft, IconArrowUpLeftCircle, IconArrowUpRight, IconArrowUpRightCircle, IconArrowWaveLeftDown, IconArrowWaveLeftUp, IconArrowWaveRightDown, IconArrowWaveRightUp, IconArrowsCross, IconArrowsDiagonal, IconArrowsDiagonal2, IconArrowsDiagonalMinimize, IconArrowsDiagonalMinimize2, IconArrowsDoubleNeSw, IconArrowsDoubleNwSe, IconArrowsDoubleSeNw, IconArrowsDoubleSwNe, IconArrowsDown, IconArrowsDownUp, IconArrowsHorizontal, IconArrowsJoin, IconArrowsJoin2, IconArrowsLeft, IconArrowsLeftDown, IconArrowsLeftRight, IconArrowsMaximize, IconArrowsMinimize, IconArrowsRight, IconArrowsRightDown, IconArrowsRightLeft, IconArrowsShuffle, IconArrowsShuffle2, IconArrowsSort, IconArrowsSplit, IconArrowsSplit2, IconArrowsUp, IconArrowsUpDown, IconArrowsUpLeft, IconArrowsUpRight, IconArrowsVertical, IconArtboard, IconAspectRatio, IconAsterisk, IconAsteriskSimple, IconAt, IconAtom, IconAtom2, IconAugmentedReality, IconAward, IconAxe, IconAxisX, IconAxisY, IconBabyCarriage, IconBackhoe, IconBackpack, IconBackspace, IconBadge, IconBadges, IconBallAmericanFootball, IconBallBaseball, IconBallBasketball, IconBallBowling, IconBallFootball, IconBallFootballOff, IconBallTennis, IconBallVolleyball, IconBallon, IconBallpen, IconBan, IconBandage, IconBarbell, IconBarcode, IconBarell, IconBarrierBlock, IconBaseline, IconBasket, IconBath, IconBattery, IconBattery1, IconBattery2, IconBattery3, IconBattery4, IconBatteryAutomotive, IconBatteryCharging, IconBatteryCharging2, IconBatteryEco, IconBatteryOff, IconBeach, IconBed, IconBeer, IconBell, IconBellMinus, IconBellOff, IconBellPlus, IconBellRinging, IconBellRinging2, IconBellSchool, IconBellX, IconBellZ, IconBible, IconBike, IconBinary, IconBiohazard, IconBlockquote, IconBluetooth, IconBluetoothConnected, IconBluetoothOff, IconBluetoothX, IconBlur, IconBold, IconBolt, IconBoltOff, IconBone, IconBook, IconBook2, IconBookDownload, IconBookUpload, IconBookmark, IconBookmarkOff, IconBookmarks, IconBooks, IconBorderAll, IconBorderBottom, IconBorderHorizontal, IconBorderInner, IconBorderLeft, IconBorderNone, IconBorderOuter, IconBorderRadius, IconBorderRight, IconBorderStyle, IconBorderStyle2, IconBorderTop, IconBorderVertical, IconBottle, IconBox, IconBoxMargin, IconBoxModel, IconBoxModel2, IconBoxMultiple, IconBoxMultiple0, IconBoxMultiple1, IconBoxMultiple2, IconBoxMultiple3, IconBoxMultiple4, IconBoxMultiple5, IconBoxMultiple6, IconBoxMultiple7, IconBoxMultiple8, IconBoxMultiple9, IconBoxPadding, IconBraces, IconBrackets, IconBrandAirbnb, IconBrandAirtable, IconBrandAndroid, IconBrandAngular, IconBrandApple, IconBrandAppleArcade, IconBrandAppstore, IconBrandAsana, IconBrandBehance, IconBrandBing, IconBrandBitbucket, IconBrandBooking, IconBrandBootstrap, IconBrandChrome, IconBrandCodepen, IconBrandCodesandbox, IconBrandCss3, IconBrandCucumber, IconBrandDebian, IconBrandDeviantart, IconBrandDiscord, IconBrandDisqus, IconBrandDocker, IconBrandDoctrine, IconBrandDribbble, IconBrandEdge, IconBrandFacebook, IconBrandFigma, IconBrandFirebase, IconBrandFirefox, IconBrandFlickr, IconBrandFoursquare, IconBrandFramer, IconBrandGit, IconBrandGithub, IconBrandGitlab, IconBrandGmail, IconBrandGoogle, IconBrandGoogleAnalytics, IconBrandGoogleDrive, IconBrandGooglePlay, IconBrandGravatar, IconBrandHipchat, IconBrandHtml5, IconBrandInstagram, IconBrandJavascript, IconBrandKickstarter, IconBrandKotlin, IconBrandLastfm, IconBrandLinkedin, IconBrandLoom, IconBrandMastercard, IconBrandMedium, IconBrandMercedes, IconBrandMessenger, IconBrandMeta, IconBrandNetbeans, IconBrandNetflix, IconBrandNotion, IconBrandNytimes, IconBrandOpenSource, IconBrandOpera, IconBrandPagekit, IconBrandPatreon, IconBrandPaypal, IconBrandPhp, IconBrandPinterest, IconBrandPocket, IconBrandProducthunt, IconBrandPython, IconBrandReactNative, IconBrandReddit, IconBrandSafari, IconBrandSass, IconBrandSentry, IconBrandShazam, IconBrandSketch, IconBrandSkype, IconBrandSlack, IconBrandSnapchat, IconBrandSoundcloud, IconBrandSpotify, IconBrandStackoverflow, IconBrandSteam, IconBrandStripe, IconBrandSublimeText, IconBrandTabler, IconBrandTailwind, IconBrandTelegram, IconBrandTidal, IconBrandTiktok, IconBrandTinder, IconBrandTripadvisor, IconBrandTumblr, IconBrandTwitch, IconBrandTwitter, IconBrandUber, IconBrandUbuntu, IconBrandUnsplash, IconBrandVercel, IconBrandVimeo, IconBrandVisualStudio, IconBrandVk, IconBrandWhatsapp, IconBrandWindows, IconBrandYahoo, IconBrandYcombinator, IconBrandYoutube, IconBread, IconBriefcase, IconBrightness, IconBrightness2, IconBrightnessDown, IconBrightnessHalf, IconBrightnessUp, IconBrowser, IconBrowserCheck, IconBrowserPlus, IconBrowserX, IconBrush, IconBucket, IconBug, IconBuilding, IconBuildingArch, IconBuildingBank, IconBuildingBridge, IconBuildingBridge2, IconBuildingCarousel, IconBuildingCastle, IconBuildingChurch, IconBuildingCommunity, IconBuildingCottage, IconBuildingFactory, IconBuildingFactory2, IconBuildingFortress, IconBuildingHospital, IconBuildingLighthouse, IconBuildingMonument, IconBuildingPavilon, IconBuildingSkyscraper, IconBuildingStore, IconBuildingWarehouse, IconBulb, IconBulbOff, IconBulldozer, IconBus, IconBusinessplan, IconButterfly, IconCSharp, IconCake, IconCalculator, IconCalendar, IconCalendarEvent, IconCalendarMinus, IconCalendarOff, IconCalendarPlus, IconCalendarStats, IconCalendarTime, IconCamera, IconCameraMinus, IconCameraOff, IconCameraPlus, IconCameraRotate, IconCameraSelfie, IconCandle, IconCandy, IconCapture, IconCar, IconCarCrane, IconCarCrash, IconCaravan, IconCardboards, IconCaretDown, IconCaretLeft, IconCaretRight, IconCaretUp, IconCash, IconCashBanknote, IconCashBanknoteOff, IconCast, IconCe, IconCell, IconCellSignal1, IconCellSignal2, IconCellSignal3, IconCellSignal4, IconCellSignal5, IconCellSignalOff, IconCertificate, IconCertificate2, IconChargingPile, IconChartArcs, IconChartArcs3, IconChartArea, IconChartAreaLine, IconChartArrows, IconChartArrowsVertical, IconChartBar, IconChartBubble, IconChartCandle, IconChartCircles, IconChartDonut, IconChartDonut2, IconChartDonut3, IconChartDonut4, IconChartDots, IconChartInfographic, IconChartLine, IconChartPie, IconChartPie2, IconChartPie3, IconChartPie4, IconChartRadar, IconCheck, IconCheckbox, IconChecklist, IconChecks, IconCheckupList, IconCheese, IconChevronDown, IconChevronDownLeft, IconChevronDownRight, IconChevronLeft, IconChevronRight, IconChevronUp, IconChevronUpLeft, IconChevronUpRight, IconChevronsDown, IconChevronsDownLeft, IconChevronsDownRight, IconChevronsLeft, IconChevronsRight, IconChevronsUp, IconChevronsUpLeft, IconChevronsUpRight, IconChristmasTree, IconCircle, IconCircle0, IconCircle1, IconCircle2, IconCircle3, IconCircle4, IconCircle5, IconCircle6, IconCircle7, IconCircle8, IconCircle9, IconCircleCheck, IconCircleDashed, IconCircleDot, IconCircleDotted, IconCircleHalf, IconCircleHalf2, IconCircleHalfVertical, IconCircleMinus, IconCircleOff, IconCirclePlus, IconCircleRectangle, IconCircleSquare, IconCircleTriangle, IconCircleX, IconCircles, IconClearAll, IconClearFormatting, IconClick, IconClipboard, IconClipboardCheck, IconClipboardList, IconClipboardPlus, IconClipboardText, IconClipboardX, IconClock, IconCloud, IconCloudDownload, IconCloudFog, IconCloudLock, IconCloudLockOpen, IconCloudOff, IconCloudRain, IconCloudSnow, IconCloudStorm, IconCloudUpload, IconClubs, IconCode, IconCodeMinus, IconCodePlus, IconCoffee, IconCoin, IconColorPicker, IconColorSwatch, IconColumnInsertLeft, IconColumnInsertRight, IconColumns, IconComet, IconCommand, IconCompass, IconComponents, IconCone, IconCone2, IconConfetti, IconContainer, IconContrast, IconContrast2, IconCookie, IconCopy, IconCopyleft, IconCopyright, IconCornerDownLeft, IconCornerDownLeftDouble, IconCornerDownRight, IconCornerDownRightDouble, IconCornerLeftDown, IconCornerLeftDownDouble, IconCornerLeftUp, IconCornerLeftUpDouble, IconCornerRightDown, IconCornerRightDownDouble, IconCornerRightUp, IconCornerRightUpDouble, IconCornerUpLeft, IconCornerUpLeftDouble, IconCornerUpRight, IconCornerUpRightDouble, IconCpu, IconCpu2, IconCrane, IconCreativeCommons, IconCreditCard, IconCreditCardOff, IconCrop, IconCross, IconCrosshair, IconCrown, IconCrownOff, IconCrutches, IconCup, IconCurling, IconCurlyLoop, IconCurrency, IconCurrencyBahraini, IconCurrencyBaht, IconCurrencyBitcoin, IconCurrencyCent, IconCurrencyDinar, IconCurrencyDirham, IconCurrencyDogecoin, IconCurrencyDollar, IconCurrencyDollarAustralian, IconCurrencyDollarCanadian, IconCurrencyDollarSingapore, IconCurrencyEthereum, IconCurrencyEuro, IconCurrencyForint, IconCurrencyFrank, IconCurrencyKroneCzech, IconCurrencyKroneDanish, IconCurrencyKroneSwedish, IconCurrencyLeu, IconCurrencyLira, IconCurrencyLitecoin, IconCurrencyNaira, IconCurrencyPound, IconCurrencyReal, IconCurrencyRenminbi, IconCurrencyRipple, IconCurrencyRiyal, IconCurrencyRubel, IconCurrencyRupee, IconCurrencyShekel, IconCurrencyTaka, IconCurrencyTugrik, IconCurrencyWon, IconCurrencyYen, IconCurrencyZloty, IconCurrentLocation, IconCursorText, IconCut, IconDashboard, IconDatabase, IconDatabaseExport, IconDatabaseImport, IconDatabaseOff, IconDental, IconDetails, IconDeviceAnalytics, IconDeviceAudioTape, IconDeviceCctv, IconDeviceComputerCamera, IconDeviceComputerCameraOff, IconDeviceDesktop, IconDeviceDesktopAnalytics, IconDeviceDesktopOff, IconDeviceFloppy, IconDeviceGamepad, IconDeviceHeartMonitor, IconDeviceLaptop, IconDeviceLaptopOff, IconDeviceMobile, IconDeviceMobileMessage, IconDeviceMobileOff, IconDeviceMobileRotated, IconDeviceMobileVibration, IconDeviceNintendo, IconDeviceSpeaker, IconDeviceTablet, IconDeviceTabletOff, IconDeviceTv, IconDeviceTvOff, IconDeviceWatch, IconDeviceWatchOff, IconDeviceWatchStats, IconDeviceWatchStats2, IconDevices, IconDevices2, IconDevicesOff, IconDevicesPc, IconDialpad, IconDiamond, IconDiamonds, IconDice, IconDice1, IconDice2, IconDice3, IconDice4, IconDice5, IconDice6, IconDimensions, IconDirection, IconDirectionHorizontal, IconDirections, IconDisabled, IconDisabled2, IconDisc, IconDiscount, IconDiscount2, IconDivide, IconDna, IconDna2, IconDogBowl, IconDoor, IconDoorEnter, IconDoorExit, IconDots, IconDotsCircleHorizontal, IconDotsDiagonal, IconDotsDiagonal2, IconDotsVertical, IconDownload, IconDragDrop, IconDragDrop2, IconDrone, IconDroneOff, IconDropCircle, IconDroplet, IconDropletFilled, IconDropletFilled2, IconDropletHalf, IconDropletHalf2, IconDropletOff, IconEar, IconEarOff, IconEdit, IconEditCircle, IconEgg, IconElevator, IconEmergencyBed, IconEmphasis, IconEngine, IconEqual, IconEqualNot, IconEraser, IconError404, IconExchange, IconExclamationMark, IconExposure, IconExternalLink, IconEye, IconEyeCheck, IconEyeOff, IconEyeTable, IconEyeglass, IconEyeglass2, IconFaceId, IconFaceIdError, IconFaceMask, IconFall, IconFeather, IconFence, IconFidgetSpinner, IconFile, IconFile3d, IconFileAlert, IconFileAnalytics, IconFileArrowLeft, IconFileArrowRight, IconFileBarcode, IconFileCertificate, IconFileChart, IconFileCheck, IconFileCode, IconFileCode2, IconFileDatabase, IconFileDescription, IconFileDiff, IconFileDigit, IconFileDislike, IconFileDollar, IconFileDots, IconFileDownload, IconFileEuro, IconFileExport, IconFileHorizontal, IconFileImport, IconFileInfo, IconFileInvoice, IconFileLike, IconFileMinus, IconFileMusic, IconFileOff, IconFilePencil, IconFilePhone, IconFilePlus, IconFilePower, IconFileReport, IconFileRss, IconFileScissors, IconFileSearch, IconFileSettings, IconFileShredder, IconFileSignal, IconFileSpreadsheet, IconFileStar, IconFileSymlink, IconFileText, IconFileTime, IconFileTypography, IconFileUnknown, IconFileUpload, IconFileVector, IconFileX, IconFileZip, IconFiles, IconFilesOff, IconFilter, IconFilterOff, IconFingerprint, IconFiretruck, IconFirstAidKit, IconFish, IconFlag, IconFlag2, IconFlag3, IconFlame, IconFlare, IconFlask, IconFlask2, IconFlipHorizontal, IconFlipVertical, IconFloatCenter, IconFloatLeft, IconFloatNone, IconFloatRight, IconFlower, IconFocus, IconFocus2, IconFocusCentered, IconFold, IconFoldDown, IconFoldUp, IconFolder, IconFolderMinus, IconFolderOff, IconFolderPlus, IconFolderX, IconFolders, IconForbid, IconForbid2, IconForklift, IconForms, IconFrame, IconFreeRights, IconFriends, IconGasStation, IconGauge, IconGavel, IconGeometry, IconGhost, IconGift, IconGitBranch, IconGitCommit, IconGitCompare, IconGitFork, IconGitMerge, IconGitPullRequest, IconGitPullRequestClosed, IconGitPullRequestDraft, IconGizmo, IconGlass, IconGlassFull, IconGlassOff, IconGlobe, IconGolf, IconGps, IconGrain, IconGridDots, IconGridPattern, IconGrill, IconGripHorizontal, IconGripVertical, IconGrowth, IconH1, IconH2, IconH3, IconH4, IconH5, IconH6, IconHammer, IconHandClick, IconHandFinger, IconHandGrab, IconHandLittleFinger, IconHandMiddleFinger, IconHandMove, IconHandOff, IconHandRingFinger, IconHandRock, IconHandStop, IconHandThreeFingers, IconHandTwoFingers, IconHanger, IconHash, IconHaze, IconHeading, IconHeadphones, IconHeadphonesOff, IconHeadset, IconHeart, IconHeartBroken, IconHeartRateMonitor, IconHeartbeat, IconHelicopter, IconHelicopterLanding, IconHelmet, IconHelp, IconHexagon, IconHexagonOff, IconHierarchy, IconHierarchy2, IconHighlight, IconHistory, IconHome, IconHome2, IconHotelService, IconHourglass, IconHourglassHigh, IconHourglassLow, IconIceCream, IconIceCream2, IconIceSkating, IconId, IconIdBadge, IconIdBadge2, IconInbox, IconIndentDecrease, IconIndentIncrease, IconInfinity, IconInfoCircle, IconInfoSquare, IconItalic, IconJumpRope, IconKarate, IconKering, IconKey, IconKeyboard, IconKeyboardHide, IconKeyboardOff, IconKeyboardShow, IconLadder, IconLamp, IconLanguage, IconLanguageHiragana, IconLanguageKatakana, IconLasso, IconLayersDifference, IconLayersIntersect, IconLayersIntersect2, IconLayersLinked, IconLayersSubtract, IconLayersUnion, IconLayout, IconLayout2, IconLayoutAlignBottom, IconLayoutAlignCenter, IconLayoutAlignLeft, IconLayoutAlignMiddle, IconLayoutAlignRight, IconLayoutAlignTop, IconLayoutBoard, IconLayoutBoardSplit, IconLayoutBottombar, IconLayoutCards, IconLayoutColumns, IconLayoutDashboard, IconLayoutDistributeHorizontal, IconLayoutDistributeVertical, IconLayoutGrid, IconLayoutGridAdd, IconLayoutKanban, IconLayoutList, IconLayoutNavbar, IconLayoutRows, IconLayoutSidebar, IconLayoutSidebarLeftCollapse, IconLayoutSidebarLeftExpand, IconLayoutSidebarRight, IconLayoutSidebarRightCollapse, IconLayoutSidebarRightExpand, IconLeaf, IconLego, IconLemon, IconLemon2, IconLetterA, IconLetterB, IconLetterC, IconLetterCase, IconLetterCaseLower, IconLetterCaseToggle, IconLetterCaseUpper, IconLetterD, IconLetterE, IconLetterF, IconLetterG, IconLetterH, IconLetterI, IconLetterJ, IconLetterK, IconLetterL, IconLetterM, IconLetterN, IconLetterO, IconLetterP, IconLetterQ, IconLetterR, IconLetterS, IconLetterSpacing, IconLetterT, IconLetterU, IconLetterV, IconLetterW, IconLetterX, IconLetterY, IconLetterZ, IconLicense, IconLifebuoy, IconLine, IconLineDashed, IconLineDotted, IconLineHeight, IconLink, IconList, IconListCheck, IconListDetails, IconListNumbers, IconListSearch, IconLivePhoto, IconLiveView, IconLoader, IconLoaderQuarter, IconLocation, IconLock, IconLockAccess, IconLockOff, IconLockOpen, IconLockSquare, IconLogin, IconLogout, IconLollipop, IconLuggage, IconLungs, IconMacro, IconMagnet, IconMail, IconMailFast, IconMailForward, IconMailOpened, IconMailbox, IconMan, IconManualGearbox, IconMap, IconMap2, IconMapPin, IconMapPinOff, IconMapPins, IconMapSearch, IconMarkdown, IconMarquee, IconMarquee2, IconMars, IconMask, IconMaskOff, IconMassage, IconMath, IconMathFunction, IconMathSymbols, IconMaximize, IconMeat, IconMedal, IconMedal2, IconMedicalCross, IconMedicineSyrup, IconMenu, IconMenu2, IconMessage, IconMessage2, IconMessage2Code, IconMessage2Share, IconMessageCircle, IconMessageCircle2, IconMessageCircleOff, IconMessageCode, IconMessageDots, IconMessageLanguage, IconMessageOff, IconMessagePlus, IconMessageReport, IconMessageShare, IconMessages, IconMessagesOff, IconMicrophone, IconMicrophone2, IconMicrophoneOff, IconMicroscope, IconMilitaryAward, IconMilitaryRank, IconMilk, IconMinimize, IconMinus, IconMinusVertical, IconMist, IconMoodBoy, IconMoodConfuzed, IconMoodCrazyHappy, IconMoodCry, IconMoodEmpty, IconMoodHappy, IconMoodKid, IconMoodNervous, IconMoodNeutral, IconMoodSad, IconMoodSmile, IconMoodSuprised, IconMoodTongue, IconMoon, IconMoon2, IconMoonStars, IconMoped, IconMotorbike, IconMountain, IconMouse, IconMovie, IconMug, IconMultiplier05x, IconMultiplier15x, IconMultiplier1x, IconMultiplier2x, IconMushroom, IconMusic, IconNewSection, IconNews, IconNfc, IconNoCopyright, IconNoCreativeCommons, IconNoDerivatives, IconNorthStar, IconNote, IconNotebook, IconNotes, IconNotification, IconNumber0, IconNumber1, IconNumber2, IconNumber3, IconNumber4, IconNumber5, IconNumber6, IconNumber7, IconNumber8, IconNumber9, IconNumbers, IconNurse, IconOctagon, IconOctagonOff, IconOld, IconOlympics, IconOmega, IconOutlet, IconOval, IconOvalVertical, IconOverline, IconPackage, IconPackgeExport, IconPackgeImport, IconPacman, IconPageBreak, IconPaint, IconPalette, IconPanoramaHorizontal, IconPanoramaVertical, IconPaperBag, IconPaperclip, IconParachute, IconParentheses, IconParking, IconPaw, IconPeace, IconPencil, IconPennant, IconPennant2, IconPentagon, IconPepper, IconPercentage, IconPerspective, IconPhone, IconPhoneCall, IconPhoneCalling, IconPhoneCheck, IconPhoneIncoming, IconPhoneOff, IconPhoneOutgoing, IconPhonePause, IconPhonePlus, IconPhoneX, IconPhoto, IconPhotoOff, IconPhysotherapist, IconPictureInPicture, IconPictureInPictureOff, IconPictureInPictureOn, IconPictureInPictureTop, IconPig, IconPill, IconPills, IconPin, IconPinned, IconPinnedOff, IconPizza, IconPlane, IconPlaneArrival, IconPlaneDeparture, IconPlaneInflight, IconPlanet, IconPlant, IconPlant2, IconPlayCard, IconPlayerEject, IconPlayerPause, IconPlayerPlay, IconPlayerRecord, IconPlayerSkipBack, IconPlayerSkipForward, IconPlayerStop, IconPlayerTrackNext, IconPlayerTrackPrev, IconPlaylist, IconPlaylistAdd, IconPlaylistX, IconPlug, IconPlugConnected, IconPlus, IconPoint, IconPokeball, IconPolaroid, IconPolygon, IconPool, IconPower, IconPray, IconPremiumRights, IconPrescription, IconPresentation, IconPresentationAnalytics, IconPrinter, IconPrison, IconPrompt, IconPropeller, IconPuzzle, IconPuzzle2, IconPyramid, IconQrcode, IconQuestionMark, IconQuote, IconRadar, IconRadar2, IconRadio, IconRadioactive, IconRadiusBottomLeft, IconRadiusBottomRight, IconRadiusTopLeft, IconRadiusTopRight, IconRainbow, IconReceipt, IconReceipt2, IconReceiptOff, IconReceiptRefund, IconReceiptTax, IconRecharging, IconRecordMail, IconRectangle, IconRectangleVertical, IconRecycle, IconRefresh, IconRefreshAlert, IconRefreshDot, IconRegistered, IconRelationManyToMany, IconRelationOneToMany, IconRelationOneToOne, IconRepeat, IconRepeatOnce, IconReplace, IconReport, IconReportAnalytics, IconReportMedical, IconReportMoney, IconReportSearch, IconResize, IconRipple, IconRoad, IconRoadSign, IconRobot, IconRocket, IconRollerSkating, IconRotate, IconRotate2, IconRotate360, IconRotateClockwise, IconRotateClockwise2, IconRotateDot, IconRotateRectangle, IconRoute, IconRouter, IconRowInsertBottom, IconRowInsertTop, IconRss, IconRuler, IconRuler2, IconRun, IconSailboat, IconSalt, IconSatellite, IconSausage, IconScale, IconScaleOutline, IconScan, IconSchool, IconScissors, IconScooter, IconScooterElectric, IconScreenShare, IconScreenShareOff, IconScubaMask, IconSearch, IconSection, IconSectionSign, IconSeeding, IconSelect, IconSelector, IconSend, IconSeparator, IconSeparatorHorizontal, IconSeparatorVertical, IconServer, IconServer2, IconServicemark, IconSettings, IconSettingsAutomation, IconShadow, IconShadowOff, IconShape, IconShape2, IconShape3, IconShare, IconShield, IconShieldCheck, IconShieldCheckered, IconShieldChevron, IconShieldLock, IconShieldOff, IconShieldX, IconShip, IconShirt, IconShoe, IconShoppingCart, IconShoppingCartDiscount, IconShoppingCartOff, IconShoppingCartPlus, IconShoppingCartX, IconShredder, IconSignLeft, IconSignRight, IconSignature, IconSitemap, IconSkateboard, IconSleigh, IconSlice, IconSlideshow, IconSmartHome, IconSmoking, IconSmokingNo, IconSnowflake, IconSoccerField, IconSocial, IconSock, IconSofa, IconSortAscending, IconSortAscending2, IconSortAscendingLetters, IconSortAscendingNumbers, IconSortDescending, IconSortDescending2, IconSortDescendingLetters, IconSortDescendingNumbers, IconSoup, IconSpace, IconSpacingHorizontal, IconSpacingVertical, IconSpade, IconSpeakerphone, IconSpeedboat, IconSportBillard, IconSquare, IconSquare0, IconSquare1, IconSquare2, IconSquare3, IconSquare4, IconSquare5, IconSquare6, IconSquare7, IconSquare8, IconSquare9, IconSquareAsterisk, IconSquareCheck, IconSquareDot, IconSquareForbid, IconSquareForbid2, IconSquareHalf, IconSquareMinus, IconSquareOff, IconSquarePlus, IconSquareRoot, IconSquareRoot2, IconSquareRotated, IconSquareRotatedForbid, IconSquareRotatedForbid2, IconSquareRotatedOff, IconSquareToggle, IconSquareToggleHorizontal, IconSquareX, IconSquaresDiagonal, IconSquaresFilled, IconStack, IconStack2, IconStack3, IconStairs, IconStairsDown, IconStairsUp, IconStar, IconStarHalf, IconStarOff, IconStars, IconSteeringWheel, IconStepInto, IconStepOut, IconStethoscope, IconSticker, IconStrikethrough, IconSubmarine, IconSubscript, IconSubtask, IconSum, IconSun, IconSunOff, IconSunrise, IconSunset, IconSuperscript, IconSwimming, IconSwitch, IconSwitch2, IconSwitch3, IconSwitchHorizontal, IconSwitchVertical, IconSword, IconTable, IconTableExport, IconTableImport, IconTableOff, IconTag, IconTagOff, IconTags, IconTagsOff, IconTallymark1, IconTallymark2, IconTallymark3, IconTallymark4, IconTallymarks, IconTank, IconTarget, IconTelescope, IconTemperature, IconTemperatureCelsius, IconTemperatureFahrenheit, IconTemperatureMinus, IconTemperaturePlus, IconTemplate, IconTent, IconTerminal, IconTerminal2, IconTestPipe, IconTextDirectionLtr, IconTextDirectionRtl, IconTextResize, IconTextWrap, IconTextWrapDisabled, IconThermometer, IconThumbDown, IconThumbUp, IconTicket, IconTie, IconTiltShift, IconTimeline, IconTir, IconToggleLeft, IconToggleRight, IconToiletPaper, IconTool, IconTools, IconToolsKitchen, IconToolsKitchen2, IconTornado, IconTournament, IconTrack, IconTractor, IconTrademark, IconTrafficCone, IconTrafficLights, IconTrain, IconTransferIn, IconTransferOut, IconTrash, IconTrashOff, IconTrashX, IconTree, IconTrees, IconTrendingDown, IconTrendingDown2, IconTrendingDown3, IconTrendingUp, IconTrendingUp2, IconTrendingUp3, IconTriangle, IconTriangleInverted, IconTriangleOff, IconTriangleSquareCircle, IconTrident, IconTrophy, IconTruck, IconTruckDelivery, IconTruckOff, IconTruckReturn, IconTypography, IconUmbrella, IconUnderline, IconUnlink, IconUpload, IconUrgent, IconUsb, IconUser, IconUserCheck, IconUserCircle, IconUserExclamation, IconUserMinus, IconUserOff, IconUserPlus, IconUserSearch, IconUserX, IconUsers, IconVaccine, IconVaccineBottle, IconVariable, IconVector, IconVectorBeizer2, IconVectorBezier, IconVectorTriangle, IconVenus, IconVersions, IconVideo, IconVideoMinus, IconVideoOff, IconVideoPlus, IconView360, IconViewfinder, IconViewportNarrow, IconViewportWide, IconVinyl, IconVirus, IconVirusOff, IconVirusSearch, IconVocabulary, IconVolume, IconVolume2, IconVolume3, IconWalk, IconWall, IconWallet, IconWallpaper, IconWand, IconWaveSawTool, IconWaveSine, IconWaveSquare, IconWebhook, IconWifi, IconWifi0, IconWifi1, IconWifi2, IconWifiOff, IconWind, IconWindmill, IconWindow, IconWindsock, IconWiper, IconWiperWash, IconWoman, IconWorld, IconWorldDownload, IconWorldLatitude, IconWorldLongitude, IconWorldUpload, IconWreckingBall, IconWriting, IconWritingSign, IconX, IconYinYang, IconYoga, IconZodiacAquarius, IconZodiacAries, IconZodiacCancer, IconZodiacCapricorn, IconZodiacGemini, IconZodiacLeo, IconZodiacLibra, IconZodiacPisces, IconZodiacSagittarius, IconZodiacScorpio, IconZodiacTaurus, IconZodiacVirgo, IconZoomCancel, IconZoomCheck, IconZoomCode, IconZoomExclamation, IconZoomIn, IconZoomMoney, IconZoomOut, IconZoomQuestion };